import type { Dict } from '../types';

export const hu: Dict = {
  'invite.header.eyebrow': "Team invitation",
  'invite.loading': "Loading invitation…",
  'invite.landing.title': "Join the team",
  'invite.landing.subtitle': "You’ve been invited to collaborate in Open Design.",
  'invite.landing.roleLabel': "Role",
  'invite.landing.invitedEmail': "Invited email",
  'invite.landing.expires': "Expires",
  'invite.role.admin': "Admin",
  'invite.role.member': "Member",
  'invite.role.admin.desc': "Can manage members, seats, and all project settings.",
  'invite.role.member.desc': "Can create your own projects, and view and comment on shared team projects.",
  'invite.accept.cta': "Accept invitation",
  'invite.accountMismatch.title': "You’re signed in as a different account",
  'invite.accountMismatch.body': "This invitation was sent to a different email address. You can continue with your current account, or switch accounts.",
  'invite.accountMismatch.continue': "Continue with current account",
  'invite.accountMismatch.switch': "Switch account",
  'invite.accepting.title': "Joining the team…",
  'invite.accepting.body': "Setting up your membership.",
  'invite.success.title': "You’re in",
  'invite.success.body': "Opening Open Design so you can start collaborating.",
  'invite.success.roleReceipt': "Joined as",
  'invite.success.enter': "Enter workspace",
  'invite.open.cta': "Open Open Design",
  'invite.open.opening': "Opening Open Design…",
  'invite.open.retry': "Already installed? Try opening again",
  'invite.notInstalled.title': "Didn’t open automatically?",
  'invite.notInstalled.body': "You may not have Open Design installed yet. Install it, then reopen this link to finish joining.",
  'invite.notInstalled.download': "Download Open Design",
  'invite.error.title': "Can’t accept this invitation",
  'invite.error.invite_expired': "This invitation has expired. Ask an admin to send a new one.",
  'invite.error.invite_consumed': "This invitation has already been used.",
  'invite.error.workspace_seat_limit_reached': "The team has no seats left. Ask an admin to free up a seat or add more.",
  'invite.error.workspace_subscription_locked': "The team’s subscription is inactive, so new members can’t join right now.",
  'invite.error.workspace_not_found': "This workspace no longer exists.",
  'invite.error.workspace_forbidden': "Your account isn’t allowed to accept this invitation.",
  'invite.error.invite_unavailable': "This invitation is no longer available.",
  'invite.error.generic': "Something went wrong. Please try again.",
  'invite.error.retry': "Try again",
  "workspaceInvite.dialogAria": "Invite members",
  "workspaceInvite.title": "Invite members to your team",
  "workspaceInvite.freePlanBody": "The free plan includes 1 seat. Inviting teammates will guide you to upgrade to Teams.",
  "workspaceInvite.teamPlanBody": "Invite teammates to share projects, design systems, and plugins together.",
  "workspaceInvite.seatsExhaustedBody": "Ebben a munkaterületben nincs több hely. Adj hozzá helyeket a csapattagok meghívásához.",
  "workspaceInvite.seatsExhaustedAction": "Helyek és csomag megtekintése",
  "workspaceInvite.emailLabel": "Invite members by email",
  "workspaceInvite.roleLabel": "Assign role",
  "workspaceInvite.defaultRoleLabel": "Default role",
  "workspaceInvite.emailPlaceholder": "Enter email address…",
  "workspaceInvite.removeRow": "Remove",
  "workspaceInvite.addMember": "Add member",
  "workspaceInvite.visibilityQuestion": "Will team members see my designs?",
  "workspaceInvite.visibilityAnswer": "Team members can see designs you share to the team space. Private designs kept in Personal projects are not visible to others.",
  "workspaceInvite.sent": "Invitation sent",
  "workspaceInvite.sending": "Inviting…",
  "workspaceInvite.confirm": "Confirm and invite",
  "workspaceInvite.submitFailed": "Failed to send invitation. Try again later.",
  "workspaceInvite.errorAlreadyMember": "Ez az e-mail-cím már csapattag, vagy már meghívták.",
  "workspaceInvite.errorNoSession": "Jelentkezz be a Vela-fiókodba, mielőtt tagokat hívnál meg.",
  "workspaceInvite.errorNoWorkspace": "Még nincs csapatmunkatér, ahová tagokat hívhatnál.",
  "workspaceInvite.errorUnreachable": "A meghívót nem sikerült elküldeni. Próbáld újra később.",
  'chat.amrCard.switchTitle': 'Sikertelen modellhívás — ez a futtatás szünetel',
  'chat.amrCard.switchBody': 'Válts az Open Design Cloud hivatalos modellszolgáltatására — nincs szükség API-kulcs beállítására. Bejelentkezés, engedélyezés és feltöltés után ez a futtatás automatikusan újraindul.',
  'chat.amrCard.chipOfficial': 'Hivatalos szolgáltatás',
  'chat.amrCard.chipNoKey': 'Nincs API-kulcs',
  'chat.amrCard.chipAutoRetry': 'Automatikus újrapróbálkozás bejelentkezés után',
  'chat.amrCard.switchCta': 'Váltás Open Design Cloud-re és újrapróbálkozás',
  'chat.amrError.authMessage': 'Az Open Design Cloud-fiókod még nincs engedélyezve. Engedélyezd, és ez a futtatás automatikusan újraindul.',
  'chat.amrError.balanceMessage': 'Az Open Design Cloud-egyenleged elfogyott. Tölts fel a futtatás folytatásához.',
  'chat.amrError.authorizeCta': 'Engedélyezés és újrapróbálkozás',
  'chat.amrError.rechargeCta': 'Feltöltés',
  'chat.amrBalanceGate.title': 'Válts csomagot és alkoss tovább',
  'chat.amrBalanceGate.message': 'Nincs elég keret (jelenleg {balance}). Csomagváltás vagy feltöltés után a feladat azonnal indulhat.',
  'chat.amrBalanceGate.benefitsTitle': 'Amit az Open Design Cloud nyújt',
  'chat.amrBalanceGate.benefit1': 'API-kulcs nélkül, rengeteg modell',
  'chat.amrBalanceGate.benefit2': 'Beépített SOTA design agent, beállítás nélkül',
  'chat.amrBalanceGate.benefit3': 'Hivatalos, megbízható szolgáltatás',
  'chat.amrBalanceGate.benefit4': 'Folyamatosan bővül: egykattintásos publikálás, multimodális, csapatok és még több',
  'chat.amrBalanceGate.laterCta': 'Most nem',
  'chat.amrBalanceGate.plansCta': 'Csomagváltás',
  'chat.amrBalanceGate.signedOutTitle': 'Jelentkezz be és kezdj alkotni',
  'chat.amrBalanceGate.signedOutMessage': 'Az Open Design Cloud agentet használod — jelentkezz be, és ez a feladat azonnal indulhat.',
  'chat.amrBalanceGate.signInCta': 'Bejelentkezés',
  'chat.amrBalanceGate.watchingWallet': 'Az egyenleg frissülése után automatikusan folytatjuk.',
  'chat.amrLowBalance.title': 'Fogytán a kereted',
  'chat.amrLowBalance.message': 'Már csak {balance} maradt — valószínűleg nem elég a feladat befejezéséhez. Előbb tölts fel vagy válts csomagot.',
  'chat.amrLowBalance.rechargeCta': 'Feltöltés',
  'chat.amrLowBalance.proceedCta': 'Indítás mégis',
  'chat.amrLowBalance.dontRemind': 'Ne kérdezze többé',
  'chat.amrArtifactUpgrade.title': 'Finomíts tovább erősebb modellekkel',
  'chat.amrArtifactUpgrade.message': 'Oldj fel fejlett modelleket, több párhuzamos feladatot és több havi kreditet.',
  'chat.amrArtifactUpgrade.benefit1': 'Több fejlett modell, köztük a Fable 5 és a GPT-5.6',
  'chat.amrArtifactUpgrade.benefit2': 'Akár 10-szer több párhuzamos feladat',
  'chat.amrArtifactUpgrade.benefit3': 'Akár 300-szor több havi kredit',
  'chat.amrArtifactUpgrade.benefit4': 'Elsőbbségi sor csúcsidőben a gyorsabb generálásért',
  'chat.amrArtifactUpgrade.promoBanner': 'Korlátozott ideig: akár 67% kedvezmény az előfizetésekre',
  'chat.amrArtifactUpgrade.countdownLabel': 'Az ajánlat véget ér',
  'chat.amrArtifactUpgrade.plansCta': 'Válts magasabb csomagra, akár 67% kedvezménnyel',
  'chat.amrArtifactUpgrade.homePlansCta': '67% kedvezmény',
  'chat.amrArtifactUpgrade.laterCta': 'Folytatás Free csomaggal és küldés',
  'chat.amrArtifactUpgrade.homeTitle': 'Elkészült az alkotásod. Vidd tovább a következő ötletet.',
  'chat.amrArtifactUpgrade.homeMessage': 'Válts erősebb modellekre, több párhuzamos feladatra és több havi kreditre.',
  'chat.amrArtifactUpgrade.homeArtifactCta': 'Alkotás megnyitása',
  'chat.antigravityError.launchTerminalCta': 'Bejelentkezés terminálon keresztül',
  'chat.antigravityError.launchSwitchModelCta': 'Modellváltás a terminálban',
  'chat.connectionDropped': 'A modellszolgáltatáshoz való kapcsolat megszakadt a válasz befejezése előtt – általában instabil hálózat vagy proxy miatt. Kérjük, próbáld újra.',
  'chat.runError.title.authRequired': 'Engedélyezés szükséges',
  'chat.runError.title.balance': 'Nincs elég egyenleg',
  'chat.runError.title.connectionDropped': 'A kapcsolat megszakadt',
  'chat.runError.title.signInRequired': 'Bejelentkezés szükséges',
  'chat.runError.title.rateLimited': 'Elérted a használati korlátot',
  'chat.runError.title.generic': 'A feladat sikertelen',
  'chat.runError.title.artifactMissing': 'Nem készült átadható fájl',
  'chat.runError.signInMessage.amr': 'Az Open Design Cloud ügynök még nincs bejelentkezve – jelentkezz be a használatához.',
  'chat.runError.signInMessage.other': '{agent} nincs bejelentkezve. Ellenőrizd a bejelentkezési állapotát helyben. Az Open Design Cloud ügynököt ajánljuk – stabilabb és gazdaságosabb.',
  'chat.runError.agentFallback': 'az ügynök',
  'chat.runError.sourceLabel': 'Hiba részletei',
  'chat.runError.sourceExpandAria': 'Hibaforrás kibontása',
  'chat.runError.sourceCollapseAria': 'Hibaforrás összecsukása',
  'chat.runError.title.cliMissing': 'Az ügynök nincs telepítve',
  'chat.runError.title.promptTooLarge': 'Túl hosszú bemenet',
  'chat.runError.title.modelUnavailable': 'A modell nem érhető el',
  'chat.runError.title.upstreamUnavailable': 'A szolgáltatás átmenetileg nem érhető el',
  'chat.runError.title.toolLoop': 'Végtelen ciklusban ragadt',
  'chat.runError.title.outputInvalid': 'Érvénytelen modellkimenet',
  'chat.runError.title.runtimeConfig': 'Konfigurációs hiba',
  'chat.runError.cliMissingMessage': 'A(z) {agent} parancssori eszköze nem található. Telepítsd, és győződj meg róla, hogy szerepel a PATH-ban, majd próbáld újra.',
  'chat.runError.promptTooLargeMessage': 'Ez a kör túllépte a modell kontextushatárát. Rövidítsd le a promptot, távolíts el mellékleteket, vagy indíts új beszélgetést, majd próbáld újra.',
  'chat.runError.modelUnavailableMessage': 'A kiválasztott modell nem érhető el vagy nem létezik. Válts át másik modellre a Beállításokban, majd próbáld újra.',
  'chat.runError.rateLimitedMessage': 'Elérted a modellszolgáltatás használati korlátját. Várj egy kicsit, és próbáld újra, vagy válts másik modellre vagy szolgáltatásra.',
  'chat.runError.upstreamUnavailableMessage': 'A modellszolgáltatás átmenetileg nem érhető el — általában upstream instabilitás vagy hálózati/proxy probléma miatt. Próbáld újra egy pillanat múlva.',
  'chat.runError.toolLoopMessage': 'A(z) {agent} ugyanazt a műveletet ismételte előrehaladás nélkül, ezért leállt. Ellenőrizd a célfájlt vagy parancsot, majd próbáld újra.',
  'chat.runError.outputInvalidMessage': 'A modell érvénytelen kimenetet állított elő, és ez a kör megszakadt. Az újrapróbálkozás általában megoldja.',
  'chat.runError.runtimeConfigMessage': 'A kiválasztott ügynök futásidejű konfigurációja érvénytelen, ezért a futtatás nem indulhatott el. Frissíts a legújabb verzióra, vagy fordulj a támogatáshoz.',
  'chat.runError.title.quotaExhausted': "Elfogyott a keret",
  'chat.runError.title.timedOut': "Időtúllépés",
  'chat.runError.title.emptyOutput': "Nincs kimenet",
  'chat.runError.title.sessionExpired': "A munkamenet lejárt",
  'chat.runError.title.gitBashMissing': "Hiányzó Git Bash",
  'chat.runError.title.cpuUnsupported': "A processzor nem támogatott",
  'chat.runError.quotaExhaustedMessage': "A modellszolgáltatásod kerete vagy számlázási korlátja elfogyott, ezért az újrapróbálkozás nem segít. Tölts fel a szolgáltatódnál, vagy válts másik modellre vagy szolgáltatásra.",
  'chat.runError.workspaceCreditsMessage': "A munkaterületed kreditjei elfogytak. Adj hozzá kreditet (vagy kérd a munkaterület tulajdonosát, hogy töltse fel), vagy válts másik modellre vagy szolgáltatásra.",
  'chat.runError.timedOutMessage': "Ez a futás túl sokáig tartott, ezért leállt. Próbáld újra, vagy szűkítsd a feladatot, és ismételd meg.",
  'chat.runError.inactivityTimeoutMessage': "Az ügynök túl sokáig nem adott új kimenetet, ezért időtúllépés miatt leállt. Az újrapróbálkozás általában folytatja.",
  'chat.runError.emptyOutputMessage': "Az ügynök úgy fejeződött be, hogy nem adott kimenetet. Ez általában átmeneti, próbáld újra.",
  'chat.runError.sessionExpiredMessage': "A folytatott munkamenet lejárt. Visszaállt, ezért próbáld újra egy új futás indításához.",
  'chat.runError.gitBashMissingMessage': "Az ügynök Windowson való futtatásához Git Bash szükséges, de nem található. Telepítsd a Git for Windowst, majd próbáld újra.",
  'chat.runError.cpuUnsupportedMessage': "Az ügynök futtatókörnyezete olyan CPU-utasításkészletet (AVX2) igényel, amellyel ez az eszköz nem rendelkezik, ezért nem tud elindulni. Frissítsd az Open Designt a legújabb verzióra, amely kompatibilis futtatókörnyezetet tartalmaz.",
  'common.cancel': 'Mégse',
  'chat.selectFromLibrary': 'Importálás a könyvtárból',
  'chat.importFigma': 'Importálás Figmából',
  'chat.plus.group.files': 'Files',
  'chat.plus.group.code': 'Code',
  'chat.plus.group.designs': 'Designs',
  'chat.plus.group.other': 'Other',
  'chat.plus.attachFiles': 'Attach files',
  'chat.plus.referenceProject': 'Reference another project',
  'chat.plus.linkLocalCode': 'Link local code',
  'chat.plus.uploadFig': 'Upload .fig file',
  'chat.plus.learnHow': 'Learn how',
  'chat.plus.designSystem': 'Design system',
  'chat.plus.skills': 'Skills',
  'chat.plus.noSkills': 'No skills available',
  'chat.plus.connectors': 'Connectors',
  'chat.plus.plugins': 'Plugins',
  'chat.plus.mcp': 'MCP',
  'chat.referenceProject.title': 'Reference another project',
  'chat.referenceProject.search': 'Search projects…',
  'chat.referenceProject.empty': 'No projects match “{query}”',
  'chat.referenceProject.emptyAll': 'No other projects yet',
  'chat.referenceProject.loadFailed': 'Could not load projects. Check that the daemon is running and try again.',
  'chat.referenceProject.confirm': 'Reference project',
  'chat.contextPrompt.referenceProject': 'Use the Open Design project “{name}” as reference context. Its local path is: {path}. Before designing or modifying anything, search and read this directory when useful.',
  'chat.contextPrompt.localCode': 'Use the local code folder “{name}” as code reference. Its absolute path is: {path}. Read relevant files when useful and stay consistent with the existing implementation.',
  'chat.figmaHelp.title': 'How to download a .fig file',
  'chat.figmaHelp.intro': 'From the Figma web or desktop app:',
  'chat.figmaHelp.step1': 'Open the file in Figma.',
  'chat.figmaHelp.step2': 'Go to File → Save local copy... (web: main menu → File).',
  'chat.figmaHelp.step3': 'Figma downloads a .fig file. Drop it onto the composer or upload it.',
  'chat.figmaHelp.note': 'The .fig file is parsed locally and is not uploaded to Figma.',
  'designFiles.library.label': 'Importálás a könyvtárból',
  'designFiles.library.title': 'Importálás a könyvtárból',
  'libraryPicker.title': 'Importálás a könyvtárból',
  'libraryPicker.searchPlaceholder': 'Keresés a könyvtárban…',
  'libraryPicker.empty': 'Még nincsenek elemek a könyvtáradban',
  'libraryPicker.allKinds': 'Összes',
  'libraryPicker.add': 'Importálás',
  'libraryPicker.loading': 'Betöltés…',
  'common.save': 'Mentés',
  'common.close': 'Bezárás',
  'common.clear': 'Törlés',
  'common.delete': 'Törlés',
  'common.rename': 'Átnevezés',
  'common.edit': 'Szerkesztés',
  'common.preview': 'Előnézet',
  'common.share': 'Megosztás',
  'common.search': 'Keresés',
  'common.searchEllipsis': 'Keresés…',
  'common.loading': 'Betöltés…',
  'common.all': 'Összes',
  'common.none': 'Nincs',
  'common.default': 'Alapértelmezett',
  'common.installed': 'telepítve',
  'common.notInstalled': 'nincs telepítve',
  'common.active': 'aktív',
  'common.inactive': 'inaktív',
  'common.offline': 'offline',
  'common.selected': 'kiválasztva',
  'common.create': 'Létrehozás',
  'common.openPreview': 'Előnézet megnyitása',
  'common.exitFullscreen': 'Kilépés a teljes képernyőből',
  'common.fullscreen': 'Teljes képernyő',
  'common.openInNewTab': 'Megnyitás új lapon',
  'common.exportPdf': 'Exportálás PDF-ként',
  'common.exportZip': 'Letöltés .zip-ként',
  'common.exportHtml': 'Exportálás önálló HTML-ként',
  'common.exportImage': 'Exportálás képként',
  'common.exportImageFailed': 'A kép rögzítése sikertelen. Próbálja újra, vagy használja a böngésző képernyőkép eszközét.',
  'common.justNow': 'az imént',
  'common.minutesAgo': '{n} perce',
  'common.hoursAgo': '{n} órája',
  'common.daysAgo': '{n} napja',
  'common.weeksAgo': '{n} hete',
  'common.now': 'most',
  'common.minutesShort': '{n}p',
  'common.hoursShort': '{n}ó',
  'common.daysShort': '{n}n',
  'common.untitled': 'Cím nélkül',
  'designBrowser.savePageBrief': 'Save page brief',
  'designBrowser.viewport.desktop': 'Asztali',
  'designBrowser.viewport.desktopTitle': 'A böngészőfül teljes méretének használata',
  'designBrowser.viewport.tablet': 'Táblagép',
  'designBrowser.viewport.tabletTitle': 'Előnézet 820 px szélességben',
  'designBrowser.viewport.mobile': 'Mobil',
  'designBrowser.viewport.mobileTitle': 'Előnézet 390 px szélességben',
  'designBrowser.menu': 'Browser menu',
  'designBrowser.copyScreenshot': 'Copy screenshot',
  'designBrowser.hardReload': 'Hard reload',
  'designBrowser.copyUrl': 'Copy URL',
  'designBrowser.openExternal': 'Open externally',
  'designBrowser.downloadPage': 'Download page',
  'designBrowser.downloadPageBusy': 'Downloading page...',
  'designBrowser.clearHistory': 'Clear history',
  'designBrowser.clearCookies': 'Clear cookies',
  'designBrowser.clearAllData': 'Clear all browser data',
  'designBrowser.status.noUrlToCopy': 'No URL to copy.',
  'designBrowser.status.urlCopied': 'URL copied.',
  'designBrowser.status.openHttpFirst': 'Open an http or https page first.',
  'designBrowser.status.openBeforeScreenshot': 'Open a page before taking a screenshot.',
  'designBrowser.status.screenshotSaved': 'Screenshot saved.',
  'designBrowser.addImageToChatButton': 'Hozzáadás a csevegéshez',
  'designBrowser.status.imageAddedToChat': 'A kép hozzáadva a csevegéshez.',
  'designBrowser.status.screenshotFailed': 'Screenshot failed.',
  'designBrowser.status.openBeforeBrief': 'Open a page before saving a brief.',
  'designBrowser.status.briefSaveFailed': 'Page brief save failed.',
  'designBrowser.status.openBeforeDownload': 'Open a page before saving a snapshot.',
  'designBrowser.status.pageSnapshotStarted': 'Saving page snapshot...',
  'designBrowser.status.pageSnapshotUnsupported': 'This page cannot be archived.',
  'designBrowser.status.pageSnapshotFailed': 'Page snapshot save failed.',
  'designBrowser.status.pageSnapshotSaved': 'Saved page snapshot (HTML + CSS).',
  'designBrowser.status.viewDesignFiles': 'View Design Files',
  'designBrowser.status.downloadAssistHint': 'When the page is ready, click Download Page. Return to chat after it is saved.',
  'designBrowser.status.desktopDataUnavailable': 'Desktop browser data is unavailable here.',
  'designBrowser.status.browserDataCleared': 'Browser data cleared.',
  'designBrowser.status.browserDataClearFailed': 'Browser data clear failed.',
  'designBrowser.status.historyCleared': 'History cleared.',
  'plugins.availableDetails.provenance': 'Eredet',
  'plugins.availableDetails.provenanceLine': 'forrás: {source} · {trust} · {resolved}',
  'plugins.availableDetails.provenanceLineWithIntegrity': 'forrás: {source} · {trust} · {resolved} · {integrity}',
  'plugins.availableDetails.install': 'Telepítés',
  'plugins.availableDetails.version': 'Verzió',
  'plugins.availableDetails.pluginVersion': 'Plugin verzió',
  'plugins.availableDetails.copyInstallCommand': 'Telepítési parancs másolása',
  'plugins.availableDetails.copied': 'Másolva',
  'plugins.availableDetails.deprecatedPrefix': 'Elavult: {message}',
  'plugins.availableDetails.deprecatedFallback': 'Ezt a verziót elavultként jelölték meg.',
  'plugins.availableDetails.yanked': 'Visszavonva.',
  'plugins.availableDetails.yankedWithReason': 'Visszavonva: {reason}',
  'plugins.availableDetails.versionDeprecatedSuffix': ' (elavult)',
  'plugins.availableDetails.versionYankedSuffix': ' (visszavonva)',
  'plugins.availableDetails.ref': 'Ref',
  'plugins.availableDetails.integrity': 'Integrity',
  'plugins.availableDetails.permissions': 'Engedélyek',
  'plugins.availableDetails.capabilitySummary': 'Képességek összefoglalása',
  'plugins.actions.copyInstallCommand': 'Telepítési parancs másolása',
  'plugins.actions.copyPluginId': 'Pluginazonosító másolása',
  'plugins.actions.copyReadmeBadge': 'README jelvény másolása',
  'plugins.actions.openSourceGithub': 'Forrás megnyitása GitHubon',
  'plugins.actions.openSource': 'Forrás megnyitása',
  'plugins.actions.openHomepage': 'Honlap megnyitása',
  'plugins.actions.openMarketplace': 'Megnyitás a piactéren',
  'app.brand': 'Open Design',
  'app.brandPill': 'Kutatási előzetes',
  'app.brandSubtitle': 'a Nexu Labs-tól',
  'app.welcomeLoading': 'Munkaterület betöltése…',
  'settings.welcomeKicker': '',
  'settings.welcomeTitle': 'Üdvözöljük az Open Designban',
  'settings.welcomeSubtitle': '',
  'settings.onboardingCreateTitle': 'Kezdés egy leírásból',
  'settings.onboardingCreateBody': 'Írja le a kívánt webhelyet, alkalmazást, prezentációt, képet vagy videót. Az Open Design létrehoz egy projektet, és a munkát szerkeszthetően tartja.',
  'settings.onboardingMemoryTitle': 'Munkakontextus mentése',
  'settings.onboardingMemoryBody': 'Adjon hozzá beállításokat, projekttényeket és visszatérő szabályokat, hogy a jövőbeli beszélgetések a megfelelő kontextust vegyék át.',
  'settings.onboardingMemoryCalloutTitle': 'Elmentve a Memóriájába',
  'settings.onboardingMemoryCalloutBody': 'Ezek a válaszok adják a Memória-profilja alapját. Az Open Design minden feladatnál újra felhasználja – és folyamatosan tanul, miközben dolgozik.',
  'settings.onboardingMemoryBenefitIntent': 'Egy rövid kérésből is megérti, mire gondol',
  'settings.onboardingMemoryBenefitFewerQuestions': 'Kihagyja az ismétlődő beállítási kérdéseket',
  'settings.onboardingMemoryBenefitPersonalized': 'A kimenetet a szerepéhez, közönségéhez és ízléséhez igazítja',
  'settings.onboardingSystemsTitle': 'Hozza a saját designrendszerét',
  'settings.onboardingSystemsBody': 'Válasszon vagy hozzon létre egy márkarendszert, hogy a generált munka valós színeket, tipográfiát és terméknyelvet kövessen.',
  'settings.onboardingExecutionTitle': 'Válasszon modellforrást',
  'settings.onboardingExecutionBody': 'Használja az Open Design Hosted szolgáltatást, csatlakoztasson helyi ügynököt, vagy adja meg saját modellkulcsát.',
  'settings.onboardingAmrCloudBenefitOfficial': 'Hivatalosan ajánlott',
  'settings.onboardingAmrCloudBenefitReady': 'Telepítés nélkül',
  'settings.onboardingAmrCloudBenefitModels': 'Érje el a Claude, GPT, Fable 5 és 5.6 sol modelleket időszakos kedvezménnyel és magas párhuzamossággal.',
  'settings.onboardingAmrCloudBenefitPricing': 'SOTA Harness',
  'settings.onboardingAmrCloudUpcomingLabel': 'Hamarosan',
  'settings.onboardingAmrCloudUpcomingImageVideo': 'Kép és videó',
  'settings.onboardingAmrCloudUpcomingSkills': 'Sok Skill',
  'settings.onboardingAmrCloudUpcomingRouting': 'Intelligens útválasztás',
  'settings.onboardingAmrModelSourceLabel': 'Open Design Hosted',
  'settings.onboardingAmrCloudAuthorizeAction': 'Open Design Cloud engedélyezése',
  'settings.onboardingAmrCloudAuthorizedAction': 'Engedélyezve',
  'settings.onboardingStepConnect': 'Connect',
  'settings.onboardingStepDesignSystem': 'Dizájnrendszer létrehozása',
  'settings.onboardingStepProfile': 'About you',
  'settings.onboardingStepNewsletter': 'Stay updated',
  'settings.onboardingNewsletterTitle': 'Stay in the loop',
  'settings.onboardingNewsletterBody': 'Get product updates, new templates, design-system drops, and ambassador work in your inbox. Optional — you can skip this.',
  'settings.onboardingConnectTitle': 'Choose a runtime',
  'settings.onboardingConnectBody': '',
  'settings.onboardingCloudTitle': 'Bejelentkezés az Open Designba',
  'settings.onboardingCloudBody': 'Jelentkezz be, és azonnal tervezz felhőalapú MI-vel – bonyolult beállítás nélkül.',
  'settings.onboardingCloudSignIn': 'Bejelentkezés az Open Designba',
  'settings.onboardingCloudContinue': 'Folytatás (bejelentkezve)',
  'settings.onboardingCloudAlternative': 'Helyi CLI vagy saját API-kulcs használata',
  'settings.onboardingCloudRights': 'Minden jog fenntartva.',
  'settings.onboardingCloudOr': 'vagy',
  'settings.onboardingGateTooltipNoRuntime': 'A következő lépések MI-n futnak — válassz futtatókörnyezetet a folytatáshoz.',
  'settings.onboardingGateTooltipAmr': 'A következő lépések MI-n futnak — jelentkezz be az Open Design Cloud-be a folytatáshoz.',
  'settings.onboardingGateTooltipLocal': 'A következő lépések MI-n futnak — válassz egy elérhető helyi CLI-t a folytatáshoz.',
  'settings.onboardingGateTooltipByok': 'A következő lépések MI-n futnak — add meg és teszteld a modellkulcsodat a folytatáshoz.',
  'settings.onboardingRecommended': 'Ajánlott',
  'settings.onboardingAmrCloudOfficialBadge': 'Hivatalos',
  'settings.onboardingLocalTitle': 'Helyi ügynök',
  'settings.onboardingLocalBody': 'Használja a Claude Code, Codex, Cursor, OpenCode, Kimi, Qwen, Hermes, Kiro és más eszközöket.',
  'settings.onboardingLocalAction': 'Open CLI settings',
  'settings.onboardingCliScanHint': 'This usually takes 5-10 seconds.',
  'settings.onboardingByokTitle': 'Saját kulcs használata',
  'settings.onboardingByokBody': 'Csatlakoztassa biztonságosan kedvenc modellszolgáltatóját a saját API-kulcsával.',
  'settings.onboardingByokAction': 'Open BYOK settings',
  'settings.onboardingDesignTitle': 'Design system',
  'settings.onboardingDesignBody': 'Generate once, reuse everywhere.',
  'settings.onboardingDesignIntroGenerateTitle': 'Generate from existing work',
  'settings.onboardingDesignIntroGenerateBody': 'Upload your design system from GitHub or local code repositories, Figma files, images, and other content assets.',
  'settings.onboardingDesignIntroReuseTitle': 'Reuse in future work',
  'settings.onboardingDesignIntroReuseBody': 'Future prototypes, slides, and other content can reference your existing fonts, spacing, logo style, and color tone.',
  'settings.onboardingDesignIntroSkipTitle': 'Optional for now',
  'settings.onboardingDesignIntroSkipBody': 'Skip this step if you want to start without generating a design system.',
  'settings.onboardingGithubTitle': 'Import from GitHub',
  'settings.onboardingGithubBody': 'Use a frontend repository.',
  'settings.onboardingUploadTitle': 'Upload local files',
  'settings.onboardingUploadBody': 'Add project files, screenshots, CSS, docs, or assets.',
  'settings.onboardingPromptTitle': 'Generate from prompt',
  'settings.onboardingPromptBody': 'Describe the product or brand.',
  'settings.onboardingProfileTitle': 'Rólad',
  'settings.onboardingProfileBody': 'Nem kötelező adatok a jobb alapbeállításokhoz.',
  'settings.onboardingRoleLabel': 'Szereped',
  'settings.onboardingOrgSizeLabel': 'Szervezet mérete',
  'settings.onboardingUseCaseLabel': 'Felhasználási cél',
  'settings.onboardingSourceLabel': 'Honnan hallottál rólunk?',
  'settings.onboardingSourceX': '🐦 X / Twitter',
  'settings.onboardingSourceGithub': '🐙 GitHub',
  'settings.onboardingSourceYoutube': '▶️ YouTube',
  'settings.onboardingSourceTiktok': '🎵 TikTok',
  'settings.onboardingSourceReddit': '👽 Reddit',
  'settings.onboardingSourceLinkedin': '💼 LinkedIn',
  'settings.onboardingSourceMetaSocial': '📸 Instagram / Threads / Facebook',
  'settings.onboardingSourceSearch': '🔍 Keresés (Google / Bing)',
  'settings.onboardingSourceAiTool': '🤖 AI-eszköz (ChatGPT / Perplexity)',
  'settings.onboardingSourceFriend': '👥 Barát vagy kolléga',
  'settings.onboardingSourceCommunity': '💬 Discord / közösség',
  'settings.onboardingSourceEmail': '✉️ E-mail / hírlevél',
  'settings.onboardingSourceBlog': '📝 Blog / cikk',
  'settings.onboardingSourceOther': '✨ Egyéb',
  'settings.onboardingSourceOtherPlaceholder': 'Írd meg, honnan (nem kötelező)',
  'settings.onboardingSelectPlaceholder': 'Válassz egyet',
  'settings.onboardingSelectMultiplePlaceholder': 'Válassz egyet vagy többet',
  'settings.onboardingOrgSolo': 'Egyedül / személyes (1)',
  'settings.onboardingOrgTeam': 'Kis csapat (2-10)',
  'settings.onboardingOrgStartup': 'Startup / kkv (11-50)',
  'settings.onboardingOrgGrowth': 'Növekvő vállalat (51-200)',
  'settings.onboardingOrgMidMarket': 'Közepes vállalat (201-1000)',
  'settings.onboardingOrgEnterprise': 'Nagyvállalat (1000+)',
  'settings.onboardingRolePm': '📋 Termékmenedzser',
  'settings.onboardingRoleDesigner': '🎨 Tervező',
  'settings.onboardingRoleEngineer': '💻 Mérnök',
  'settings.onboardingRoleMarketing': '📣 Marketing',
  'settings.onboardingRoleAgency': '📣 Marketingügynökség',
  'settings.onboardingRoleGrowth': '📈 Növekedés',
  'settings.onboardingRoleOps': '⚙️ Üzemeltetés',
  'settings.onboardingRoleFounder': '🚀 Alapító / vezető',
  'settings.onboardingRoleStudent': '🎓 Diák / oktató',
  'settings.onboardingRoleOther': '✨ Egyéb',
  'settings.onboardingUseProduct': '🎨 Terméktervezés',
  'settings.onboardingUseDesignSystem': '🧩 Dizájnrendszer',
  'settings.onboardingUsePrototype': '📱 Prototípus / alkalmazás UI',
  'settings.onboardingUseLanding': '🌐 Landing oldalak',
  'settings.onboardingUseAds': '📣 Hirdetések / közösségi tartalom',
  'settings.onboardingUseDashboard': '📊 Irányítópultok / belső eszközök',
  'settings.onboardingUseDeck': '🖥️ Prezentáció / diasor',
  'settings.onboardingUseMarketing': '📈 Marketing / növekedés',
  'settings.onboardingUseEngineering': '🤝 Fejlesztői átadás',
  'settings.onboardingUseAgency': '💼 Ügynökségi / ügyfélmunka',
  'settings.onboardingBack': 'Back',
  'settings.onboardingContinue': 'Continue',
  'settings.onboardingFinish': 'Finish setup',
  'settings.kicker': 'Beállítások',
  'settings.title': 'Modellek és szolgáltatók',
  'settings.subtitle': 'Válassz helyi CLI és BYOK között.',
  'settings.general': 'Általános',
  'settings.generalHint': 'Nyelv, megjelenés, értesítések, projekt-helyek, adatvédelem és alkalmazásadatok.',
  'settings.modeAria': 'Végrehajtási mód',
  'settings.protocolAria': 'API protokoll',
  'settings.modeDaemon': 'Helyi CLI',
  'settings.modeDaemonHelp': 'Futtatás a gépeden lévő code-agent CLI-n keresztül',
  'settings.modeDaemonOffline': 'A daemon nem fut',
  'settings.modeDaemonOfflineMeta': 'a daemon offline',
  'settings.modeDaemonInstalledMeta': '{count} telepítve',
  'settings.modeApi': 'API-szolgáltató',
  'settings.cloudCalloutTitle': 'Use Open Design Cloud',
  'settings.cloudCalloutBody': 'Sign in to the cloud version to enable team spaces, shared projects, member permissions, and the audit dashboard.',
  'settings.cloudCalloutButton': 'Sign in / Register',
  'settings.modeApiMeta': 'API-szolgáltatók',
  'settings.byokNoFileToolsNotice': 'A BYOK nem tud projektfájlokat olvasni, írni vagy szerkeszteni. Ha kódmódosításra van szüksége, használja a Local CLI-t.',
  'settings.byokDraftNotice': 'Töltsd ki a kötelező mezőket a szolgáltató mentéséhez. A jelenlegi beállítás aktív marad.',
  'settings.codeAgent': 'Kód Agent',
  'settings.codeAgentHint': 'A PATH átvizsgálásával észlelve. Válaszd ki a CLI-t, amelyen át a generálásokat szeretnéd futtatni.',
  'settings.rescan': '↻ Újraellenőrzés',
  'settings.rescanTitle': 'PATH újraellenőrzése',
  'settings.rescanRunning': 'Ellenőrzés...',
  'settings.rescanSuccess': 'Ellenőrzés kész. {count} elérhető.',
  'settings.designSystemRenameFailed': 'Az átnevezés sikertelen. Ellenőrizd a daemont, majd próbáld újra.',
  'settings.rescanFailed': 'Az ellenőrzés sikertelen. Ellenőrizd a daemont, majd próbáld újra.',
  'settings.test': 'Teszt',
  'settings.testTitle': 'Küldj egy apró tesztkérdést a kapcsolat ellenőrzéséhez',
  'settings.testRunning': 'Kapcsolat tesztelése…',
  'settings.byokReadyToTest': 'Tesztelésre kész',
  'settings.testCancel': 'Mégse',
  'settings.testRetry': 'Teszt újrapróbálása',
  'settings.required': 'kötelező',
  'settings.testMissingFields': 'Töltse ki a következőt a kapcsolat teszteléséhez: {fields}.',
  'settings.testSuccessApi': 'Csatlakozva. Válasz {ms} ms alatt — \'{sample}\'',
  'settings.testSuccessCli': '{agentName} {ms} ms alatt válaszolt — \'{sample}\'',
  'settings.testAuthFailed': 'A hitelesítés sikertelen. Ellenőrizd az API kulcsot.',
  'settings.testForbidden': 'A hozzáférés tiltott. Ellenőrizd a fiókot, régiót vagy szervezetet.',
  'settings.testNotFoundModel': 'A(z) \'{model}\' modell nem található ezen a végponton.',
  'settings.testInvalidModelId': 'A(z) \'{model}\' modellazonosító érvénytelen. Az egyéni azonosító betűvel vagy számmal kezdődjön, és ne tartalmazzon szóközt.',
  'settings.testInvalidBaseUrl': 'A Base URL érvénytelen vagy nem elérhető.',
  'settings.testRateLimited': 'A szolgáltató korlátozta a tesztet. A konfiguráció érvényesnek tűnik.',
  'settings.testUpstream': 'A szolgáltató {status} kódot adott vissza. Próbáld újra rövidesen.',
  'settings.testTimeout': 'A teszt {ms} ms után időtúllépéssel megszakadt.',
  'settings.testAgentMissing': 'A(z) {agentName} nincs telepítve vagy nincs a PATH-ban.',
  'settings.testAgentSpawn': 'Nem sikerült elindítani: {agentName} — {detail}.',
  'settings.testUnknown': 'Sikertelen teszt: {detail}',
  'settings.agentInstall.install': 'Telepítés',
  'settings.agentInstall.docs': 'Dokumentáció',
  'settings.agentInstall.pathHint': 'Ha npm-mel vagy Homebrew-val telepítettél egy CLI-t, de továbbra is nincs telepítve állapotban látszik, ellenőrizd, hogy az eszköz bin könyvtára benne van-e abban a PATH-ban, amit az Open Design daemon örököl (macOS-en a Terminal és a GUI appok PATH-ja eltérhet). Lásd a QUICKSTART.md "Local agent CLI and PATH" szakaszát.',
  'settings.agentInstall.stepOpenLinks': 'Nyisd meg a Telepítés vagy Dokumentáció hivatkozást a kívánt ügynöknél.',
  'settings.agentInstall.stepAuth': 'Hitelesíts a szolgáltató CLI-jében (bejelentkezés vagy API hitelesítő adatok megadása), mielőtt visszatérsz az Open Designhoz.',
  'settings.agentInstall.stepRescan': 'Kattints az Újraellenőrzés gombra ebben a szakaszban.',
  'settings.agentInstall.stepSelect': 'Válaszd ki az ügynök kártyáját, amint telepítettként jelenik meg.',
  'settings.noAgentsDetected': 'Még nincs észlelt ügynök. Telepítsd a Claude Code, Codex, Devin for Terminal, OpenCode, Cursor Agent, Qwen vagy GitHub Copilot CLI valamelyikét, majd kattints az Újraellenőrzésre.',
  'settings.agentInstalledGroup': 'Saját CLI-k ({count})',
  'settings.agentInstallGroup': 'Telepíthető ({count})',
  'settings.agentAuthRequired': 'Hitelesítés szükséges',
  'settings.agentAuthUnknown': 'A hitelesítési állapot ismeretlen',
  'settings.amrCloud': 'Open Design Cloud',
  'settings.amrAuthorize': 'Engedélyezés',
  'settings.amrBenefitOfficial': 'Officially maintained',
  'settings.amrBenefitLowerPrice': 'Lower price',
  'settings.amrBenefitManyModels': 'Számos modell',
  'settings.amrPromoBonus': 'Korlátozott bónusz: +100%',
  'settings.amrSignInToContinue': 'Jelentkezzen be a folytatáshoz',
  'settings.amrSignIn': 'Bejelentkezés',
  'settings.amrSignedIn': 'Bejelentkezve',
  'settings.amrWalletBalance': 'Wallet balance',
  'settings.amrWalletUnavailable': 'Balance temporarily unavailable',
  'settings.amrWalletUpdatedAt': 'Updated {time}',
  'settings.amrWalletCached': 'cached',
  'settings.amrWalletRefresh': 'Refresh',
  'settings.amrWalletRefreshTitle': 'Refresh Open Design Cloud wallet balance',
  'settings.amrNotSignedIn': 'Nincs bejelentkezve',
  'settings.amrSigningIn': 'Bejelentkezés…',
  'settings.amrActivationHint': 'Nem nyílt meg a bejelentkezési oldal? Az alábbi gombbal nyisd meg újra.',
  'settings.amrActivationBrowserFailed': 'A böngészőt nem sikerült automatikusan megnyitni. A folytatáshoz nyissa meg az alábbi bejelentkezési oldalt.',
  'settings.amrActivationOpen': 'Bejelentkezési oldal megnyitása',
  'settings.amrCancelSignIn': 'Bejelentkezés megszakítása',
  'settings.amrAccountStatus': 'Open Design Cloud fiók állapota',
  'settings.amrConsole': 'Kezelés',
  'settings.amrBalance': 'Keret',
  'settings.amrPlan': 'Csomag',
  'settings.amrUpgrade': 'Frissítés',
  'settings.amrModelUpgradeHint': 'Frissíts a használathoz',
  'settings.amrLoginErrorCompact': 'Az Open Design Cloud bejelentkezés sikertelen.',
  'settings.advanced': 'Speciális',
  'settings.amrLogin': 'Bejelentkezés',
  'settings.amrLogout': 'Kijelentkezés',
  'settings.amrLoggingIn': 'Bejelentkezés…',
  'settings.amrLoggingOut': 'Kijelentkezés…',
  'settings.amrLoggedInAs': 'Bejelentkezve mint {email}',
  'settings.amrLoggedInWithPlan': 'Bejelentkezve mint {email} · {plan}',
  'settings.amrLoggedInPill': 'Bejelentkezve',
  'settings.amrNotLoggedIn': 'Nincs bejelentkezve',
  'settings.apiSection': 'Anthropic API',
  'settings.quickFillProvider': 'Szolgáltató gyors kitöltése',
  'settings.providerPreset': 'Szolgáltatói előbeállítás',
  'settings.protocolGroupProtocols': 'Protokollok',
  'settings.protocolGroupGateways': 'Átjárók',
  'settings.customProvider': 'Egyéni szolgáltató',
  'settings.apiKey': 'API-kulcs',
  'settings.apiKeyGetLink': 'Kulcs beszerzése ↗',
  'settings.showKey': 'Kulcs megjelenítése',
  'settings.hideKey': 'Kulcs elrejtése',
  'settings.show': 'Megjelenítés',
  'settings.hide': 'Elrejtés',
  'settings.model': 'Modell',
  'settings.apiKeyInvalid': 'Érvénytelen API key.',
  'settings.apiKeyCleaned': 'Felesleges szóköz eltávolítva az API key-ből.',
  'settings.modelsLoadedFromAccount': '✓ {count} modell betöltve a fiókodból.',
  'settings.modelsLoadedCount': '✓ {count} modell betöltve.',
  'settings.modelSourceAccount': 'A fiókjából',
  'settings.modelSourceSuggested': 'Javasolt',
  'modelCapability.standard': 'Standard',
  'modelCapability.advanced': 'Advanced',
  'modelCapability.bestQuality': 'Best Quality',
  'modelCapability.standardDescription': 'Solid quality for regular tasks.',
  'modelCapability.advancedDescription': 'Stronger quality for more demanding tasks.',
  'modelCapability.bestQualityDescription': 'Best output quality for the most demanding work.',
  'modelCost.upToHalf': 'Alacsony költség',
  'modelCost.halfToOne': 'Közepes költség',
  'modelCost.oneToFour': 'Magas költség',
  'modelCost.overFour': 'Legmagasabb költség',
  'settings.fetchModels': 'Modellek lekérése',
  'settings.fetchModelsTitle': 'Elérhető modellek lekérése ettől a szolgáltatótól',
  'settings.fetchModelsRunning': 'Modellek lekérése…',
  'settings.fetchModelsMissingFields': 'Töltse ki a következőt a modellek lekéréséhez: {fields}.',
  'settings.fetchModelsInvalidBaseUrl': 'Adjon meg egy érvényes Base URL-t a modellek lekéréséhez.',
  'settings.fetchModelsUnsupportedAzure': 'Az Azure OpenAI üzemelési neveket használ, ezért a modellfelderítés itt nem érhető el.',
  'settings.fetchModelsUnsupportedOllama': 'Az Ollama Cloud modellfelderítés még nem érhető el. Válasszon vagy írjon be egy modellt.',
  'settings.fetchModelsSuccess': '{count} modell lekérve.',
  'settings.fetchModelsEmpty': 'Nem érkezett vissza kompatibilis szövegmodell.',
  'settings.fetchModelsUnsupported': 'A modellfelderítés nem érhető el ehhez a protokollhoz.',
  'settings.fetchModelsFailed': 'Nem sikerült lekérni a modelleket: {detail}',
  'settings.suggestedModelsHint': 'Ezek a protokollhoz javasolt modellek. A szolgáltatód más modelleket is támogathat.',
  'settings.baseUrl': 'Base URL',
  'settings.baseUrlInvalid': 'Használj nyilvános http:// vagy https:// URL-t.',
  'settings.baseUrlCustomize': 'URL testreszabása',
  'settings.baseUrlDefaultHint': 'Csak proxy vagy kompatibilis átjáró használatakor módosítsd.',
  'settings.azureBaseUrlPlaceholder': 'https://my-resource.openai.azure.com',
  'settings.azureBaseUrlHint': 'Ezt az Azure portálon találod → az erőforrásod → Endpoint.',
  'settings.azureDeploymentModel': 'Deployment név',
  'settings.azureCustomDeploymentName': 'Egyéni üzemelési név',
  'settings.azureDeploymentModelHint': 'Azure OpenAI esetén ez a mező a /openai/deployments/<model> deployment neveként szerepel. Add meg az Azure-ban létrehozott deployment nevét.',
  'settings.azureModelFetchHint': 'Add meg a telepítés nevét az Azure-erőforrásodból. Az Azure-telepítések nem kérhetők le automatikusan.',
  'settings.apiVersion': 'API-verzió',
  'settings.byokImageModel': 'Képgenerálási modell',
  'settings.byokVideoModel': 'Videógenerálási modell',
  'settings.byokVideoI2vHint': 'Kép-videó modell: referenciakép szükséges (különben a projekt legújabb képét használja automatikusan)',
  'settings.byokSpeechModel': 'Beszédmodell',
  'settings.byokSpeechVoice': 'Hang',
  'settings.byokModelDefaultOption': 'Alapértelmezett',
  'settings.maxTokens': 'Max tokenek (opcionális)',
  'settings.maxTokensHint': 'Maximális válaszhossz. Hagyd üresen a modell alapértelmezésének használatához.',
  'settings.apiHint': 'Helyben, ezen az eszközön tárolva.',
  'settings.skipForNow': 'Most kihagyom',
  'settings.getStarted': 'Kezdjük',
  'settings.envConfigure': 'Modellek és szolgáltatók',
  'settings.localCli': 'Helyi CLI',
  'settings.anthropicApi': 'Anthropic API',
  'settings.noAgentSelected': 'nincs kiválasztott ügynök',
  'settings.language': 'Nyelv',
  'settings.languageHint': 'A felület nyelvének váltása. Ebben a böngészőben mentve.',
  'settings.agentModelHead': 'Modell ehhez:',
  'settings.modelPicker': 'Modell',
  'settings.modelSourceLive': 'Élőben a CLI-ből',
  'settings.modelUsesCliDefault': 'CLI-alapértelmezés',
  'settings.modelSourceFallback': 'Beépített lista',
  'settings.reasoningPicker': 'Gondolkodási erőfeszítés',
  'settings.serviceTierPicker': 'Szolgáltatási szint',
  'settings.modelPickerHint': 'A CLI-tól kérdezi le, ha az közzéteszi a `models` parancsot. Az „Alapértelmezett" a CLI saját konfigjára bízza a választást; az „Egyedi…" tetszőleges, a CLI által elfogadott modell-id-t enged megadni.',
  'settings.modelPickerLiveHint': 'A modellek frissültek a telepített CLI-ből. Az Alapértelmezett továbbra is a CLI konfigurációját használja.',
  'settings.modelPickerLiveCatalogOnlyHint': 'A modellek frissültek a telepített CLI-ből.',
  'settings.modelPickerFallbackHint': 'A beépített alapértékek láthatók. Kattints az Újraellenőrzésre az élő CLI-modellek lekéréséhez.',
  'settings.cliEnvTitle': 'Speciális: proxy és egyéni útvonalak',
  'settings.cliEnvHint': 'Ezekkel írhatod felül a kiválasztott CLI környezetét: API-kulcsok, proxy base URL-ek, egyéni home-ok vagy nem szabványos bináris útvonalak. Base URL nélkül a CLI a saját alapértelmezett endpointját használja. A titkok a helyi alkalmazás-konfigurációban maradnak, és csak a kiválasztott CLI kapja meg őket.',
  'settings.cliEnvClaudeConfigDir': 'Claude Code konfigurációs könyvtár',
  'settings.cliEnvClaudeBaseUrl': 'Claude proxy Base URL',
  'settings.cliEnvClaudeApiKey': 'Claude CLI API-kulcs',
  'settings.cliEnvCodexHome': 'Codex könyvtár',
  'settings.cliEnvCodexBin': 'Codex futtatható fájl elérési útja',
  'settings.cliEnvCodexBaseUrl': 'Codex/OpenAI proxy Base URL',
  'settings.cliEnvCodexApiKey': 'Codex/OpenAI CLI API-kulcs',
  'settings.modelCustom': 'Egyedi (gépeld be alább)…',
  'settings.modelCustomLabel': 'Egyedi modell-id',
  'settings.modelCustomPlaceholder': 'pl. anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': 'Média-szolgáltatók',
  'settings.mediaProvidersHint': 'API-kulcsok kép-, videó- és hanggeneráláshoz. Helyben tárolva, és a helyi daemonnal szinkronizálva.',
  'settings.mcpServerTitle': 'Open Design MCP',
  'settings.mcpServerHint': 'Tedd elérhetővé az Open Designt MCP-szerverként a kódügynököd számára.',
  'settings.externalMcpTitle': 'Külső MCP',
  'settings.externalMcpHint': 'Adj hozzá MCP-eszközöket külső szolgáltatásokból (Higgsfield, GitHub, …).',
  'settings.mediaProviderApiKey': 'API-kulcs',
  'settings.mediaProviderBaseUrl': 'Bázis URL',
  'settings.mediaProviderConfigured': 'Beállítva',
  'settings.mediaProviderUnset': 'Nincs beállítva',
  'settings.mediaProviderClear': 'Törlés',
  'settings.mediaProviderClearConfirm': 'Törölni szeretnéd a mentett {name} beállításokat? A {name} használatához újra meg kell adnod azokat.',
  'settings.mediaProviderPlaceholder': 'API-kulcs beillesztése',
  'settings.mediaProviderBaseUrlPlaceholder': 'Alapértelmezett bázis URL felülírása',
  'settings.mediaProviderReload': 'Újratöltés a helyi démonból',
  'settings.mediaProviderReloadError': 'Nem sikerült újratölteni a médiaszolgáltatók beállításait a helyi démonból.',
  'settings.mediaProviderReloadSuccess': 'A médiaszolgáltatók beállításai újra lettek töltve a helyi démonból.',
  'settings.mediaProviderLoadError': 'Nem sikerült betölteni a médiaszolgáltatók beállításait a helyi démonból. Egyelőre a böngészőben mentett beállításokat használjuk.',
  'settings.mediaProviderComingSoonHint': 'Ezeket nyomon követjük az ütemtervben; a daemon még nem szállít klienst, így nincs mit konfigurálni.',
  'settings.privacy': 'Adatvédelem',
  'settings.privacyHint': 'Milyen adatokat osztunk meg az Open Design csapatával',
  'settings.privacyConsentKicker': 'Segíts jobbá tenni az Open Design alkalmazást',
  'settings.privacyConsentLead': 'A használati adatok megosztása segít megérteni, hogyan működik az Open Design valódi munkafolyamatokban, így az élményed szempontjából legfontosabb részeket fejleszthetjük.',
  'settings.privacyConsentFooter': 'Ezeket bármikor módosíthatod a Beállítások → Adatvédelem menüben.',
  'settings.privacyConsentShare': 'Megosztás',
  'settings.privacyConsentDecline': 'Ne ossza meg',
  'settings.privacyConsentAccept': 'Értem',
  'settings.privacyConsentBannerFooter': 'Az adatmegosztás alapértelmezetten be van kapcsolva. Bármikor kikapcsolhatod a Beállítások → Adatvédelem menüben.',
  'settings.privacyConsentPolicyLink': 'Adatvédelmi szabályzat elolvasása',
  'settings.privacyMetrics': 'Névtelen metrikák',
  'settings.privacyMetricsHint': 'Futtatások száma, Token-használat, hibaarány és időtartam alapvető használati mutatóként.',
  'settings.privacyContent': 'Conversation content',
  'settings.privacyContentHint': 'A titkok és más érzékeny információk eltávolítása után promptokat, asszisztensi válaszokat, eszközbemeneteket/-kimeneteket és a minőség-ellenőrzéshez szükséges kontextust használunk.',
  'settings.privacyInstallationId': 'Névtelen azonosító',
  'settings.privacyOptedOut': 'kikapcsolva',
  'settings.privacyDataDeletion': 'Adataim törlése',
  'settings.privacyDataDeletionHint': 'Lecseréli a névtelen azonosítódat, és leállítja a küldést. A meglévő nyomok a megőrzési szabályzatunk szerint évülnek el.',
  'settings.about': 'Névjegy',
  'settings.aboutHint': 'Verzió- és futtatókörnyezeti adatok',
  'settings.appVersion': 'Verzió',
  'settings.appChannel': 'Csatorna',
  'settings.appRuntime': 'Futtatókörnyezet',
  'settings.appPlatform': 'Platform',
  'settings.appArchitecture': 'Architektúra',
  'settings.runtimePackaged': 'Csomagolt alkalmazás',
  'settings.runtimeDevelopment': 'Fejlesztői',
  'settings.versionUnavailable': 'A verzió adatai nem érhetők el, amíg a daemon offline.',
  "settings.allowSilentUpdates": "Jövőbeli alkalmazáson belüli frissítések automatikus telepítése",
  "settings.allowSilentUpdatesDesc": "Ha alkalmazáson belüli frissítés kész, a következő indításkor automatikusan települ. A jelenlegi munkamenetet nem frissíti azonnal. A telepítős frissítések továbbra is előbb kérdeznek.",
  'settings.installLatest': 'Legújabb verzió telepítése',
  'settings.alreadyLatest': 'Ön már a legújabb verziót használja',
  'settings.updateCheck': 'Frissítések keresése',
  'settings.updateNow': 'Frissítés most',
  'settings.updateRecheck': 'Újra ellenőrzés',
  'settings.updateRetry': 'Újrapróbálás',
  'settings.updateViewReleases': 'Kiadási megjegyzések',
  'settings.updateActionFailed': 'Nem sikerült végrehajtani a frissítési műveletet.',
  'settings.updateQuitFailed': 'A telepítő megnyílt, de az Open Design nem tudott automatikusan kilépni.',
  'settings.updateStatusNotChecked': 'Még nincs ellenőrizve',
  'settings.updateStatusDevelopment': 'A fejlesztői buildek nem támogatják az alkalmazáson belüli frissítést.',
  'settings.updateStatusUnsupported': 'Ez a környezet nem támogatja az alkalmazáson belüli frissítést.',
  'settings.updateStatusChecking': 'Frissítések keresése...',
  'settings.updateStatusUpToDate': 'Már a legújabb verziót használod.',
  'settings.updateStatusAvailable': '{version} verzió megtalálva. Letöltés előkészítése.',
  'settings.updateStatusAvailableUnknown': 'Új verzió található. Letöltés előkészítése.',
  'settings.updateStatusDownloading': 'Frissítés letöltése...',
  'settings.updateStatusDownloadingPercent': 'Frissítés letöltése {percent}%.',
  'settings.updateStatusReady': 'A(z) {version} verzió telepítésre kész.',
  'settings.updateStatusReadyUnknown': 'A frissítés telepítésre kész.',
  'settings.updateStatusInstalling': 'Frissítés telepítése...',
  'settings.updateStatusFailed': 'Az ellenőrzés sikertelen. Próbáld újra.',
  'settings.mcpTitle': 'MCP szerver',
  'settings.mcpHint': 'Engedd, hogy a kódoló agentek (Cursor, Claude Code, VS Code…) közvetlenül olvassák az Open Design projektjeidet.',
  'settings.mcpDaemonError': 'Nem sikerült elérni a helyi daemont a telepítési útvonalak feloldásához ({error}). Győződj meg róla, hogy az Open Design fut, majd nyisd meg újra ezt a panelt.',
  'settings.mcpBuildDaemon': 'Először építsd fel a daemont.',
  'settings.mcpNodeMissing': 'A Node bináris fájl hiányzik.',
  'settings.mcpBuildHint': 'Az apps/daemon/dist/cli.js hiányzik. Futtasd a `pnpm --filter @open-design/daemon build` parancsot, majd frissíts.',
  'settings.mcpMethodCli': 'CLI parancs',
  'settings.mcpInstructionCli': 'Futtasd ezt a terminálodban.',
  'settings.mcpMethodToml': 'TOML konfiguráció',
  'settings.mcpInstructionCodex': 'Fűzd hozzá ezt a táblát a következőhöz: {path}. Ugyanazt a konfigurációt használja a Codex CLI és a Codex IDE-kiegészítő.',
  'settings.mcpMethodOneClick': 'Egykattintásos telepítés',
  'settings.mcpInstructionCursor': 'Kattints az „Install in Cursor” gombra a jóváhagyási párbeszédpanellel történő telepítéshez, vagy egyesítsd ezt a JSON-t a következővel: {path}.',
  'settings.mcpDeeplinkInstallCursor': 'Telepítés a Cursorba',
  'settings.mcpMethodJson': 'JSON konfiguráció',
  'settings.mcpInstructionKiro': 'Nyisd meg ezt: {path}, és egyesítsd ezt a JSON-t. Workspace-szintű konfigurációhoz használd: .kiro/settings/mcp.json.',
  'settings.mcpInstructionCopilot': 'Nyisd meg a Command Palette-et ({shortcut}), futtasd az „MCP: Open User Configuration” parancsot, és egyesítsd ezt a JSON-t. A Copilot Chatnek Agent módban kell lennie, hogy az eszközök megjelenjenek.',
  'settings.mcpInstructionAntigravity': 'Az Antigravityben: Agent panel "..." menü → MCP Servers → Manage MCP Servers → View raw config. Egyesítsd ezt a JSON-t.',
  'settings.mcpInstructionZed': 'Nyisd meg a Zed beállításait ({shortcut}), és egyesítsd ezt a legfelső szintű objektummal. A Zed a „context_servers” kulcsot használja, nem a „mcpServers” kulcsot.',
  'settings.mcpInstructionWindsurf': 'Nyisd meg ezt: {path} (vagy használd az MCPs ikont a Cascade-ben → Configure), majd egyesítsd:',
  'settings.mcpCopyAria': 'MCP konfigurációs részlet másolása',
  'settings.mcpResolvingFailed': '# az útvonalak feloldása sikertelen, lásd a fenti hibát',
  'settings.mcpLoadingPaths': '# telepítési útvonalak betöltése a helyi daemonból…',
  'settings.mcpCopied': 'Másolva',
  'settings.mcpCopy': 'Másolás',
  'settings.mcpCursorApproval': 'A Cursor megjelenít egy jóváhagyási párbeszédpanelt a konfiguráció írása előtt.',
  'settings.mcpCodexOneClickInstall': 'Telepítés a Codexbe',
  'settings.mcpCodexOneClickUninstall': 'Eltávolítás a Codexből',
  'settings.mcpCodexOneClickUnavailable': 'A Codex CLI nem található a PATH-on — telepítsd a Codexet, vagy illeszd be a kódrészletet manuálisan.',
  'settings.mcpCodexInstallSuccess': 'Telepítve. Indítsd újra a Codexet az új szerver betöltéséhez.',
  'settings.mcpCodexUninstallSuccess': 'Eltávolítva a Codexből.',
  'settings.mcpCodexBusy': 'Dolgozom…',
  'settings.mcpCodexInstallError': 'A művelet sikertelen: {error}',
  'settings.mcpRestartNote': 'Indítsd újra a klienst az új szerver betöltéséhez.',
  'settings.mcpRestartDetail': 'A legtöbb szerkesztő csak indításkor tölti be az MCP szervereket. A Cursor / VS Code / Antigravity / Windsurf esetén a teljes újraindítás helyett futtathatod a `Developer: Reload Window` parancsot a parancspalettáról. A Zed és a Claude Code esetén ki kell lépni és újra meg kell nyitni.',
  'settings.mcpCapabilitiesTitle': 'Mit tehet az Agented',
  'settings.mcpCapabilityRead': 'Bármilyen fájl olvasása vagy keresése egy projektben (HTML, JSX, CSS, JSON, SVG, Markdown).',
  'settings.mcpCapabilityPull': 'Egy designcsomag lekérése egyetlen hívással: a belépési fájl, valamint minden CSS-változó, komponens és betűtípus, amelyre hivatkozik.',
  'settings.mcpCapabilityDefault': 'Alapértelmezésként az Open Designban éppen megnyitott projektet és fájlt használja, így mondhatod, hogy „építsd ezt meg az alkalmazásomban” anélkül, hogy újra meg kellene adnod, melyik designról van szó.',
  'settings.mcpRunningNote': 'Az Open Designnak futnia kell az MCP eszközhívások sikeréhez. Ha azelőtt indítottad el a kódoló Agentet, hogy megnyitottad volna az Open Designt, indítsd újra az Agentet, hogy elérje az élő daemont.',
  'entry.tabDesigns': 'Tervek',
  'entry.tabTemplates': 'Sablonok',
  'entry.tabDesignSystems': 'Designrendszerek',
  'entry.tabConnectors': 'Kapcsolók',
  'entry.openSettingsTitle': 'Beállítások',
  'entry.openSettingsAria': 'Beállítások megnyitása',
  'entry.discordLabel': 'Csatlakozás a Discordhoz',
  'entry.discordAria': 'Csatlakozás az Open Design Discordhoz',
  'entry.discordAriaWithOnline': 'Csatlakozás az Open Design Discordhoz - {online}',
  'entry.discordOnlineLabel': '{count} online',
  'entry.mailAria': 'E-mail küldése az Open Designnak',
  'entry.accountSettings': 'Beállítások',
  'chat.collapsePane': 'Beszélgetéspanel összecsukása',
  'collabPresence.ariaOne': '1 collaborator online',
  'collabPresence.aria': '{count} collaborators online',
  'collabPresence.ariaWithSelfOne': '1 collaborator online, including you',
  'collabPresence.ariaWithSelf': '{count} collaborators online, including you',
  'collabPresence.moreOnline': '{count} more online',
  'collabPresence.dialogTitle': 'Online collaborators',
  'collabPresence.onlineCount': '{count} online',
  'collabPresence.selfBadge': 'You',
  'collabPresence.roleOwner': 'Owner',
  'collabPresence.roleAdmin': 'Admin',
  'collabPresence.roleMember': 'Member',
  'collabPresence.viewingFileSelf': 'You are viewing {file}',
  'collabPresence.viewingFileOther': 'Viewing {file}',
  'collabPresence.viewingProjectSelf': 'You are viewing this project',
  'collabPresence.viewingProjectOther': 'Viewing this project',
  'entry.followXLabel': 'Kövesd a @OpenDesignHQ fiókot az X-en',
  'entry.followThreadsLabel': 'Follow Open Design on Threads',
  'entry.youtubeLabel': 'Open Design on YouTube',
  'entry.followInstagramLabel': 'Kövesd a @opendesign.ai fiókot az Instagramon',
  'entry.followLinkedinLabel': 'Kövesd az Open Designt a LinkedInen',
  'entry.followXiaohongshuLabel': 'Kövesd az Open Designt a Xiaohongshun',
  'entry.resizeAria': 'Oldalsáv átméretezése',
  'entry.loadingWorkspace': 'Munkaterület betöltése…',
  'entry.useEverywhereTitle': 'Használat bárhol',
  'entry.useEverywhereAria': '„Használat bárhol” útmutató megnyitása (CLI, MCP, HTTP, Skills)',
  'entry.workspaceTeamsLabel': 'Teams',
  'workspaceSwitcher.team': 'Team',
  'workspaceSwitcher.invite': 'Invite colleague',
  'workspaceSwitcher.createTeam': 'New team',
  "workspaceSwitcher.draftsTooltip": "Személyes projektek",
  "workspaceSwitcher.allProjectsTooltip": "Csapatprojektek",
  "entry.primaryNavAria": "Primary",
  "entry.billingTierTeam": "Teams",
  "entry.billingTierFree": "Free",
  "entry.billingTierPro": "Pro",
  "entry.billingFamilyCreator": "Creator",
  "entry.upgradeTitle": "Upgrade plan",
  "entry.upgradeCreditsExhaustedTitle": "Credits exhausted",
  "entry.upgradeAutoRechargeTitle": "Auto recharge",
  "entry.upgradeDialogAria": "Upgrade plan",
  "entry.upgradeSubtitle": "Upgrade to a higher plan to increase your quota immediately. The charge is prorated for the current billing cycle.",
  "entry.upgradeCreditsExhaustedSubtitle": "You need more credits to continue. Upgrade to a higher plan to increase your quota immediately. The charge is prorated for the current billing cycle.",
  "entry.upgradeAutoRechargeMemberSubtitle": "Enable a separate allowance for {member}. Saving this setting will not charge immediately; credits refill only when this member falls below the threshold.",
  "entry.upgradeAutoRechargeTeamSubtitle": "Enable an allowance for all teammates. Saving this setting will not charge immediately; team credits refill only when the balance falls below the threshold.",
  "entry.upgradeScopeLabel": "Scope",
  "entry.upgradeScopeMember": "{member} · single-member allowance",
  "entry.upgradeScopeTeam": "All teammates · shared allowance",
  "entry.upgradePaymentHint": "Uses the subscription payment method by default. You can manage it anytime.",
  "entry.upgradeManagePayment": "Manage payment method",
  "entry.upgradeMonthlyLimit": "Monthly limit",
  "entry.upgradeLimitCustom": "",
  "entry.upgradeLimitUnlimited": "∞ unlimited (no monthly cap)",
  "entry.upgradeBillingCycleAria": "Billing cycle",
  "entry.upgradeAnnual": "Annual",
  "entry.upgradeAnnualSave": "Save 20%",
  "entry.upgradeMonthly": "Monthly",
  "entry.upgradePlanPlus": "Personal Plus",
  "entry.upgradePlanPlusDesc": "Basic token allowance · SOTA models",
  "entry.upgradePlanPro": "Personal Pro",
  "entry.upgradePlanProDesc": "3x token allowance · top multimodal models",
  "entry.upgradePlanMax": "Personal Max",
  "entry.upgradePlanMaxDesc": "10x token allowance · top multimodal models",
  "entry.upgradePlanTeam": "Teams",
  "entry.upgradePlanTeamDesc": "Collaboration · shared assets · role permissions",
  "entry.upgradePriceUnitMonth": "/mo",
  "entry.upgradePriceUnitSeat": "/seat/mo",
  "entry.upgradeProrateAnnualPrefix": "Annual billing saves 20%; ",
  "entry.upgradeProrateMonthlyPrefix": "Monthly billing; ",
  "entry.upgradeProrateSuffix": "upgrades are prorated for the current billing cycle and take effect immediately.",
  "entry.upgradeBack": "Back",
  "entry.upgradeAutoRechargeSaved": "Auto recharge settings saved",
  "entry.upgradeConfirm": "Confirm payment and upgrade",
  "entry.creditsAria": "{tier} · credits remaining",
  "entry.creditsAriaWithBalance": "{tier} · {balance} credits remaining",
  "entry.creditsGrantTip": "Teams credits are granted by subscription allowance. Usage is available in billing.",
  "entry.creditsUpgrade": "Upgrade",
  "entry.creditsOpening": "Opening...",
  "entry.creditsRemaining": "Credits remaining",
  "entry.credits": "Keret",
  "entry.creditsUsage": "View usage",
  "entry.creditsMemberNoticeTitle": "Need more credits?",
  "entry.creditsMemberNoticeBody": "You are currently a Member and cannot add credits yourself. Ask a team Admin to increase the allowance when you need more.",
  "entry.creditsMemberNoticeAction": "Ask Admin to increase allowance",
  "entry.accountToggleTheme": "Toggle theme",
  "entry.accountSwitchLanguage": "Switch language",
  "entry.accountLanguageMeta": "中文 / English",
  "entry.accountGithubHelp": "Get help on GitHub",
  "entry.accountFeatureRequest": "Submit feature request",
  "entry.accountAddAccount": "Add account",
  "entry.accountSignOut": "Sign out",
  "signOut.confirmTitle": "Kijelentkezés",
  "signOut.confirmMessage": "Biztosan ki szeretne jelentkezni?",
  "signOut.confirmAction": "Kijelentkezés",
  "entry.navRecents": "Kezdőlap",
  "entry.navDashboard": "Dashboard",
  "entry.blankDraftsTitle": "Start a private draft",
  "entry.blankDraftsDescription": "Create a project here first. It stays private until you move it into the team space.",
  "entry.blankAllProjectsTitle": "No team projects yet",
  "entry.blankAllProjectsDescription": "Projects shared to the team will appear here for everyone in the workspace.",
  "entry.blankCreate": "New project",
  'entry.workspaceTeamsTitle': 'Workspace csapatoknak — mondd el, mire van szüksége a csapatodnak',
  'entry.workspaceTeamsAria': 'A „Workspace csapatoknak” oldal megnyitása',
  'entry.navExpand': 'Oldalsáv kibontása',
  'entry.navCollapse': 'Oldalsáv összecsukása',
  'entry.navNewProject': 'Új projekt',
  'entry.navHome': 'Kezdőlap',
  'entry.navProjects': 'Projektek',
  'entry.navTasks': 'Automatizálások',
  'entry.navPlugins': 'Pluginok',
  'entry.navDesignSystems': 'Tervezőrendszerek',
  'entry.navBrands': 'Márkacsomag',
  'entry.navIntegrations': 'Integrációk',
  'entry.navMembers': 'Members',
  'entry.navWorkspaceSettings': 'Workspace settings',
  'entry.navDrafts': 'Személyes projektek',
  'entry.navAllProjects': 'Csapatprojektek',
  'entry.draftsDescription': 'Projects you created, visible only to you',
  'entry.allProjectsDescription': 'Projects owned by everyone on the team',
  'entry.navBoard': 'Board',
  'entry.navTeamSection': 'Team',
  'entry.teamSlotNote': 'This space is provided by the team service. Integration is in progress.',
  "entry.cloudCalloutTitle": "Open Design Cloud",
  "entry.cloudCalloutBody": "Jelentkezzen be az Open Design Cloud használatához és a felhőalapú együttműködéshez",
  "entry.cloudCalloutDismissAria": "Open Design Cloud értesítés bezárása",
  'entry.workspaceLockedNote': 'This workspace is locked. Restore billing to resume editing shared projects.',
  'entry.workspaceLockedRecover': 'Restore access',
  'messageCenter.openAria': 'Open message center',
  'messageCenter.unreadCount': '{count} unread',
  'messageCenter.title': 'Message center',
  'messageCenter.subtitle': 'Open Design updates, platform announcements, and account notices.',
  'messageCenter.filterAll': 'All',
  'messageCenter.filterUnread': 'Unread',
  'messageCenter.filterRead': 'Read',
  'messageCenter.markAllRead': 'Mark all read',
  'messageCenter.emptyAllTitle': 'No messages yet',
  'messageCenter.emptyUnreadTitle': 'All caught up',
  'messageCenter.emptyReadTitle': 'No read messages',
  'messageCenter.emptyBody': 'New platform messages will appear here.',
  'messageCenter.close': 'Close message center',
  'messageCenter.desktopSettings': 'Desktop notification settings',
  'messageCenter.desktopSettingsHint': 'Task completion sounds and system notifications stay in Settings.',
  'workspaceTabs.project': 'Projekt',
  'workspaceTabs.pluginDetails': 'Plugin részletei',
  'workspaceTabs.marketplace': 'Marketplace',
  'homeHero.title': 'Mit tervezel ma az ügynököddel?',
  'homeHero.startWithTemplate': 'Kezdés sablonnal…',
  'homeHero.startBlankProject': 'kezdj egy üres projektet',
  'homeHero.templatePicker.label': 'Alkotás típusa',
  'homeHero.templatePicker.searchPlaceholder': 'Sablonok keresése',
  'homeHero.templatePicker.projectTypes': 'Projekttípusok',
  'homeHero.templatesScrollHint': 'Görgess felfelé további sablonokért',
  'homeHero.templatesCollapse': 'Sablonok összecsukása',
  'homeHero.subtitlePrefix': 'A forráskóddal elérhető Claude Design alternatíva.',
  'homeHero.placeholder': 'Írd le, mit szeretnél generálni…',
  'homeHero.placeholderActive': 'Szerkeszd a példalekérdezést, vagy írj sajátot…',
  'homeHero.carousel.hint': 'Csatolj egy fájlt, kapcsold össze a dizájnrendszered, vagy írd le, mit szeretnél készíteni',
  'homeHero.carousel.onePageBrief': 'Egyoldalas projektösszefoglaló írása',
  'homeHero.carousel.notesToDeck': 'Jegyzeteim átalakítása prezentációvá',
  'homeHero.carousel.signupFlow': 'Regisztrációs folyamat megtervezése',
  'homeHero.carousel.improveBrief': 'Meglévő projektösszefoglaló javítása',
  'homeHero.carousel.loadingAnimation': 'Betöltési animáció készítése',
  'homeHero.carousel.teamUpdateSlides': 'Diák tervezése csapatfrissítéshez',
  'homeHero.carousel.ordersDashboard': 'Rendeléskövető irányítópult prototípusa',
  'homeHero.carousel.productDetail': 'Termékadatlap elrendezése',
  'homeHero.carousel.caseStudy': 'Esettanulmány vázlata',
  'homeHero.carousel.landingIntro': 'Rövid bevezető tervezése egy landing oldalhoz',
  'homeHero.carousel.pitchDeck': 'Pitch deck készítése új termékhez',
  'homeHero.carousel.appIdea': 'Egy alkalmazásötlet leírása',
  'homeHero.carousel.landingLayout': 'Landing oldal elrendezésének felvázolása',
  'homeHero.skills': 'Skillek',
  'homeHero.addMenu': 'Kontextus hozzáadása',
  'homeHero.addPlugin': 'Bővítmény hozzáadása',
  'homeHero.addConnectors': 'Csatlakozók hozzáadása',
  'homeHero.addMcp': 'MCP-kiszolgáló hozzáadása',
  'homeHero.noPlugins': 'Nincs telepített bővítmény',
  'homeHero.noMcp': 'Nincs MCP-kiszolgáló',
  'homeHero.noConnectors': 'Nincs csatlakoztatott csatlakozó',
  'homeHero.applying': 'Alkalmazás…',
  'homeHero.pluginTitle': 'Plugin: {title}',
  'homeHero.pluginPrefix': 'Plugin: {title}',
  'homeHero.skillPrefix': 'Skill: {title}',
  'homeHero.removePlugin': 'Plugin eltávolítása',
  'homeHero.removePluginAria': '{title} plugin eltávolítása',
  'homeHero.clearActivePlugin': 'Aktív plugin törlése',
  'homeHero.clearActiveSkill': 'Aktív skill törlése',
  'homeHero.contextItemsResolved': '{n} kontextuselem feloldva',
  'homeHero.removeFile': 'Fájl eltávolítása',
  'homeHero.contextSearchResults': 'Kontextuskeresés eredményei',
  'homeHero.contextSurfaces': 'Kontextusfelületek',
  'homeHero.loadingContext': 'Kontextus betöltése…',
  'homeHero.noResults': 'Nincs találat erre: "{query}".',
  'homeHero.searchPrompt': 'Fájlok, pluginok, skillek, MCP-szerverek és összekötők keresése.',
  'homeHero.parameters': '{n} paraméter',
  'homeHero.details': 'Részletek',
  'homeHero.toRun': 'a futtatáshoz',
  'homeHero.forNewLine': 'új sorhoz',
  'homeHero.run': 'Futtatás',
  'homeHero.typeSomethingToRun': 'Írj be valamit a futtatáshoz',
  'homeHero.promptExamples': 'Példák',
  'homeHero.footer.designSystem': 'Stílus',
  'homeHero.footer.autoDesignSystem': 'Automatikus',
  'homeHero.footer.autoDesignSystemSummary': 'Automatikusan kiválasztja az aktuális prompthoz illő designrendszert és vizuális stílust.',
  'homeHero.footer.ratio': 'Arány',
  'homeHero.footer.duration': 'Időtartam',
  'homeHero.footer.resolution': 'Felbontás',
  'homeHero.footer.speakerNotes': 'Jegyzetek',
  'homeHero.footer.noSpeakerNotes': 'Nincs jegyzet',
  'homeHero.footer.availableCount': '{n} elérhető',
  'homeHero.footer.noMatches': 'Nincs találat',
  'homeHero.moreShortcuts': 'Továbbiak',
  'homeHero.railAria': 'Válassz projektkategóriát vagy kezdő gyorsindítót',
  'homeHero.subTypeAria': 'Válassz altípust',
  'homeHero.subTypeMore': 'Több',
  'homeHero.confirmReplaceTitle': 'Lecseréled a jelenlegi promptot?',
  'homeHero.confirmReplaceBody': 'A(z) {title} használata lecseréli a beviteli mezőben jelenleg lévő szöveget.',
  'homeHero.confirmReplace': 'Csere',
  'homeHero.chip.prototype': 'UI Mockup',
  'homeHero.chip.webClone': 'Weboldal-klón',
  'homeHero.chip.liveArtifact': 'Élő artifact',
  'homeHero.chip.deck': 'Diasor',
  'homeHero.chip.image': 'Kép',
  'homeHero.chip.video': 'Videó',
  'homeHero.chip.hyperframes': 'HyperFrames',
  'homeHero.chip.webgl': 'WebGL élmény',
  'homeHero.chip.webglDesc': 'Shaderek, 3D és generatív GPU vizuálok',
  'homeHero.chip.worker': 'Worker vizualizáló',
  'homeHero.chip.workerDesc': 'Szálon kívüli szimulációk, részecskék és adatvizualizáció',
  'homeHero.chip.audio': 'Hang',
  'homeHero.chip.createBrandKit': 'Márkacsomag létrehozása',
  'homeHero.chip.createPlugin': 'Plugin létrehozása',
  'homeHero.chip.figma': 'Figmából',
  'homeHero.chip.folder': 'Mappából',
  'homeHero.chip.template': 'Sablonból',
  'homeHero.chip.liveArtifactHint': 'Készíts interaktív HTML/CSS/JS artifactot, amelyet élőben előnézhetsz.',
  'homeHero.chip.hyperframesHint': 'Hozz létre HTML-alapú animációt: feliratok, hangra reagáló vizuálok, jelenetátmenetek.',
  'homeHero.chip.createBrandKitHint': 'Készíts márkacsomagot egy webhelyből, majd alkalmazd bármelyik csevegésben.',
  'homeHero.chip.createPluginHint': 'Hozz létre újrafelhasználható Open Design plugint, és add hozzá a Saját pluginjaimhoz.',
  'homeHero.chip.figmaHint': 'Migrálj egy Figma frame-et az aktív tervezőrendszerbe.',
  'homeHero.chip.folderHint': 'Importálj egy meglévő helyi mappát, és folytasd a szerkesztést.',
  'homeHero.chip.templateHint': 'Indulj egy beépített sablonból.',
  'homeHero.chip.wireframe': 'Wireframe',
  'homeHero.chip.mobile': 'Mobile app',
  'homeHero.chip.document': 'Document',
  'homeHero.chip.prototypeDesc': 'Interactive app mockups',
  'homeHero.chip.webCloneDesc': 'Source-first site reproduction',
  'homeHero.chip.wireframeDesc': 'Lo-fi screens & flows',
  'homeHero.chip.mobileDesc': 'iOS & Android screens',
  'homeHero.chip.deckDesc': 'Presentations & pitch decks',
  'homeHero.chip.documentDesc': 'Resumes, reports & PDFs',
  'homeHero.chip.imageDesc': 'Posters, graphics & art',
  'homeHero.chip.videoDesc': 'Clips, reels & promos',
  'homeHero.chip.audioDesc': 'Voiceovers, music & SFX',
  'homeHero.chip.hyperframesDesc': 'Motion graphics & loops',
  'homeHero.chip.liveArtifactDesc': 'Data-backed live dashboards',
  'homeHero.chip.createBrandKitDesc': 'Extract a brand design system',
  'homeHero.chip.prototypeNext': 'Open a chat that builds a high-fidelity, clickable web prototype you refine turn by turn.',
  'homeHero.chip.webCloneNext': 'Open a chat that asks for a target URL, reconstructs the site, and audits the clone.',
  'homeHero.chip.wireframeNext': 'Open a chat that sketches lo-fi screens and flows to validate structure first.',
  'homeHero.chip.mobileNext': 'Open a chat that lays out mobile screens for iOS and Android.',
  'homeHero.chip.deckNext': 'Open a chat that builds a slide deck you can present and export.',
  'homeHero.chip.documentNext': 'Open a chat that drafts a polished document — resume, report, or PDF.',
  'homeHero.chip.imageNext': 'Open a chat that generates on-brand images you can iterate on.',
  'homeHero.chip.videoNext': 'Open a chat that produces a short video you can refine.',
  'homeHero.chip.audioNext': 'Open a chat that creates voiceover, music, or sound effects.',
  'homeHero.chip.webClonePromptSeed': 'Website URL to clone: ',
  'homeWorkingDir.trigger': 'Select working directory',
  'homeWorkingDir.triggerShort': 'Working directory',
  'homeWorkingDir.pick': 'Choose folder',
  'homeWorkingDir.replace': 'Change working directory',
  'homeWorkingDir.recent': 'Recent folders',
  'homeWorkingDir.recentEmpty': 'No recent folders',
  'homeWorkingDir.clear': 'Remove working directory',
  'homeWorkingDir.hint': 'Let the agent read this local folder (not imported into Design Files)',
  'homeWorkingDir.missing': 'This working folder no longer exists — pick another',
  'homeWorkingDir.applyFailed': 'Couldn\'t set the working directory — the folder may no longer exist',
  'workingDirPicker.title': 'Mappa',
  'workingDirPicker.homeTitle': 'Helyi tárhelyen mentve – kattints mappa választásához',
  'workingDirPicker.processing': 'Feldolgozás…',
  'workingDirPicker.select': 'Helyi tárhely',
  'workingDirPicker.clearAria': 'Munkakönyvtár törlése',
  'workingDirPicker.replaceFailed': 'A munkakönyvtár cseréje nem sikerült',
  'workingDirPicker.unavailable': 'A mappaválasztó nem érhető el ebben a buildben. Mappa kiválasztásához futtasd az asztali alkalmazást.',
  'workingDirPicker.openUnavailable': 'Nyisd meg ezt a projektet az asztali alkalmazásban a mappa megjelenítéséhez.',
  'workingDirPicker.openFailed': 'A mappa nem jeleníthető meg',
  'workingDirPicker.showInFileManager': 'Megjelenítés a fájlkezelőben',
  'workingDirPicker.replace': 'Mappa választása…',
  'workingDirPicker.recent': 'Legutóbbi könyvtárak',
  'workingDirPicker.defaultLabel': 'Helyi tárhely',
  'handoff.toTarget': 'Átadás ide: {target}',
  'handoff.openInTarget': 'Megnyitás itt: {target}',
  'handoff.openAction': 'Megnyitás',
  'handoff.menuTitle': 'Melyik szerkesztőben nyissuk meg?',
  'handoff.action': 'Átadás',
  'handoff.fallbackTitle': 'Nem található szerkesztő a $PATH útvonalon – megnyitás itt: {target}',
  'handoff.chooseTargetAria': 'Válassz átadási célt',
  'handoff.optionsAria': 'Átadási beállítások',
  'handoff.editorSection': 'Megnyitás szerkesztővel',
  'handoff.cliSection': 'Másolás CLI-hez',
  'handoff.clickOpen': 'Kattints a megnyitáshoz',
  'handoff.framework': 'Kódkeretrendszer',
  'handoff.framework.react': 'React',
  'handoff.framework.vue': 'Vue.js',
  'handoff.framework.svelte': 'Svelte',
  'handoff.framework.solid': 'SolidJS',
  'handoff.framework.next': 'Next.js',
  'handoff.framework.vanilla': 'JS',
  'handoff.frameworkPrompt.react': 'React',
  'handoff.frameworkPrompt.vue': 'Vue.js',
  'handoff.frameworkPrompt.svelte': 'Svelte',
  'handoff.frameworkPrompt.solid': 'SolidJS',
  'handoff.frameworkPrompt.next': 'Next.js / React',
  'handoff.frameworkPrompt.vanilla': 'vanilla JavaScript, HTML és CSS',
  'handoff.amrWebsite': 'Open Design Cloud webhely megnyitása',
  'handoff.copyPrompt': 'Prompt másolása',
  'handoff.copyPromptForTarget': 'Prompt másolása ehhez: {target}',
  'handoff.copied': 'Másolva',
  'handoff.projectPathUnavailable': 'A projekt útvonala még betöltődik. Próbáld újra egy pillanat múlva.',
  'handoff.copyFailed': 'A vágólapra írás le lett tiltva. Próbáld újra egy pillanat múlva.',
  'handoff.promptIntro': 'Folytatás ebből a helyi Open Design projektmappából:',
  'handoff.promptTarget': 'Cél',
  'handoff.promptCli': 'CLI',
  'handoff.promptStepsLead': 'Te veszed át a munkát itt: {cli}. Kérlek:',
  'handoff.promptReadFiles': 'Először lépj be ebbe a könyvtárba, vagy olvasd be. Részesítsd előnyben a DESIGN.md, README, meglévő HTML/CSS/JS, eszközök és a package.json fájlokat, ha vannak.',
  'handoff.promptKeepDesign': 'Őrizd meg a jelenlegi vizuális megjelenést, elrendezést, interakciókat és eszközöket. Ne állj meg egy tervnél.',
  'handoff.promptProduceCode': 'Generálj vagy módosíts valódi, futtatható {framework} kódot. Ha a projektnek már van egyértelműbb technológiai készlete, jelezd az ütközést, és tartsd futtathatóan az eredményt.',
  'handoff.promptVerify': 'Végezetül add meg a futtatáshoz, az előnézethez és az ellenőrzéshez szükséges parancsokat.',
  'handoff.promptCommandHint': 'A projektkönyvtárból való indításhoz használd ezt:',
  'handoff.promptProject': 'Projekt',
  'handoff.promptProjectId': 'Projektazonosító',
  'handoff.notInstalled': 'Nincs telepítve',
  'handoff.notDetectedTitle': '{target} – nem észlelhető a $PATH útvonalon',
  'designSystemPicker.select': 'Válassz tervezési rendszert',
  'designSystemPicker.loading': 'Design rendszerek betöltése…',
  'designSystemPicker.searchPlaceholder': 'Tervezési rendszerek keresése (cím / kategória / összegzés)',
  'designSystemPicker.searchCompactPlaceholder': 'Tervezési rendszerek keresése',
  'designSystemPicker.noneTitle': 'Nincs tervezési rendszer',
  'designSystemPicker.noneSummary': 'Hagyd, hogy a modell szabadon válasszon',
  'designSystemPicker.empty': 'Nincs egyező tervezési rendszer',
  'designSystemPicker.openPreview': 'Előnézet megnyitása',
  'designSystemPicker.loadingPreview': 'Előnézet betöltése…',
  'designSystemPicker.noPreview': 'Nincs előnézeti oldal. Nyisd meg a Tervezési rendszereket a teljes előnézet megtekintéséhez.',
  'designSystemPicker.previewHint': 'Vigyél az egeret egy tervezési rendszer fölé az előnézethez',
  'designSystemPicker.fullscreenAria': '{title} teljes képernyős előnézet',
  'designSystemPicker.closeFullscreen': 'Teljes képernyős előnézet bezárása',
  'designSystemPicker.closeEsc': 'Bezárás (Esc)',
  'designSystemPicker.previewFrameTitle': '{title} előnézet',
  'designSystemPicker.fullscreenFrameTitle': '{title} teljes képernyős előnézet',
  'recentProjects.title': 'Legutóbbi projektek',
  'recentProjects.viewAll': 'Összes megtekintése',
  'recentProjects.empty': 'Még nincsenek projektek — írj egy promptot az elsőhöz.',
  'recentProjects.ownerAll': 'All',
  'recentProjects.ownerMine': 'Mine',
  'recentProjects.ownerOthers': 'Others',
  'recentProjects.kindAll': 'Any type',
  'recentProjects.kindPrototype': 'Prototype',
  'recentProjects.kindSlides': 'Slides',
  'recentProjects.kindMedia': 'Media',
  'recentProjects.kindOther': 'Other',
  'recentProjects.inviteTeammates': 'Invite teammates',
  'recentProjects.multiSelect': 'Multi-select',
  'recentProjects.sortAria': 'Sort projects',
  'recentProjects.sortNewest': 'Newest first',
  'recentProjects.sortOldest': 'Oldest first',
  'recentProjects.sortName': 'Name',
  'recentProjects.viewList': 'List view',
  'recentProjects.sharedBadge': 'Shared',
  'recentProjects.sharedProjectFallbackName': 'Shared project',
  'recentProjects.creatorLine': 'Created by {name}',
  'recentProjects.selfCreator': 'Me',
  'recentProjects.teamMemberCreator': 'Team member',
  'recentProjects.ownOnlyMutation': 'Only projects you created can be changed or deleted.',
  'recentProjects.shareInProgress': 'Sharing…',
  'recentProjects.sharedInTeam': 'In team space',
  'recentProjects.moveToTeam': 'Move to team space',
  'recentProjects.moveToTeamDescPre': 'Once moved to the team space, ',
  'recentProjects.moveToTeamDescStrong': 'all team members can view and comment',
  'recentProjects.moveToTeamDescPost': ', and only the creator can edit. You can find it under "Team projects".',
  'recentProjects.moveToPersonalDescPre': 'Once moved out of the team space, it returns to a personal project, ',
  'recentProjects.moveToPersonalDescStrong': 'only you can view and edit it',
  'recentProjects.moveToPersonalDescPost': '.',
  'recentProjects.moveDontRemind': 'Don\'t remind me again',
  'recentProjects.confirmMoveToTeam': 'Confirm move',
  'recentProjects.confirmMoveToPersonal': 'Confirm move',
  'recentProjects.unshareInProgress': 'Moving out…',
  'recentProjects.moveOutOfTeam': 'Move out of team space',
  'recentProjects.unshareFailed': 'Could not move out of team space. Try again.',
  'recentProjects.shareFailed': 'Could not move to team space. Try again.',
  'recentProjects.shareOwnerConflict': 'Could not move to team space: another member already shares this project with the team.',
  'recentProjects.clearFilters': 'Szűrők törlése',
  'pluginsHome.title': 'Közösség',
  'pluginsHome.subtitle': 'Ehhez a futtatókörnyezethez csomagolt, használatra kész Open Design munkafolyamatok. Válasszon egyet egy kezdő prompt betöltéséhez, vagy böngésszen a registry-ben továbbiakért.',
  'pluginsHome.browseRegistry': 'Registry böngészése',
  'pluginsHome.count': '{filtered} / {total}',
  'pluginsHome.loadingCatalog': 'Katalógus betöltése…',
  'pluginsHome.emptyCatalog': 'A katalógus üres. A beépített pluginok az Open Design részeként érkeznek, és automatikusan meg kell jelenniük itt — próbáld újraindítani a daemont, ha ez továbbra is fennáll.',
  'pluginsHome.emptyFiltered': 'Egyetlen plugin sem felel meg a jelenlegi szűrőknek.',
  'pluginsHome.clearFilters': 'Szűrők törlése',
  'pluginsHome.modeAria': 'Plugin mód',
  'pluginsHome.featured': 'Mentve',
  'pluginsHome.totalInCatalog': '{n} a katalógusban',
  'pluginsHome.categoryFilterAria': 'Kategóriaszűrő',
  'pluginsHome.subcategoryFilterAria': '{label} alkategória-szűrő',
  'pluginsHome.allCategory': 'Összes: {label}',
  'pluginsHome.searchPlaceholder': 'Pluginok keresése…',
  'pluginsHome.searchAria': 'Pluginek keresése',
  'pluginsHome.clearSearch': 'Keresés törlése',
  'pluginsHome.sortAria': 'Rendezési sorrend',
  'pluginsHome.sortHot': 'Felkapott',
  'pluginsHome.sortNewest': 'Legújabb',
  'pluginsHome.facet.import': 'Importálás',
  'pluginsHome.facet.create': 'Létrehozás',
  'pluginsHome.facet.export': 'Exportálás',
  'pluginsHome.facet.share': 'Megosztás',
  'pluginsHome.facet.deploy': 'Üzembe helyezés',
  'pluginsHome.facet.refine': 'Finomítás',
  'pluginsHome.facet.extend': 'Bővítés',
  'pluginsHome.facet.figma': 'Figma',
  'pluginsHome.facet.github': 'GitHub',
  'pluginsHome.facet.codeFolder': 'Kód / mappa',
  'pluginsHome.facet.url': 'URL',
  'pluginsHome.facet.screenshot': 'Képernyőkép',
  'pluginsHome.facet.pdf': 'PDF',
  'pluginsHome.facet.pptx': 'PPTX',
  'pluginsHome.facet.framer': 'Framer',
  'pluginsHome.facet.webflow': 'Webflow',
  'pluginsHome.facet.slides': 'Diák',
  'pluginsHome.facet.publicLink': 'Nyilvános link',
  'pluginsHome.facet.githubPr': 'GitHub PR',
  'pluginsHome.facet.githubGist': 'GitHub Gist',
  'pluginsHome.subfacet.business-dashboards': 'Dashboardok',
  'pluginsHome.subfacet.app-prototypes': 'Appok',
  'pluginsHome.subfacet.landing-marketing': 'Landing / marketing',
  'pluginsHome.subfacet.developer-tools': 'Fejlesztői eszközök',
  'pluginsHome.subfacet.docs-reports': 'Dokumentumok / riportok',
  'pluginsHome.subfacet.brand-design': 'Márka / design',
  'pluginsHome.subfacet.pitch-business': 'Pitch / üzlet',
  'pluginsHome.subfacet.course-training': 'Kurzus / képzés',
  'pluginsHome.subfacet.reports-briefings': 'Riportok / összefoglalók',
  'pluginsHome.subfacet.product-sales': 'Termék / értékesítés',
  'pluginsHome.subfacet.engineering-talks': 'Tech előadások',
  'pluginsHome.subfacet.creative-decks': 'Kreatív prezentációk',
  'pluginsHome.subfacet.ui-product-mockups': 'UI / mockupok',
  'pluginsHome.subfacet.brand-visuals': 'Márka / logó',
  'pluginsHome.subfacet.storyboards-motion-refs': 'Storyboardok',
  'pluginsHome.subfacet.social-content': 'Közösségi / tartalom',
  'pluginsHome.subfacet.avatar-portrait': 'Avatar / portré',
  'pluginsHome.subfacet.illustration-style': 'Illusztráció / stílus',
  'pluginsHome.subfacet.motion-effects': 'Motion / effektek',
  'pluginsHome.subfacet.social-short-form': 'Közösségi / rövid videók',
  'pluginsHome.subfacet.marketing-product': 'Marketing / termék',
  'pluginsHome.subfacet.data-explainers': 'Adatok / magyarázatok',
  'pluginsHome.subfacet.cinematic-story': 'Filmszerű / történet',
  'pluginsHome.commercialCategory.student-coursework': 'Student coursework',
  'pluginsHome.commercialCategory.corporate-strategy': 'Corporate strategy',
  'pluginsHome.commercialCategory.professional-training': 'Professional training',
  'pluginsHome.commercialCategory.b2b-sales': 'B2B sales',
  'pluginsHome.commercialCategory.academic-research': 'Academic research',
  'pluginsHome.commercialCategory.marketing-gtm': 'Marketing & GTM',
  'pluginsHome.commercialCategory.data-finance': 'Data & finance',
  'pluginsHome.commercialCategory.fundraising-pitch': 'Fundraising pitch',
  'pluginsHome.commercialCategory.government-policy': 'Government & policy',
  'pluginsHome.commercialCategory.product-management': 'Product management',
  'pluginsHome.commercialCategory.consulting': 'Consulting',
  'pluginsHome.commercialCategory.career': 'Career',
  'pluginsHome.commercialCategory.ai-literacy': 'AI literacy',
  'pluginsHome.commercialCategory.life': 'Life & story',
  'pluginsHome.commercialCategory.design-craft': 'Design craft',
  'pluginsView.lede': 'Böngéssze a telepített munkafolyamatokat, fedezzen fel registry-bejegyzéseket, kezelje a forrásokat, és készítse elő a plugineket a csapaton belüli terjesztéshez.',
  'pluginsView.importPlugin': 'Plugin importálása',
  'pluginsView.agentContext': 'Agent kontextus',
  'pluginsView.summaryAria': 'Plugin összefoglaló',
  'pluginsView.areasAria': 'Plugin területek',
  'pluginsView.loading': 'Pluginok betöltése…',
  'pluginsView.tab.installed': 'Telepítve',
  'pluginsView.tab.available': 'Elérhető',
  'pluginsView.tab.sources': 'Források',
  'pluginsView.tab.team': 'Csapat',
  'pluginsView.tabHint.installed': 'Az Ön pluginjei',
  'pluginsView.tabHint.available': 'Forrásokból',
  'pluginsView.tabHint.sources': 'Katalógusok',
  'pluginsView.tabHint.team': 'Vállalati',
  'pluginsView.installedTitle': 'Telepített pluginek',
  'pluginsView.installedSubtitle': 'Marketplace-forrásokból importált vagy telepített pluginek.',
  'pluginsView.installedEmpty': 'Még nincsenek telepített felhasználói pluginek. Használja a Létrehozás / Importálás lehetőséget, vagy telepítsen egy Elérhető bejegyzést.',
  'pluginsView.availableTitle': 'Forrásokból elérhető',
  'pluginsView.availableSubtitle': 'A konfigurált marketplace-ekből felfedezett katalógusbejegyzések.',
  'pluginsView.availableFiltersAria': 'Elérhető plugin szűrők',
  'pluginsView.searchAvailableAria': 'Elérhető pluginek keresése',
  'pluginsView.searchAvailablePlaceholder': 'Elérhető pluginek keresése',
  'pluginsView.clearAvailableSearch': 'Elérhető plugin keresés törlése',
  'pluginsView.source': 'Forrás',
  'pluginsView.availableEmptyInstalled': 'Még nincsenek elérhető bejegyzések. A telepített katalógusbejegyzések eltűnnek az Elérhető listából; távolíts el egyet, hogy újra elérhetővé váljon.',
  'pluginsView.availableEmptyFiltered': 'Egyetlen elérhető bejegyzés sem felel meg a szűrőknek.',
  'pluginsView.availableEmptyNoSources': 'Még nincsenek elérhető bejegyzések. Adj hozzá egy forrást a Források lapon.',
  'pluginsView.installing': 'Telepítés…',
  'pluginsView.installWaiting': 'Várakozás…',
  'pluginsView.installQueuedHint': 'Egy másik bővítmény telepítése folyik. A telepítések egyesével futnak – ez a gomb a befejezés után lesz elérhető.',
  'pluginsView.install': 'Telepítés',
  'pluginsView.sourcesTitle': 'Registry-források',
  'pluginsView.sourcesSubtitle': 'Marketplace-katalógusok, amelyek feltöltik az Elérhető plugin-bejegyzéseket.',
  'pluginsView.sourceUrl': 'Forrás URL',
  'pluginsView.defaultTrust': 'Alapértelmezett megbízhatóság',
  'pluginsView.trust.restricted': 'Korlátozott',
  'pluginsView.trust.trusted': 'Megbízható',
  'pluginsView.trust.official': 'Hivatalos',
  'pluginsView.adding': 'Hozzáadás…',
  'pluginsView.addSource': 'Forrás hozzáadása',
  'pluginsView.sourcesEmpty': 'Még nincsenek registry-források konfigurálva.',
  'pluginsView.pluginsCount': '{n} plugin',
  'pluginsView.catalogVersion': 'katalógus v{version}',
  'pluginsView.trustFor': 'Megbízhatóság: {name}',
  'pluginsView.refreshing': 'Frissítés…',
  'pluginsView.removing': 'Eltávolítás…',
  "pluginsView.marketplaceTitle": "Extensions",
  "pluginsView.marketplaceBody": "Install expert suites, skills, and connectors to add new work capabilities to Open Design.",
  "pluginsView.marketplaceModeAria": "Marketplace mode",
  "pluginsView.marketplaceSourceFiltersAria": "Marketplace source filters",
  "pluginsView.scope.official": "Open Design official",
  "pluginsView.scope.team": "Team",
  "pluginsView.scope.personal": "Personal",
  "pluginsView.kind.plugins": "Expert suites",
  "pluginsView.kind.skills": "Skills",
  "pluginsView.searchPlugins": "Search expert suites",
  "pluginsView.searchSkills": "Search skills",
  "pluginsView.modeNote.plugins": "Expert suites are role- and industry-focused toolkits. Type @ or slash in the composer to use them.",
  "pluginsView.modeNote.skills": "Skills are reusable task workflows and review rules. Use them directly or compose them into expert suites.",
  "pluginsView.create": "Add",
  "pluginsView.createTitle": "Add {kind}",
  "pluginsView.createWithAgent": "Describe it and let the agent build it",
  "pluginsView.createWithAgentBody": "Start from a prompt in the home composer instead of importing an existing extension.",
  "pluginsView.createWithAgentAction": "Start from a prompt",
  "pluginsView.createPluginBody": "Import a plugin from GitHub or a local folder, then upload it for team use.",
  "pluginsView.createSkillBody": "Create a reusable task workflow or review rule that can later be reused by plugins.",
  "pluginsView.createClose": "Close add panel",
  "pluginsView.createTypeAria": "Create type",
  "pluginsView.importFromUrl": "Import from link",
  "pluginsView.importUrlBody": "Paste a public link for a {kind}. Open Design will fetch the manifest, validate capabilities, and upload it to the team space.",
  "pluginsView.uploadFolder": "Upload local folder",
  "pluginsView.uploadFolderBody": "Choose a local folder containing {manifest}. After validation, it will upload as a team {kind}.",
  "pluginsView.importing": "Importing…",
  "pluginsView.importAndUpload": "Import and upload",
  "pluginsView.uploading": "Uploading…",
  "pluginsView.uploadKind": "Upload {kind}",
  "pluginsView.filesSelected": "{count} files selected",
  "pluginsView.chooseFolder": "Choose folder",
  "pluginsView.emptyNoMatchTitle": "No matching results",
  "pluginsView.emptyNoMatchHint": "Try another keyword.",
  "pluginsView.emptyTeamTitle": "No content shared to the team yet",
  "pluginsView.emptyTeamHint": "Share expert suites or skills from Personal to Team, and they will appear here.",
  "pluginsView.emptyPersonalPluginsTitle": "No personal expert suites yet",
  "pluginsView.emptyPersonalSkillsTitle": "No personal skills yet",
  "pluginsView.emptyPersonalHint": "Install from Open Design official, or use Add in the top right to create one.",
  "pluginsView.emptyOfficialPluginsTitle": "No official expert suites available",
  "pluginsView.emptyOfficialSkillsTitle": "No official skills available",
  "pluginsView.emptyOfficialHint": "Check back later, or add a marketplace in plugin sources.",
  "pluginsView.teamSharedBadge": "Shared with team",
  "pluginsView.tryIt": "Try it",
  "pluginsView.categoriesAria": "Categories",
  "pluginsView.statSkills": "{count} skills",
  "pluginsView.statConnectors": "{count} connectors",
  "pluginsView.uninstall": "Uninstall",
  "pluginsView.uninstalling": "Uninstalling…",
  "pluginsView.uninstallConfirm": "Uninstall {title}?",
  "pluginsView.uninstallSuccess": "Uninstalled {title}",
  "pluginsView.uninstallFailed": "Could not uninstall {title}",
  "pluginsView.sharing": "Sharing…",
  "pluginsView.unsharing": "Removing…",
  "pluginsView.shareToTeam": "Share with team",
  "pluginsView.syncToTeam": "Szinkronizálás a csapattal",
  "pluginsView.unshareFromTeam": "Remove from team",
  "pluginsView.moreActions": "{title} more actions",
  "pluginsView.skillUrlUnsupported": "Skills do not support import from link yet. Use Upload local folder instead.",
  "pluginsView.importPluginSuccess": "Imported and uploaded expert suite",
  "pluginsView.importFailed": "Import failed. Check the link and try again.",
  "pluginsView.uploadPluginSuccess": "Uploaded expert suite",
  "pluginsView.uploadFailed": "Upload failed. Check the folder contents.",
  "pluginsView.importSkillSuccess": "Imported Skill \"{name}\". You can share it with the team from Personal.",
  "pluginsView.shareSuccess": "Shared \"{title}\" with the team. Teammates can now use it.",
  "pluginsView.shareUnavailable": "Could not share \"{title}\" yet. Confirm you are in a team workspace.",
  "pluginsView.shareFailed": "Failed to share \"{title}\". Try again later.",
  "pluginsView.syncSuccess": "A(z) \"{title}\" legfrissebb verziója szinkronizálva lett a csapattal.",
  "pluginsView.syncUnavailable": "A(z) \"{title}\" még nem szinkronizálható. Ellenőrizd, hogy csapat-munkaterületen vagy-e.",
  "pluginsView.syncFailed": "Nem sikerült szinkronizálni a(z) \"{title}\" elemet a csapattal. Próbáld újra később.",
  "pluginsView.unshareSuccess": "Removed \"{title}\" from team sharing.",
  "pluginsView.unshareUnavailable": "Could not remove \"{title}\" from team sharing. Confirm you have permission.",
  "pluginsView.unshareFailed": "Failed to remove \"{title}\" from team sharing. Try again later.",
  "pluginsView.installSuccess": "Installed \"{title}\"",
  "pluginsView.installFailed": "Failed to install \"{title}\"",
  "pluginsView.skillMissingFile": "No SKILL.md was found in the selected folder.",
  "pluginsView.skillReadFailed": "Could not read SKILL.md. Try again.",
  "pluginsView.skillMissingName": "SKILL.md is missing a name field.",
  "pluginsView.skillEmptyBody": "SKILL.md content is empty.",
  'pluginsView.teamTitle': 'Privát csapat-marketplace-ek',
  'pluginsView.teamBody': 'Ez a terület a vállalati és csapatkatalógusok, a privát megbízhatósági szabályok és a megosztott plugin-életciklus vezérlők számára van fenntartva.',
  'pluginCard.details': 'Részletek',
  'pluginCard.use': 'Használat',
  'pluginCard.useWithQuery': 'Használat lekérdezéssel',
  'pluginCard.applying': 'Alkalmazás…',
  'pluginCard.duplicate': 'Remix',
  'pluginCard.duplicating': 'Remixeles…',
  'pluginCard.duplicateFailed': 'Nem sikerult remixelni ezt a sablont.',
  'pluginCard.saved': 'Mentve',
  'pluginCard.publish': 'Közzététel',
  'pluginCard.contribute': 'Hozzájárulás',
  'pluginCard.starting': 'Indítás…',
  'pluginCard.detailsAria': '{title} részleteinek megtekintése',
  'pluginCard.chooseUseAria': 'Válaszd ki, hogyan használod ezt: {title}',
  'pluginCard.useOptionsAria': 'Használati lehetőségek ehhez: {title}',
  'pluginCard.duplicateAria': '{title} remixelese uj projektkent',
  'pluginCard.saveAria': '{title} mentése',
  'pluginCard.savedAria': '{title} mentve',
  'pluginCard.shareAria': '{title} megosztása',
  'pluginCard.publishAria': '{title} közzététele GitHub-tárolóként',
  'pluginCard.publishTitle': 'Plugin közzététele GitHub-tárolóként',
  'pluginCard.contributeAria': '{title} hozzájárulása az Open Designhoz',
  'pluginCard.contributeTitle': 'Plugin hozzájárulása az Open Designhoz pull requesttel',
  'skillPluginCandidate.createForMe': 'Plugin/sablon létrehozása',
  'skillPluginCandidate.contributeToMain': 'Hozzájárulás az open-designhoz',
  'skillPluginCandidate.repoDescription': 'Úgy tűnik, ez a tároló pluginként működhetne.',
  'integrations.kicker': 'Integráció',
  'integrations.lede': 'Csatlakoztass külső rendszereket, hozd be az MCP-eszközöket az agent-folyamatodba, és használd az Open Designt más IDE-kből, szkriptekből és automatizációkból.',
  'integrations.agentReady': 'Agentre kész',
  'integrations.areasAria': 'Integrációs területek',
  'integrations.tabLabel.mcp': 'MCP',
  'integrations.tabLabel.skills': 'Skillek',
  'integrations.tabHint.mcp': 'Külső eszközök',
  'integrations.tabHint.connectors': 'Fiókok és API-k',
  'integrations.tabHint.useEverywhere': 'CLI, HTTP, MCP',
  'integrations.skillsTitle': 'Skill-integrációk',
  'integrations.skillsBody': 'A skill-szintű integrációkezelés egy másik ágról kerül át. Ez a lap azért van fenntartva, hogy az MCP, a Connectorok és a jövőbeli Skill-beállítások ugyanazon az Integráció útvonalon legyenek.',
  'mcpClient.title': 'Külső MCP-szerverek',
  'mcpClient.subtitle': 'Külső felek eszközei a kódoló agentedhez.',
  'mcpClient.addServer': 'Szerver hozzáadása',
  'mcpClient.emptyTitle': 'Nincs MCP-szerver konfigurálva.',
  'mcpClient.emptyBody': 'Kattints a „Szerver hozzáadása” gombra a kezdéshez — válassz egy sablont (Higgsfield OpenClaw, Pollinations, Allyson, Imagician, EdgeOne Pages, GitHub, Filesystem…), vagy állíts be egyéni stdio / HTTP szervert.',
  'mcpClient.saveChanges': 'Módosítások mentése',
  'mcpClient.storedAt': 'Tárolva itt:',
  'mcpClient.daemonError': 'Nem sikerült elérni a helyi daemont. Győződj meg róla, hogy az Open Design fut, majd nyisd meg újra ezt a panelt.',
  'mcpClient.saveFailed': 'A mentés sikertelen. Ellenőrizd, hogy a daemon fut-e, majd próbáld újra.',
  'useEverywhere.modalAria': 'Használd az Open Designt mindenhol',
  'useEverywhere.modalTitle': 'Használd az Open Designt mindenhol',
  'useEverywhere.modalSubtitle': 'Illeszd be az Open Designt bármely IDE-be, agentbe vagy szkriptbe — CLI, HTTP, MCP és Skills. Használd a „Útmutató másolása agenthez” lehetőséget, és illeszd be a Claude Code, Codex, Cursor, openclaw vagy hermes felületre a teljes beállításhoz.',
  'useEverywhere.closeAria': '„Használat mindenhol” bezárása',
  'useEverywhere.closeTitle': 'Bezárás (Esc)',
  'useEverywhere.tabsAria': 'Integrációs felületek',
  'useEverywhere.footStrong': 'Átadás egy kattintással.',
  'useEverywhere.footBody': 'Strukturált markdown útmutatót másol, amelyre az agented azonnal cselekvéssel reagálhat — telepítés, ellenőrzés és használat.',
  'useEverywhere.configureMcp': 'MCP-szerver konfigurálása',
  'useEverywhere.copyGuide': 'Útmutató másolása egy agentnek',
  'useEverywhere.copy': 'Másolás',
  'useEverywhere.copied': 'Másolva',
  'useEverywhere.copyFailed': 'A másolás sikertelen',
  'useEverywhere.copySnippetAria': 'Kódrészlet másolása: {label}',
  'useEverywhere.section.overview.tab': 'Áttekintés',
  'useEverywhere.section.overview.heading': 'Az Open Design ott működik, ahol az agented dolgozik',
  'useEverywhere.section.overview.intro': 'Az Open Design több mint egy ablak — egy helyi, privilegizált daemon (`od`) és egy Skills + Design-Systems + Atoms registry. Amint fut a gépeden, bármely kód-agent (Claude Code, Codex, Cursor, OpenCode/openclaw, Hermes, a saját szkripted) vezérelhet generálásokat, vizsgálhat projekteket, és állíthat elő design artefaktumokat négy felcserélhető felületen keresztül.',
  'useEverywhere.section.overview.bullet1': 'CLI — `od <command>` headless szkriptekhez, CI-hez és shell-automatizáláshoz.',
  'useEverywhere.section.overview.bullet2': 'MCP szerver — az Open Designt Model Context Protocol szerverként köti be, így bármely MCP-képes agent listázhatja a skilleket, futtathat szcenáriókat és olvashat artefaktumokat.',
  'useEverywhere.section.overview.bullet3': 'HTTP API — `http://127.0.0.1:7456/api/*` REST + SSE végpontok; ugyanaz a felület, amelyet a webes felhasználói felület használ.',
  'useEverywhere.section.overview.bullet4': 'Skills — beilleszthető `SKILL.md` csomagok (Claude-kompatibilis), amelyeket bármely, a PATH-odon már meglévő agent meghívhat egyáltalán Open Design nélkül.',
  'useEverywhere.section.overview.bullet5': 'Standard artefaktumok — valódi HTML projektek létrehozása Skillsből, beépített alapértelmezett pluginokból és közösségi plugin példákból, mielőtt a daemon elindul.',
  'useEverywhere.section.overview.snippet1': 'Indítsd el a daemont (és a webes felületet) helyben',
  'useEverywhere.section.overview.snippet2': 'Erősítsd meg, hogy elérhető',
  'useEverywhere.section.overview.snippet3': 'Szabványos artefaktumok beolvasása indítás előtt',
  'useEverywhere.section.overview.footer': 'A daemon alapértelmezetten a `./.od/` mappába (projektszintű) ír. Állítsd be az `OD_DATA_DIR=~/.open-design` értéket, hogy az adatokat megoszd a projektek között.',
  'useEverywhere.section.cli.tab': 'CLI · od',
  'useEverywhere.section.cli.heading': 'Vezéreld az Open Designt bármelyik shellből',
  'useEverywhere.section.cli.intro': 'Az `od` bináris a daemonnal együtt érkezik, és ugyanaz a bináris, amelyet a Claude Code / Codex használ generáláskor. A legtöbb alparancs vékony kliens, amely a helyi daemonnak POST-ol, így ugyanúgy működnek, akár a `pnpm tools-dev` paranccsal, akár csomagolt alkalmazásként indítottad őket.',
  'useEverywhere.section.cli.bullet1': '`od` (argumentumok nélkül) — elindítja a daemont és megnyitja a webes felhasználói felületet.',
  'useEverywhere.section.cli.bullet2': '`od media generate ...` — kép / videó / audio bájtok előállítása az egységes médiaprotokollon keresztül.',
  'useEverywhere.section.cli.bullet3': '`od run ...` — projektfuttatás indítása prompt + skill alapján.',
  'useEverywhere.section.cli.bullet4': '`od plugin install <source>` / `od plugin apply <id>` — közösségi pluginok telepítése és alkalmazása.',
  'useEverywhere.section.cli.bullet5': '`od skills list` / `od design-systems list` — annak vizsgálata, hogy mi érhető el helyben.',
  'useEverywhere.section.cli.bullet6': '`od status` / `od doctor` — a daemon állapotának ellenőrzése és az agent CLI-k felismerése a PATH-odon.',
  'useEverywhere.section.cli.snippet1': 'Kép generálása (a beállított médiaszolgáltatóra delegálja)',
  'useEverywhere.section.cli.snippet2': 'Forgatókönyv-plugin futtatása fej nélkül, és események streamelése JSON-sorokként',
  'useEverywhere.section.cli.snippet3': 'Helyben elérhető skillek és tervezőrendszerek leltározása',
  'useEverywhere.section.cli.snippet4': 'Beültetett artefaktumok ellenőrzése a CLI-n keresztül',
  'useEverywhere.section.cli.snippet5': 'Környezet + felismert agentek ellenőrzése (Claude, Codex, Cursor, …)',
  'useEverywhere.section.cli.footer': 'Minden alparancs elfogadja a `--daemon-url http://127.0.0.1:<port>` opciót egy konkrét futó daemon megcélzásához — hasznos, ha tesztekhez sandbox-olt második példányt futtatsz.',
  'useEverywhere.section.mcp.tab': 'MCP-szerver',
  'useEverywhere.section.mcp.heading': 'Tedd elérhetővé az Open Designt MCP-szerverként bármely kódoló agent számára',
  'useEverywhere.section.mcp.intro': 'Az Open Design egy Model Context Protocol szerverrel (`od mcp`) érkezik, amely lehetővé teszi bármely MCP-képes kliens — Cursor, Claude Code, Antigravity, VS Code Copilot Chat, openclaw, hermes — számára, hogy felfedezze az Open Design eszközeit (skillek listázása, előnézetek renderelése, média generálása, pluginok futtatása) manuális shell-hívás nélkül. A daemon minden főbb klienshez közzétesz egy beillesztésre kész telepítési kódrészletet a `GET /api/mcp/install-info` végponton keresztül.',
  'useEverywhere.section.mcp.bullet1': 'Stdio transport — nincs extra port, a kliens közvetlenül indítja az `od mcp` parancsot.',
  'useEverywhere.section.mcp.bullet2': 'Automatikusan felismeri az élő daemon URL-jét a helyi IPC-állapotsocketen keresztül, amikor sidecar-ként indul.',
  'useEverywhere.section.mcp.bullet3': 'Egyszerű telepítések esetén a `--daemon-url http://127.0.0.1:<port>` értékre tér vissza, így az MCP-folyamat mindig megtalálja a futó daemont.',
  'useEverywhere.section.mcp.bullet4': 'Rögzíti az `OD_DATA_DIR` értéket, hogy a létrehozott MCP-folyamat ugyanoda írjon, ahová a daemon már ír (elkerüli az EPERM hibát a csomagolt macOS-alkalmazáscsomagokban).',
  'useEverywhere.section.mcp.snippet1': 'Általános MCP kliens-konfiguráció (működik Cursorban, Claude Code-ban, Codexben, …)',
  'useEverywhere.section.mcp.snippet2': 'Vagy: kérd el a daemontól a telepítésedhez igazított kódrészletet',
  'useEverywhere.section.mcp.snippet3': 'Élő artefaktumokat kezelő MCP-változat (irányítópultok olvasása és frissítése)',
  'useEverywhere.section.mcp.footer': 'Az Open Design alkalmazásban nyisd meg a Beállítások → Integrációk menüt, hogy kliens-specifikus telepítési parancsot másolj (Cursor, Claude Code, Antigravity, VS Code), ahelyett hogy kézzel szerkesztenéd a JSON-t.',
  'useEverywhere.section.http.tab': 'HTTP API',
  'useEverywhere.section.http.heading': 'Ugyanaz a REST + SSE felület, amelyet a webes felület használ',
  'useEverywhere.section.http.intro': 'A helyi daemon egy HTTP API-t szolgál ki a `http://127.0.0.1:7456` címen (a port konfigurálható). Minden végpont, amelyet a webes felület hív, a szkriptjeid számára is elérhető. A streamelő végpontok (chatfordulók, projektfuttatások) Server-Sent Events eseményeket bocsátanak ki a `@open-design/contracts` szerződéstípusaival.',
  'useEverywhere.section.http.bullet1': '`GET /api/health` — a daemon életjele.',
  'useEverywhere.section.http.bullet2': '`GET /api/skills` és `GET /api/design-systems` — elérhető registry-k.',
  'useEverywhere.section.http.bullet3': '`GET /api/projects` és `POST /api/projects` — projektek listázása és létrehozása (a POST a projektet + az első beszélgetést adja vissza).',
  'useEverywhere.section.http.bullet4': '`GET /api/projects/:id/chat` — egy beszélgetés agent-eseményeinek SSE adatfolyama.',
  'useEverywhere.section.http.bullet5': '`POST /api/plugins/:id/apply` — egy telepített plugin összekötése, és a renderelt példa-lekérdezésének + bemeneteinek lekérése.',
  'useEverywhere.section.http.bullet6': '`GET /api/agents` — a PATH-odon felismert kód-agent CLI-k.',
  'useEverywhere.section.http.snippet1': 'Telepített skillek listázása (az agent ezeket sablonként használja)',
  'useEverywhere.section.http.snippet2': 'Projekt létrehozása promptból (teljes szerveroldali folyamat)',
  'useEverywhere.section.http.snippet3': 'Egy chat-forduló streamelése (SSE — minden sor JSON-Lines kompatibilis)',
  'useEverywhere.section.http.footer': 'Minden kéréshez/válaszhoz tartozó tiszta TypeScript típusok a `@open-design/contracts` csomagban élnek — importáld őket a szkriptedbe a teljes automatikus kiegészítéshez, generátor bekötése nélkül.',
  'useEverywhere.section.skills.tab': 'Skillek és fej nélküli mód',
  'useEverywhere.section.skills.heading': 'Beilleszthető Skills bármely agenthez — még futó Open Design nélkül is',
  'useEverywhere.section.skills.intro': 'A Skill egy könyvtár, amely Claude-kompatibilis `SKILL.md` fájlt tartalmaz (YAML front-matter + törzs). Az Open Design kibővíti a formátumot az `od:` névtérrel (`mode`, `preview`, `design_system`, `inputs`, …), így ugyanaz az artefaktum használható mind az Open Designon belül, mind egy egyszerű agenttel, mint a Claude Code, Codex, openclaw vagy hermes. A felfedezés precedencia-láncot követ, így a projektek felülbírálhatják a saját skilljeiket.',
  'useEverywhere.section.skills.bullet1': 'Felfedezés: `./.claude/skills/` → `./skills/` → `~/.claude/skills/` (a projekt nyer).',
  'useEverywhere.section.skills.bullet2': 'Hozz létre szimbolikus linket egy skillre több projektben, hogy megoszd másolás nélkül.',
  'useEverywhere.section.skills.bullet3': 'Minden skill deklarálhat konnektorokat, atomokat, tervezőrendszer-követelményeket és egy `preview` példakimenetet a galériához.',
  'useEverywhere.section.skills.bullet4': 'Fej nélkül: egy agent, amelynek `od` szerepel a PATH-jában, meghívhatja az `od skills list` parancsot, majd futtathat bármely skillt; a daemon a csak olvasható folyamatokhoz nem kötelező.',
  'useEverywhere.section.skills.bullet5': 'A `pnpm seed:test-projects` ugyanazt az artefaktumformát gyakoroltatja az alapértelmezett plugin-példákkal és a közösségi plugin-példákkal, majd a kapott `index.html` projekteket újrafelhasználható tesztadatként tárolja.',
  'useEverywhere.section.skills.snippet1': 'Minimális SKILL.md (Claude-kompatibilis front matter + Open Design extrák)',
  'useEverywhere.section.skills.snippet2': 'Megosztott skill szimbolikus linkelése egy projektbe (cc-switch stílusban)',
  'useEverywhere.section.skills.snippet3': 'Fej nélkül: a daemon által jelenleg látott skillek listázása',
  'useEverywhere.section.skills.snippet4': 'Fej nélküli artefaktum-fixtúracsomag',
  'useEverywhere.section.skills.footer': 'Specifikáció: a `docs/skills-protocol.md` és a `docs/agent-adapters.md` lefedi a teljes adapterfelületet (Claude Code, Codex, Cursor, MCP-képes agentek, BYOK API fallback) és az adapterenkénti skill-injektálási stratégiákat.',
  'tasks.kicker': 'Automatizálási munkaterület',
  'tasks.comingSoon': 'Hamarosan',
  'tasks.lede': 'Az automatizálások a promptokból tartós munkát hoznak létre: az Orbit futtatja őket, a rutinok fenntartják őket, az ütemezések eldöntik, mikor induljanak, az élő artefaktumok pedig megmutatják, mi változott.',
  'tasks.newAutomation': 'Új automatizálás',
  'tasks.previewNote': 'Csak előnézeti felület. Az Orbit beállításai ma már elérhetők; a rutinok, az ütemezések és az élő artefaktumok bekötése a backend-ágak összeolvadásával érkezik.',
  'tasks.primitivesAria': 'Automatizálási alapelemek',
  'tasks.primitive.orbit.title': 'Orbit',
  'tasks.primitive.orbit.body': 'Tartós futtatókörnyezet hosszan futó vagy ismétlődő agentmunkához.',
  'tasks.primitive.orbit.enabled': 'Napi összefoglaló engedélyezve',
  'tasks.primitive.orbit.manualOnly': 'Csak manuálisan',
  'tasks.primitive.routines.title': 'Rutinok',
  'tasks.primitive.routines.body': 'Tartós feladatdefiníciók, amelyek egyetlen chat befejezése után is megmaradnak.',
  'tasks.primitive.routines.meta': 'A termékváz kész',
  'tasks.primitive.schedules.title': 'Ütemezések',
  'tasks.primitive.schedules.body': 'Idő- vagy eseményalapú triggerek, amelyek eldöntik, mikor fusson egy rutin.',
  'tasks.primitive.schedules.meta': 'Ág függőben',
  'tasks.primitive.liveArtifacts.title': 'Élő artefaktumok',
  'tasks.primitive.liveArtifacts.body': 'Jelentések és jegyzetek, amelyek folyamatosan frissülnek, amíg egy agent dolgozik.',
  'tasks.primitive.liveArtifacts.meta': 'Előnézeti modell',
  'tasks.listAria': 'Automatizálások listája',
  'tasks.routinesAndRuns': '{n} rutin és futtatás',
  'tasks.filtersAria': 'Automatizálási szűrők',
  'tasks.filter.scheduled': 'Ütemezett',
  'tasks.filter.running': 'Fut',
  'tasks.filter.done': 'Kész',
  'tasks.configurationAria': 'Automatizálás beállításai',
  'tasks.slot.trigger': 'Trigger',
  'tasks.slot.pattern': 'Minta',
  'tasks.slot.runtime': 'Futásidő',
  'tasks.slot.output': 'Kimenet',
  'tasks.liveArtifact': 'Élő artefaktum',
  'tasks.viewProgress': 'Folyamat megtekintése',
  'tasks.pause': 'Szüneteltetés',
  'tasks.runNow': 'Futtatás most',
  'tasks.openArtifact': 'Artefaktum megnyitása',
  'tasks.status.dailyAt': 'Naponta · {time}',
  'tasks.status.pausedManual': 'Szüneteltetve · csak manuálisan',
  'tasks.sample.orbit.title': 'Orbit Daily connector összefoglaló',
  'tasks.sample.orbit.metaEnabled': 'A connector-összefoglaló ütemezve van',
  'tasks.sample.orbit.metaDisabled': 'Nyisd meg az Orbit beállításait az engedélyezéshez',
  'tasks.sample.orbit.previewEnabled': 'orbit_daily.html · élő artefaktum',
  'tasks.sample.orbit.previewDisabled': 'Nincs ütemezett futtatás',
  'tasks.sample.orbit.triggerEnabled': 'Ütemezés · naponta ekkor: {time}',
  'tasks.sample.orbit.triggerDisabled': 'Manuális · igény szerint futtatva',
  'tasks.sample.orbit.pattern': 'Rutin · connector-összefoglaló',
  'tasks.sample.orbit.runtime': 'Orbit · daemon által ütemezve',
  'tasks.sample.orbit.output': 'Élő tartalom · frissíthető jelentés',
  'tasks.sample.orbit.artifactMetaEnabled': 'Minden futtatás után frissül',
  'tasks.sample.orbit.artifactMetaDisabled': 'Várakozás az ütemezésre',
  'tasks.sample.orbit.body1': '# Orbit Daily tevékenység-összefoglaló',
  'tasks.sample.orbit.body2': 'Connectorok ellenőrizve · sikerek, kihagyások és hibák',
  'tasks.sample.orbit.body3': 'A kiemelésekből frissíthető élő artefaktum lesz.',
  'tasks.sample.mcp.title': 'MCP alternatívák kutatása',
  'tasks.sample.mcp.status': 'Fut az Orbit-ban · 2 ó 14 p',
  'tasks.sample.mcp.meta': '14 / 30 forrás feldolgozva',
  'tasks.sample.mcp.preview': 'research_notes.md · élő',
  'tasks.sample.mcp.trigger': 'Kézi · egyszeri',
  'tasks.sample.mcp.pattern': 'Mélykutatási prompt',
  'tasks.sample.mcp.runtime': 'Távoli · tartós',
  'tasks.sample.mcp.output': 'Élő jelentés · automatikus frissítés',
  'tasks.sample.mcp.artifactMeta': 'Frissítve 12 mp-e',
  'tasks.sample.mcp.body1': '# MCP alternatívák – ideiglenes eredmények',
  'tasks.sample.mcp.body2': '14 forrás áttekintve · 3 esélyes kiválasztva',
  'tasks.sample.mcp.body3': '## Szűkített lista',
  'tasks.sample.mcp.body4': '- Eszközhívási sémák JSON-RPC-n keresztül...',
  'tasks.sample.mcp.body5': '- gRPC-alapú agent protokollok...',
  'tasks.sample.weekly.title': 'Heti csapatösszefoglaló',
  'tasks.sample.weekly.status': 'Következő: hétfő 9:00',
  'tasks.sample.weekly.meta': 'Frissíti a heti csapatdokumentumot',
  'tasks.sample.weekly.preview': 'team_weekly.md · következő tartalom',
  'tasks.sample.weekly.trigger': 'Ütemezés · heti',
  'tasks.sample.weekly.pattern': 'Rutin · csapatösszefoglaló',
  'tasks.sample.weekly.runtime': 'Távoli · ismétlődő',
  'tasks.sample.weekly.output': 'Élő tartalom · markdown',
  'tasks.sample.weekly.artifactMeta': 'Utoljára frissítve 4 napja',
  'tasks.sample.weekly.body1': '# Heti csapat',
  'tasks.sample.weekly.body2': '## Folyamatban',
  'tasks.sample.weekly.body3': '- Designrendszer-integrációs kör',
  'tasks.sample.weekly.body4': '- Connectorok minőségi átvizsgálása',
  'tasks.sample.weekly.body5': '## Kockázatok',
  'tasks.sample.pr.title': 'PR-felülvizsgálati emlékeztető',
  'tasks.sample.pr.status': 'Új PR esetén · 23 perce indult',
  'tasks.sample.pr.meta': 'Slack DM-et küld',
  'tasks.sample.pr.preview': 'Az utolsó kézbesítés sikeres volt',
  'tasks.sample.pr.trigger': 'Esemény · új PR',
  'tasks.sample.pr.pattern': 'Rutin · értesítés',
  'tasks.sample.pr.runtime': 'Helyi · gyors futtatás',
  'tasks.sample.pr.output': 'Üzenet · Slack DM',
  'tasks.sample.pr.artifactMeta': 'Utoljára aktiválva 23 perce',
  'tasks.sample.pr.body1': 'PR #184 megnyitva felülvizsgálatra',
  'tasks.sample.pr.body2': 'Egyező felülvizsgálók: design-platform, web-runtime',
  'tasks.sample.pr.body3': 'Kézbesítés: Slack DM elküldve',
  'tasks.sample.meeting.title': 'Megbeszélés előtti előkészület',
  'tasks.sample.meeting.status': 'Holnap · 10:00',
  'tasks.sample.meeting.meta': 'Egyszeri · összefoglalót küld',
  'tasks.sample.meeting.preview': 'meeting_brief.md · sorban áll',
  'tasks.sample.meeting.trigger': 'Ütemezés · egyszeri',
  'tasks.sample.meeting.pattern': 'Tájékoztató prompt',
  'tasks.sample.meeting.runtime': 'Távoli · korlátozott',
  'tasks.sample.meeting.output': 'Artefaktum + üzenet',
  'tasks.sample.meeting.artifactMeta': 'Generálásra sorba állítva',
  'tasks.sample.meeting.body1': '# Megbeszélés-tájékoztató',
  'tasks.sample.meeting.body2': 'Napirend forrása: naptáresemény + hivatkozott dokumentumok',
  'tasks.sample.meeting.body3': 'A kimenet tartalmazni fogja a döntéseket, akadályokat és kérdéseket.',
  'tasks.sample.candidate.title': 'Jelöltek követése',
  'tasks.sample.candidate.status': 'Sikertelen · beavatkozás szükséges',
  'tasks.sample.candidate.meta': 'A hitelesítés lejárt',
  'tasks.sample.candidate.preview': 'Csatlakoztasd újra a Greenhouse-t a folytatáshoz',
  'tasks.sample.candidate.trigger': 'Ütemezés · napi',
  'tasks.sample.candidate.pattern': 'Rutin · jelentkezők szinkronizálása',
  'tasks.sample.candidate.runtime': 'Távoli · ismétlődő',
  'tasks.sample.candidate.output': 'Élő tartalom · táblázat',
  'tasks.sample.candidate.artifactMeta': 'Szüneteltetve, amíg a hitelesítés helyre nem áll',
  'tasks.sample.candidate.body1': '# Jelöltfolyamat',
  'tasks.sample.candidate.body2': 'Utolsó sikeres szinkronizálás: 2 napja',
  'tasks.sample.candidate.body3': 'Beavatkozás szükséges: csatlakoztassa újra a forrásfiókot.',
  'routines.title': 'Automatizálások',
  'routines.subtitle': 'Ütemezett automatizálások, amelyek felügyelet nélkül futnak.',
  'routines.newAutomation': 'Új automatizálás',
  'routines.loading': 'Betöltés…',
  'routines.empty': 'Még nincsenek automatizálások.',
  'routines.emptyHint': 'Kattintson az Új automatizálás gombra felügyelet nélküli agentfuttatás ütemezéséhez.',
  'routines.runHistoryLoading': 'Futások betöltése…',
  'routines.runHistoryEmpty': 'Még nincsenek futtatások.',
  'routines.fieldName': 'Név',
  'routines.fieldNamePlaceholder': 'Reggeli összefoglaló',
  'routines.fieldPrompt': 'Prompt',
  'routines.fieldPromptPlaceholder': 'Töltsd le a tegnapi GitHub + Linear tevékenységet, és foglald össze, mi változott.',
  'routines.fieldSchedule': 'Ütemezés',
  'routines.fieldMinute': 'Minden óra perce',
  'routines.fieldTime': 'Időpont',
  'routines.fieldTimezone': 'Időzóna',
  'routines.fieldsetProject': 'Projekt',
  'routines.kind.hourly': 'Óránként',
  'routines.kind.daily': 'Naponta',
  'routines.kind.weekdays': 'Hétköznapokon',
  'routines.kind.weekly': 'Hetente',
  'routines.weekday.short.0': 'V',
  'routines.weekday.short.1': 'H',
  'routines.weekday.short.2': 'K',
  'routines.weekday.short.3': 'Sze',
  'routines.weekday.short.4': 'Cs',
  'routines.weekday.short.5': 'P',
  'routines.weekday.short.6': 'Szo',
  'routines.weekday.long.0': 'Vasárnap',
  'routines.weekday.long.1': 'Hétfő',
  'routines.weekday.long.2': 'Kedd',
  'routines.weekday.long.3': 'Szerda',
  'routines.weekday.long.4': 'Csütörtök',
  'routines.weekday.long.5': 'Péntek',
  'routines.weekday.long.6': 'Szombat',
  'routines.timeAm': 'AM',
  'routines.timePm': 'PM',
  'routines.describe.hourly': 'Minden órában :{minute} perckor fut',
  'routines.describe.daily': 'Naponta {time} {tz} időpontban fut',
  'routines.describe.weekdays': 'Fut hétfőtől péntekig {time} {tz} időpontban',
  'routines.describe.weekly': 'Minden {day} {time} {tz} időpontban fut',
  'routines.modeCreate': 'Új projekt létrehozása minden futtatáskor',
  'routines.modeCreateHint': 'Friss, elkülönített munkaterület minden indításkor.',
  'routines.modeReuse': 'Meglévő projekt újrafelhasználása',
  'routines.modeReuseHint': 'Minden futtatás új beszélgetésként él a projekten belül.',
  'routines.pickProject': '— Válassz projektet —',
  'routines.targetReuse': '→ {project}',
  'routines.targetCreate': '→ minden futáskor új projekt',
  'routines.tagPaused': 'szüneteltetve',
  'routines.metaNext': 'következő: {when}',
  'routines.metaLast': 'utolsó:',
  'routines.triggerManual': 'kézi',
  'routines.triggerScheduled': 'ütemezett',
  'routines.openProject': 'Projekt megnyitása',
  'routines.openProjectTitle': 'A projekt megnyitása, amelybe ez a futtatás írt',
  'routines.runNow': 'Futtatás most',
  'routines.edit': 'Szerkesztés',
  'routines.pause': 'Szüneteltetés',
  'routines.resume': 'Folytatás',
  'routines.history': 'Előzmények',
  'routines.hideHistory': 'Előzmények elrejtése',
  'routines.delete': 'Törlés',
  'routines.deleteTitle': 'Automatizálás törlése',
  'routines.cancel': 'Mégse',
  'routines.save': 'Mentés',
  'routines.saving': 'Mentés…',
  'routines.create': 'Létrehozás',
  'routines.creating': 'Létrehozás…',
  'routines.status.queued': 'várakozási sorban',
  'routines.status.running': 'fut',
  'routines.status.succeeded': 'sikeres',
  'routines.status.failed': 'sikertelen',
  'routines.status.canceled': 'megszakítva',
  'routines.confirmDelete': 'Törli ezt az automatizálást? A korábbi futtatások és projektjeik megmaradnak.',
  'routines.errorPickProject': 'Válassz egy projektet az újrafelhasználáshoz, vagy válts a „Minden futáskor új létrehozása” lehetőségre',
  'routines.errorAgentEmptyOutput': 'Az Agent kimenet nélkül fejeződött be. Lehet, hogy a modell vagy a szolgáltató üres választ adott vissza — ellenőrizd az Agent naplóit a felsőbb szintű hibákért.',
  'entry.helpAria': 'Súgó',
  'entry.helpMenuAria': 'Súgó menü',
  'entry.helpGetHelp': 'Kérj segítséget a GitHubon',
  'entry.helpSubmitFeature': 'Funkció javaslása',
  'entry.helpWhatsNew': 'Újdonságok',
  'entry.helpDownloadDesktop': 'Asztali alkalmazás letöltése',
  'entry.githubStarLabel': 'Csillagozás',
  'entry.githubStarTitle': 'Csillagozz meg minket a GitHubon',
  'entry.githubStarAria': 'Csillagozd meg az Open Design projektet a GitHubon',
  'entry.tabImageTemplates': 'Képsablonok',
  'entry.tabVideoTemplates': 'Videósablonok',
  'promptTemplates.searchPlaceholder': 'Sablonok keresése…',
  'promptTemplates.countLabel': '{n} találat',
  'promptTemplates.emptyImage': 'Még nincs telepített képsablon.',
  'promptTemplates.emptyVideo': 'Még nincs telepített videósablon.',
  'promptTemplates.emptyNoMatch': 'Egy sablon sem felel meg a keresésnek.',
  'promptTemplates.attributionFooter': 'Nyilvános prompt-tárakból átvéve. Minden kártya az eredeti szerzőre mutat.',
  'promptTemplates.openPreviewTitle': 'Prompt és előnézet megnyitása',
  'promptTemplates.sourcePrefix': 'Forrás:',
  'promptTemplates.fetchError': 'A sablon törzse nem tölthető be.',
  'promptTemplates.promptLabel': 'Prompt törzse',
  'promptTemplates.copyPrompt': 'Prompt másolása',
  'promptTemplates.copyDone': 'Másolva!',
  'promptTemplates.modelHint': 'Ajánlott modell: {model}',
  'promptTemplates.openSource': 'Eredeti megnyitása',
  'promptTemplates.openFullscreen': 'Teljes képernyős előnézet',
  'promptTemplates.closeFullscreen': 'Teljes képernyős előnézet bezárása',
  'promptTemplates.allSources': 'Minden forrás',
  'promptTemplates.sourceFilterAria': 'Szűrés forrás szerint',
  'promptTemplates.retry': 'Újra',
  'connectors.title': 'Kapcsolók',
  'connectors.subtitle': 'Helyi és jövőbeli adatforrások, amelyek élő artefaktokat táplálhatnak.',
  'connectors.account': 'Fiók',
  'connectors.noAccount': 'Nincs csatlakoztatva',
  'connectors.tools': 'Eszközök',
  'connectors.connect': 'Csatlakozás',
  'connectors.disconnect': 'Leválasztás',
  'connectors.authorizationPending': 'Várakozás az engedélyezésre...',
  'connectors.authorizationPendingHint': 'Fejezd be az engedélyezést a megnyitott ablakban.',
  'connectors.cancelAuthorization': 'Mégse',
  'connectors.configure': 'Beállítás',
  'connectors.unavailable': 'Nem érhető el',
  'connectors.phaseStubTitle': 'A kapcsoló API-k a 3. fázisban érkeznek; ez csak előnézet.',
  'connectors.statusAvailable': 'Elérhető',
  'connectors.statusConnected': 'Csatlakoztatva',
  'connectors.statusError': 'Hiba',
  'connectors.statusDisabled': 'Letiltva',
  'connectors.gateTitle': 'Add meg a Composio API-kulcsot a folytatáshoz',
  'connectors.gateBody': 'Illeszd be fent a kulcsot, majd kattints a Kulcs mentése gombra az elérhető integrációk betöltéséhez.',
  'connectors.aboutLabel': 'Névjegy',
  'connectors.detailsLabel': 'Részletek',
  'connectors.statusLabel': 'Állapot',
  'connectors.category.aiAgents': 'AI-ügynökök',
  'connectors.category.aiInfrastructure': 'AI-infrastruktúra',
  'connectors.category.accounting': 'Könyvelés',
  'connectors.category.admin': 'Adminisztráció',
  'connectors.category.advertising': 'Hirdetés',
  'connectors.category.analytics': 'Analitika',
  'connectors.category.automation': 'Automatizálás',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'Naptár',
  'connectors.category.commerce': 'Kereskedelem',
  'connectors.category.communication': 'Kommunikáció',
  'connectors.category.contacts': 'Kapcsolatok',
  'connectors.category.dataPlatform': 'Adatplatform',
  'connectors.category.database': 'Adatbázis',
  'connectors.category.design': 'Tervezés',
  'connectors.category.developer': 'Fejlesztői eszközök',
  'connectors.category.documentation': 'Dokumentáció',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': 'Oktatás',
  'connectors.category.email': 'E-mail',
  'connectors.category.events': 'Események',
  'connectors.category.fieldService': 'Terepszolgálat',
  'connectors.category.finance': 'Pénzügy',
  'connectors.category.fitness': 'Fitnesz',
  'connectors.category.forms': 'Űrlapok',
  'connectors.category.gaming': 'Játék',
  'connectors.category.hr': 'HR',
  'connectors.category.hospitality': 'Vendéglátás',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': 'Integráció',
  'connectors.category.localization': 'Lokalizáció',
  'connectors.category.logistics': 'Logisztika',
  'connectors.category.maps': 'Térképek',
  'connectors.category.marketing': 'Marketing',
  'connectors.category.media': 'Média',
  'connectors.category.meetings': 'Megbeszélések',
  'connectors.category.nonprofit': 'Nonprofit',
  'connectors.category.observability': 'Megfigyelhetőség',
  'connectors.category.payments': 'Fizetések',
  'connectors.category.personal': 'Személyes',
  'connectors.category.presentations': 'Prezentációk',
  'connectors.category.procurement': 'Beszerzés',
  'connectors.category.product': 'Termék',
  'connectors.category.productivity': 'Produktivitás',
  'connectors.category.projectManagement': 'Projektmenedzsment',
  'connectors.category.recruiting': 'Toborzás',
  'connectors.category.research': 'Kutatás',
  'connectors.category.salesIntelligence': 'Értékesítési intelligencia',
  'connectors.category.scheduling': 'Ütemezés',
  'connectors.category.search': 'Keresés',
  'connectors.category.security': 'Biztonság',
  'connectors.category.signing': 'Aláírás',
  'connectors.category.social': 'Közösségi',
  'connectors.category.spreadsheets': 'Táblázatok',
  'connectors.category.storage': 'Tárhely',
  'connectors.category.support': 'Támogatás',
  'connectors.category.surveys': 'Kérdőívek',
  'connectors.category.tasks': 'Feladatok',
  'connectors.category.timeTracking': 'Időkövetés',
  'connectors.category.video': 'Videó',
  'connectors.category.whiteboard': 'Tábla',
  'connectors.categoryLabel': 'Kategória',
  'connectors.providerLabel': 'Szolgáltató',
  'connectors.toolsSection': 'Eszközök',
  'connectors.toolsLoading': 'Eszközök betöltése…',
  'connectors.noToolsAvailable': 'Még nincs elérhető eszköz. Csatlakozás után megjelennek ennek az integrációnak a képességei.',
  'connectors.toolDetailsUnavailable': 'Az eszközök részletei nem érhetők el, de ez a csatlakozó {n} eszközt jelez.',
  'connectors.loadMoreTools': 'További eszközök betöltése',
  'connectors.openDetailsAria': '{name} részleteinek megnyitása',
  'connectors.toolsBadgeNone': 'Nincs eszköz',
  'connectors.toolsBadgeOne': '{n} eszköz',
  'connectors.toolsBadgeMany': '{n} eszköz',
  'connectors.searchPlaceholder': 'Kapcsolók keresése…',
  'connectors.searchAriaLabel': 'Kapcsolók keresése név, szolgáltató vagy eszköz alapján',
  'connectors.searchClear': 'Keresés törlése',
  'connectors.emptyNoMatchTitle': 'Nincs „{query}” kifejezésre illeszkedő kapcsoló',
  'connectors.emptyNoMatchBody': 'Próbálj más kulcsszót, vagy töröld a keresést a teljes katalógushoz.',
  'connectors.emptyNoMatchAction': 'Keresés törlése',
  'newproj.tabPrototype': 'Prototípus',
  'newproj.tabLiveArtifact': 'Élő artifact',
  'newproj.tabDeck': 'Diavetítés',
  'newproj.tabTemplate': 'Sablonból',
  'newproj.tabMedia': 'Média',
  'newproj.tabOther': 'Egyéb',
  'newproj.titlePrototype': 'Új prototípus',
  'newproj.titleLiveArtifact': 'Új élő artifact',
  'newproj.titleDeck': 'Új diavetítés',
  'newproj.titleTemplate': 'Indulás sablonból',
  'newproj.titleImage': 'Új kép',
  'newproj.titleVideo': 'Új videó',
  'newproj.titleAudio': 'Új hang',
  'newproj.titleMedia': 'Új média',
  'newproj.titleOther': 'Új projekt',
  'newproj.namePlaceholder': 'Projekt neve',
  'newproj.fidelityLabel': 'Részletesség',
  'newproj.fidelityWireframe': 'Drótváz',
  'newproj.fidelityHigh': 'Részletes',
  'newproj.toggleSpeakerNotes': 'Előadói jegyzetek használata',
  'newproj.toggleSpeakerNotesHint': 'Kevesebb szöveg a diákon — a beszédpontok a jegyzetekbe kerülnek.',
  'newproj.toggleAnimations': 'Animációk hozzáadása',
  'newproj.toggleAnimationsHint': 'Mozgás (belépés, hover, átmenetek) hozzáadása a sablonra.',
  'newproj.targetPlatformsLabel': 'Célplatformok',
  'newproj.targetPlatformsHint': 'Válasszon egyet vagy többet. A reszponzív web csak a böngésző töréspontjait fedi le; natív, többplatformos változatokhoz adjon hozzá iOS, Android, táblagépes vagy asztali alkalmazást.',
  'newproj.platform.responsive.label': 'Reszponzív web',
  'newproj.platform.responsive.hint': 'Egyetlen webes élmény, asztali, táblagépes és mobil böngészőkre optimalizálva',
  'newproj.platform.webDesktop.label': 'Asztali web',
  'newproj.platform.webDesktop.hint': 'Böngészőközpontú termék vagy nyitóoldal',
  'newproj.platform.mobileIos.label': 'iOS alkalmazás',
  'newproj.platform.mobileIos.hint': 'iPhone-keretek és iOS-interakciós szabályok',
  'newproj.platform.mobileAndroid.label': 'Android alkalmazás',
  'newproj.platform.mobileAndroid.hint': 'Pixel-keretek és Material-interakciós szabályok',
  'newproj.platform.tablet.label': 'Táblagépes alkalmazás',
  'newproj.platform.tablet.hint': 'Natív stílusú táblagépes élmény osztott nézetekkel',
  'newproj.platform.desktopApp.label': 'Asztali alkalmazás',
  'newproj.platform.desktopApp.hint': 'macOS/Windows alkalmazáskeret',
  'newproj.surfaceOptionsLabel': 'Kiegészítő felületek',
  'newproj.includeLandingPage': 'Nyitóoldal hozzáadása',
  'newproj.includeLandingPageHint': 'Adjon hozzá egy reszponzív marketingoldalt hirdetésekhez, várólistákhoz, indítási kampányokhoz, alkalmazásletöltésekhez vagy a termék bemutatásához.',
  'newproj.includeOsWidgets': 'OS-widgetek hozzáadása',
  'newproj.includeOsWidgetsHint': 'Adjon hozzá platformnatív kezdőképernyő-, zárolási képernyő- vagy gyorselérési widgeteket mobil/táblagépes alkalmazásokhoz.',
  'newproj.includeOsWidgetsDisabledHint': 'Akkor érhető el, ha célplatformként iOS, Android vagy táblagépes alkalmazás van kiválasztva.',
  'newproj.templateLabel': 'Sablon',
  'newproj.noTemplatesTitle': 'Még nincs sablon',
  'newproj.noTemplatesBody': 'Nyiss meg egy projektet, majd a fájlnézőben a Megosztás menüvel alakítsd sablonná. A sablonok itt jelennek meg.',
  'newproj.savedTemplate': 'Mentett sablon',
  'newproj.fileSingular': 'fájl',
  'newproj.filePlural': 'fájl',
  'newproj.create': 'Létrehozás',
  'newproj.locationLabel': 'Mentés ide',
  'newproj.locationDefault': 'Open Design projektek',
  'newproj.locationExternalBase': 'Külső bázis',
  'newproj.createLiveArtifact': 'Élő artifact létrehozása',
  'newproj.createFromTemplate': 'Létrehozás sablonból',
  'newproj.createDisabledTitle': 'Először ments el egy projektet sablonként (bármely projekt Megosztás menüjéből).',
  'newproj.openFolder': 'Mappa megnyitása',
  'newproj.openingFolder': 'Megnyitás…',
  'newproj.importClaudeZip': 'Claude Design ZIP importálása',
  'newproj.importClaudeZipTitle': 'Claude Design .zip export importálása',
  'newproj.importingClaudeZip': 'Importálás…',
  'newproj.privacyFooter': 'Alapértelmezetten csak te láthatod a projekted.',
  'newproj.designSystem': 'Designrendszer',
  'newproj.dsNoneFreeform': 'Nincs — szabad formátum',
  'newproj.dsNoneSubtitleEmpty': 'Nincsenek rendszertokenek, válassz saját palettát',
  'newproj.dsNoneSubtitleSelected': 'Hagyd ki a rendszertokeneket. Az ügynök maga választ palettát.',
  'newproj.dsCategoryFallback': 'Designrendszer',
  'newproj.dsSearch': 'Designrendszerek keresése…',
  'newproj.dsModeAria': 'Kijelölési mód',
  'newproj.dsModeSingle': 'Egy',
  'newproj.dsModeMulti': 'Több',
  'newproj.dsNoneTitle': 'Nincs — szabad formátum',
  'newproj.dsNoneSub': 'Hagyd ki a rendszertokeneket. Az ügynök maga választ palettát.',
  'newproj.dsEmpty': 'Egy designrendszer sem felel meg a „{query}" keresésnek.',
  'newproj.dsFootSingular': 'csak inspiráció.',
  'newproj.dsFootPlural': 'csak inspiráció.',
  'newproj.dsFootClear': 'Törlés',
  'newproj.dsBadgeDefault': 'ALAPÉRT.',
  'newproj.dsPrimaryFallback': 'Elsődleges',
  'newproj.surfaceImage': 'Kép',
  'newproj.surfaceVideo': 'Videó',
  'newproj.surfaceAudio': 'Hang',
  'newproj.modelLabel': 'Modell',
  'newproj.modelSearch': 'Modellek keresése…',
  'newproj.modelEmpty': 'Nincs találat a modellekre.',
  'newproj.modelRecommended': 'Ajánlott',
  'newproj.modelMissingTitle': 'Modell kiválasztása',
  'newproj.modelMissingSub': 'Válassz modellt ehhez a felülethez.',
  'newproj.aspectLabel': 'Képarány',
  'newproj.videoLengthLabel': 'Hossz',
  'newproj.videoLengthSeconds': '{n} mp',
  'newproj.audioKindLabel': 'Hangtípus',
  'newproj.audioKindMusic': 'Zene',
  'newproj.audioKindSpeech': 'Beszéd / TTS',
  'newproj.audioKindSfx': 'Hangeffekt',
  'newproj.audioDurationLabel': 'Időtartam',
  'newproj.audioDurationSeconds': '{n} mp',
  'newproj.voiceLabel': 'Hang',
  'newproj.voicePlaceholder': 'Szolgáltatói hang-id, opcionális',
  'newproj.connectorsLabel': 'Kapcsolók',
  'newproj.connectorsHint': 'Adatforrások, amelyeket ez az artefaktum használhat.',
  'newproj.connectorsEmptyTitle': 'Nincs beállított kapcsoló',
  'newproj.connectorsEmptyBody': 'Csatlakoztass egy adatforrást, hogy az élő artefaktum valódi adatokat használjon helykitöltők helyett.',
  'newproj.connectorsEmptyCta': 'Kapcsolók beállítása →',
  'newproj.connectorsLoading': 'Kapcsolók betöltése…',
  'newproj.connectorsCountOne': '{n} csatlakoztatva',
  'newproj.connectorsCountMany': '{n} csatlakoztatva',
  'newproj.connectorsManage': 'Kezelés',
  'newproj.promptTemplateLabel': 'Hivatkozási sablon',
  'newproj.promptTemplateNoneTitle': 'Nincs — saját megfogalmazás',
  'newproj.promptTemplateNoneSub': 'Hagyd ki a galériát, írd le a saját brieffed',
  'newproj.promptTemplateRefSub': 'Hivatkozási sablon',
  'newproj.promptTemplateSearch': 'Sablonok keresése…',
  'newproj.promptTemplateEmpty': 'Még nincs telepített sablon ehhez a felülethez.',
  'newproj.promptTemplateBodyLabel': 'Prompt (módosítható)',
  'newproj.promptTemplateOptimizeHint': 'Bármit módosíthatsz — a változtatásaid beépülnek az ügynök briefjébe.',
  'newproj.promptTemplateBodyEmpty': 'Üres törzs — az ügynök nem kap sablonhivatkozást.',
  'newproj.deleteTemplateTitle': 'Sablon törlése',
  'newproj.deleteTemplateConfirm': 'Törlöd a(z) „{name}" sablont? Ez nem vonható vissza.',
  'newproj.deleteTemplateConfirmCta': 'Sablon törlése',
  'newproj.deleteTemplateError': 'A sablon törlése nem sikerült. Próbáld újra.',
  'designs.subRecent': 'Legutóbbi',
  'designs.subYours': 'A te terveid',
  'designs.filterAria': 'Projektek szűrése',
  'designs.searchPlaceholder': 'Keresés…',
  'designs.emptyNoProjects': 'Még nincs projekt.',
  'designs.emptyNoMatch': 'Egy projekt sem felel meg a keresésnek.',
  'designs.deleteTitle': 'Projekt törlése',
  'designs.deleteConfirm': 'Törlöd a(z) „{name}" projektet?',
  'designs.cardFreeform': 'szabad formátum',
  'designs.badgeLive': 'Élő',
  'designs.liveArtifactBadgesAria': 'Élő artifact jelvények',
  'designs.liveCount': '{n} élő',
  'designs.statusLive': 'Élő artifact',
  'designs.statusArchived': 'Archivált',
  'designs.statusError': 'Hiba',
  'designs.statusRefreshing': 'Frissítés…',
  'designs.statusRefreshFailed': 'A frissítés sikertelen',
  'designs.statusRefreshed': 'Frissítve',
  'designs.status.notStarted': 'Nem kezdődött el',
  'designs.status.queued': 'Sorban',
  'designs.status.running': 'Fut',
  'designs.status.awaitingInput': 'Bevitelre vár',
  'designs.status.incomplete': 'Befejezetlen',
  'designs.status.succeeded': 'Befejezve',
  'designs.status.published': 'Közzétéve',
  'designs.status.failed': 'Sikertelen',
  'designs.status.canceled': 'Megszakítva',
  'designs.viewToggleAria': 'Nézet módja',
  'designs.viewGrid': 'Rácsnézet',
  'designs.viewKanban': 'Tábla nézet',
  'designs.kanbanEmptyColumn': 'Nincs terv',
  'designs.deleteAria': '{name} projekt törlése',
  'designs.menuMore': 'További műveletek',
  'designs.menuRename': 'Átnevezés',
  'designs.menuDuplicate': 'Duplicate project',
  'designs.menuDelete': 'Törlés',
  'designs.renamePrompt': 'Új név ehhez: „{name}”',
  'designs.selectMode': 'Kijelölés',
  'designs.cancelSelect': 'Mégse',
  'designs.deleteSelected': 'Kijelöltek törlése',
  'designs.selectedCount': '{n} kijelölve',
  'designs.deleteSelectedConfirm': 'Töröl {n} projektet?',
  'designs.deleteSelectedSuccess': '{n} projekt sikeresen törölve.',
  'designs.deleteSelectedPartial': '{deleted} projekt törölve; {failed} sikertelen.',
  'designs.tagPrototype': 'Prototípus',
  'designs.tagLiveArtifact': 'Élő elem',
  'designs.tagWebClone': 'Weboldal-klón',
  'designs.tagSlide': 'Dia',
  'designs.tagMedia': 'Média',
  'designs.renameTitle': 'Projekt átnevezése',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'Mégse',
  'examples.typeLabel': 'Típus',
  'examples.surfaceLabel': 'Felület',
  'examples.surfaceWeb': 'Web',
  'examples.surfaceImage': 'Kép',
  'examples.surfaceVideo': 'Videó',
  'examples.surfaceAudio': 'Hang',
  'examples.scenarioLabel': 'Forgatókönyv',
  'examples.modeAll': 'Mind',
  'examples.modePrototypeDesktop': 'Prototípusok · Asztali',
  'examples.modePrototypeMobile': 'Prototípusok · Mobil',
  'examples.modeDeck': 'Diák',
  'examples.modeDocument': 'Dokumentumok és sablonok',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'Élő',
  'examples.scenarioGeneral': 'Általános',
  'examples.scenarioEngineering': 'Mérnöki',
  'examples.scenarioProduct': 'Termék',
  'examples.scenarioDesign': 'Dizájn',
  'examples.scenarioMarketing': 'Marketing',
  'examples.scenarioSales': 'Értékesítés',
  'examples.scenarioFinance': 'Pénzügy',
  'examples.scenarioHr': 'HR',
  'examples.scenarioOperations': 'Operáció',
  'examples.scenarioSupport': 'Ügyfélszolgálat',
  'examples.scenarioLegal': 'Jogi',
  'examples.scenarioEducation': 'Oktatás',
  'examples.scenarioPersonal': 'Személyes',
  'examples.searchPlaceholder': 'Példák keresése…',
  'examples.searchAria': 'Példák keresése név alapján',
  'examples.emptyNoSkills': 'Nincs elérhető skill. Fut a daemon?',
  'examples.emptyNoMatch': 'Egy példa sem felel meg ezeknek a szűrőknek.',
  'examples.openPreview': '⤢ Előnézet megnyitása',
  'examples.loadingPreview': 'Előnézet betöltése…',
  'examples.hoverPreview': 'Vidd fölé az egeret az előnézethez',
  'examples.usePrompt': 'Használd ezt a promptot',
  'examples.previewModalTitle': 'Teljes előnézet (modális)',
  'examples.shareTitle': 'Példa megosztása',
  'examples.shareLoadFirst': 'Vidd fölé az egeret az előnézet betöltéséhez',
  'examples.unavailablePlaceholder': 'Nincs mellékelt {kind} előnézet — nyisd meg a részletekért',
  'examples.shareUnavailable': 'Nincs megosztható {kind} előnézet mellékelve',
  'examples.shareMenu': 'Megosztás ▾',
  'examples.exportPdfAllSlides': 'Exportálás PDF-ként (minden dia)',
  'examples.exportPptxLocked': 'Exportálás PPTX-ként… (előbb sablont nyiss)',
  'examples.tagSlideDeck': 'Diavetítés',
  'examples.tagTemplate': 'Sablon',
  'examples.tagDesignSystem': 'Designrendszer',
  'examples.tagMobilePrototype': 'Mobil prototípus',
  'examples.tagDesktopPrototype': 'Asztali prototípus',
  'examples.tagImage': 'Kép',
  'examples.tagVideo': 'Videó',
  'examples.tagAudio': 'Hang',
  'examples.previewLabel': 'Előnézet',
  'ds.surfaceLabel': 'Felület',
  'ds.surfaceWeb': 'Web',
  'ds.surfaceImage': 'Kép',
  'ds.surfaceVideo': 'Videó',
  'ds.surfaceAudio': 'Hang',
  'ds.searchPlaceholder': 'Designrendszerek keresése…',
  'ds.emptyNoMatch': 'Egy designrendszer sem felel meg a keresésnek.',
  'ds.badgeDefault': 'ALAPÉRT.',
  'ds.preview': 'Előnézet',
  'ds.previewTitle': 'Designrendszer előnézete',
  'ds.categoryAll': 'Mind',
  'ds.categoryUncategorized': 'Kategorizálatlan',
  'ds.showcase': 'Bemutató',
  'ds.tokens': 'Tokenek',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'DESIGN.md betöltése…',
  'avatar.title': 'Fiók és beállítások',
  'avatar.localCli': 'Helyi CLI',
  'avatar.anthropicApi': 'Anthropic API',
  'avatar.useLocal': 'Helyi CLI használata',
  'avatar.useApi': 'API · BYOK használata',
  'avatar.codeAgent': 'Kód-ügynök',
  'avatar.rescan': 'PATH újraellenőrzése',
  'avatar.amrConsole': 'Open Design Cloud-fiók',
  'avatar.amrConsoleMeta': 'Egyenleg és feltöltés',
  'avatar.settings': 'Beállítások',
  'avatar.backToProjects': 'Vissza a projektekhez',
  'avatar.metaActive': 'aktív',
  'avatar.metaOffline': 'offline',
  'avatar.metaSelected': 'kiválasztva',
  'avatar.noAgentSelected': 'nincs kiválasztott ügynök',
  'avatar.modelSection': 'Modell',
  'avatar.modelLabel': 'Modell',
  'avatar.reasoningLabel': 'Gondolkodás',
  'avatar.serviceTierLabel': 'Szolgáltatási szint',
  'avatar.customSuffix': '(egyedi)',
  'socialShare.openDesignSection': 'Open Design megosztása',
  'socialShare.openDesignTitle': 'Open Design a GitHubon',
  'socialShare.openDesignText': 'Az Open Design egy forráskóddal elérhető munkaterület tervezési elemek létrehozásához, szerkesztéséhez, telepítéséhez és átadásához.',
  'socialShare.openDesignCopyText': '{text}\n{url}',
  'socialShare.projectSection': 'MEGOSZTÁS KÖZÖSSÉGI MÉDIÁN',
  'socialShare.publishPageTitle': 'Megosztási oldal közzététele',
  'socialShare.publishPageSubtitle': 'Tedd közzé ezt az előnézetet, hogy megosztható legyen közösségi platformokon.',
  'socialShare.projectTitle': '{title} · Open Design',
  'socialShare.projectText': 'Open Design segítségével készült: {title}. Tekintsd meg a telepített elemet, és csillagozd a repót: {repo}',
  'socialShare.projectCopyText': 'Open Design segítségével készült: {title}\n{url}\nOpen Design repó: {repo}',
  'socialShare.deployFirst': 'Telepítés, majd megosztás…',
  'socialShare.copied': 'Másolva',
  'socialShare.platform.x': 'X',
  'socialShare.platform.linkedin': 'LinkedIn',
  'socialShare.platform.facebook': 'Facebook',
  'socialShare.platform.reddit': 'Reddit',
  'socialShare.platform.telegram': 'Telegram',
  'socialShare.platform.whatsapp': 'WhatsApp',
  'socialShare.platform.weibo': 'Weibo',
  'socialShare.platform.line': 'LINE',
  'socialShare.platform.instagram': 'Instagram',
  'socialShare.platform.xiaohongshu': 'Xiaohongshu',
  'inlineSwitcher.chipTitle': 'CLI / modell váltása',
  'inlineSwitcher.chipCli': 'Helyi CLI',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'alapértelmezett',
  'inlineSwitcher.noAgent': 'nincs ügynök',
  'inlineSwitcher.modeLabel': 'Mód',
  'inlineSwitcher.agentLabel': 'Ügynök',
  'inlineSwitcher.providerLabel': 'Szolgáltató',
  'inlineSwitcher.modelLabel': 'Modell',
  'inlineSwitcher.useCli': 'Helyi CLI használata',
  'inlineSwitcher.useByok': 'Saját API-kulcs használata',
  'inlineSwitcher.daemonOffline': 'A démon offline — nyisd meg a beállításokat',
  'inlineSwitcher.noAgentsDetected': 'Nincs CLI a PATH-ban',
  'inlineSwitcher.openSettingsForModel': 'Állítsd be a szolgáltatót a Beállításokban',
  'inlineSwitcher.missingApiKey': 'Hiányzó API-kulcs — add hozzá a Beállításokban.',
  'inlineSwitcher.openFullSettings': 'Végrehajtási beállítások megnyitása',
  'inlineSwitcher.customSuffix': '(egyedi)',
  'project.backToProjects': 'Vissza a projektekhez',
  'project.brandReadyTitle': 'A(z) {name} dizájnrendszer kész',
  'project.brandReadyTitleGeneric': 'A dizájnrendszered kész',
  'project.brandReadyCta': 'Megtekintés a Tervezőrendszerekben',
  'project.brandReadyDismiss': 'Elvetés',
  'project.brandReadyRefineHint': 'Automatic extraction can miss details. Refine it before using this system broadly.',
  'project.brandReadyAiOptimize': 'AI Optimize',
  'project.brandReadyEditManually': 'Edit manually',
  'project.brandReadyPreviewOpened': 'Designrendszer előnézete megnyitva.',
  'project.previewCommentSaveFailed': 'A megjegyzést nem sikerült elmenteni. Próbáld újra.',
  'project.previewCommentReorderFailed': 'A megjegyzések sorrendjét nem sikerült elmenteni, és újratöltéskor visszaállhat.',
  'project.metaFreeform': 'szabad formátum',
  'project.typePrototype': 'Prototípus',
  'project.typeDeck': 'Diák',
  'project.typeTemplate': 'Sablon',
  'project.typeImage': 'Kép',
  'project.typeVideo': 'Videó',
  'project.typeAudio': 'Hang',
  'project.customInstructions': 'Projektutasítások',
  'project.customInstructionsPlaceholder': 'Utasítások ehhez a projekthez (minden üzenetbe beillesztve)…',
  'project.resizeChatPanel': 'Csevegőpanel átméretezése',
  'project.instructionsActive': 'Aktív – minden üzenethez hozzáadva',
  'project.missing': 'This project has been deleted or no longer exists.',
  'chat.tabChat': 'Csevegés',
  'chat.tabComments': 'Megjegyzések',
  'chat.commentsSoon': 'Megjegyzések — hamarosan',
  'chat.comments.attached': 'Csevegéshez csatolva',
  'chat.comments.emptyAttached': 'Nincs csatolt megjegyzés.',
  'chat.comments.saved': 'Mentett megjegyzések',
  'chat.comments.emptySaved': 'Nincsenek mentett megjegyzések.',
  'chat.comments.add': 'Hozzáadás',
  'chat.comments.addAll': 'Összes hozzáadása',
  'chat.comments.remove': 'Eltávolítás',
  'chat.comments.placeholder': 'Megjegyzés ehhez az elemhez…',
  'chat.comments.addSend': 'Hozzáadás és küldés',
  'chat.comments.updateSend': 'Frissítés és küldés',
  'chat.comments.removeAttachment': 'Megjegyzéscsatolmány eltávolítása',
  'chat.comments.removeAttachmentAria': 'Megjegyzéscsatolmány eltávolítása ehhez: {name}',
  'chat.comments.comment': 'Megjegyzés',
  'chat.comments.sendToChat': 'Küldés a csevegésbe',
  'chat.comments.sending': 'Küldés…',
  'chat.comments.edit': 'Szerkesztés',
  'chat.comments.select': 'Kijelölés',
  'chat.comments.selectAll': 'Összes kijelölése',
  'chat.comments.deselect': 'Kijelölés megszüntetése',
  'chat.comments.nSelected': '{n} kijelölve',
  'chat.comments.pin': 'Rögzítés',
  'chat.comments.addNote': 'Jegyzet hozzáadása',
  'chat.comments.savedToast': 'Megjegyzés elmentve',
  'chat.comments.pinSavedToast': 'Rögzítés elmentve',
  'chat.comments.pinAtCoords': 'at {x}, {y}',
  'chat.comments.capturedItems': '{n} rögzített elem',
  'chat.comments.clear': 'Törlés',
  'chat.comments.targetImage': 'Kép',
  'chat.comments.targetControl': 'Vezérlés',
  'chat.comments.targetLink': 'Hivatkozás',
  'chat.comments.targetText': 'Szöveg',
  'chat.comments.targetSection': 'Szakasz',
  'chat.comments.targetPage': 'Oldal',
  'chat.comments.targetArea': 'Terület',
  'chat.annotationNotePlaceholder': 'Jegyzet hozzáadása ehhez a jelöléshez',
  'chat.annotationAttachImage': 'Kép csatolása',
  'chat.annotationAttachedImages': 'Csatolt képek',
  'chat.annotationAttachedRemove': 'Utolsó kép eltávolítása',
  'chat.annotationAddToInput': 'Hozzáadás a bemenethez',
  'chat.annotationAddingToInput': 'Hozzáadás...',
  'chat.annotationQueue': 'Sorba állítás',
  'chat.annotationQueueing': 'Sorba állítás...',
  'chat.annotationSubmitOptions': 'Küldési beállítások',
  'chat.annotationSending': 'Küldés...',
  'chat.annotationSendDisabledReason': 'Jelenleg fut egy feladat',
  'chat.annotationPreviewMissing': 'Nem sikerült rögzíteni az előnézetet. Kérjük, próbálja újra.',
  'chat.annotationPreviewMissingInk': 'Nem sikerült rögzíteni az előnézetet. Próbálja újra, hogy ne csak a tinta legyen elküldve.',
  'chat.annotationSentWithoutScreenshot': 'Nem sikerült rögzíteni az előnézetet. A jegyzet képernyőkép nélkül lett elküldve.',
  'chat.annotationTimeout': 'Az annotáció küldése időtúllépés miatt megszakadt. Kérjük, próbálja újra.',
  'chat.annotationFailed': 'Az annotáció küldése nem sikerült. Kérjük, próbálja újra.',
  'chat.annotationProjectCreateFailed': 'Nem sikerült projektet létrehozni, ezért az annotáció nem lett elküldve.',
  'chat.annotationUploadFailed': 'A melléklet feltöltése nem sikerült. Kérjük, próbálja újra.',
  'chat.conversationsTitle': 'Beszélgetések',
  'chat.conversationsAria': 'Beszélgetések előzménye',
  'chat.newConversation': 'Új beszélgetés',
  'chat.newConversationsTitle': 'Új beszélgetés',
  'chat.conversationsHeading': 'Beszélgetések',
  'chat.new': 'Új',
  'chat.emptyConversations': 'Még nincs beszélgetés.',
  'chat.deleteConversation': 'Beszélgetés törlése',
  'chat.renameConversationLabel': '„{title}” átnevezése',
  'chat.deleteConversationConfirm': 'Törlöd a(z) „{title}" beszélgetést? Ez eltávolítja az üzeneteit.',
  'chat.untitledConversation': 'Cím nélküli beszélgetés',
  'chat.forkedConversationTitle': '{title} elágazás',
  'chat.forkConversationFailed': 'Nem sikerült forkot létrehozni ebből a beszélgetésből.',
  'chat.startTitle': 'Indíts beszélgetést',
  'chat.startHint': 'Írd le, mit szeretnél létrehozni, vagy indulj ki az egyik példából:',
  'chat.brandBrowserAssistDesktopOnly': 'Browser assist needs the desktop app so Open Design can read the live browser page.',
  'chat.brandBrowserAssistReadFailed': 'Could not read the browser page. Make sure the brand site is open and fully loaded.',
  'chat.brandBrowserAssistMessage': 'Open Design needs browser assist to finish this brand extraction. Use the card below to open Browser, then click More, choose Download Page, wait for the success message, and use the left Next Step card to continue extraction.',
  'chat.brandBrowserLocalSnapshotMissing': 'No saved page snapshot is available for this URL.',
  'chat.brandBrowserLocalSnapshotReadFailed': 'Could not read the saved page snapshot.',
  'chat.brandBrowserSnapshotSaveFailed': 'Could not save a page snapshot from the browser.',
  'chat.brandBrowserAssistDownloadGuideTitle': 'Browser opened',
  'chat.brandBrowserAssistDownloadGuideDetails': 'Step 1: Browser is open. Step 2: click More, then Download Page. Step 3: wait for the saved snapshot success message. Step 4: return to the left Next Step card and click Continue extraction to continue the programmatic extraction.',
  'brandEnrichment.title': "AI-optimalizálás",
  'brandEnrichment.body': "Az Open Design mélyebb kinyerést futtat a háttérben, automatikusan alkalmazza a megfelelő design system skilleket, és helyben frissíti ezt a rendszert. Ez 10-20 percig tarthat; közben dolgozhatsz tovább.",
  'brandEnrichment.cta': "AI-optimalizálás",
  'brandEnrichment.busy': "AI-optimalizálás indítása...",
  'brandExtractionTranscript.sourceDesignMd': 'beillesztett DESIGN.md',
  'brandExtractionTranscript.user': 'Designrendszer kinyerése innen: {source}.',
  'brandExtractionTranscript.doneTitle': 'A(z) {name} programozott kinyerése befejeződött.',
  'brandExtractionTranscript.doneBody': 'Létrehoztam és regisztráltam a(z) {designSystemId} designrendszert innen: {source}. Már előnézetben megnyitható és új designokban használható.',
  'brandExtractionTranscript.next': 'Ezután futtathatod az AI Optimize műveletet egy mélyebb kinyeréshez, vagy létrehozhatsz egy új designt ezzel a rendszerrel.',
  'chat.fillInputTitle': 'Kattints a beviteli mező kitöltéséhez',
  'chat.jumpToLatest': 'Ugrás a legutóbbira',
  'chat.scrollToLatest': 'Görgetés a legutóbbira',
  'chat.messageRail.aria': 'Felhasználói üzenetek navigációja',
  'chat.messageRail.jumpAria': 'Ugrás a(z) {index}. felhasználói üzenetre',
  'chat.messageRail.empty': '(Nincs tartalom)',
  'chat.you': 'Te',
  'chat.openFile': '{name} megnyitása',
  'chat.copyPrompt': 'Prompt másolása',
  'chat.copyErrorDiagnostic': 'Hibadiagnosztika másolása',
  'chat.copyDone': 'Másolva!',
  'chat.inspect.noEditableTargets': 'This page has no editable elements yet.',
  'chat.inspect.noCommentTargets': 'This page has no commentable elements yet.',
  'chat.inspect.editHint': 'Click an element in the canvas to edit its styles.',
  'chat.inspect.commentHint': 'Click an element in the canvas to add a comment.',
  'chat.composerPlaceholder': 'Írd le, mit szeretnél létrehozni…',
  'chat.activeFileEditingLabel': 'Szerkesztés',
  'chat.activeFilePlaceholder': 'Kérd meg az Open Designt, hogy módosítsa: {file}...',
  'chat.designArtifactsShowMore': 'További {count} tervfájl megjelenítése',
  'chat.mode.chat.label': 'Kérdezés',
  'chat.mode.chat.title': 'Kérdezés mód',
  'chat.mode.chat.summary': 'Gyors válaszokhoz, javításokhoz, tervezéshez és beszélgetéshez, anélkül hogy kötelezően design kimenetet készítene.',
  'chat.mode.chat.solves': 'Használd ötletek tisztázására, promptok finomítására, opciók összevetésére vagy meglévő munka megbeszélésére.',
  'chat.mode.chat.query1': 'Foglalod össze ezt a vázlatot, és mutasd meg a hiányosságokat.',
  'chat.mode.chat.query2': 'Segíts eldönteni a legjobb struktúrát ehhez a landing page-hez.',
  'chat.mode.chat.query3': 'Nézd át ezt a designt, és adj konkrét javítási javaslatokat.',
  'chat.mode.plan.label': "Plan",
  'chat.mode.plan.title': "Plan mode",
  'chat.mode.plan.summary': "Creates an editable plan document first, then hands off to Design after you review it.",
  'chat.mode.plan.solves': "Use it for PRDs, slide outlines, prototype briefs, wireframes, storyboards, and any broad request that needs confirmation before generation.",
  'chat.mode.plan.query1': "Create a slide-by-slide PPT outline first.",
  'chat.mode.plan.query2': "Draft a PRD before generating the prototype.",
  'chat.mode.plan.query3': "Turn this idea into an editable design plan.",
  'chat.mode.design.label': 'Tervezés',
  'chat.mode.design.title': 'Tervezés mód',
  'chat.mode.design.summary': 'Konkrét kimenetek létrehozásához vagy módosításához: oldalak, prototípusok, live artifactek, diák, képek, videók, HyperFrames, audió, dashboardok és projektfájlok.',
  'chat.mode.design.solves': 'Akkor használd, ha az Open Designnak fájlokat kell generálnia, frissítenie kell a workspace-t, vagy briefből multimodális eredményt kell készítenie.',
  'chat.mode.design.query1': 'Készíts termékbevezető landing page-et és HyperFrames prototípust ebből a briefből.',
  'chat.mode.design.query2': 'Készíts 10 diás befektetői decket előadói jegyzetekkel.',
  'chat.mode.design.query3': 'Készíts kép-, videó- és audióötleteket ehhez a kampányhoz.',
  'chat.mode.cardBestFor': 'Erre jó',
  'chat.mode.cardTry': 'Példakérések',
  'chat.mode.cardCost': 'Várható felhasználás',
  'chat.mode.chat.cost': 'Alacsony',
  'chat.mode.chat.costNote': 'Csak beszélgetés – semmi sem készül, így ez fogyaszt a legkevesebbet.',
  'chat.mode.plan.cost': 'Normál',
  'chat.mode.plan.costNote': 'Előbb egy szerkeszthető tervdokumentumot készít, mielőtt bármit generálna.',
  'chat.mode.design.cost': 'Magas',
  'chat.mode.design.costNote': 'Fájlokat és multimodális tartalmat hoz létre, így egy futás fogyaszthat a legtöbbet.',
  'chat.modePicker.choose': 'Válassz módot',
  'chat.modePicker.current': 'Mód: {name}',
  'chat.modePicker.clear': 'Mód törlése',
  'chat.modePicker.mode': 'Mód',
  'chat.composerHint': '⌘/Ctrl + Enter küldéshez · add meg a célt, tartalmat, stílust és formátumot',
  'chat.cliSettingsTitle': 'CLI- és modellbeállítások',
  'chat.cliSettingsAria': 'CLI- és modellbeállítások megnyitása',
  'chat.attachTitle': 'Fájlok csatolása (vagy beillesztés / húzás)',
  'chat.addContextTitle': 'Add context',
  'chat.attachAria': 'Fájlok csatolása',
  'chat.importTitle': 'Források importálása (hamarosan)',
  'chat.importLabel': 'Importálás',
  'chat.importComingSoon': 'Hamarosan',
  'chat.importSoon': 'Hamarosan',
  'chat.importFig': '.fig fájl feltöltése',
  'chat.importGitHub': 'GitHub csatlakoztatása',
  'chat.importWeb': 'Webelem mentése',
  'chat.importFolder': 'Kódmappa hozzákapcsolása',
  'chat.importSkills': 'Skillek és designrendszerek',
  'chat.importProject': 'Hivatkozás egy másik projektre',
  'chat.importDesignSystemHeader': 'Válassz designrendszert',
  'chat.importDesignSystemBack': 'Vissza',
  'chat.importDesignSystemSearch': 'Designrendszerek keresése…',
  'chat.importDesignSystemEmpty': 'Nincs a(z) "{query}"-hoz illeszkedő designrendszer',
  'chat.importDesignSystemNone': 'Nincs — szabad',
  'chat.importDesignSystemNoneSub': 'Most ne kötődj egyik rendszerhez sem',
  'chat.importDesignSystemActive': 'Aktív',
  'chat.importDesignSystemSwitched': 'Designrendszer átállítva: {title}',
  'chat.importDesignSystemFailed': 'Nem sikerült váltani a designrendszert. Próbáld újra.',
  'chat.importDesignSystemLoadFailed': 'Nem sikerült betölteni a designrendszereket.',
  'browserUse.title': 'Inspiráció',
  'browserUse.summary': '{count} webes művelet, előtérbe helyezve az eszközök kinyerését, a designnyelvet, a mozgást, a vizuális ellenőrzéseket és a komponensszerkezetet.',
  'browserUse.searchAria': 'Inspiráció keresése',
  'browserUse.searchPlaceholder': 'Képernyőképek, betűtípusok, színek, a11y keresése...',
  'browserUse.empty': 'Nincs egyező inspiráció',
  'browserUse.unavailable': 'Az inspiráció itt nem érhető el',
  'browserUse.added': 'Hozzáadva a szerkesztőhöz',
  // Design Browser
  'designBrowser.aria': 'Design Browser',
  'designBrowser.goBack': 'Go Back',
  'designBrowser.goForward': 'Go Forward',
  'designBrowser.reload': 'Reload',

  'designBrowser.stopLoading': 'Betöltés leállítása',
  'designBrowser.viewportAria': 'Browser viewport',
  'designBrowser.addressPlaceholder': 'Enter URL or search...',
  'designBrowser.addressAria': 'Browser address',
  'designBrowser.suggestion.reference': 'Reference',
  'designBrowser.suggestion.history': 'History',
  'designBrowser.menu.copyScreenshot': 'Copy Screenshot',
  'designBrowser.menu.hardReload': 'Hard Reload',
  'designBrowser.menu.copyUrl': 'Copy URL',
  'designBrowser.menu.openInBrowser': 'Open in Browser',
  'designBrowser.menu.savePageBrief': 'Save Page Brief',
  'designBrowser.menu.clearBrowsingHistory': 'Clear Browsing History',
  'designBrowser.menu.clearCookies': 'Clear Cookies',
  'designBrowser.menu.clearAllData': 'Clear All Data',
  'designBrowser.status.openHttpUrlFirst': 'Open an http URL first',
  'designBrowser.status.openPageBeforeScreenshot': 'Open a page before taking a screenshot',
  'designBrowser.status.screenshotCopied': 'Screenshot copied to clipboard',
  'designBrowser.status.openPageBeforeBrief': 'Open a page before saving a brief',
  'designBrowser.status.openPageBeforeTools': 'Open a page before using browser tools',
  'designBrowser.status.clickElementToComment': 'Click an element to comment',
  'designBrowser.status.clickElementToTune': 'Click an element to tune',
  'designBrowser.status.noElementSelected': 'No browser element selected',
  'designBrowser.status.addBrowserComment': 'Add a browser comment',
  'designBrowser.status.tuneElementThenSaveHtml': 'Tune the element, then save HTML',
  'designBrowser.status.tuneLiveOnly': 'Tune is live only for non-project pages',
  'designBrowser.status.pickerFailed': 'Browser element picker failed',
  'designBrowser.status.applyStyleFailed': 'Could not apply style in browser page',
  'designBrowser.status.editTextFailed': 'Could not edit text in browser page',
  'designBrowser.status.onlyProjectHtmlCanSave': 'Only project-local HTML pages can be saved',
  'designBrowser.status.htmlSaved': 'HTML changes saved',
  'designBrowser.status.htmlSaveFailed': 'HTML save failed',
  'designBrowser.status.commentSavingUnavailable': 'Comment saving is unavailable',
  'designBrowser.status.commentSaved': 'Browser comment saved',
  'designBrowser.status.commentSendingUnavailable': 'Comment sending is unavailable',
  'designBrowser.comments.aria': 'Browser comments',
  'designBrowser.comments.openFor': 'Open browser comment for {label}',
  'designBrowser.comment.dialog': 'Browser comment',
  'designBrowser.comment.elementFallback': 'Browser element',
  'designBrowser.comment.close': 'Close browser comment',
  'designBrowser.comment.noteAria': 'Browser comment note',
  'designBrowser.comment.placeholder': 'Describe the change or issue...',
  'designBrowser.comment.addNote': 'Add note',
  'designBrowser.comment.saveComment': 'Save comment',
  'designBrowser.comment.sending': 'Sending...',
  'designBrowser.comment.sendToChat': 'Send to chat',
  'designBrowser.inspect.editTitle': 'Edit HTML element',
  'designBrowser.inspect.tuneTitle': 'Tune browser element',
  'designBrowser.inspect.closeTune': 'Close browser tune',
  'designBrowser.inspect.colors': 'Colors',
  'designBrowser.inspect.text': 'Text',
  'designBrowser.inspect.fill': 'Fill',
  'designBrowser.inspect.type': 'Type',
  'designBrowser.inspect.size': 'Size',
  'designBrowser.inspect.weight': 'Weight',
  'designBrowser.inspect.spacing': 'Spacing',
  'designBrowser.inspect.pad': 'Pad',
  'designBrowser.inspect.radius': 'Radius',
  'designBrowser.inspect.content': 'Content',
  'designBrowser.inspect.elementText': 'Element text',
  'designBrowser.inspect.saving': 'Saving...',
  'designBrowser.inspect.saveHtml': 'Save HTML',
  'designBrowser.inspect.liveOnly': 'Live only',
  'designBrowser.reference.kicker': 'Open Design browser',
  'designBrowser.reference.title': 'Reference Board',
  'designBrowser.reference.subtitle': 'A curated set of references across inspiration, real product UI, motion, color, type, assets, and design systems. Open one to browse it live while gathering design language for the next artifact.',
  'designBrowser.reference.categoryAria': 'Reference category',
  'designBrowser.reference.searchPlaceholder': 'Search references...',
  'designBrowser.reference.searchAria': 'Search references',
  'designBrowser.reference.clearSearch': 'Clear search',
  'designBrowser.reference.noMatches': 'No references match “{query}”.',
  'designBrowser.reference.clearFilters': 'Clear filters',
  'designBrowser.reference.open': 'Open',
  'designBrowser.reference.group.inspiration': 'Inspiration',
  'designBrowser.reference.group.interfaces': 'Real Interfaces',
  'designBrowser.reference.group.motion': 'Motion',
  'designBrowser.reference.group.color': 'Color',
  'designBrowser.reference.group.type': 'Typography',
  'designBrowser.reference.group.icons': 'Icons',
  'designBrowser.reference.group.illustration': 'Illustration',
  'designBrowser.reference.group.photography': 'Photography',
  'designBrowser.reference.group.3d': '3D & Graphics',
  'designBrowser.reference.group.mockups': 'Mockups',
  'designBrowser.reference.group.systems': 'Design Systems',
  'designBrowser.reference.group.components': 'Components',
  'designBrowser.reference.group.guidelines': 'Guidelines & A11y',
  'designBrowser.reference.group.tools': 'Tools & Resources',
  'designBrowser.reference.site.dribbble.detail': 'Design shots and UI inspiration.',
  'designBrowser.reference.site.behance.detail': 'Creative portfolios and case studies.',
  'designBrowser.reference.site.awwwards.detail': 'Award-winning website design.',
  'designBrowser.reference.site.godly.detail': 'Curated modern web design.',
  'designBrowser.reference.site.land_book.detail': 'Landing page gallery and patterns.',
  'designBrowser.reference.site.mobbin.detail': 'Real app screens and UI patterns.',
  'designBrowser.reference.site.screenlane.detail': 'Latest UI design patterns from apps.',
  'designBrowser.reference.site.pageflows.detail': 'Real product user flows and onboarding.',
  'designBrowser.reference.site.uisources.detail': 'Interaction patterns from top apps.',
  'designBrowser.reference.site.collectui.detail': 'Daily UI collection by category.',
  'designBrowser.reference.site.gsap.detail': 'Production animation engine and examples.',
  'designBrowser.reference.site.animations.detail': 'Animation patterns and interaction examples.',
  'designBrowser.reference.site.transitions.detail': 'Transition patterns for modern interfaces.',
  'designBrowser.reference.site.motionsites.detail': 'High-end motion and interaction references.',
  'designBrowser.reference.site.motion.detail': 'Scroll and timeline animation inspiration.',
  'designBrowser.reference.site.animography.detail': 'Animated type and kinetic lettering.',
  'designBrowser.reference.site.reactbits.detail': 'React text animation reference for shiny kinetic type.',
  'designBrowser.reference.site.coolors.detail': 'Fast color palette generator.',
  'designBrowser.reference.site.colorhunt.detail': 'Curated color palettes.',
  'designBrowser.reference.site.realtimecolors.detail': 'Preview palettes on a real UI.',
  'designBrowser.reference.site.color_adobe.detail': 'Color wheel and harmony rules.',
  'designBrowser.reference.site.happyhues.detail': 'Palettes shown in real context.',
  'designBrowser.reference.site.fonts_google.detail': 'Open-source font library.',
  'designBrowser.reference.site.fontshare.detail': 'Quality fonts free for commercial use.',
  'designBrowser.reference.site.typewolf.detail': 'Fonts in use and pairing guidance.',
  'designBrowser.reference.site.fontpair.detail': 'Font pairing suggestions.',
  'designBrowser.reference.site.fontsinuse.detail': 'Typography in real-world design.',
  'designBrowser.reference.site.thesvg.detail': 'SVG assets and vector references.',
  'designBrowser.reference.site.svglogos.detail': 'Clean SVG logos for product and brand mocks.',
  'designBrowser.reference.site.icons_lobehub.detail': 'Product and AI-brand icons for interfaces.',
  'designBrowser.reference.site.icon_sets_iconify.detail': '200k+ open-source icons in one place.',
  'designBrowser.reference.site.lucide.detail': 'Clean, consistent open icon set.',
  'designBrowser.reference.site.heroicons.detail': 'Tailwind-made SVG icons.',
  'designBrowser.reference.site.svgrepo.detail': 'Free SVG vectors and icons.',
  'designBrowser.reference.site.storyset.detail': 'Customizable vector illustrations.',
  'designBrowser.reference.site.undraw.detail': 'Open-source MIT illustrations.',
  'designBrowser.reference.site.blush.detail': 'Mix-and-match illustrations.',
  'designBrowser.reference.site.lummi.detail': 'Free AI-generated visuals.',
  'designBrowser.reference.site.whirrls.detail': 'Hand-drawn image references.',
  'designBrowser.reference.site.worldindots.detail': 'Dot-map and data-viz references.',
  'designBrowser.reference.site.unsplash.detail': 'Free high-resolution photos.',
  'designBrowser.reference.site.pexels.detail': 'Free stock photos and video.',
  'designBrowser.reference.site.pixabay.detail': 'Royalty-free images and media.',
  'designBrowser.reference.site.cosmos.detail': 'Visual discovery and mood boards.',
  'designBrowser.reference.site.spline.detail': 'Browser-based 3D design.',
  'designBrowser.reference.site.threejs.detail': 'WebGL 3D references and demos.',
  'designBrowser.reference.site.womp.detail': 'Easy in-browser 3D creation.',
  'designBrowser.reference.site.pixcap.detail': '3D icons, mockups, and scenes.',
  'designBrowser.reference.site.shots.detail': 'Device and browser mockups.',
  'designBrowser.reference.site.mockuuups.detail': 'Drag-and-drop device mockups.',
  'designBrowser.reference.site.angle.detail': '3D device mockup library.',
  'designBrowser.reference.site.rotato.detail': 'Animated 3D product mockups.',
  'designBrowser.reference.site.impeccable.detail': 'High-quality style and interface references.',
  'designBrowser.reference.site.styles_refero.detail': 'Design style references and visual systems.',
  'designBrowser.reference.site.brandfetch.detail': 'Brand assets, logos, and identity.',
  'designBrowser.reference.site.designsystemsrepo.detail': 'Gallery of public design systems.',
  'designBrowser.reference.site.startups.detail': 'Top startup product and brand references.',
  'designBrowser.reference.site.base_ui.detail': 'Unstyled accessible primitives for custom systems.',
  'designBrowser.reference.site.ui_shadcn.detail': 'Composable React components built on Radix and Tailwind.',
  'designBrowser.reference.site.heroui.detail': 'Modern React component library and design system.',
  'designBrowser.reference.site.radix_ui.detail': 'Accessible low-level UI primitives.',
  'designBrowser.reference.site.react_spectrum_adobe.detail': 'Accessible behavior primitives from Adobe.',
  'designBrowser.reference.site.headlessui.detail': 'Unstyled accessible components for Tailwind projects.',
  'designBrowser.reference.site.mui.detail': 'Material-based React component ecosystem.',
  'designBrowser.reference.site.mantine.detail': 'Full-featured React components and hooks.',
  'designBrowser.reference.site.chakra_ui.detail': 'Accessible React components with theme tokens.',
  'designBrowser.reference.site.ant.detail': 'Enterprise component system and patterns.',
  'designBrowser.reference.site.ark_ui.detail': 'Headless components across modern frameworks.',
  'designBrowser.reference.site.daisyui.detail': 'Tailwind CSS component classes and themes.',
  'designBrowser.reference.site.developer_apple.detail': 'Apple platform design guidelines.',
  'designBrowser.reference.site.m3_material.detail': 'Google\'s Material Design 3.',
  'designBrowser.reference.site.lawsofux.detail': 'UX principles and heuristics.',
  'designBrowser.reference.site.webaim.detail': 'Color contrast checker.',
  'designBrowser.reference.site.a11yproject.detail': 'Accessibility checklist and patterns.',
  'designBrowser.reference.site.toolfolio.detail': 'Design tools, resources, and collections.',
  'designBrowser.reference.site.getdesign.detail': 'Curated design resources.',
  'designBrowser.reference.site.tasteskill.detail': 'Design taste training and critique references.',
  'designBrowser.reference.site.uigoodies.detail': 'Hand-picked design resources.',
  'designBrowser.reference.site.sidebar.detail': 'Five design links, every day.',
  'designBrowser.reference.site.github.detail': 'Reference implementation for embedded browser workflows.',
  'browserUse.category.assets': 'Eszközök kinyerése',
  'browserUse.category.tokens': 'Designnyelv',
  'browserUse.category.motion': 'Mozgás',
  'browserUse.category.visual': 'Vizuális ellenőrzések',
  'browserUse.category.structure': 'Komponensek',
  'browserUse.category.project': 'Projektfuttatás',
  'browserUse.category.general': 'Általános',
  'browserUse.input.none': 'Nincs bemenet',
  'browserUse.input.assetKind': 'kind: images | svgs | media | fonts, limit=200',
  'browserUse.input.optionalSelector': 'Opcionális szelektor',
  'browserUse.input.requirementSelector': 'Követelmény, opcionális szelektor',
  'browserUse.input.selectorOptional': 'Opcionális szelektor',
  'browserUse.input.scaleOne': 'scale=1',
  'browserUse.input.selectorScaleTwo': 'Szelektor, scale=2',
  'browserUse.input.gridOverlay': '12 oszlop, max. 1200, térköz 24',
  'browserUse.input.bodySelector': 'selector=\'body\'',
  'browserUse.input.navigate': 'URL, domain vagy keresési kifejezések',
  'browserUse.input.selector': 'Szelektor',
  'browserUse.input.selectorText': 'Szelektor és szöveg',
  'browserUse.input.scroll': 'Pixel, felül, alul vagy oldal',
  'browserUse.input.terminalRun': 'Parancs, időtúllépés 120 mp',
  'browserUse.input.command': 'Parancs',
  'browserUse.input.maxChars': 'maxChars=8000',
  'browserUse.input.custom': '{input}',
  'browserUse.action.extract_logo.output': 'A legjobb logójelöltek a fejlécből, navigációból, osztálynevekből, pozícióból, OG-képből, valamint favicon tartalékként.',
  'browserUse.action.list_images.output': 'Minden img, srcset, source és CSS háttérkép méretekkel és alt szöveggel.',
  'browserUse.action.download_assets.output': 'Letöltött eszközmappa, valamint _manifest.json referer és cookie támogatással.',
  'browserUse.action.extract_svgs.output': 'Beágyazott SVG-k és hivatkozott .svg fájlok külön SVG fájlokként mentve.',
  'browserUse.action.optimize_svgs.output': 'Optimalizált SVG fájlok, valamint tömörítési arány.',
  'browserUse.action.extract_colors.output': 'Súlyozott paletta, valamint :root CSS színváltozók palette.json és palette.html formátumban.',
  'browserUse.action.extract_fonts.output': 'A leggyakoribb betűtípuscsaládok, méretek, vastagságok és @font-face szabályok typography.json formátumban.',
  'browserUse.action.extract_design_tokens.output': 'Sugár, árnyék, térköz és CSS-változók tokens.json fájlként.',
  'browserUse.action.extract_type_scale.output': 'Címsor-, törzsszöveg- és gombtípus-skála mérettel, vastagsággal, sormagassággal és arányokkal.',
  'browserUse.action.extract_buttons.output': 'Duplikátumoktól megtisztított gombstílus-könyvtár buttons.html és buttons.json fájlként.',
  'browserUse.action.extract_grid_system.output': 'Grid- és flex-konténerek, irány, közök, oszlopok és maximális szélességek layout.json fájlként.',
  'browserUse.action.extract_breakpoints.output': 'Reszponzív media query töréspontok breakpoints.json fájlként.',
  'browserUse.action.extract_gradients.output': 'CSS-színátmenetek gradients.css, gradients.json és előnézeti HTML formátumban.',
  'browserUse.action.extract_shadows.output': 'Dobozárnyékok, szövegárnyékok és vetett árnyékok shadows.json fájlként, előnézettel együtt.',
  'browserUse.action.extract_easings.output': 'Átmenet- és animáció-időzítő (easing) függvények easings.json fájlként.',
  'browserUse.action.export_tokens.output': 'tokens.css, tokens.scss, tailwind.theme.js és style-dictionary.tokens.json.',
  'browserUse.action.extract_animations.output': '@keyframes, átmenet- és transzformációs szabályok, észlelt mozgáskönyvtárak, motion.css és motion.json.',
  'browserUse.action.validate_view.output': 'Képernyőkép-útvonalak, valamint strukturált vizuális és elrendezési problémák.',
  'browserUse.action.audit_layout.output': 'Elrendezési hibák, beleértve a túlcsordulást, a határátlépést, az átfedést és a levágott szöveget audit.json fájlként.',
  'browserUse.action.audit_accessibility.output': 'Akadálymentesítési problémák szelektorokkal, címkékkel, szerepekkel, fókusszal, kontraszttal és ahol hasznos, képernyőképekkel.',
  'browserUse.action.responsive_screenshots.output': 'Mobil 390, tablet 834 és asztali 1440 képernyőképek.',
  'browserUse.action.screenshot_full.output': 'Teljes oldalas képernyőkép a látómezőn túl.',
  'browserUse.action.screenshot_element.output': 'Egyetlen elem képernyőképe alapértelmezetten 2x méretben.',
  'browserUse.action.screenshot_with_grid.output': 'Képernyőkép elrendezési rács átfedéssel.',
  'browserUse.action.screenshot_dark_mode.output': 'Képernyőkép prefers-color-scheme: dark beállítással.',
  'browserUse.action.generate_styleguide.output': 'Egyoldalas stílusútmutató színekkel, típusskálával, sugárral és árnyékokkal.',
  'browserUse.action.extract_html.output': 'Tiszta, önálló HTML script, noscript és beágyazott eseménykezelő attribútumok nélkül.',
  'browserUse.action.extract_component_inventory.output': 'Ismétlődő komponensmintázatok, szelektorok, darabszámok és képernyőképek.',
  'browserUse.action.extract_copy.output': 'Címsorok, CTA-k, törzsszöveg és leírások copy.md és copy.json fájlként.',
  'browserUse.action.extract_nav.output': 'Elsődleges navigációs és lábléc-hivatkozások sitemap.md és nav.json fájlként.',
  'browserUse.action.extract_forms.output': 'Űrlapmezők, címkék, validációs súgók és beküldési műveletek forms.json fájlként.',
  'browserUse.action.run_project.output': 'Az észlelt fejlesztői szerver URL-je a Browser fülön megnyitva.',
  'browserUse.action.detect_project.output': 'Keretrendszer, csomagkezelő, telepítési parancs, fejlesztői parancs és port.',
  'browserUse.action.page_info.output': 'URL, cím, leírás, OG-kép, témaszín, favicon és viewport.',
  'browserUse.action.snapshot.output': 'Legfeljebb 120 látható interaktív és szöveges elem tag-gel, címkével, href-fel és koordinátákkal.',
  'browserUse.action.navigate.output': 'Nyisd meg az oldalt, és add vissza a page_info adatokat.',
  'browserUse.action.click.output': 'Kattints az első egyező elemre, miután a látómezőbe görgetted.',
  'browserUse.action.type_text.output': 'Tölts ki egy beviteli mezőt, és váltsd ki az input és change eseményeket.',
  'browserUse.action.scroll.output': 'Aktuális és maximális görgetési pozíció.',
  'browserUse.action.extract_og_metadata.output': 'Meta cím, leírás, kanonikus URL, OG/Twitter kártyák, közösségi kép és témaszín.',
  'browserUse.action.terminal_run.output': 'stdout, stderr és kilépési kód.',
  'browserUse.action.terminal_run_background.output': 'Háttérfeladat azonosítója és legutóbbi kimenete.',
  'browserUse.action.terminal_read.output': 'Legutóbbi megosztott terminálkimenet.',
  'chat.designToolbox.title': 'Tervezői eszköztár',
  'chat.designToolbox.tooltip': 'Tervezői eszköztár',
  'chat.designToolbox.aria': 'Tervezői eszköztár megnyitása',
  'chat.designToolbox.searchPlaceholder': 'Készségek / MCP / bővítmények / csatlakozók / tervfájlok keresése...',
  'chat.designToolbox.searchAria': 'Tervezői eszköztár erőforrásainak keresése',
  'chat.designToolbox.followupSection': 'Folytatás',
  'chat.designToolbox.resourcesSection': 'Globális erőforrások',
  'chat.designToolbox.selected': 'Kiválasztva',
  'chat.designToolbox.noResources': 'Nincs erőforrás a következőhöz: "{query}".',
  'chat.designToolbox.badge.video': 'Videó',
  'chat.designToolbox.badge.image': 'Kép',
  'chat.designToolbox.badge.motion': 'Mozgás',
  'chat.designToolbox.badge.polish': 'Finomítás',
  'chat.designToolbox.action.auto-match.title': 'Következő lépés egyeztetése',
  'chat.designToolbox.action.auto-match.badge': 'Egyeztetés',
  'chat.designToolbox.action.auto-match.description': 'Előbb határozd meg az ízlésszintet, majd egyeztesd a készségeket, az MCP-t, a bővítményeket, a csatlakozókat és a fájlokat.',
  'chat.designToolbox.action.asset-search.title': 'Find images / references',
  'chat.designToolbox.action.asset-search.badge': 'Assets',
  'chat.designToolbox.action.asset-search.description': 'Search for usable images, reference screenshots, moodboards, and source candidates for the current design.',
  'chat.designToolbox.action.icon-workflow.title': 'Find / replace icons',
  'chat.designToolbox.action.icon-workflow.badge': 'Icons',
  'chat.designToolbox.action.icon-workflow.description': 'Find, generate, or swap iconography, SVGs, Lucide icons, and visual symbols with a consistent style.',
  'chat.designToolbox.action.image-replace.title': 'Replace page images',
  'chat.designToolbox.action.image-replace.badge': 'Swap',
  'chat.designToolbox.action.image-replace.description': 'Audit current imagery and replace weak hero, section, background, or card images with better assets.',
  'chat.designToolbox.action.reference-extract.title': 'Extract visual references',
  'chat.designToolbox.action.reference-extract.badge': 'Refs',
  'chat.designToolbox.action.reference-extract.description': 'Analyze a reference screenshot or site for palette, typography, layout posture, motion, and asset direction.',
  'chat.designToolbox.action.motion.title': 'Animáció / mozgás hozzáadása',
  'chat.designToolbox.action.motion.badge': 'Mozgás',
  'chat.designToolbox.action.motion.description': 'Adj belépési, görgetési, állapotátmeneti és mikrointerakciós mozgást az aktuális HTML-hez vagy oldalelemhez.',
  'chat.designToolbox.action.motion-polish.title': 'Mozgás finomítása',
  'chat.designToolbox.action.motion-polish.badge': 'Időzítés',
  'chat.designToolbox.action.motion-polish.description': 'Tekintsd át a meglévő mozgás időzítését, easing függvényeit, teljesítményét és a csökkentett mozgáshoz tartozó tartalék megoldásait.',
  'chat.designToolbox.action.transition-motion.title': 'Design transitions',
  'chat.designToolbox.action.transition-motion.badge': 'Transition',
  'chat.designToolbox.action.transition-motion.description': 'Design page, scene, loading, and state transitions with restrained timing and reduced-motion fallbacks.',
  'chat.designToolbox.action.threejs-scene.title': '3D / Three.js scene',
  'chat.designToolbox.action.threejs-scene.badge': '3D',
  'chat.designToolbox.action.threejs-scene.description': 'Add or plan Three.js, Spline, Vanta, particle, WebGL, map, or deck.gl-style interactive visuals.',
  'chat.designToolbox.action.anti-ai-polish.title': 'AI-érzet eltávolítása',
  'chat.designToolbox.action.anti-ai-polish.badge': 'Ízlés',
  'chat.designToolbox.action.anti-ai-polish.description': 'Távolítsd el a sablonos érzetet, az AI-gradienseket, az olcsó kártyahalmokat és a homályos szövegeket.',
  'chat.designToolbox.action.visual-polish.title': 'Dizájn finomítása / kiadásra kész',
  'chat.designToolbox.action.visual-polish.badge': 'Finomítás',
  'chat.designToolbox.action.visual-polish.description': 'Ellenőrizd a vizuális hierarchiát, a tipográfiát, a térközöket, a reszponzív viselkedést, az akadálymentességet és a kiszállítás minőségét.',
  'chat.designToolbox.action.image-gen.title': 'Képek / vizuális referenciák generálása',
  'chat.designToolbox.action.image-gen.badge': 'Kép',
  'chat.designToolbox.action.image-gen.description': 'Szakaszreferenciák, eszközök, ikonok, közösségi képek vagy moodboard generálása az aktuális oldalhoz.',
  'chat.designToolbox.action.chart-gen.title': 'Generate charts / diagrams',
  'chat.designToolbox.action.chart-gen.badge': 'Charts',
  'chat.designToolbox.action.chart-gen.description': 'Generate ECharts, React Flow, diagrams, dashboards, relationship maps, or data-visualization assets.',
  'chat.designToolbox.action.logo-gen.title': 'Generate logo / identity',
  'chat.designToolbox.action.logo-gen.badge': 'Logo',
  'chat.designToolbox.action.logo-gen.description': 'Create logo routes, wordmarks, lockups, marks, and identity-system prompts for the current brand.',
  'chat.designToolbox.action.plan-outline.title': "Generate PPT outline from idea",
  'chat.designToolbox.action.plan-outline.badge': "Plan",
  'chat.designToolbox.action.plan-outline.description': "Turn a rough idea into an editable Markdown deck outline before creating slides.",
  'chat.designToolbox.action.video-gen.title': 'Videó / mozgásszkript generálása',
  'chat.designToolbox.action.video-gen.badge': 'Videó',
  'chat.designToolbox.action.video-gen.description': 'Alakítsd a dizájnt rövid videóvá, Remotion / Hyperframes storyboarddá vagy generálásra kész prompttá.',
  'chat.designToolbox.kind.skill': 'Skill',
  'chat.designToolbox.kind.plugin': 'Plugin',
  'chat.designToolbox.kind.mcp': 'MCP',
  'chat.designToolbox.kind.mcpTemplate': 'MCP-sablon',
  'chat.designToolbox.kind.connector': 'Csatlakozó',
  'chat.designToolbox.kind.designFile': 'Dizájnfájl',
  'chat.designToolbox.context.browser': 'Böngésző',
  'chat.designToolbox.context.designFiles': 'Dizájnfájlok',
  'chat.designToolbox.context.designSystem': 'Dizájnrendszer',
  'chat.designToolbox.context.folder': 'Mappa',
  'chat.designToolbox.context.terminal': 'Terminál',
  'chat.designToolbox.context.sideChat': 'Oldalsó csevegés',
  'chat.designToolbox.context.liveArtifact': 'Élő artifact',
  'chat.designToolbox.context.file': 'Fájl',
  'chat.designToolbox.prompt.contextGeneric': 'Aktuális célpont: a jelenleg megnyitott HTML / dizájnfájl / webelem.',
  'chat.designToolbox.prompt.contextSpecific': 'Aktuális cél: {kind} · {label}.',
  'chat.designToolbox.prompt.preserveDraft': 'Őrizd meg a szerkesztőben már meglévő szándékot: {draft}',
  'chat.designToolbox.prompt.selectedSkill': 'Kiválasztott skill: {skill}. Használd ezt elsődleges munkafolyamatként ebben a körben.',
  'chat.designToolbox.prompt.noSkill': 'Ha nincs konkrét egyező skill, először válaszd ki a legjobb kombinációt az elérhető skillek, MCP-k, pluginok, csatlakozók és dizájnfájlok közül.',
  'chat.designToolbox.prompt.autoMatchIntro': 'Lépj fel kreatívigazgató-orchestratorként, és fejezz be egy dizájn-munkafolyamatot:',
  'chat.designToolbox.prompt.autoMatchStep1': '1. Először határozd meg, mit jelent a „jól kinéző dizájn”: célközönség, üzleti cél, márkaérzet, stílusreferenciák, információsűrűség, szín-/tipográfia-/mozgás-/asset-szabványok, valamint a kerülendő AI-/sablonmintázatok.',
  'chat.designToolbox.prompt.autoMatchStep2': '2. Keresd át és illeszd hozzá a fenti teljes erőforrásindexet. Ne csak a dizájn-eszköztár ajánlásait használd; ahol hasznos, kombináld a skilleket, MCP-ket, pluginokat, csatlakozókat és dizájnfájlokat.',
  'chat.designToolbox.prompt.autoMatchStep3': '3. If the target or aesthetic bar is still unclear, guide me with a structured question-form, include recommended defaults, and make each finite-choice question editable with a custom answer field. If it is clear enough, execute the next step directly.',
  'chat.designToolbox.prompt.autoMatchStep4': '4. Fejezd be a folyamatot ebben a sorrendben: diagnózis -> stílusirány -> erőforrásválasztás -> konkrét szerkesztés/generálás -> ellenőrzés. Minden lépésnél magyarázd el, miért ezeket az erőforrásokat választottad, és mit kell legközelebb megerősíteni.',
  'chat.designToolbox.prompt.assetSearch': 'Find the best image/reference assets for the current design. Search available files, connectors, MCPs, browser captures, and generation tools. Return concrete candidates with usage notes, licensing/source caveats when relevant, and a fallback generation prompt if no usable asset exists.',
  'chat.designToolbox.prompt.iconWorkflow': 'Improve the icon system for the current design: find missing icons, replace weak icons, keep stroke/fill/radius/weight consistent, prefer existing icon libraries when available, and generate SVG/icon prompts only when a library icon is insufficient.',
  'chat.designToolbox.prompt.imageReplace': 'Audit every visible image slot in the current design, identify weak or placeholder imagery, then replace or specify better hero, section, background, card, and social images. Preserve layout and provide exact file/prompt/source choices.',
  'chat.designToolbox.prompt.referenceExtract': 'Use the current reference image/site/design file as visual input. Extract palette, type scale, layout rhythm, component posture, motion cues, and asset style, then apply those findings to the current design without copying protected brand assets verbatim.',
  'chat.designToolbox.prompt.motion': 'Add high-quality motion to the current HTML / page element: choose the most useful 1-2 entrance, scroll, state-transition, transition, Rive/Lottie-style icon motion, or GSAP/Motion micro-interaction moments. Keep it restrained, prefer transform / opacity, and include prefers-reduced-motion fallbacks.',
  'chat.designToolbox.prompt.planOutline': "Create or update a Markdown planning document for a PPT/deck outline from this idea. Do not generate the final deck yet. Include slide-by-slide titles, goals, content bullets, visual direction, required data/assets, and open questions. Save it as a `.md` file in Design Files and tell me which file to review.",
  'chat.designToolbox.prompt.motionPolish': 'Vizsgáld felül és finomítsd a meglévő mozgás időzítését, gyorsulását, teljesítményét és akadálymentességét. Távolítsd el a hirtelen, olcsó vagy az olvashatóságot rontó animációkat; szükség esetén használj kifinomultabb idővonalat.',
  'chat.designToolbox.prompt.transitionMotion': 'Design high-quality transitions for the current design: page/scene changes, loading bridges, state changes, and section handoffs. Use GSAP/Motion/CSS where appropriate, keep it performant, and include reduced-motion behavior.',
  'chat.designToolbox.prompt.threejsScene': 'Plan or implement a focused Three.js/WebGL visual for the current design. Consider Three.js, Spline-style scenes, Vanta backgrounds, particle systems, Mapbox/deck.gl data layers, or browser portal effects, but keep the scene useful and verify it renders.',
  'chat.designToolbox.prompt.antiAiPolish': 'Végezz egy AI-érzet elleni finomítási kört: távolítsd el a sablonos elrendezéseket, az olcsó gradienseket/ragyogásokat, az értelmetlen kártyahalmokat és a homályos szövegeket. Őrizd meg az információt, és tedd olyanná, mintha egy valódi dizájner adta volna át.',
  'chat.designToolbox.prompt.visualPolish': 'Finomítsd ezt a dizájnt, amíg kiadásra kész nem lesz: ellenőrizd a hierarchiát, a tipográfiát, a térközöket, a reszponzív viselkedést, a gombállapotokat, az üres/betöltési/hibaállapotokat és az akadálymentességet; közvetlenül javítsd ki a legfontosabb problémákat.',
  'chat.designToolbox.prompt.imageGen': 'Készítsd el a következő vizuáliseszköz-tervet ehhez a dizájnhoz: szakaszreferenciák, hero-eszközök, illusztrációk, ikonok, közösségi képek vagy moodboard. Először döntsd el, milyen típusú kép hiányzik, majd adj végrehajtható generálási prompteket / fájltervet.',
  'chat.designToolbox.prompt.chartGen': 'Generate the right chart, diagram, or data-visualization for the current design. Choose between ECharts, React Flow, SVG/CSS diagrams, radar charts, relationship maps, dashboards, or deck.gl/map visualizations based on the data and user goal.',
  'chat.designToolbox.prompt.logoGen': 'Create logo and identity directions for the current brand. Produce multiple routes for wordmark, symbol, lockup, palette, usage rules, and generation prompts; make sure the result is original and usable in the current artifact.',
  'chat.designToolbox.prompt.videoGen': 'Fordítsd ezt a dizájnt a videó felé: készíts rövidvideó-storyboardot, Hyperframes / Remotion képkockastruktúrát vagy Sora/fal-ra kész promptot. Részesítsd előnyben, hogy a meglévő HTML / oldaltartalom természetesen váljon felvételekké.',
  'chat.designToolbox.prompt.useSkill': 'Használd a(z) {skill} skillt az aktuális dizájnon.',
  'chat.designToolbox.prompt.skillInstruction': 'Először döntsd el a legjobb következő célt, majd fejezz be egy konkrét kört. Ha külső eszközöktől vagy API-któl függ, adj egy futtatható tartalék megoldást, vagy mondd meg, mit kell biztosítanom.',
  'chat.designToolbox.prompt.selectedResource': 'Kiválasztott erőforrás: {kind} · {title} ({id}).',
  'chat.designToolbox.prompt.resourceDescription': 'Erőforrás leírása: {description}',
  'chat.designToolbox.prompt.pluginResource': 'Használd ezt a plugint az aktuális dizájnfolyamat fő kontextusaként. Ha bemeneteket vagy GenUI-t tesz elérhetővé, szükség esetén irányíts a választásban; ha nem illik a célponthoz, válassz egy jobb globális erőforrást, és magyarázd el, miért.',
  'chat.designToolbox.prompt.mcpResource': 'Részesítsd előnyben ezt az MCP-képességet a következő dizájnlépéshez. Amikor külső eszközökre, webes rögzítésre, kép-/videógenerálásra vagy adatokra van szükség, először döntsd el, hogy elvégzi-e a feladatot, majd adj végrehajtható tervet.',
  'chat.designToolbox.prompt.mcpTemplateResource': 'Ez az MCP egy konfigurálható sablon. Ha ez a leghasznosabb eszköz ehhez a dizájnlépéshez, először irányíts a beállításon; ha létezik konfigurált alternatíva, folytasd azzal az alternatívával.',
  'chat.designToolbox.prompt.connectorResource': 'Használd ezt a csatlakozót, amikor valós adatokra, eszközökre, fióktartalomra vagy külső munkafolyamathoz való hozzáférésre van szükség. Használat előtt magyarázd el, mit fognak olvasni vagy írni, és kérj megerősítést, amikor az helyénvaló.',
  'chat.designToolbox.prompt.fileResource': 'Használd ezt a dizájnfájlt aktuális dizájncélpontként vagy referenciaeszközként, és ebből fejezd be a következő lépést. Ha más fájlokat is össze kell hasonlítani, folytasd a keresést az összes dizájnfájl között.',
  'chat.designToolbox.prompt.resourceIndex': 'Globális erőforrásindex: skillek({skills}), pluginok({plugins}), MCP({mcpEnabled} engedélyezve / {mcpTemplates} sablon), csatlakozók({connectors} csatlakoztatva), dizájnfájlok({files}).',
  'chat.designToolbox.prompt.searchableSkills': 'Kereshető skillek',
  'chat.designToolbox.prompt.searchablePlugins': 'Kereshető pluginok',
  'chat.designToolbox.prompt.availableMcp': 'Elérhető MCP',
  'chat.designToolbox.prompt.connectedConnectors': 'Csatlakoztatott csatlakozók',
  'chat.designToolbox.prompt.referenceDesignFiles': 'Referencia dizájnfájlok',
  'chat.designToolbox.prompt.mcpTemplateName': '{name} sablon',
  'chat.designToolbox.prompt.processRule': 'Workflow rule: define the aesthetic goal and constraints first, then search and match resources; when user choice is needed, generate a structured question-form with editable custom answers and continue after confirmation.',
  'chat.designToolbox.prompt.moreSuffix': ', +{count} további',
  'chat.designToolbox.prompt.compactLine': '{label}: {values}{suffix}.',
  'chat.mentionTabsAria': 'Említési felületek',
  'chat.mentionTabAll': 'Mind',
  'chat.mentionTabTabs': 'Lapok',
  'chat.mentionTabPlugins': 'Bővítmények',
  'chat.mentionTabSkills': 'Készségek',
  'chat.mentionTabMcp': 'MCP',
  'chat.mentionTabConnectors': 'Csatlakozók',
  'chat.mentionTabFiles': 'Tervezőfájlok',
  'chat.mentionNoResults': 'Nincs találat erre: „{query}”.',
  'chat.mentionSearchPrompt': 'Tervezőfájlok, lapok, bővítmények, készségek, MCP-kiszolgálók és csatlakozók keresése.',
  'chat.mentionSectionTabs': 'Lapok',
  'chat.mentionSectionPlugins': 'Bővítmények',
  'chat.mentionSectionSkills': 'Készségek',
  'chat.mentionSectionMcp': 'MCP',
  'chat.mentionSectionConnectors': 'Csatlakozók',
  'chat.mentionSectionFiles': 'Tervezőfájlok',
  'chat.mentionActiveSkill': 'Aktív',
  'chat.mentionUseMcpTitle': '{name} használata',
  'chat.mentionUseConnectorTitle': '{name} használata',
  'chat.mentionPluginOfficial': 'Hivatalos',
  'chat.mentionPluginMine': 'Saját bővítmény',
  'chat.linkedFolderRemoveAria': 'Hozzákapcsolt mappa eltávolítása {path}',
  'chat.linkedFolderNotFound': 'A mappa nem létezik',
  'chat.linkedFolderAlready': 'Ez a mappa már hozzá van kapcsolva',
  'chat.linkedFolderPickError': 'Nem sikerült megnyitni a mappaválasztót',
  'chat.queuedHeader': 'Sorban áll',
  'chat.queuedToSend': 'a küldéshez',
  'chat.queuedEditQueuedTaskAria': 'Sorban álló feladat szerkesztése',
  'chat.queuedSave': 'Mentés',
  'chat.queuedCancel': 'Mégse',
  'chat.queuedReorder': 'Húzza az átrendezéshez',
  'chat.queuedEdit': 'Szerkesztés',
  'chat.queuedMore': 'további sorban áll',
  'chat.queuedFollowUpFallback': 'Sorban álló utókövetés',
  'chat.send': 'Küldés',
  'chat.stop': 'Leállítás',
  'chat.removeAria': '{name} eltávolítása',
  'chat.example1Title': 'Magazinszerű pitch deck',
  'chat.example1Tag': 'Magazin',
  'chat.example1Prompt': 'Egy 10 diás magazinszerű pitch deck egy designstúdió seed köréhez — svájci rácselrendezés, túlméretezett serif címsorok félkövér drop capekkel, monospace szakaszszámok, bőséges üres tér, és teljes kihasználású fotódiák szövegközpontú diákkal váltakozva. Borító, vízió, piac, termék, eredmények, csapat, kérés, kapcsolat.',
  'chat.example2Title': 'SaaS analitikai dashboard',
  'chat.example2Tag': 'Adat',
  'chat.example2Prompt': 'Sűrű analitikai dashboard fejlesztői SaaS-hez — KPI-csík hét/hét deltákkal, két egymásra rakott vonaldiagram (MRR és aktív munkaterületek), világtérképes hőtérkép a használatról, kohorsz-megtartási rács, top-ügyfelek ranglista, és valós idejű eseménystream. Sötét téma, táblázatos monospace számok, sparkline akcentusok.',
  'chat.example3Title': 'Éves jelentés long-scroll',
  'chat.example3Tag': 'Magazinszerű',
  'chat.example3Prompt': 'Interaktív éves jelentés egy klíma-non-profitnak — long-scroll magazinszerű elrendezés, nagy kiemelt-idézet blokkokkal, adatvizualizációkkal (egymásra rakott oszlopok, animált számlálók, projekthelyek choropleth térképe), fotó-megszakítókkal, donor fallal, és záró cselekvésre hívással. Modern serif törzs, sans-serif diagramcímkék, földes papírpaletta.',
  'home.recommendation.eyebrow': 'Neked ajánljuk',
  'home.recommendation.primaryCta': 'Alkotás indítása',
  'home.recommendation.change': 'Próbálj ki másikat',
  'home.recommendation.browseAll': 'Összes típus',
  'home.recommendation.defaultProjectName': 'Új projekt',
  'home.recommendation.startFailed': 'Nem sikerült elindítani a létrehozást. Próbáld újra.',
  'studio.firstArtifactHint.title': 'Az első terved elkészült',
  'studio.firstArtifactHint.body': 'Próbáld meg közvetlenül szerkeszteni és jegyzetelni — exportáld vagy oszd meg, ha elégedett vagy.',
  'studio.firstArtifactHint.dismiss': 'Értem',
  'home.starter.product_ui_prototype.title': 'Kezdj egy szerkeszthető termékprototípussal',
  'home.starter.product_ui_prototype.desc': 'A célod alapján kezdj egy kattintható felülettel, amelyet finomíthatsz.',
  'home.starter.product_ui_prototype.firstPrompt': 'Tervezz egy szerkeszthető termékprototípust a(z) [terméked] számára a kulcsképernyőkkel és egy világos elsődleges folyamattal.',
  'home.starter.product_ui_component.title': 'Kezdj egy újrafelhasználható komponenssel',
  'home.starter.product_ui_component.desc': 'Először építs egy komponenst, majd állítsd össze belőle a teljes képernyőket.',
  'home.starter.product_ui_component.firstPrompt': 'Tervezz egy újrafelhasználható [komponens neve] komponenst a fő állapotaival és változataival.',
  'home.starter.product_ui_lowfi.title': 'Kezdj egy alacsony részletességű prototípussal',
  'home.starter.product_ui_lowfi.desc': 'Először vázold fel a szerkezetet, majd emeld a részletességet.',
  'home.starter.product_ui_lowfi.firstPrompt': 'Készíts egy alacsony részletességű drótvázat a fő képernyőkről a(z) [terméked] számára.',
  'home.starter.marketing_landing.title': 'Kezdj egy landing oldallal',
  'home.starter.marketing_landing.desc': 'Alakítsd a kampányodat egy közzétehető landing oldallá.',
  'home.starter.marketing_landing.firstPrompt': 'Tervezz egy landing oldalt a(z) [terméked] számára egy hero szekcióval, a fő előnyökkel és egy világos cselekvésre hívással.',
  'home.starter.marketing_multivariant.title': 'Kezdj több landing változattal',
  'home.starter.marketing_multivariant.desc': 'Generálj néhány verziót az összehasonlításhoz, mielőtt döntesz.',
  'home.starter.marketing_multivariant.firstPrompt': 'Készíts 3 landing oldal változatot a(z) [terméked] számára eltérő hero üzenetekkel az összehasonlításhoz.',
  'home.starter.internal_dashboard.title': 'Kezdj egy belső irányítópulttal',
  'home.starter.internal_dashboard.desc': 'Indulj egy irányítópult-elrendezésből a munkafolyamatodhoz.',
  'home.starter.internal_dashboard.firstPrompt': 'Tervezz egy belső irányítópultot, amely a(z) [kulcsmutatók] elemeket jeleníti meg szűrőkkel és egy adattáblával.',
  'home.starter.internal_report.title': 'Kezdj egy jelentéssel',
  'home.starter.internal_report.desc': 'Írd le az adatokat és mezőket, amelyeket látni szeretnél.',
  'home.starter.internal_report.firstPrompt': 'Készíts egy jelentésoldalt, amely összegzi a(z) [írd le a számodra fontos adatokat, mezőket és mutatókat] elemeket.',
  'home.starter.general_menu.title': 'Kezdj az első projekteddel',
  'home.starter.general_menu.desc': 'Írd le, mit szeretnél, és mi generálunk egy szerkeszthető első verziót.',
  'home.starter.general_menu.firstPrompt': 'Készíts egy szerkeszthető első verziót a(z) [írd le, mit szeretnél készíteni] elemből.',
  'chat.example4Title': 'Termék motion videó',
  'chat.example4Tag': 'Motion',
  'chat.example4Prompt': 'Készíts 15 másodperces motion videó storyboardot egy produktivitási app bevezetéséhez: nyitó hook, UI-közeli képek, kinetikus tipográfia, funkcióátmenetek, záró logo és CTA. Add meg az időzítést, jeleneteket, kameramozgást és képernyőszövegeket.',
  'preview.usePlugin': 'Bővítmény használata',
  'preview.usePluginOnly': 'Hasznalat prompt nelkul',
  'preview.usePluginOnlyDesc': 'Hasznald a bovítmeny szerkezetet a peldaprompt betoltese nelkul',
  'preview.replicateContent': 'Hasznalat',
  'preview.replicateContentDesc': 'Hasznald a peldapromptot az elonezet ujraalkotasahoz',
  'preview.duplicateTemplate': 'Remix',
  'preview.duplicateTemplateDesc': 'Remixeld ezt a peldat egy uj, szerkesztheto projektbe',
  'preview.shareMenu': 'Megosztás',
  'preview.exportMenu': 'Exportálás',
  'preview.shareTemplateBadge': 'Sablon',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': 'Sablonhivatkozás másolása',
  'preview.copyShareText': 'Megosztási szöveg másolása',
  'preview.shareSocialGroup': 'Megosztás közösségi médiában',
  'preview.shareCopyGroup': 'Másolás',
  'preview.shareExportGroup': 'Fájlok exportálása',
  'preview.shareCopied': 'Másolva',
  'preview.shareCopyFailed': 'A másolás sikertelen',
  'preview.shareTextDefault': 'Open Design sablon: {title}',
  'preview.openInNewTab': 'Megnyitás új lapon',
  'preview.exit': '⤓ Kilépés',
  'preview.fullscreen': '⤢ Teljes képernyő',
  'preview.closeTitle': 'Bezárás (Esc)',
  'preview.loading': '{label} betöltése…',
  'preview.errorTitle': 'A példa betöltése nem sikerült.',
  'preview.errorBody': 'A példa HTML-jének letöltése meghiúsult. Győződj meg róla, hogy az Open Design fut, majd próbáld újra.',
  'preview.retry': 'Újra',
  'preview.unavailableTitle': 'Nincs mellékelt előnézet: {noun}.',
  'preview.unavailableBody': 'Futtasd a promptot a csevegésben, hogy {kind} kimenetet készíts.',
  'preview.nounSkill': 'ez a skill',
  'preview.nounPlugin': 'ez a plugin',
  'preview.nounTemplate': 'ez a sablon',
  'preview.showSidebar': '{label} megjelenítése',
  'preview.hideSidebar': '{label} elrejtése',
  'misc.savedTemplate': 'Mentett sablon',
  'misc.primary': 'Elsődleges',
  'misc.designSystem': 'Designrendszer',
  'workspace.designFiles': 'Designfájlok',
  'workspace.focusMode': 'Munkaterület fókuszálása',
  'workspace.showChat': 'Csevegés megjelenítése',
  'workspace.closeTab': 'Lap bezárása',
  'workspace.fileSyncDownloading': 'Letöltés a csapattól…',
  'workspace.fileSyncUploading': 'Szinkronizálás a csapattal…',
  'workspace.deleteFileConfirm': 'Törlöd a(z) „{name}" fájlt a projektmappából?',
  'workspace.readonlyNotice': 'Ez egy megosztott projekt — megtekintheted és kommentálhatod, de a műtermékeket nem módosíthatod Chaten vagy a szerkesztőeszközökön keresztül.',
  'workspace.readonlyNoticeBy': 'Ez egy {owner} által létrehozott megosztott projekt — megtekintheted és kommentálhatod, de a műtermékeket nem módosíthatod Chaten vagy a szerkesztőeszközökön keresztül.',
  'workspace.deleteSelectedFilesConfirm': 'Törlöd a(z) {n} kijelölt fájlt a projektmappából?',
  'workspace.deleteSelectedFilesPartial': '{n} fájl törlése sikertelen.',
  'workspace.openFromDesignFiles': 'Nyiss meg egy fájlt innen:',
  'workspace.designFilesLink': 'Designfájlok',
  'workspace.loadingSketch': 'Vázlat betöltése…',
  'workspace.newTab': 'Új lap',
  'workspace.searchFilesPlaceholder': 'Search files…',
  'workspace.openTabs': 'Megnyitott lapok',
  'workspace.searchTabs': 'Search tabs',
  'workspace.noTabsFound': 'No tabs found',
  'workspace.openFile': 'Open a file',
  'workspace.noFilesMatch': 'No files match',
  'workspace.allFiles': 'All',
  'workspace.createNew': 'Create new',
  'workspace.tabOpen': 'Open',
  'workspace.sideChatContextBanner': 'Integrated context from the current conversation',
  'workspace.sideChatDefaultTitle': 'Side chat',
  'workspace.newTerminal': 'New Terminal',
  'workspace.newTerminalDescription': 'Open a shell in the project directory in a new tab',
  'workspace.newBrowser': 'New Browser',
  'workspace.newBrowserDescription': 'Open a built-in browser tab for reference sites and design research',
  'workspace.newSketchDescription': 'Sketch rough layouts and notes for the agent to use as design context',
  'workspace.terminalStarting': 'Terminál indítása…',
  'workspace.terminalStartingDescription': 'A projekt shell előkészítése. Ez általában csak néhány másodperc.',
  'workspace.terminalSessionEnded': 'A munkamenet véget ért',
  'workspace.terminalReconnecting': 'Újracsatlakozás…',
  'workspace.terminalStartFailed': 'Nem sikerült elindítani a terminálmunkamenetet',
  'workspace.terminalRestart': 'Újraindítás',
  'designFiles.title': 'Designfájlok',
  'designFiles.upload': 'Fájlok feltöltése',
  'designFiles.pasteText': 'Beillesztés szövegfájlként',
  'designFiles.newSketch': 'Új vázlat',
  'designFiles.newDocument': 'Új dokumentum',
  'designFiles.newDocumentTitle': 'Új Markdown-dokumentum létrehozása',
  'designFiles.empty': 'A kreációk itt jelennek meg',
  'designFiles.syncing': 'A csapat megosztott fájljainak szinkronizálása…',
  'designFiles.refresh': 'Frissítés',
  'designFiles.delete': 'Törlés',
  'designFiles.searchPlaceholder': 'Fájlok keresése…',
  'designFiles.up': 'Fel',
  'designFiles.back': 'Vissza',
  'designFiles.crumbs': 'projekt',
  'designFiles.rowMenu': 'Sor menü',
  'designFiles.openInTab': 'Megnyitás lapon',
  'designFiles.download': 'Letöltés',
  'designFiles.downloadSelected': '{n} fájl letöltése ZIP-ként',
  'designFiles.deleteSelected': '{n} törlése',
  'designFiles.clearSelection': 'Kijelölés törlése',
  'designFiles.selectPage': 'Összes kijelölése az oldalon',
  'designFiles.selectAll': 'Összes kijelölése',
  'designFiles.dropTitle': '⤓ Húzd ide a fájlokat',
  'designFiles.dropDesc': 'Képek, dokumentumok, hivatkozások vagy mappák — az ügynök kontextusként használja őket.',
  'designFiles.dropLabel': 'Húzd ide a fájlokat',
  'designFiles.upload.title': 'Fájlok feltöltése',
  'designFiles.paste.title': "Szöveg beillesztése fájlként",
  'designFiles.upload.label': 'Feltöltés',
  'designFiles.paste.label': "Beillesztés",
  'designFiles.documentTemplate.titleFallback': 'Document',
  'designFiles.documentTemplate.goalHeading': 'Goal',
  'designFiles.documentTemplate.goalBody': 'Describe what Open Design should generate, edit, or decide from this document.',
  'designFiles.documentTemplate.capabilitiesHeading': 'How to use this document',
  'designFiles.documentTemplate.capabilityMarkdown': 'Use any Markdown format: headings, tables, checklists, links, quotes, code blocks, and images.',
  'designFiles.documentTemplate.capabilityAgent': 'The Open Design agent can read, edit, and use this file as project context.',
  'designFiles.documentTemplate.capabilityImages': 'Paste images, or drag image files onto the editor; uploaded images are inserted at the cursor.',
  'designFiles.documentTemplate.scenarioHeading': 'Scenario guide',
  'designFiles.documentTemplate.scenario.prototype': 'For prototypes, outline the product goal, target users, flows, screens, modules, interaction states, responsive breakpoints, and design tokens such as color, type, spacing, radius, and motion.',
  'designFiles.documentTemplate.scenario.wireframe': 'For wireframes, describe the user flow, screen list, layout hierarchy, content blocks, low-fidelity constraints, and the questions the structure should answer before visual design.',
  'designFiles.documentTemplate.scenario.mobile': 'For mobile apps, list target platforms, screens, navigation model, gestures, native patterns, device sizes, states, and mobile design tokens.',
  'designFiles.documentTemplate.scenario.slideDeck': 'For slides, write a paginated PPT outline: one section per slide with title, purpose, key message, evidence, visual direction, speaker notes, and export needs.',
  'designFiles.documentTemplate.scenario.document': 'For documents, define audience, tone, section structure, source material, citations or data, layout expectations, and PDF/export requirements.',
  'designFiles.documentTemplate.scenario.image': 'For images, specify subject, aspect ratio, composition, visual style, brand tokens, reference files, and negative constraints.',
  'designFiles.documentTemplate.scenario.video': 'For video, draft a storyboard with scenes, timing, captions, motion, assets, audio notes, and output format.',
  'designFiles.documentTemplate.scenario.hyperframes': 'For HyperFrames, describe the HTML motion piece: scenes, timeline, captions, audio-reactive moments, transitions, and capture/export requirements.',
  'designFiles.documentTemplate.scenario.audio': 'For audio, define voice or music direction, duration, mood, script or copy, pacing, pronunciation notes, and final use.',
  'designFiles.documentTemplate.scenario.liveArtifact': 'For live artifacts, describe data sources, refresh cadence, widgets, filters, interactions, empty/loading/error states, and any alerts or automations.',
  'designFiles.documentTemplate.scenario.designSystem': 'For design systems, list brand goals, tokens, typography, color, spacing, components, assets, references, and rules to follow or avoid.',
  'designFiles.documentTemplate.scenario.default': 'Describe the audience, deliverable, required content, references, constraints, and what done should look like.',
  'designFiles.documentTemplate.nextHeading': 'Next step',
  'designFiles.documentTemplate.nextBody': 'Review and edit this document, then ask Open Design to generate, revise, or operate from it.',

  'designFiles.projectMenu': 'Project actions',
  'designFiles.createDesignSystemFromProject': 'Create design system from this project',
  'designFiles.duplicateProject': 'Duplicate project',

  'designFiles.previewOpen': 'Megnyitás',
  'designFiles.previewClose': 'Előnézet bezárása',
  'designFiles.modified': 'Módosítva: {time} · {size}',
  'designFiles.weeksAgo': '{n} hete',
  'designFiles.groupBy': 'Csoportosítás',
  'designFiles.groupByKind': 'Típus',
  'designFiles.groupByModified': 'Módosítás',
  'designFiles.filterBy': 'Szűrés típus szerint',
  'designFiles.filterClear': 'Törlés',
  'designFiles.filterCount': '{n} típus',
  'designFiles.expandGroup': 'Kibontás',
  'designFiles.collapseGroup': 'Összecsukás',
  'designFiles.sectionPages': 'Oldalak',
  'designFiles.sectionScripts': 'Szkriptek',
  'designFiles.sectionImages': 'Képek',
  'designFiles.sectionSketches': 'Vázlatok',
  'designFiles.sectionLiveArtifacts': 'Élő elemek',
  'designFiles.sectionOther': 'Egyéb',
  'designFiles.modifiedToday': 'Ma',
  'designFiles.modifiedYesterday': 'Tegnap',
  'designFiles.modifiedPrevious7Days': 'Előző 7 nap',
  'designFiles.modifiedPrevious30Days': 'Előző 30 nap',
  'designFiles.modifiedOlder': 'Régebbi',
  'designFiles.showMore': '+{n} további megjelenítése',
  'designFiles.kindHtml': 'HTML oldal',
  'designFiles.kindImage': 'Kép',
  'designFiles.kindSketch': 'Vázlat',
  'designFiles.kindText': 'Szöveg',
  'designFiles.kindCode': 'Szkript',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': 'Dokumentum',
  'designFiles.kindPresentation': 'Prezentáció',
  'designFiles.kindSpreadsheet': 'Táblázat',
  'designFiles.kindLiveArtifact': 'Élő elem',
  'designFiles.kindBinary': 'Bináris',
  'designFiles.kindFolder': 'Mappa',
  'designFiles.folderCount': '{n} fájl',
  'designFiles.newFolderTitle': 'Új mappa',
  'designFiles.newFolderLabel': 'Mappa neve',
  'designFiles.moveTitle': 'Áthelyezés mappába',
  'designFiles.moveLabel': 'Cél mappa',
  'designFiles.moveRoot': 'Projekt gyökere',
  'designFiles.moveNewFolder': 'Új mappa…',
  'designFiles.move': 'Áthelyezés',
  'designFiles.copyPath': 'Útvonal másolása',
  'designFiles.copiedPath': 'Útvonal másolva',
  'designFiles.copyLocalPath': 'Helyi fájlútvonal másolása',
  'designFiles.copiedLocalPath': 'Helyi fájlútvonal másolva',
  'designFiles.deleteFolderConfirm': 'Törli a(z) „{name}“ mappát és teljes tartalmát?',
  'designFiles.folderCreated': '„{name}“ mappa létrehozva',
  'designFiles.folderDeleted': '„{name}“ mappa törölve',
  'designFiles.filesMoved': '{n} áthelyezve ide: {dest}',
  'designFiles.colName': 'Név',
  'designFiles.colKind': 'Típus',
  'designFiles.colModified': 'Módosítva',
  'designFiles.perPage': 'Mutat',
  'designFiles.all': 'Összes',
  'designFiles.prev': 'Előző',
  'designFiles.next': 'Következő',
  'designFiles.jumpToPage': 'Ugrás oldalra',
  'designFiles.pageInfo': '{start}–{end} / {total}',
  'designFiles.sectionFolders': 'Mappák',
  'designFiles.sectionStylesheets': 'Stíluslapok',
  'designFiles.sectionDocuments': 'Dokumentumok',
  'designFiles.kindStylesheet': 'Stíluslap',
  'designFiles.modifiedExt': 'Módosítva: {time} · {size} · {ext}',
  'designFiles.usefulInfoLabel': 'Hasznos információk',
  'designFiles.usefulInfoTip': 'Kattints duplán bármelyik fájlra, hogy egy teljes lapon nyisd meg.',
  'designFiles.usefulInfoTip2': 'Írj @ jelet a csevegésben, hogy fájlt használj kontextusként.',
  'designFiles.usefulInfoTip4': 'Válassz design rendszert, és az eredmény a márkádhoz igazodik.',
  'designFiles.usefulInfoTip5': 'Nincs ötleted? Próbálj ki egy plugin sablont a kezdőlap Közösség részében.',
  'designFiles.usefulInfoTip6': 'Kérdésed vagy javaslatod van? Csatlakozz hozzánk Discordon.',
  'designFiles.usefulInfoTip7': 'Tetszik az Open Design? Adj egy csillagot GitHubon.',
  'designFiles.usefulInfoTip8': 'Kövesd a @OpenDesignHQ fiókot X-en a friss hírekért.',
  'designFiles.usefulInfoTip9': 'Húzz képeket, dokumentumokat vagy egész mappákat erre a panelre — az ügynök kontextusként használja őket.',
  'designFiles.usefulInfoTip10': 'Kattints az „Új vázlat” gombra, rajzolj egy elrendezést, és az ügynök elkészíti.',
  'designFiles.usefulInfoTip11': 'Jelölj ki bármilyen elemet az előnézetben és írj megjegyzést — az ügynök célzottan módosít.',
  'designFiles.usefulInfoTip12': 'Nem tetszik az eredmény? Bekarikázni gyorsabb, mint újra leírni.',
  'designFiles.usefulInfoTip13': 'Bármely terv egy kattintással exportálható PDF, kép vagy önálló HTML formátumban.',
  'designFiles.usefulInfoTip14': 'Elégedett vagy egy projekttel? Mentsd el sablonként a Megosztás menüből.',
  'designFiles.usefulInfoTip15': 'Telepítés után azonnal készíthetsz közösségi megosztókártyákat.',
  'designFiles.usefulInfoTip16': 'Kövesd a @opendesign.ai fiókot a Threadsen a kulisszák mögötti hírekért.',
  'designFiles.usefulInfoTip17': 'Kövesd a @opendesign.ai fiókot az Instagramon dizájn-inspirációért.',
  'designFiles.usefulInfoTip18': 'Iratkozz fel az Open Designra a YouTube-on oktatóanyagokért és demókért.',
  'designFiles.usefulInfoTip19': 'Kövesd az Open Designt a LinkedInen a termékhírekért.',
  'designFiles.usefulInfoTip20': 'Kövesd az Open Designt a Xiaohongshun tippekért és inspirációért.',
  'quickSwitcher.placeholder': 'Fájl megnyitása…',
  'quickSwitcher.empty': 'Nincsenek fájlok ebben a projektben',
  'quickSwitcher.noMatches': 'Nincs találat',
  'quickSwitcher.navigate': 'navigáció',
  'quickSwitcher.open': 'megnyitás',
  'quickSwitcher.close': 'bezárás',
  'pasteDialog.title': 'Szöveg beillesztése',
  'pasteDialog.hint': 'A projektmappába mentve. Bármilyen név adható.',
  'pasteDialog.fileNameLabel': 'Fájlnév',
  'pasteDialog.namePlaceholder': 'jegyzetek.txt',
  'pasteDialog.contentLabel': 'Tartalom',
  'pasteDialog.contentPlaceholder': 'Illessz be bármit…',
  'pasteDialog.save': 'Mentés',
  'pasteDialog.cancel': 'Mégse',
  'sketch.save': 'Vázlat mentése',
  'sketch.cancel': 'Mégse',
  'sketch.saving': 'Mentés…',
  'sketch.saved': 'Mentve',
  'sketch.tooltipMainMenu': 'Főmenü: mentés, exportálás, súgó és vászonbeállítások',
  'sketch.tooltipLock': "Keep the current drawing tool active for repeated use",
  'sketch.tooltipHand': "Pan the canvas without selecting objects",
  'sketch.tooltipSelection': "Select, move, resize, or edit objects on the canvas",
  'sketch.tooltipRectangle': "Draw a rectangle or card area",
  'sketch.tooltipDiamond': "Draw a diamond for decisions or branching structure",
  'sketch.tooltipEllipse': "Draw a circle or ellipse",
  'sketch.tooltipArrow': "Draw a directional connector or flow arrow",
  'sketch.tooltipLine': "Draw a straight divider or connector line",
  'sketch.tooltipFreedraw': "Draw freehand lines on the canvas",
  'sketch.tooltipText': "Add editable text to the canvas",
  'sketch.tooltipImage': "Insert an image into the canvas",
  'sketch.tooltipEraser': "Erase objects from the canvas",
  'sketch.tooltipFrame': "Create a frame to group a region of the canvas",
  'sketch.tooltipEmbeddable': "Web Embed only supports valid https:// or http:// links",
  'sketch.tooltipLaser': "Point at canvas content temporarily without changing it",
  'sketch.tooltipMoreTools': "Open additional tools such as frame, web embed, and laser pointer",
  'sketch.tooltipDirty': 'Mentetlen változtatások',
  'sketch.tooltipClean': 'Mentve',
  'fileViewer.empty': 'Válassz fájlt a megtekintéshez.',
  'fileViewer.loading': 'Betöltés…',
  'fileViewer.exportPptx': 'Exportálás PPTX-ként',
  'fileViewer.openInNewTab': 'Megnyitás új lapon',
  'fileViewer.copyPath': 'Útvonal másolása',
  'fileViewer.copied': 'Másolva!',
  'fileViewer.share': 'Megosztás',
  'fileViewer.binaryMeta': 'Bináris · {size}',
  'fileViewer.binaryNote': 'Bináris fájl ({size} bájt). A megtekintéshez töltsd le, vagy nyisd meg lemezről.',
  'fileViewer.pdfMeta': 'PDF · {size}',
  'fileViewer.documentMeta': 'Dokumentum',
  'fileViewer.presentationMeta': 'Prezentáció',
  'fileViewer.spreadsheetMeta': 'Táblázat',
  'fileViewer.previewUnavailable': 'Előnézet nem elérhető. Töltsd le vagy nyisd meg a fájlt a megtekintéshez.',
  'fileViewer.download': 'Letöltés',
  'fileViewer.open': 'Megnyitás',
  'fileViewer.imageMeta': 'Kép · {size}',
  'fileViewer.reactMeta': 'React komponens · {size}',
  'fileViewer.sketchMeta': 'Vázlat · {size}',
  'fileViewer.markdownStreamingMeta': 'Streamelő előnézet…',
  'fileViewer.markdownErrorMeta': 'Az előnézet hiányos lehet (generálási hiba).',
  'fileViewer.markdownStreamingStatus': 'Streamelés… részleges markdownt mutatva.',
  'fileViewer.markdownErrorStatus': 'Generálási hiba. Az utolsó elérhető tartalom látszik.',
  'fileViewer.markdownSaving': "Saving...",
  'fileViewer.markdownSaveFailed': "Save failed",
  'fileViewer.markdownSaved': "Saved",
  'fileViewer.markdownAutoSaved': "Auto-saved · {time}",
  'fileViewer.markdownAutoSaveHint': "Auto-save on",
  'fileViewer.markdownViewMode': "Markdown view mode",
  'fileViewer.split': "Split",
  'fileViewer.markdownEditor': "Markdown editor",
  'fileViewer.markdownEditorPlaceholder': "Type notes, requirements, or instructions for this document...",
  'fileViewer.markdownPreview': "Markdown preview",
  'fileViewer.videoMeta': 'Videó · {size}',
  'fileViewer.audioMeta': 'Hang · {size}',
  'fileViewer.reload': 'Újratöltés',
  'fileViewer.reloadDisk': 'Újratöltés lemezről',
  'fileViewer.copy': 'Másolás',
  'fileViewer.copyTitle': 'Fájltartalom másolása',
  'fileViewer.saveDisabled': 'Mentés (csak olvasható nézet)',
  'fileViewer.save': 'Mentés',
  'fileViewer.preview': 'Előnézet',
  'fileViewer.source': 'Forrás',
  'fileViewer.tweaks': 'Finomhangolás',
  'fileViewer.tweaksUnavailable': 'Nincs finomhangolási panel ebben az artefaktumban',
  'fileViewer.jsxModuleTitle': 'Nincs önálló előnézet',
  'fileViewer.jsxModuleBody': 'Ez a fájl egy komponensmodul, amelyet egy másik oldal tölt be.',
  'fileViewer.jsxModuleCta': 'Nyisd meg az oldalt, amely megjeleníti:',
  'fileViewer.comment': 'Megjegyzés',
  'fileViewer.edit': 'Szerkesztés',
  'fileViewer.draw': 'Rajz',
  'fileViewer.mark': 'Megjelölés',
  'fileViewer.markTool': 'Megjelölő eszköz',
  'fileViewer.boxSelect': 'Keretes kijelölés',
  'fileViewer.textTool': 'Szöveg',
  'fileViewer.textAnnotationRemove': 'Szöveg eltávolítása',
  'fileViewer.screenshot': 'Képernyőkép',
  'fileViewer.versions.entry': 'Verziók',
  'fileViewer.versions.entryFull': 'Verzióelőzmények',
  'fileViewer.versions.title': 'Verziók',
  'fileViewer.versions.countOne': '1 verzió',
  'fileViewer.versions.countMany': '{count} verzió',
  'fileViewer.versions.current': 'Aktuális',
  'fileViewer.versions.sourceAi': 'AI edit',
  'fileViewer.versions.sourceManual': 'Manual edit',
  'fileViewer.versions.sourceRestore': 'Restored',
  'fileViewer.versions.restoredFrom': 'Restored from v{version}',
  'fileViewer.versions.versionLabel': 'Verzió {version}',
  'fileViewer.versions.listAria': 'Fájlverziók',
  'fileViewer.versions.loading': 'Verziók betöltése...',
  'fileViewer.versions.empty': 'Még nincsenek verziók.',
  'fileViewer.versions.loadFailed': 'Nem sikerült betölteni a verziókat.',
  'fileViewer.versions.previewFailed': 'Nem sikerült betölteni ennek a verziónak az előnézetét.',
  'fileViewer.versions.previewLoading': 'Verzióelőnézet betöltése...',
  'fileViewer.versions.noPrompt': 'Nincs rögzített prompt',
  'fileViewer.versions.noPromptBody': 'Ehhez a verzióhoz nem lett prompt rögzítve.',
  'fileViewer.versions.promptTitle': 'Prompt',
  'fileViewer.versions.copyPrompt': 'Prompt másolása',
  'fileViewer.versions.fullscreen': 'Teljes képernyős előnézet',
  'fileViewer.versions.open': 'Előnézet megnyitása',
  'fileViewer.versions.currentHelp': 'Ez már az aktuális verzió.',
  'fileViewer.versions.restoreHelp': 'A váltás ezt a HTML-t új aktuális verzióként állítja vissza.',
  'fileViewer.versions.restore': 'Váltás erre a verzióra',
  'fileViewer.versions.restoreConfirmTitle': 'Átvált erre a verzióra?',
  'fileViewer.versions.restoreConfirmCta': 'Átváltás',
  'fileViewer.versions.restoring': 'Váltás...',
  'fileViewer.versions.restoreFailed': 'Nem sikerült erre a verzióra váltani.',
  'fileViewer.versions.restoreSuccess': 'Átváltva erre a verzióra.',
  'fileViewer.editScreenshotToChat': 'Képernyőkép a csevegésbe',
  'manualEdit.layers': 'Rétegek',
  'manualEdit.editableCount': '{count} szerkeszthető',
  'manualEdit.hiddenBadge': 'Rejtett',
  'manualEdit.title': 'Kézi szerkesztő',
  'manualEdit.fallbackTitle': 'Szerkesztés',
  'manualEdit.movePanel': 'Szerkesztőpanel áthelyezése',
  'manualEdit.editParams': 'Paraméterek szerkesztése',
  'manualEdit.closePanel': 'Szerkesztőpanel bezárása',
  'manualEdit.selectLayer': 'Válassz egy réteget',
  'manualEdit.empty': 'Kattints egy elemre az előnézetben, vagy válassz egy réteget.',
  'manualEdit.noEditableLayers': 'Nem található szerkeszthető réteg.',
  'manualEdit.noClass': 'nincs osztály',
  'manualEdit.tabsAria': 'Kézi szerkesztés fülek',
  'manualEdit.tabContent': 'Tartalom',
  'manualEdit.tabStyle': 'Stílus',
  'manualEdit.tabAttributes': 'Attribútumok',
  'manualEdit.tabHtml': 'Html',
  'manualEdit.tabSource': 'Forrás',
  'manualEdit.attributesJson': 'Attribútumok JSON',
  'manualEdit.selectedHtml': 'Kijelölt elem HTML-je',
  'manualEdit.fullSource': 'Teljes elem forráskódja',
  'manualEdit.applyContent': 'Tartalom alkalmazása',
  'manualEdit.applyStyle': 'Stílus alkalmazása',
  'manualEdit.applyAttributes': 'Attribútumok alkalmazása',
  'manualEdit.applyHtml': 'HTML alkalmazása',
  'manualEdit.applySource': 'Forrás alkalmazása',
  'manualEdit.invalidAttributes': 'Érvénytelen attribútumok JSON.',
  'manualEdit.changes': 'Módosítások',
  'manualEdit.undo': 'Visszavonás',
  'manualEdit.redo': 'Mégis',
  'manualEdit.noChanges': 'Még nincsenek kézi szerkesztések.',
  'manualEdit.imageUrl': 'Kép URL',
  'manualEdit.altText': 'Alternatív szöveg',
  'manualEdit.label': 'Címke',
  'manualEdit.text': 'Szöveg',
  'manualEdit.href': 'Href',
  'manualEdit.textColor': 'Szövegszín',
  'manualEdit.background': 'Háttér',
  'manualEdit.fontSize': 'Betűméret',
  'manualEdit.weight': 'Vastagság',
  'manualEdit.align': 'Igazítás',
  'manualEdit.textAlignLeft': 'Balra igazítás',
  'manualEdit.textAlignCenter': 'Középre igazítás',
  'manualEdit.textAlignRight': 'Jobbra igazítás',
  'manualEdit.padding': 'Belső margó',
  'manualEdit.margin': 'Külső margó',
  'manualEdit.radius': 'Lekerekítés',
  'manualEdit.referenceValues': 'Referenciaértékek',
  'manualEdit.referenceValuesEmpty': 'Nincs egyező referenciaérték',
  'manualEdit.referenceValuesLoading': 'Betöltés…',
  'manualEdit.lineHeight': 'Sormagasság',
  'manualEdit.letterSpacing': 'Betűköz',
  'manualEdit.borderStyle': 'Szegélystílus',
  'manualEdit.borderStyleSolid': 'Folytonos',
  'manualEdit.borderStyleDashed': 'Szaggatott',
  'manualEdit.borderStyleDotted': 'Pontozott',
  'manualEdit.borderStyleDouble': 'Dupla',
  'manualEdit.borderStyleNone': 'Nincs',
  'manualEdit.border': 'Szegély',
  'manualEdit.width': 'Szélesség',
  'manualEdit.minHeight': 'Minimális magasság',
  'manualEdit.deleteElement': 'Elem törlése',
  'manualEdit.deleteElementConfirm': 'Törli a kijelölt elemet? Ez a Visszavonás paranccsal visszavonható.',
  'manualEdit.alignCenter': "Center",
  'manualEdit.opacity': "Opacity",
  'manualEdit.uploadImage': 'Kép feltöltése',
  'manualEdit.uploadingImage': 'Kép feltöltése…',
  'manualEdit.uploadImageFailed': 'A kép feltöltése nem sikerült.',
  'manualEdit.focusSlides': 'Diákra fókuszálás',
  'manualEdit.showPanels': 'Panelek megjelenítése',
  'manualEdit.parameters': "Parameters",
  'manualEdit.fontFamily': "Font",
  'manualEdit.borderColor': "Border color",
  'manualEdit.borderWidth': "Border width",
  'manualEdit.height': "Height",
  'manualEdit.sideTop': "Top",
  'manualEdit.sideBottom': "Bottom",
  'manualEdit.sideLeft': "Left",
  'manualEdit.sideRight': "Right",
  'manualEdit.layoutDirection': "Direction",
  'manualEdit.distribution': "Distribution",
  'manualEdit.gap': "Gap",
  'manualEdit.layoutUnavailable': "Layout controls are available for flex or grid containers.",
  'manualEdit.directionRow': "Horizontal",
  'manualEdit.directionRowReverse': "Horizontal reverse",
  'manualEdit.directionColumn': "Vertical",
  'manualEdit.directionColumnReverse': "Vertical reverse",
  'manualEdit.justifyStart': "Start",
  'manualEdit.justifyCenter': "Center",
  'manualEdit.justifyEnd': "End",
  'manualEdit.justifyBetween': "Space between",
  'manualEdit.justifyAround': "Space around",
  'manualEdit.justifyEvenly': "Space evenly",
  'manualEdit.alignStart': "Start",
  'manualEdit.alignEnd': "End",
  'manualEdit.alignStretch': "Stretch",
  'manualEdit.alignBaseline': "Baseline",
  'fileViewer.zoomOut': 'Kicsinyítés',
  'fileViewer.zoomIn': 'Nagyítás',
  'fileViewer.resetZoom': 'Nagyítás visszaállítása',
  'fileViewer.viewportAria': 'Előnézeti nézetablak',
  'fileViewer.viewportDesktop': 'Asztali',
  'fileViewer.viewportDesktopTitle': 'Teljes szélességű asztali előnézet',
  'fileViewer.viewportTablet': 'Táblagép',
  'fileViewer.viewportTabletTitle': 'Tablet előnézet 820 × 1180 méretben (modern álló alapérték)',
  'fileViewer.viewportMobile': 'Mobil',
  'fileViewer.viewportMobileTitle': 'Mobil előnézet 390 × 844 méretben',
  'fileViewer.reloadAria': 'Újratöltés',
  'fileViewer.previousSlide': 'Előző dia',
  'fileViewer.nextSlide': 'Következő dia',
  'fileViewer.slideNavAria': 'Dianavigáció',
  'fileViewer.speakerNotes': 'Előadói jegyzetek',
  'fileViewer.speakerNotesSlide': 'Dia {current} / {total}',
  'fileViewer.speakerNotesEmpty': 'Ehhez a diához nincsenek előadói jegyzetek.',
  'fileViewer.speakerNotesEdit': 'Szerkesztés',
  'fileViewer.speakerNotesSave': 'Jegyzetek mentése',
  'fileViewer.speakerNotesSaving': 'Mentés…',
  'fileViewer.speakerNotesSaved': 'Mentve',
  'fileViewer.speakerNotesSaveFailed': 'Az előadói jegyzetek mentése nem sikerült.',
  'fileViewer.speakerNotesPlaceholder': 'Adj előadói jegyzeteket ehhez a diához…',
  'fileViewer.previewAssetBlockedTitle': 'Az előnézeti elem blokkolva',
  'fileViewer.previewAssetBlockedDetail': 'A(z) {filePath} nem tölthető be. Cseréld a külső szimbolikus linkeket a projekten belüli fájlokra.',
  'fileViewer.presenterReset': 'Visszaállítás',
  'fileViewer.present': 'Bemutatás',
  'fileViewer.presentInTab': 'Ezen a lapon',
  'fileViewer.presentFullscreen': 'Teljes képernyő',
  'fileViewer.presentNewTab': 'Új lap',
  'fileViewer.presentFromBeginning': 'Indítás az elejéről',
  'fileViewer.presentFromCurrentSlide': 'Indítás az aktuális diától',
  'fileViewer.presenterMode': 'Előadói mód',
  'fileViewer.exitPresentation': 'Bemutató bezárása',
  'fileViewer.shareLabel': 'Megosztás',
  'fileViewer.shareMenuShareLink': 'MEGOSZTÁS',
  'fileViewer.shareMenuPublishOnline': 'ONLINE KÖZZÉTÉTEL',
  'fileViewer.shareMenuDownload': 'LETÖLTÉS',
  'fileViewer.shareMenuPresentation': 'Prezentáció',
  'fileViewer.shareMenuSourceFiles': 'Forrásfájlok',
  'fileViewer.shareMenuSave': 'MENTÉS',
  'fileViewer.unifiedShareAria': 'Share and export actions',
  'fileViewer.unifiedShareTab': 'Share',
  'fileViewer.unifiedExportTab': 'Export',
  'fileViewer.unifiedSendTab': 'Send to...',
  'fileViewer.openFileForHistory': 'Open a file to view version history',
  'fileViewer.workspaceShareTitle': 'Share project in workspace',
  'fileViewer.workspaceSharePrivateDescription': 'Only you can access this project. Choose workspace members to share it with the team.',
  'fileViewer.workspaceShareWorkspaceDescription': 'Members of this workspace can access this project.',
  'fileViewer.workspaceAccessPrivate': 'Only me',
  'fileViewer.workspaceAccessMembers': 'Workspace members',
  'fileViewer.publishSingleFileTitle': 'Publish this file for everyone',
  'fileViewer.publishSingleFileDescription': 'Make the current file externally visible. Anyone with the published link can view it online.',
  'fileViewer.openFileRequired': 'Open a file to use this.',
  'fileViewer.publishFile': 'Publish file',
  'fileViewer.publishingFile': 'Publishing…',
  'fileViewer.unpublishFile': 'Közzététel visszavonása',
  'fileViewer.shareEmptyStateTitle': 'Még nincs mit megosztani',
  'fileViewer.shareEmptyStateDescription': 'Hozz létre egy csapatot, vagy csatlakozz egyhez, hogy megoszthasd ezt a fájlt a kollégáiddal',
  'fileViewer.shareEmptyStateCreateTeam': 'Csapat létrehozása',
  'fileViewer.shareTeamMissingTitle': 'Még nincs csapat, amellyel megoszthatnád',

  'fileViewer.publishFileRequiresTeam': 'A nyilvános hivatkozás közzétételéhez csapatmunkaterület szükséges. Válts csapatmunkaterületre, vagy tedd közzé a fájlt a Közzététel funkcióval.',
  'fileViewer.publishFileRequiresWorkspace': 'A nyilvános hivatkozás közzétételéhez be kell jelentkezned egy munkaterületre. Jelentkezz be az Open Design Cloudba, vagy tedd közzé a fájlt a Közzététel funkcióval.',
  'fileViewer.publishFileFailed': 'Nem sikerült közzétenni ezt a fájlt. Próbáld újra.',
  'fileViewer.workspaceShareSuccess': 'Shared with workspace members',
  'fileViewer.workspaceShareFailed': 'Could not share with workspace',
  'fileViewer.workspaceUnshareSuccess': 'Moved back to private',
  'fileViewer.workspaceUnshareFailed': 'Could not move back to private',
  'fileViewer.readonlySharedNoExport': 'Shared project is read-only: you can comment, but cannot edit or export.',
  'fileViewer.copyShareLink': 'Megosztási link másolása',
  'fileViewer.openSharePage': 'Megosztási oldal megnyitása',
  'fileViewer.shareLinkRequiresDeploy': 'Előbb tedd közzé online, hogy linket kapj',
  'fileViewer.shareLinkPublishGuide': 'Tedd közzé online fent a megosztás engedélyezéséhez ↑',
  'fileViewer.shareAfterGenerationComplete': 'A generálás befejezése után megosztható',
  'fileViewer.copyProviderLink': '{provider} hivatkozás másolása',
  'fileViewer.copyCloudflareLink': 'Cloudflare hivatkozás másolása',
  'fileViewer.screenshotCopying': 'Képernyőkép másolása...',
  'fileViewer.screenshotCopied': 'Képernyőkép a vágólapra másolva',
  'fileViewer.screenshotClipboardDenied': 'A böngésző letiltotta a vágólap-hozzáférést',
  'fileViewer.screenshotPreviewLoading': 'Az előnézet még töltődik. Próbálja újra egy pillanat múlva.',
  'fileViewer.screenshotCaptureFailed': 'Az előnézetet nem sikerült rögzíteni. Kérjük, próbálja újra.',
  'fileViewer.exportPdf': 'Exportálás PDF-ként',
  'fileViewer.exportPdfAllSlides': 'Exportálás PDF-ként (minden dia)',
  'fileViewer.exportPptxBusy': 'Várj, amíg az aktuális kör befejeződik.',
  'fileViewer.exportPptxHint': 'Küldj kérést az ügynöknek, hogy alakítsa át ezt a designt PPTX-szé.',
  'fileViewer.exportPptxNa': 'A PPTX export itt nem elérhető.',
  'fileViewer.exportZip': 'Letöltés .zip-ként',
  'fileViewer.exportHtml': 'Exportálás önálló HTML-ként',
  'fileViewer.exportMd': 'Exportálás Markdown-ként',
  'fileViewer.exportImage': 'Exportálás képként',
  'fileViewer.exportPptxImages': 'Exportálás PPTX-ként (képek)',
  'fileViewer.exportPptxEditable': 'Exportálás PPTX-ként (szerkeszthető)',
  'fileViewer.exportPptxEditableHint': 'Native editable shapes & text (not pixel-perfect)',
  'fileViewer.exportPptxModalSubtitle': "Choose how to export, then download.",
  'fileViewer.exportPptxScreenshot': "Screenshot PPTX",
  'fileViewer.exportPptxScreenshotHint': "One image per slide — pixel-perfect, but not editable.",
  'fileViewer.exportPptxConfirm': "Export",
  'fileViewer.exportPptxRecommended': "Recommended",
  'fileViewer.exportingProgress': 'Exportálás…',
  'fileViewer.exportSlideProgress': '{current}/{total}. dia exportálása…',
  'fileViewer.exportingElapsed': 'Exportálás… {seconds}mp',
  'fileViewer.exportSlideEta': '{current}/{total}. dia · ~{seconds}mp van hátra',
  'fileViewer.exportFailed': 'Az exportálás nem sikerült. Próbáld újra.',
  'fileViewer.exportDone': 'Exportálás kész',
  'fileViewer.exportImageFailed': 'A képrögzítés sikertelen. Kérjük, próbálja újra, vagy használja a böngészője képernyőkép eszközét.',
  'fileViewer.exportImageModalSubtitle': 'Válasszon formátumot, majd töltse le az aktuális előnézetet képként.',
  'fileViewer.exportImageFormatLabel': 'Formátum',
  'fileViewer.exportImageSaving': 'Kép mentése…',
  'fileViewer.exportImageSaved': 'Kép mentve',
  'fileViewer.exportImageDownloadStarted': 'Letöltés elindítva',
  'fileViewer.exportImageDownloadDetails': 'Ha nem jelent meg Mentés másként párbeszédablak, a {filename} a böngésző letöltései között található.',
  'fileViewer.exportJsx': 'Exportálás JSX-ként',
  'fileViewer.exportReactHtml': 'Előnézet exportálása HTML-ként',
  'fileViewer.exportStarted': 'Az exportálás elindult',
  'fileViewer.saveAsTemplate': 'Mentés sablonként…',
  'fileViewer.savingTemplate': 'Sablon mentése…',
  'fileViewer.savedTemplate': 'Mentve „{name}" néven',
  'fileViewer.savedTemplateFail': 'A sablon mentése nem sikerült — próbáld újra.',
  'fileViewer.templateNamePrompt': 'Sablon neve',
  'fileViewer.templateNameDefault': 'Cím nélküli sablon',
  'fileViewer.templateDescPrompt': 'Rövid leírás (opcionális — mitől hasznos ez a sablon?)',
  'liveArtifact.refresh.button': 'Frissítés',
  'liveArtifact.refresh.buttonTitle': 'Ennek az élő tartalomnak a frissítése',
  'liveArtifact.refresh.loadingTitle': 'Élő artifact betöltése…',
  'liveArtifact.refresh.noSourceTitle': 'Még nem érhető el frissítési forrás.',
  'liveArtifact.refresh.running': 'Frissítés…',
  'liveArtifact.refresh.runningMessage': 'Adatok és előnézet frissítése. Ez eltarthat egy ideig.',
  'liveArtifact.refresh.runningAction': 'A korábbi előnézet látható marad, amíg a frissítés sikeresen le nem fut.',
  'liveArtifact.refresh.successOne': 'A frissítés befejeződött. Az adatok frissültek.',
  'liveArtifact.refresh.successMany': 'A frissítés befejeződött. Az adatok frissültek.',
  'liveArtifact.refresh.successAction': 'Az előnézet újratöltődött a legutóbb véglegesített adatokkal.',
  'liveArtifact.refresh.previousFailure': 'A korábbi frissítés sikertelen: {message}',
  'liveArtifact.refresh.failureAction': 'Tekintse át a Frissítési előzményeket, javítsa ki a forrás- vagy jogosultsági hibát, majd próbálja újra.',
  'liveArtifact.refresh.networkFailure': 'A frissítési kérés sikertelen. Ellenőrizze a kapcsolatot, és próbálja újra.',
  'liveArtifact.refresh.genericFailure': 'A frissítés sikertelen.',
  'liveArtifact.refresh.statusNever': 'Nem frissíthető',
  'liveArtifact.refresh.statusReady': 'Frissítésre kész',
  'liveArtifact.refresh.statusSucceeded': 'Naprakész',
  'liveArtifact.refresh.statusFailed': 'A frissítés sikertelen',
  'liveArtifact.refresh.statusRunning': 'Frissítés folyamatban',
  'liveArtifact.refresh.statusRunningDescription': 'Jelenleg frissítés van folyamatban.',
  'liveArtifact.refresh.statusSucceededDescription': 'A legutóbbi frissítés sikeresen befejeződött.',
  'liveArtifact.refresh.statusFailedDescription': 'A legutóbbi frissítési kísérlet nem fejeződött be sikeresen.',
  'liveArtifact.refresh.statusReadyDescription': 'Frissíthető források vannak beállítva, de nincs folyamatban futtatás.',
  'liveArtifact.refresh.statusNeverDescription': 'Ennek az élő tartalomnak még nincs frissítési forrása.',
  'liveArtifact.refresh.eventStarted': 'Elindítva',
  'liveArtifact.refresh.eventSucceeded': 'Sikeres',
  'liveArtifact.refresh.eventFailed': 'Sikertelen',
  'liveArtifact.refresh.eventStartedDetail': 'Frissítés elindítva…',
  'liveArtifact.refresh.sourcesUpdatedOne': '{n} forrás frissítve',
  'liveArtifact.refresh.sourcesUpdatedMany': '{n} forrás frissítve',
  'liveArtifact.refresh.timelineEmpty': 'Ebben a munkamenetben még nem volt frissítési tevékenység. Indítson Frissítést az idővonal rögzítéséhez, vagy várja meg az automatikus futtatásokat.',
  'liveArtifact.refresh.heroLastRefreshedLabel': 'Utoljára frissítve',
  'liveArtifact.refresh.heroLastRefreshedNever': 'Soha',
  'liveArtifact.refresh.justNow': 'épp most',
  'liveArtifact.refresh.factCreated': 'Létrehozva',
  'liveArtifact.refresh.factLastUpdated': 'Utoljára frissítve',
  'liveArtifact.refresh.factUnknown': 'Ismeretlen',
  'liveArtifact.refresh.persistedTitle': 'Megőrzött frissítési előzmények',
  'liveArtifact.refresh.persistedHint': 'A refreshes.jsonl fájlból betöltött bejegyzések',
  'liveArtifact.refresh.persistedEmpty': 'Még nincsenek megőrzött frissítési előzmények.',
  'liveArtifact.refresh.persistedStatusSucceeded': 'sikeres',
  'liveArtifact.refresh.persistedStatusRunning': 'fut',
  'liveArtifact.refresh.persistedStatusFailed': 'sikertelen',
  'liveArtifact.refresh.persistedStatusCancelled': 'megszakítva',
  'liveArtifact.refresh.persistedStatusSkipped': 'kihagyva',
  'liveArtifact.refresh.sessionTitle': 'Munkamenet-tevékenység',
  'liveArtifact.refresh.sessionHint': 'A lap megnyitása közben megfigyelt események',
  'liveArtifact.refresh.docSourceTitle': 'Dokumentumforrás',
  'liveArtifact.refresh.docSourceHint': 'Forrás beállítva',
  'liveArtifact.refresh.docSourceType': 'Típus',
  'liveArtifact.refresh.docSourceTool': 'Eszköz',
  'liveArtifact.refresh.docSourceConnector': 'Csatlakozó',
  'liveArtifact.refresh.debugSummary': 'Speciális hibakeresési metaadatok',
  'liveArtifact.refresh.debugNote': 'Tartalmazhat csatlakozó-azonosítókat, fájlneveket, forrás-metaadatokat és belső műtermék-elérési utakat.',
  'liveArtifact.viewer.tabPreview': 'Előnézet',
  'liveArtifact.viewer.tabCode': 'Kód',
  'liveArtifact.viewer.tabData': 'Adatok',
  'liveArtifact.viewer.tabRefreshHistory': 'Frissítési előzmények',
  'liveArtifact.viewer.dataEmpty': 'Nincs elérhető data.json gyorsítótár.',
  'liveArtifact.viewer.code.templateHeading': 'Sablon HTML',
  'liveArtifact.viewer.code.renderedHeading': 'Renderelt HTML',
  'liveArtifact.viewer.code.templateHelp': 'A data.json fájllal az előnézet létrehozásához használt szerkeszthető sablon.',
  'liveArtifact.viewer.code.renderedHelp': 'Az előnézet által jelenleg betöltött generált index.html.',
  'liveArtifact.viewer.code.variantAria': 'Kódváltozat',
  'liveArtifact.viewer.code.variantTemplate': 'Sablon',
  'liveArtifact.viewer.code.variantRendered': 'Renderelt',
  'liveArtifact.viewer.code.loading': 'Kód betöltése…',
  'liveArtifact.viewer.code.unavailable': 'A kód még nem érhető el.',
  'liveArtifact.viewer.code.empty': 'Ez a kódfájl üres.',
  'fileViewer.deployToVercel': 'Telepítés Vercelre',
  'fileViewer.redeployToVercel': 'Újratelepítés',
  'fileViewer.deployingToVercel': 'Telepítés Vercelre…',
  'fileViewer.deployProviderLabel': 'Szolgáltató',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployTargetLabel': 'Cél',
  'fileViewer.deployTargetPreview': 'Előnézet',
  'fileViewer.deployTargetProduction': 'Éles',
  'fileViewer.deployToProvider': 'Telepítés ide: {provider}',
  'fileViewer.redeployToProvider': 'Újratelepítés ide: {provider}',
  'fileViewer.deployingToProvider': 'Telepítés ide: {provider}…',
  'fileViewer.preparingPublicLink': 'Nyilvános link előkészítése…',
  'fileViewer.copyDeployLink': 'Link másolása',
  'fileViewer.deployModalTitle': 'Telepítés',
  'fileViewer.deployModalSubtitle': 'A kiválasztott szolgáltató fiókjával telepítheted ezt a HTML-előnézetet.',
  'fileViewer.vercelToken': 'Vercel token',
  'fileViewer.vercelTokenGetLink': 'Vercel token kérése',
  'fileViewer.vercelTokenPlaceholder': 'Illeszd be a Vercel tokenedet',
  'fileViewer.vercelTokenReuseHint': 'A mentett tokent használjuk. Adj meg újat a cseréhez.',
  'fileViewer.vercelTokenRequired': 'Előbb adj meg és ments el egy Vercel tokent.',
  'fileViewer.cloudflareApiToken': 'Cloudflare API token',
  'fileViewer.cloudflareApiTokenGetLink': 'API token lekérése',
  'fileViewer.cloudflareApiTokenPlaceholder': 'Illeszd be a Cloudflare API tokenedet',
  'fileViewer.cloudflareApiTokenReuseHint': 'A mentett Cloudflare API tokent használjuk. Adj meg újat a cseréhez.',
  'fileViewer.cloudflareApiTokenRequired': 'Előbb adj meg és ments el egy Cloudflare API tokent.',
  'fileViewer.cloudflareApiTokenScopeHint': 'Az API token létrehozásakor válaszd a Pages Edit jogosultságot; egyedi domainekhez Zone Read / DNS Edit szükséges.',
  'fileViewer.vercelTeamId': 'Csapatazonosító',
  'fileViewer.vercelTeamSlug': 'Csapat slug',
  'fileViewer.cloudflareAccountId': 'Fiók ID',
  'fileViewer.cloudflareAccountIdHint': 'A fiók ID-t a Cloudflare irányítópulton találod.',
  'fileViewer.cloudflareAccountIdRequired': 'Előbb add meg és mentsd el a Cloudflare Account ID-t.',
  'fileViewer.cloudflareZoneLabel': 'Tartomány',
  'fileViewer.cloudflareZonePlaceholder': 'Mentsd a Cloudflare beállításokat a tartományok betöltéséhez',
  'fileViewer.cloudflareZoneRequired': 'Először válassz egy Cloudflare tartományt.',
  'fileViewer.cloudflareZonesLoading': 'Cloudflare domainek betöltése…',
  'fileViewer.cloudflareZonesRefresh': 'Tartományok frissítése',
  'fileViewer.cloudflareZonesLoadFailed': 'Nem sikerült betölteni a Cloudflare tartományokat.',
  'fileViewer.cloudflareZonesEmpty': 'Ehhez a fiókhoz nem található aktív teljes Cloudflare tartomány.',
  'fileViewer.cloudflareDomainPrefixLabel': 'Aldomain előtag',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': 'Csak egy DNS-címkét használj: kisbetűk, számok és kötőjelek.',
  'fileViewer.cloudflareHostnamePreview': 'Egyéni tartomány előnézete: {hostname}',
  'fileViewer.cloudflareCustomDomainHint': 'Opcionális: egyedi domain csatolása. Ha üresen hagyod, akkor is létrejön egy pages.dev link.',
  'fileViewer.cloudflarePagesDevLinkLabel': 'pages.dev URL',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'Egyéni tartomány',
  'fileViewer.optional': 'Opcionális',
  'fileViewer.vercelPreviewOnly': 'A telepítések egyelőre csak Preview-k.',
  'fileViewer.cloudflarePagesPreviewHint': 'A Cloudflare Pages Direct Uploadot használ.',
  'fileViewer.savingConfig': 'Mentés…',
  'fileViewer.deployConfigSaveFailed': 'A Vercel beállítások nem menthetők.',
  'fileViewer.deployFailed': 'A telepítés sikertelen. Ellenőrizd a Vercel beállításokat, és próbáld újra.',
  'fileViewer.deployProviderConfigSaveFailed': 'A {provider} beállításai nem menthetők.',
  'fileViewer.deployProviderFailed': 'A {provider} telepítés sikertelen. Ellenőrizd a beállításokat, és próbáld újra.',
  'fileViewer.deployResultLabel': 'Telepített URL',
  'fileViewer.deployLinkReady': 'Kész',
  'fileViewer.deploySuccessToast': 'A telepítés sikeresen feltöltve',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': 'Nyilvános link várólistán',
  'fileViewer.deployLinkDelayed': 'A webhely telepítve van. A szolgáltató még készíti a nyilvános linket.',
  'fileViewer.deployLinkFailed': 'Az egyéni domain sikertelen',
  'fileViewer.deployLinkProtectedLabel': 'Telepítési védelem bekapcsolva',
  'fileViewer.deployLinkProtected': 'A webhely telepítve van, de ez az előnézeti link hitelesítést kér. Kapcsold ki a Deployment Protectiont, vagy használj saját domaint.',
  'fileViewer.retryLink': 'Újra most',
  'questionForm.submit': 'Beküldés',
  'questionForm.skip': 'Kihagyás',
  'questionForm.locked': 'Megválaszolva',
  'conv.switch': 'Beszélgetés váltása',
  'conv.label': 'Beszélgetés',
  'conv.heading': 'Beszélgetések',
  'conv.new': '+ Új',
  'conv.empty': 'Még nincs beszélgetés.',
  'conv.untitled': 'Cím nélküli beszélgetés',
  'conv.renameTooltip': 'Dupla kattintás az átnevezéshez',
  'conv.delete': 'Beszélgetés törlése',
  'conv.deleteConfirm': 'Törlöd a(z) „{title}" beszélgetést? Ez eltávolítja az üzeneteit.',
  'agentPicker.label': 'Ügynök',
  'agentPicker.modeChoose': 'Válassz végrehajtási módot',
  'agentPicker.localCli': 'Helyi CLI',
  'agentPicker.daemonOff': 'a daemon kikapcsolva',
  'agentPicker.byok': 'API · BYOK',
  'agentPicker.selectAgent': 'Válassz egy észlelt code-agent CLI-t',
  'agentPicker.noAgents': 'nincs ügynök a PATH-on',
  'agentPicker.notInstalled': 'nincs telepítve',
  'agentPicker.rescan': 'Helyi PATH újraellenőrzése ügynökökért',
  'tool.openInTab': '{name} megnyitása lapon',
  'tool.open': 'megnyitás',
  'tool.todos': 'Feladatok',
  'tool.todosExpand': 'Feladatok mutatása',
  'tool.todosCollapse': 'Feladatok elrejtése',
  'tool.todosDone': 'Kész',
  'tool.todosDismiss': 'Feladatlista elvetése',
  'tool.write': 'Írás',
  'tool.edit': 'Szerkesztés',
  'tool.read': 'Olvasás',
  'tool.delete': 'Törlés',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': 'Lekérés',
  'tool.search': 'Keresés',
  'tool.lines': '{n} sor',
  'tool.changeSingular': 'változás',
  'tool.changePlural': 'változás',
  'tool.in': 'itt: {path}',
  'tool.hide': 'elrejtés',
  'tool.output': 'kimenet',
  'tool.running': 'fut…',
  'tool.error': 'hiba',
  'tool.done': 'kész',
  'assistant.role': 'Asszisztens',
  'assistant.workingLabel': 'Dolgozik',
  'assistant.doneLabel': 'Kész',
  'assistant.copyMarkdown': 'Válasz Markdown másolása',
  'assistant.forkConversation': 'Fork innen',
  'assistant.forkingConversation': 'Fork létrehozása…',
  'assistant.shareToOpenDesign': 'Megosztás az Open Designnal',
  'assistant.shareToOpenDesignBusy': 'Csomag előkészítése…',
  'assistant.feedbackPrompt': 'Visszajelzés',
  'assistant.feedbackPositive': 'Hasznos',
  'assistant.feedbackNegative': 'Nem hasznos',
  'assistant.feedbackReasonTitle': 'Mondd el, miért',
  'assistant.feedbackReasonPositiveMatched': 'Megértette a kérésemet',
  'assistant.feedbackReasonPositiveVisual': 'Jól néz ki',
  'assistant.feedbackReasonPositiveUseful': 'Hasznos struktúra',
  'assistant.feedbackReasonPositiveEasy': 'Könnyen szerkeszthető tovább',
  'assistant.feedbackReasonPositiveDesignSystem': 'Követte a dizájnrendszert',
  'assistant.feedbackReasonNegativeMissed': 'Figyelmen kívül hagyta a kérésemet',
  'assistant.feedbackReasonNegativeVisual': 'A vizuális minőség javításra szorul',
  'assistant.feedbackReasonNegativeIncomplete': 'Hiányos kimenet',
  'assistant.feedbackReasonNegativeHard': 'Nehéz használni',
  'assistant.feedbackReasonNegativeDesignSystem': 'Nem követte a dizájnrendszert',
  'assistant.feedbackReasonOther': 'Egyéb',
  'assistant.feedbackReasonPlaceholder': 'Adj hozzá egy rövid megjegyzést...',
  'assistant.feedbackReasonSubmit': 'Küldés',
  'assistant.emptyResponseLabel': 'Nincs kimenet',
  'assistant.emptyResponseMessage': 'A szolgáltató szöveg vagy műtermék visszaadása nélkül zárta le a kérést. Próbálj másik modellt vagy szolgáltatót, ellenőrizd a kvótát, vagy próbáld újra.',
  'assistant.unfinishedLabel': 'Befejezetlen munkával állt le',
  'assistant.unfinishedSummary': '{n} feladat hátravan',
  'assistant.unfinishedMore': '+{n} további',
  'assistant.continueRemaining': 'Hátralévő feladatok folytatása',
  'chat.resumeRunCta': 'Futás folytatása',
  'assistant.outTokens': '{n} ki',
  'assistant.producedFiles': 'A körben létrehozott fájlok',
  'assistant.openFile': 'Megnyitás',
  'assistant.downloadFile': 'Letöltés',
  'nextStep.title': 'Következő lépés',
  'nextStep.more': 'Több',
  'nextStep.share': 'Megosztás',
  'nextStep.download': 'Letöltés',
  'nextStep.createDesignSystemTitle': 'Create design system',
  'nextStep.createDesignSystemBody': 'Duplicate this project into a design-system workspace and start an agent pass from all current files and references.',
  'nextStep.createDesignSystemBusy': 'Creating design system...',
  'nextStep.contribute': 'Hozzájárulás',
  'nextStep.planGenerateTitle': "Generate from document",
  'nextStep.planGenerateBody': "Use the approved Markdown plan as the source of truth for the next design run.",
  'nextStep.planImproveTitle': "Improve document",
  'nextStep.planImproveBody': "Tighten the current plan document before generating the final artifact.",
  'nextStep.planGeneratePrompt': "Use `{file}` as the source of truth. Read the document first, preserve its decisions, then generate the final design artifact that matches it. If it is a slide outline, generate the deck; if it is a PRD/prototype plan, generate the prototype or wireframes; if it is a storyboard/creative brief, generate the matching visual/media artifact. Before generating, call out any blocking TODOs or contradictions you cannot resolve.",
  'nextStep.planImprovePrompt': "Read `{file}` and improve it in place as an editable plan document. Tighten scope, fill weak sections, add missing acceptance checks, and keep TODO/open questions where user input is still needed. Do not generate the final design artifact yet.",
  'nextStep.planImproveArtifactTitle': "Improve artifact",
  'nextStep.planImproveArtifactBody': "Keep iterating the generated artifact instead of going back to planning.",
  'nextStep.planImproveArtifactPrompt': "Improve `{artifact}` in place. Keep the existing working artifact and make the highest-impact product, visual, interaction, and content improvements. Preserve behavior that already works, then summarize changed files and any remaining risks.",
  'nextStep.planMergeTitle': "Align document and artifact",
  'nextStep.planMergeBody': "Reconcile the plan and generated artifact so they advance together.",
  'nextStep.planMergePrompt': "Read `{document}` and `{artifact}` together. Treat the document as the intent and the artifact as the current implementation. Reconcile them: update the artifact to match confirmed decisions, update the document only where it is stale, and keep explicit TODO/open questions for anything still unresolved. Preserve existing working behavior and summarize what changed in both files.",

  'nextStep.projectContinueTitle': 'Continue working',
  'nextStep.projectGenerateArtifactTitle': 'Generate artifact',
  'nextStep.designSystemAiRefineTitle': 'AI refine design system',
  'nextStep.designSystemAuditKitTitle': 'Audit tokens & kit',

  'nextStep.brandAiOptimizeTitle': 'Refine extracted design system',
  'nextStep.brandAiOptimizeBody': 'Starts an agent pass that consumes model tokens, re-extracts the source, and updates this design system in place.',
  'nextStep.brandCreateDesignTitle': 'Create with this design system',
  'nextStep.brandCreateDesignBody': 'Start a new design using the extracted colors, type, assets, and system guidance.',
  'nextStep.brandCreateDesignPrompt': 'Create a new design with the {designSystem} design system.',

  'nextStep.brandContinueExtractionTitle': 'Continue extraction',
  'nextStep.brandContinueExtractionBody': 'After the Browser tab is past any verification, read it and keep filling the saved kit.',
  'nextStep.brandContinueExtractionBusy': 'Continuing extraction...',
  'nextStep.brandContinueAiExtractionTitle': 'Continue with agent',
  'nextStep.brandContinueAiExtractionProgrammaticBody': 'Use the selected agent to extract from the saved draft if the programmatic pass still cannot finish.',
  'nextStep.brandContinueAiExtractionAiBody': 'Resume the selected agent from the current brand scaffold and finish the same design system.',
  'nextStep.brandContinueAiExtractionBusy': 'Continuing with agent...',
  'nextStep.createDesignBusy': 'Design létrehozása...',
  'assistant.thinking': 'Gondolkodik',
  'assistant.thought': 'Gondolkodott',
  'assistant.thoughtFor': 'Gondolkodott {s} mp-ig',
  'assistant.systemReminder': 'Rendszer-emlékeztető',
  'assistant.possiblePromptInjection': 'Lehetséges prompt injekció',
  'assistant.waitingFirstOutput': 'Az első kimenetre vár',
  'assistant.statusBootingAgent': 'Ügynök indítása',
  'assistant.statusPreparing': 'Előkészítés...',
  'assistant.statusStarting': 'Indítás',
  'assistant.statusRequesting': 'Kérés küldése',
  'assistant.statusThinking': 'Gondolkodik',
  'assistant.statusStreaming': 'Streamelés',
  'assistant.slowHint': 'Tovább tart a szokásosnál. Az űrlap általában 5–10 mp alatt megjelenik — leállíthatod és újrafogalmazhatod.',
  'assistant.verbEditing': 'Szerkesztés',
  'assistant.verbWriting': 'Írás',
  'assistant.verbReading': 'Olvasás',
  'assistant.verbSearching': 'Keresés',
  'assistant.verbRunning': 'Futtatás',
  'assistant.verbTodos': 'Feladatok',
  'assistant.verbFetching': 'Lekérés',
  'assistant.verbCalling': 'Hívás',
  'qf.answered': 'megválaszolva',
  'qf.choose': 'Válassz…',
  'qf.customLabel': 'Custom answer',
  'qf.customPlaceholder': 'Type your own answer...',
  'qf.otherOption': 'Egyéb',
  'qf.required': 'kötelező',
  'qf.lockedSubmitted': 'Válaszok elküldve — az ügynök ezeket használja a folyamat további részében.',
  'qf.lockedPrev': 'Ez az űrlap egy korábbi körből származik.',
  'qf.hint': 'Válaszd, ami illik. Hagyd ki az opcionális mezőket, amik nem érdekesek — az ügynök ésszerű alapértékeket használ.',
  'qf.submitDefault': 'Válaszok küldése',
  'qf.submitDisabledTitle': 'Előbb töltsd ki a kötelező mezőket',
  'qf.submitTitle': 'Válaszok küldése',
  'qf.cardSelected': 'kiválasztva',
  'qf.cardRefs': 'Hivatkozások:',
  'qf.cardSampleText': 'Árvíztűrő tükörfúrógép · 0123',
  'questions.tabLabel': 'Kérdések',
  'questions.banner': 'Megengeded, hogy feltegyek néhány gyors kérdést?',
  'questions.bannerAnswered': 'Kérdések megválaszolva',
  'questions.continue': 'Folytatás',
  'questions.generating': 'Kérdések generálása…',
  'questions.skipAll': 'Összes kihagyása',
  'questions.autoSkipHint': 'Automatikusan folytatódik az időzítő lejártakor',
  'questions.submitting': 'Küldés…',
  'sketch.toolSelect': 'Kijelölés (nem aktív)',
  'sketch.toolPen': 'Toll',
  'sketch.toolText': 'Szöveg',
  'sketch.toolRect': 'Téglalap',
  'sketch.toolArrow': 'Nyíl',
  'sketch.toolEraser': 'Radír',
  'sketch.color': 'Szín',
  'sketch.strokeSize': 'Vonalvastagság',
  'sketch.undo': 'Visszavonás',
  'sketch.clear': 'Törlés',
  'sketch.close': 'Bezárás',
  'sketch.closeConfirm': 'Bezárod a vázlatot, és elveted a nem mentett változtatásokat?',
  'sketch.textPrompt': 'Szöveg:',
  'sketch.textModalTitle': 'Szöveg hozzáadása',
  'critiqueTheater.userFacingName': 'Dizájnzsűri',
  'critiqueTheater.roleDesigner': 'Tervező',
  'critiqueTheater.roleCritic': 'Kritikus',
  'critiqueTheater.roleBrand': 'Márka',
  'critiqueTheater.roleA11y': 'Akadálymentesség',
  'critiqueTheater.roleCopy': 'Másolás',
  'critiqueTheater.roundLabel': '{n}. kör / {m}',
  'critiqueTheater.mustFix': '{n} kötelező javítás',
  'critiqueTheater.composite': 'Összesített',
  'critiqueTheater.threshold': 'Küszöbérték',
  'critiqueTheater.consensus': 'Konszenzus',
  'critiqueTheater.interrupt': 'Megszakítás',
  'critiqueTheater.interrupting': 'Megszakítás…',
  'critiqueTheater.interrupted': 'Megszakítva',
  'critiqueTheater.degradedHeading': 'A panel offline ebben a futtatásban',
  'critiqueTheater.degradedReasonMalformed': 'Hibás panelkimenet (az elemző elutasította a blokkot).',
  'critiqueTheater.degradedReasonOversize': 'A panelkimenet túllépte a biztonságos bájtkeretet.',
  'critiqueTheater.degradedReasonAdapter': 'A(z) {adapter} adapter nem támogatta a Critique protokollt.',
  'critiqueTheater.degradedReasonProtocol': 'A(z) {adapter} adapter nem támogatott protokollverziót küldött.',
  'critiqueTheater.degradedReasonMissingArtifact': 'A futtatás végső műtárgy nélkül fejeződött be.',
  'critiqueTheater.replay': 'Visszajátszás',
  'critiqueTheater.replaySpeed': 'Visszajátszás sebessége',
  'critiqueTheater.readOnly': 'Csak olvasható',
  'critiqueTheater.shippedSummary': 'Leszállítva a(z) {round}. körben · összesített {composite}',
  'critiqueTheater.interruptedSummary': 'Megszakítva a(z) {round}. körben · legjobb összesített {composite}',
  'critiqueTheater.shippedBadge': 'Kiszállítva',
  'critiqueTheater.belowThresholdBadge': 'Küszöbérték alatt',
  'critiqueTheater.timedOutBadge': 'Időtúllépés',
  'critiqueTheater.failedHeading': 'A futtatás meghiúsult',
  'critiqueTheater.failedReasonCliExit': 'Az Agent CLI nem nulla kóddal lépett ki, mielőtt a panel befejezhette volna.',
  'critiqueTheater.failedReasonPerRoundTimeout': 'Egy kör túllépte az időkeretét.',
  'critiqueTheater.failedReasonTotalTimeout': 'A teljes futtatás túllépte a teljes időkeretét.',
  'critiqueTheater.failedReasonOrchestrator': 'Belső orkesztrátorhiba.',
  'critiqueTheater.transcriptEmpty': 'Még nincs visszajátszható átirat. Futtass egy kritikát egy rögzítéséhez.',
  'critiqueTheater.transcriptLoading': 'Átirat betöltése…',
  'critiqueTheater.transcriptError': 'Nem sikerült betölteni az átiratot: {error}',
  'critiqueTheater.replaySpeedPaused': 'Szüneteltetve',
  'critiqueTheater.replaySpeedInstant': 'Azonnali',
  'critiqueTheater.replaySpeedLive': 'Élő',
  'critiqueTheater.replaySpeedFast': 'Gyors',
  'critiqueTheater.settingsNav': 'Dizájnzsűri',
  'critiqueTheater.settingsNavHint': 'Ötpaneles tervezési felülvizsgálat a futtatásaidhoz',
  'critiqueTheater.settingsEnabledLabel': 'Design Jury megjelenítése az agent futtatások során',
  'critiqueTheater.settingsEnabledDescription': 'Ha engedélyezve van, egy ötpaneles felülvizsgálat jelenik meg az agent generálások mellett, és a kiszállítás előtt pontozza a kimenetet. Bármikor megszakíthatod.',
  'critiqueTheater.settingsEnabledProjectHint': 'Mentve ehhez a projekthez. Az ebben a projektben futó új futtatások a Design Jury-n keresztül haladnak a szerveroldalon.',
  'critiqueTheater.settingsEnabledNoProjectHint': 'Nyiss meg egy projektet a szerveroldali megőrzéshez. Addig ez csak a böngészőn belüli beállítást módosítja.',
  'pet.title': 'Háziállatok',
  'pet.subtitle': 'Fogadj be egy apró társat, aki a munkaterületed felett lebeg.',
  'pet.navTitle': 'Háziállatok',
  'pet.navHint': 'Befogadás vagy testreszabás',
  'pet.tabBuiltIn': 'Beépített',
  'pet.tabBuiltInHint': 'Az Open Designnal csomagolt társak — válassz egyet és fogadd örökbe.',
  'pet.builtInEmpty': 'A beépített állatok most nem elérhetők. Frissítsd a Közösség fület, amint a daemon újra online.',
  'pet.tabCustom': 'Egyéni',
  'pet.tabCustomHint': 'Készíts sajátot névvel, jellel, színnel vagy sprite-tal.',
  'pet.tabCommunity': 'Közösségi',
  'pet.tabCommunityHint': 'Codex-ben kikelt háziállatok — fogadj be egyet, vagy generálj újat.',
  'pet.tabsAria': 'Háziállat forrása',
  'pet.adopt': 'Befogadás',
  'pet.adoptedBadge': 'Befogadva',
  'pet.adoptCallout': 'Fogadj be egy háziállatot',
  'pet.changePet': 'Háziállat váltása',
  'pet.wake': 'Ébresztés',
  'pet.tuck': 'Elrejtés',
  'pet.wakeTitle': 'Háziállat ébresztése — lebegő réteg megjelenítése.',
  'pet.tuckTitle': 'Háziállat elrejtése — lebegő réteg eltüntetése.',
  'pet.settingsTitle': 'Háziállat beállításainak megnyitása',
  'pet.useCustom': 'Saját háziállat használata',
  'pet.customTitle': 'Készíts egy sajátot',
  'pet.customHint': 'Válassz nevet, jelet és kiemelőszínt — a réteg élőben frissül.',
  'pet.customGreetingPlaceholder': 'Köszönj a háziállatod nevében…',
  'pet.fieldName': 'Név',
  'pet.fieldGlyph': 'Jel',
  'pet.fieldGlyphHint': 'Egyetlen emoji a legjobb (pl. 🐝, 🦄, 🐢).',
  'pet.fieldGreeting': 'Üdvözlés',
  'pet.fieldAccent': 'Kiemelőszín',
  'pet.fieldAccentCustom': 'Egyedi szín',
  'pet.fieldAccentDefault': 'Alapértelmezett kiemelőszín',
  'pet.overlayAria': 'Háziállat társ',
  'pet.spriteAria': '{name} — húzd a mozgatáshoz, kattints a beszélgetéshez',
  'pet.spriteTitle': 'Üdv tőlem, {name}! Kattints a beszélgetéshez.',
  'pet.taskSummarySingle': '{count} agent feladat fut.',
  'pet.taskSummaryMultiple': '{count} agent feladat fut {projects} projektben.',
  'pet.taskSummaryRecentSingle': '{count} agent feladat fejeződött be nemrég.',
  'pet.taskSummaryRecentMultiple': '{count} agent feladat fejeződött be nemrég.',
  'pet.taskListAria': 'Aktív agent feladatok',
  'pet.taskOpenProject': '{project} megnyitása',
  'pet.taskGroup.running': 'Fut',
  'pet.taskGroup.queued': 'Várakozik',
  'pet.taskGroup.recent': 'Nemrég befejezve',
  'pet.idleQuote.leonardo.text': 'A tanulás sohasem meríti ki az elmét.',
  'pet.idleQuote.leonardo.author': 'Leonardo da Vinci',
  'pet.idleQuote.michelangelo.text': 'Megláttam az angyalt a márványban, és addig faragtam, amíg kiszabadítottam.',
  'pet.idleQuote.michelangelo.author': 'Michelangelo',
  'pet.idleQuote.bernini.text': 'Két eszköz segítheti a szobrászt: a fény és az árnyék.',
  'pet.idleQuote.bernini.author': 'Gian Lorenzo Bernini',
  'pet.idleQuote.raphael.text': 'Amikor az ember fest, nem gondolkodik.',
  'pet.idleQuote.raphael.author': 'Raffaello',
  'pet.idleQuote.caravaggio.text': 'Minden mű, bárki bármit fessen is, nem más, mint csekélység és gyermeteg semmiség, hacsak nem életből készül és festik.',
  'pet.idleQuote.caravaggio.author': 'Caravaggio',
  'pet.idleQuote.rodin.text': 'A lényeg az, hogy meghatódjunk, szeressünk, reménykedjünk, remegjünk, éljünk.',
  'pet.idleQuote.rodin.author': 'Auguste Rodin',
  'pet.composerTitle': 'Háziállatok — ébresztés, elrejtés vagy választás',
  'pet.composerMenuTitle': 'Háziállatok',
  'pet.composerMenuHint': 'tipp: írd be /pet a váltáshoz',
  'pet.composerOpenSettings': 'Háziállatok kezelése',
  'pet.welcomeTeaserTitle': 'Fogadj be egy háziállatot',
  'pet.welcomeTeaserBody': 'Egy apró lebegő társ, aki veled van.',
  'pet.welcomeTeaserCta': 'Választok egyet',
  'pet.imageUpload': 'Sprite feltöltése',
  'pet.imageReplace': 'Sprite cseréje',
  'pet.imageRemove': 'Emoji használata',
  'pet.imageHintIdle': 'PNG, JPG, WebP, GIF vagy SVG. Spritesheet? Tölts fel egy vízszintes szalagot, és add meg a képkockaszámot.',
  'pet.imageHintActive': 'A sprite-od látható. Állítsd a képkockaszámot 1 fölé egy vízszintes spritesheet animálásához.',
  'pet.fieldFrames': 'Képkockák',
  'pet.fieldFramesHint': '1 = statikus. > 1 = vízszintes spritesheet.',
  'pet.fieldFps': 'Sebesség (fps)',
  'pet.fieldFpsHint': 'Milyen gyorsan forognak a képkockák.',
  'pet.atlasImport': 'Codex sprite importálása',
  'pet.atlasImportTitle': 'Importálj egy hatch-pet 8x9 / 192x208 atlast (PNG vagy WebP).',
  'pet.atlasPickerTitle': 'Válassz animációs sort',
  'pet.atlasPickerHint': 'A Codex háziállatok 9 animációs sort hoznak. Alapból a teljes atlast használjuk, így a háziállat sort vált hover, húzás és tétlen állapot szerint. Egy sorra is rögzíthető.',
  'pet.atlasCancel': 'Atlas eldobása',
  'pet.atlasAdopt': 'Rögzítés erre a sorra',
  'pet.atlasAdoptFull': 'Teljes atlas használata (animált)',
  'pet.atlasAdoptFullTitle': 'Minden sor megmarad, így a háziállat reagál a hoverre, a húzás irányára és a hosszú tétlenségre.',
  'pet.atlasAdoptRowTitle': 'Csak a kiemelt sort vágjuk ki egy ismétlődő szalaggá.',
  'pet.atlasActiveHint': 'Animált atlas aktív — a háziállat az interakcióid (hover, húzás, tétlen) alapján választ sort.',
  'pet.atlasRow.idle': 'Tétlen',
  'pet.atlasRow.running-right': 'Futás jobbra',
  'pet.atlasRow.running-left': 'Futás balra',
  'pet.atlasRow.waving': 'Integetés',
  'pet.atlasRow.jumping': 'Ugrás',
  'pet.atlasRow.failed': 'Sikertelen',
  'pet.atlasRow.waiting': 'Várakozás',
  'pet.atlasRow.running': 'Futás',
  'pet.atlasRow.review': 'Áttekintés',
  'pet.hatchTitle': 'Új háziállat költése MI-vel',
  'pet.hatchHint': 'Használd a beépített hatch-pet skillt a chatben egy Codex-stílusú spritesheet generálásához, majd importáld ide.',
  'pet.hatchConcept': 'Háziállat-koncepció (opcionális)',
  'pet.hatchConceptPlaceholder': 'pl. egy apró pixel-art shiba kötött pulóverben',
  'pet.hatchCopy': 'Prompt másolása',
  'pet.hatchCopied': 'Kimásolva!',
  'pet.hatchFoot': 'Miután a skill elmentette a háziállatot, gyere vissza és válaszd a „Codex sprite importálása" lehetőséget.',
  'pet.slashPopoverAria': 'Slash parancsok',
  'pet.slashPopoverTitle': 'Parancsok',
  'pet.slashPopoverHint': '↑↓ navigáció · enter választás · esc kilépés',
  'pet.slashPet': 'Háziállat váltása, befogadása vagy a beállítások megnyitása.',
  'pet.slashPetWake': 'Lebegő háziállat-réteg ébresztése.',
  'pet.slashPetTuck': 'Háziállat elrejtése egy időre.',
  'pet.slashHatch': 'Codex háziállat generálása a hatch-pet skill-lel.',
  'pet.slashHatchArg': '<koncepció>',
  'pet.slashSearch': 'Webes keresés az OD research paranccsal.',
  'pet.slashSearchArg': '<keresés>',
  'pet.codexTitle': 'Frissen kikelt',
  'pet.codexSubtitle': 'A hatch-pet skill által csomagolt háziállatok itt jelennek meg, egy kattintással befogadhatók.',
  'pet.codexSubtitleWithDir': '{dir} keresése hatch-pet csomagok után.',
  'pet.codexEmpty': 'Még nincs kikelt háziállat. Írd be /hatch a chatbe egy generálásához.',
  'pet.codexLoading': 'Kikelt háziállatok keresése…',
  'pet.codexRefresh': 'Frissítés',
  'pet.codexAdopt': 'Befogadás',
  'pet.codexAdopting': 'Befogadás folyamatban…',
  'pet.communitySync': 'Közösségi háziállatok letöltése',
  'pet.communitySyncing': 'Letöltés…',
  'pet.communitySyncTitle': 'Frissítsd a Codex Pet Share és j20 Hatchery legutóbbi háziállatait a ~/.codex/pets/ mappába.',
  'pet.communitySyncDone': '{wrote} új háziállat szinkronizálva (összesen {total}).',
  'pet.communitySyncFailed': 'A szinkronizálás sikertelen: {error}',
  'pet.codexBundled': 'Beépített',
  'pet.codexBundledTitle': 'Az Open Designgal érkezik — letöltés nem szükséges.',
  'settings.systemPrefsTitle': 'Rendszerbeállítások',
  'settings.systemPrefsHint': 'Befejezési hang, böngészőértesítések és feladatállapot-riasztások.',
  'settings.notifications': 'Értesítések',
  'settings.notificationsHint': 'Hang és asztali értesítés a feladat befejezésekor',
  'settings.notifyCompletionSound': 'Befejezési hang',
  'settings.notifyCompletionSoundHint': 'Megszólal egy kör végén. Alapértelmezetten kikapcsolva.',
  'settings.notifySuccessSound': 'Sikerhang',
  'settings.notifyFailureSound': 'Hibahang',
  'settings.notifyDesktop': 'Asztali értesítés',
  'settings.notifyDesktopHint': 'Akkor érkezik, ha az ablak nem aktív.',
  'settings.notifyDesktopBlocked': 'A böngésző letiltotta. Engedélyezd a webhely beállításaiban.',
  'settings.notifyDesktopUnsupported': 'Az asztali értesítések ebben a környezetben nem elérhetők.',
  'settings.notifyTest': 'Tesztküldés',
  'settings.notifyTestSent': 'Tesztértesítés elküldve. Ha nem jelenik meg banner, ellenőrizd a böngésző és a rendszer értesítési beállításait.',
  'settings.notifyTestFailed': 'Az értesítéshívás sikertelen. Ellenőrizd a böngésző és a rendszer értesítési beállításait.',
  'settings.notifySoundDing': 'Csilingelés',
  'settings.notifySoundChime': 'Csengő',
  'settings.notifySoundTwoToneUp': 'Kétszólamú emelkedő',
  'settings.notifySoundPluck': 'Pengetés',
  'settings.notifySoundBuzz': 'Zümmögés',
  'settings.notifySoundTwoToneDown': 'Kétszólamú ereszkedő',
  'settings.notifySoundThud': 'Tompa puffanás',
  'settings.skills': 'Készségek',
  'settings.skillsHint': 'Funkcionális készségek, amelyeket az ügynök egy feladat közben hívhat',
  'settings.skillsNew': 'Új készség',
  'settings.skillsEmpty': 'Válassz egy készséget balra, vagy hozz létre újat.',
  'settings.skillsEdit': 'Szerkesztés',
  'settings.skillsDelete': 'Törlés',
  'settings.skillsDeleteConfirm': 'Törlés megerősítése',
  'settings.skillsName': 'Név',
  'settings.skillsTriggers': 'Indítók (vesszővel vagy új sorral elválasztva)',
  'settings.skillsDescription': 'Leírás',
  'settings.skillsBody': 'SKILL.md tartalom',
  'settings.skillsCreate': 'Létrehozás',
  'settings.skillsSave': 'Mentés',
  'settings.skillsSaving': 'Mentés…',
  'settings.skillsOverrideCreate': 'Felhasználói felülbírálás létrehozása',
  'settings.skillsOverrideSave': 'Mentés felhasználói felülbírálásként',
  'settings.skillsBuiltInOverrideWarning': 'A beépített készség szerkesztése felhasználói felülbírálást hoz létre. A beépített bejegyzés rejtve marad a listából, amíg nem törli a felülbírálást. Folytatja?',
  'settings.skillsFiles': 'Fájlok',
  'settings.skillsNoFiles': 'Nincs fájl ebben a készségmappában.',
  'settings.skillsNameRequired': 'A készség neve kötelező.',
  'settings.skillsBodyRequired': 'A készség tartalma kötelező.',
  'settings.designSystems': 'Designrendszerek',
  'settings.designSystemsHint': 'Böngészd és kapcsold be az elérhető designrendszereket',
  'settings.designSystemsInstalled': 'Telepítve',
  'settings.designSystemsAdd': 'Designrendszer hozzáadása',
  'settings.designSystemsHiddenCount': '{count} elrejtve a kezdő galériából',
  'settings.designSystemsShowAll': 'Összes megjelenítése',
  'settings.designSystemsShowHidden': 'Rejtettek megjelenítése',
  'settings.designSystemsSource': 'Forrás',
  'settings.designSystemsSourceLocal': 'Helyi',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsSourceShadcn': 'shadcn',
  'settings.designSystemsShadcnReference': 'shadcn-registry hivatkozás',
  'settings.designSystemsImportShadcn': 'Importálás shadcnból',
  'settings.designSystemsStructure': 'Struktúra',
  'settings.designSystemsModeHybrid': 'Hibrid',
  'settings.designSystemsModeNormalized': 'Normalizált',
  'settings.designSystemsModeVerbatim': 'Változatlan',
  'settings.designSystemsCraft': 'Készítés',
  'settings.designSystemsCraftColor': 'Szín',
  'settings.designSystemsCraftAccessibility': 'Akadálymentesség',
  'settings.designSystemsGithubUrl': 'GitHub URL',
  'settings.designSystemsProjectPath': 'Projekt útvonala',
  'settings.designSystemsImportGithub': 'Importálás GitHubból',
  'settings.designSystemsImportProject': 'Importálás projektből',
  'settings.designSystemsImportedStatus': '{title} importálva',
  'settings.designSystemsViewImported': 'Importált designrendszer megtekintése',
  'settings.designSystemsCategory': 'Kategória',
  'settings.designSystemsAllCategories': 'Minden kategória',
  'settings.designSystemsShowInHomeGallery': 'Megjelenítés a kezdő galériában',
  'settings.projectLocations': 'Projekt helyek',
  'settings.projectLocationsHint': 'Munkaterület tárolási gyökerek',
  'settings.projectLocationsDescription': 'Adj hozzá munkabázisokat, amelyek több Open Design projektmappát is tartalmazhatnak. Az új projektek mappaként jönnek létre a kiválasztott bázison belül.',
  'settings.projectLocationsSaveError': 'Nem sikerült menteni a projekt helyeket. Ellenőrizd, hogy minden útvonal elérhető mappa-e.',
  'settings.projectLocationsSaved': 'Projekt helyek mentve.',
  'settings.projectLocationsScanError': 'Nem sikerült beolvasni a projekt helyeket.',
  'settings.projectLocationsScanComplete': 'Beolvasás kész: {imported} importálva, {existing} már regisztrálva.',
  'settings.projectLocationsNoFolderSelected': 'Nincs kiválasztott mappa.',
  'settings.projectLocationsDuplicate': 'Ez a munkabázis már hozzá van adva.',
  'settings.projectLocationsWorkBaseMeta': 'Munkabázis · a projektek itt almappaként jönnek létre',
  'settings.projectLocationsAddFolder': 'Mappa hozzáadása…',
  'settings.projectLocationsDefaultBadge': 'Alapértelmezett hely',
  'settings.projectLocationsMakeDefault': 'Legyen alapértelmezett',
  'settings.projectLocationsDefaultSaved': 'Az alapértelmezett projekt hely frissítve.',
  'settings.librarySkills': 'Készségek',
  'settings.libraryDesignSystems': 'Tervezőrendszerek',
  'settings.librarySearch': 'Keresés...',
  'settings.libraryAll': 'Összes',
  'settings.libraryPreview': 'Előnézet',
  'settings.libraryPreviewClose': 'Bezárás',
  'settings.libraryLoading': 'Betöltés...',
  'settings.libraryNoResults': 'Nincs a keresésnek megfelelő elem.',
  'settings.libraryEnabled': 'Engedélyezve',
  'settings.libraryDisabled': 'Letiltva',
  'settings.connectorsNavHint': 'Külső rendszerek kapcsolatai',
  'settings.connectorsHint': 'Kezeld az eszköz csatlakozó- és eszközszolgáltató-beállításait.',
  'settings.connectorsComposioApiKey': 'Composio API-kulcs',
  'settings.connectorsSavedTitle': 'Helyi daemonban mentve',
  'settings.connectorsSavedWithTail': 'Mentve · ••••{tail}',
  'settings.connectorsSaved': 'Mentve',
  'settings.connectorsGetApiKey': 'API-kulcs beszerzése',
  'settings.connectorsReplaceKeyPlaceholder': 'Illessz be új kulcsot a mentett cseréjéhez',
  'settings.connectorsApiKeyPlaceholder': 'Composio API-kulcs beillesztése',
  'settings.connectorsClear': 'Törlés',
  'settings.connectorsClearConfirmTitle': 'Törlöd a mentett Composio API-kulcsot?',
  'settings.connectorsClearConfirmBody': 'A kulcs törlése lekapcsolja ehhez a munkaterülethez kapcsolt összes Composio csatlakozót. A csatlakoztatott fiókok, OAuth-engedélyek és eszközhozzáférések mind eltávolításra kerülnek.',
  'settings.connectorsClearConfirmContinue': 'Tovább',
  'settings.connectorsClearFinalTitle': 'Ez minden csatlakozót lekapcsol',
  'settings.connectorsClearFinalBody': 'Nincs visszavonás. Új kulcs beillesztése után minden integrációt újra kell csatlakoztatnod.',
  'settings.connectorsClearFinalConfirm': 'Kulcs törlése és lecsatlakoztatás',
  'settings.connectorsClearArming': 'Egy pillanat…',
  'settings.connectorsClearCancel': 'Mégse',
  'settings.connectorsSaveKey': 'Kulcs mentése',
  'settings.connectorsSaveKeyTitle': 'Kulcs elküldése a helyi daemonhoz',
  'settings.connectorsKeySaving': 'Mentés…',
  'settings.connectorsKeySaved': 'Mentve ✓',
  'settings.connectorsKeyError': 'A kulcs mentése nem sikerült. Ellenőrizd, hogy a helyi daemon fut-e, majd próbáld újra.',
  'settings.connectorsHelpSaved': 'A kulcs feloldja az alábbi katalógust, és a helyi daemonban marad. Illessz be új kulcsot a cseréhez, vagy töröld az eltávolításhoz.',
  'settings.connectorsHelpUnsaved': 'Mentetlen változtatások — kattints a Kulcs mentése gombra, hogy a hitelesítő adat a helyi daemonba kerüljön, és nyíljon a lenti katalógus.',
  'settings.connectorsHelpEmpty': 'Adj hozzá kulcsot az alábbi katalógus feloldásához. A kulcsok helyben, a daemonban tárolódnak, és soha nem mennek át környezeti változókon.',
  'settings.connectorsLoadingSavedKey': 'Mentett kulcs ellenőrzése a helyi daemonban…',
  'settings.autosaveSaving': 'Mentés…',
  'settings.autosaveSaved': 'Minden változtatás mentve',
  'settings.autosaveError': 'A változtatások mentése nem sikerült. A helyi daemon offline lehet.',
  'settings.libraryToggleLabel': 'Átváltás',
  'settings.memory': 'Memória',
  'settings.memoryHint': 'Personal facts auto-extracted from chats',
  'settings.customInstructionsTitle': 'Globális szabályok',
  'settings.customInstructionsHint': 'Rögzített utasítások, amelyeket az OpenDesignnek minden csevegésben követnie kell. Mentsen tényeket, beállításokat és projektkontextust memóriaként.',
  'settings.customInstructionsPlaceholder': 'pl. „Mindig TypeScriptet használj. Részesítsd előnyben a funkcionális komponenseket. Tartsd tömören a válaszokat.”',
  'settings.memoryDescription': 'Auto-extracted facts about you and your preferences. Saved as Markdown files and folded into every chat.',
  'settings.memoryEnabled': 'Engedélyezve',
  'settings.memoryDisabled': 'Letiltva',
  'settings.memoryEnableLabel': 'Memóriainjektálás engedélyezése',
  'settings.memoryDisabledBanner': 'A memória jelenleg KI van kapcsolva. A meglévő tények megőrződnek a lemezen, de nem épülnek be az új csevegésekbe, és az új körök nem nyernek ki semmi újat.',
  'settings.memoryNew': 'Új memória',
  'settings.memoryEdit': 'Szerkesztés',
  'settings.memoryDelete': 'Törlés',
  'settings.memoryPreview': 'Előnézet',
  'settings.memoryEmpty': 'Még nincs memória.',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'A sötét módot részesítem előnyben',
  'settings.memoryName': 'Name',
  'settings.memoryDesc': 'One-line description',
  'settings.memoryBody': 'Memory body (Markdown supported)',
  'settings.memoryBodyHint': 'Lead with the rule itself; add Why and How to apply lines.',
  'settings.memoryStartersLabel': 'Kell egy kiindulópont? Kattintson az űrlap kitöltéséhez:',
  'settings.memoryStarterUserName': 'Saját szerepkör',
  'settings.memoryStarterUserDesc': 'Frontend mérnök vagyok, aki egy SaaS tervezőeszközön dolgozik',
  'settings.memoryStarterUserBody': '- Szerepkör: senior frontend mérnök\n- Stack: React, TypeScript, Vite\n- Terület: dizájn / együttműködési eszközök\n- Időzóna: GMT+8 (Asia/Shanghai)\n\nMikor alkalmazandó: bármilyen csevegés — a példákat webes frontendre építsd.',
  'settings.memoryStarterFeedbackName': 'Felhasználói felület beállításai',
  'settings.memoryStarterFeedbackDesc': 'Sötét mód, nagy törzsszöveg, alacsony információsűrűség',
  'settings.memoryStarterFeedbackBody': '- Téma: alapértelmezetten sötét\n- Törzsszöveg: ≥ 18px\n- Információsűrűség: részesítsd előnyben az üres helyet, kevesebb elem képernyőnként\n\nMiért: kevesebb szemmegerőltetés hosszú munkamenetek során.\nMikor alkalmazandó: amikor felhasználói felületet, weboldalakat vagy diákat generálsz.',
  'settings.memoryStarterProjectName': 'Jelenlegi projekt',
  'settings.memoryStarterProjectDesc': 'Open Design v0.5 — csevegésvezérelt dizájnszerkesztő',
  'settings.memoryStarterProjectBody': '- Cél: a csevegésvezérelt szerkesztő kiadása ebben a negyedévben\n- Prioritások: streaming renderelés, helyi multimodális, offline-first\n- Technológiai készlet: Next.js 16, Express daemon, SQLite\n\nMikor alkalmazandó: bármely, e projektről szóló beszélgetésben.',
  'settings.memorySaveHint': 'Nem mentődik automatikusan — a Create / Save gombbal alkalmazhatod.',
  'settings.memoryIndexSaveHint': 'Az index módosításai nem mentődnek automatikusan — a Save index gombbal alkalmazhatod.',
  'settings.memoryIndexUnsaved': 'Nem mentett módosítások',
  'settings.memoryFlashCreated': '✓ Memória létrehozva',
  'settings.memoryFlashSaved': '✓ Memória mentve',
  'settings.memoryFlashDeleted': '✓ Memória törölve',
  'settings.memoryFlashIndexSaved': '✓ Index mentve',
  'settings.memoryFlashPathCopied': '✓ Útvonal másolva',
  'settings.memoryNameLabel': 'Cím',
  'settings.memoryTypeLabel': 'Típus',
  'settings.memoryDescLabel': 'Leírás',
  'settings.memoryBodyLabel': 'Tartalom',
  'settings.memoryTypeUser': 'Felhasználó',
  'settings.memoryTypeFeedback': 'Visszajelzés',
  'settings.memoryTypeProject': 'Projekt',
  'settings.memoryTypeReference': 'Hivatkozás',
  'settings.memoryIndex': 'MEMORY.md (index)',
  'settings.memoryIndexSave': 'Index mentése',
  'settings.memoryIndexReset': 'Visszaállítás',
  'settings.memoryToastChanged': 'Memória frissítve',
  'settings.memoryToastClickHint': 'Megnyitás',
  'settings.memoryAll': 'Összes',
  'settings.memoryExtractions': 'Kinyerési előzmények',
  'settings.memoryExtractionsHint': 'Recent LLM-backed extraction attempts. Heuristic regex extraction always runs first; LLM extraction runs in the background after each turn.',
  'settings.memoryExtractionsEmpty': 'Még nincsenek kinyerések. A következő csevegési kör feltölti ezt a listát.',
  'settings.memoryExtractionsRefresh': 'Frissítés',
  'settings.memoryExtractionsRefreshing': 'Frissítés…',
  'settings.memoryExtractionPhaseRunning': 'Futtatás…',
  'settings.memoryExtractionPhaseSuccess': 'Sikeres',
  'settings.memoryExtractionPhaseSkipped': 'Kihagyva',
  'settings.memoryExtractionPhaseFailed': 'Sikertelen',
  'settings.memoryExtractionSkipNoProvider': 'Nincs konfigurált API key az LLM-alapú memóriakinyeréshez.',
  'settings.memoryExtractionSkipUnsupportedProvider': 'A saved media provider is not supported for LLM memory extraction.',
  'settings.memoryExtractionSkipDisabled': 'A memória le van tiltva.',
  'settings.memoryExtractionSkipEmpty': 'Üres felhasználói üzenet — nincs mit kinyerni.',
  'settings.memoryExtractionSkipNoMatch': 'Egyetlen regex minta sem illeszkedett ebben a körben.',
  'settings.memoryExtractionKindHeuristic': 'regex',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'env',
  'settings.memoryExtractionProviderMediaConfig': 'médiabeállítások',
  'settings.memoryExtractionProviderOverride': 'memóriabeállítások',
  'settings.memoryExtractionProposed': 'javasolt',
  'settings.memoryExtractionWritten': 'kiírva',
  'settings.memoryExtractionDuration': 'in',
  'settings.memoryExtractionDelete': 'Törlés',
  'settings.memoryExtractionsClear': 'Törlés',
  'settings.memoryExtractionsClearTitle': 'Összes kinyerési előzmény törlése',
  'settings.memoryExtractionsClearConfirm': 'Törli az összes kinyerési előzményt? Ezt nem lehet visszavonni.',
  'settings.memoryNoProviderBannerTitle': 'Az LLM-alapú memóriakinyerés nem fut',
  'settings.memoryNoProviderBannerBody': 'Nem található API key a memóriakinyerőhöz. Adjon hozzá egy OpenAI kulcsot a Media providers alatt, vagy állítsa be az ANTHROPIC_API_KEY / OPENAI_API_KEY változót a környezetben az LLM-vezérelt kinyerés engedélyezéséhez. A heurisztikus regex-kinyerés továbbra is aktív.',
  'artifact.odCardTaskBriefChip': 'Memória alkalmazva · összefoglaló megtekintése',
  'artifact.odCardScorecardTitle': 'Önellenőrzés',
  'artifact.odCardScorecardStatusPass': 'Megfelelt',
  'artifact.odCardScorecardStatusPartial': 'Részleges',
  'artifact.odCardScorecardStatusFail': 'Javítandó',
  'artifact.odCardRuleKicker': 'Javasolt szabály',
  'artifact.odCardRuleNameLabel': 'Név',
  'artifact.odCardRuleDescriptionLabel': 'Leírás',
  'artifact.odCardRuleAssertionLabel': 'Teljesülnie kell',
  'artifact.odCardRuleCheckLabel': 'Hogyan ellenőrizd',
  'artifact.odCardRuleRationaleLabel': 'Miért',
  'artifact.odCardRuleKeep': 'Megtartás',
  'artifact.odCardRuleEdit': 'Szerkesztés',
  'artifact.odCardRuleDone': 'Kész',
  'artifact.odCardRuleDiscard': 'Elvetés',
  'artifact.odCardRuleSaving': 'Mentés…',
  'artifact.odCardRuleSaved': '„{name}” mentve szabályként',
  'artifact.odCardRuleError': 'A szabályt nem sikerült menteni. Próbáld újra.',
  'artifact.odCardBrandAssistDone': 'Browser assist confirmed',
  'artifact.odCardBrandAssistKicker': 'Browser assist needed: {reason}',
  'artifact.odCardBrandAssistBody': 'Open Browser and clear any human check. Then click More, choose Download Page, wait for the saved snapshot success, and use the left Next Step card to continue extraction.',
  'artifact.odCardBrandAssistError': 'Could not start browser assist. Try again.',
  'artifact.odCardBrandAssistWorking': 'Starting...',
  'artifact.odCardBrandAssistConfirm': 'Open browser assist',
  'settings.memoryTypeProfile': 'Profil',
  'settings.memoryTypeRule': 'Szabály',
  'settings.memoryTabMemories': 'Emlékek',
  'settings.memoryTabMemoriesCaption': 'Mentett memória megtekintése és kezelése',
  'settings.memoryTabHow': 'Hogyan működik',
  'settings.memoryTabHowCaption': 'A két hurok és vezérlőik',
  'settings.memoryAddDisclosure': 'Emlékek hozzáadása vagy importálása',
  'settings.memoryAddDisclosureHint': 'Profil, kézi bevitel vagy csatlakoztatott alkalmazások',
  'settings.memoryProfileTab': 'Munkaprofil',
  'settings.memoryProfileTabCaption': 'Ki vagy és milyen alapbeállításaid vannak',
  'settings.memoryProfileTitle': 'A munkaprofilod',
  'settings.memoryProfileHint':
    'Néhány tény rólad és az alapbeállításaidról. A memória ezt minden feladat előtt beilleszti, így az ügynök egy rövid kérésből is kikövetkezteti, mire gondolsz.',
  'settings.memoryProfileName': 'Munkaprofil',
  'settings.memoryProfileDescription':
    'Szerepkör, cég, terület, közönség, ízlés és alapbeállítások, amelyeket az asszisztens újra felhasználhat.',
  'settings.memoryProfileSave': 'Profil mentése',
  'settings.memoryProfileSaving': 'Mentés…',
  'settings.memoryProfileSaved': 'Profil mentve',
  'settings.memoryProfileRole': 'Szerepkör',
  'settings.memoryProfileRolePlaceholder': 'pl. Founder, designer, PM',
  'settings.memoryProfileCompany': 'Cég / Csapat',
  'settings.memoryProfileCompanyPlaceholder': 'pl. Acme, growth team',
  'settings.memoryProfileDomain': 'Terület',
  'settings.memoryProfileDomainPlaceholder': 'pl. B2B SaaS, fintech, devtools',
  'settings.memoryProfileAudience': 'Elsődleges közönség',
  'settings.memoryProfileAudiencePlaceholder': 'pl. executives, engineers, end users',
  'settings.memoryProfileAesthetic': 'Esztétika / ízlés',
  'settings.memoryProfileAestheticPlaceholder':
    'pl. clean and editorial, light backgrounds, generous whitespace',
  'settings.memoryProfileDeliverables': 'Alapértelmezett szállítandók',
  'settings.memoryProfileDeliverablesPlaceholder': 'pl. landing pages, decks, one-pagers',
  'settings.memoryProfileLocale': 'Régió / Nyelv',
  'settings.memoryProfileLocalePlaceholder': 'pl. English (US), Simplified Chinese',
  'settings.memoryProfileGoals': 'Aktuális célok',
  'settings.memoryProfileGoalsPlaceholder':
    'pl. ship the new pricing page, raise conversion on the trial flow',
  'settings.memoryHooksTitle': 'Memóriahookok',
  'settings.memoryHooksHint':
    'Válaszd ki, mely memóriarészek fussanak automatikusan. A fenti főkapcsoló mindet kikapcsolja.',
  'settings.memoryHooksProfileLabel': 'Profilom használata',
  'settings.memoryHooksProfileDesc': 'Illeszd be a munkaprofilodat minden feladatba.',
  'settings.memoryHooksRewriteLabel': 'Rövid kérések átírása',
  'settings.memoryHooksRewriteDesc': 'PRE: bővíts ki egy rövid kérést teljes feladat-összefoglalóvá.',
  'settings.memoryHooksVerifyLabel': 'Kimenet önellenőrzése',
  'settings.memoryHooksVerifyDesc': 'POST: ellenőrizd az eredményt a szabályaid alapján, majd mutass egy eredménylapot.',
  'settings.memoryHooksExtractionLabel': 'Tanulás a csevegésekből',
  'settings.memoryHooksExtractionDesc': 'Hasznos tények és preferenciák rögzítése a csevegési körökből.',
  'settings.memoryUnsupportedProviderBannerBody': 'A media provider key is saved, but Memory can only reuse text-capable providers: OpenAI, MiniMax, AIHubMix, and SenseAudio. Configure one of those under Media providers, set ANTHROPIC_API_KEY / OPENAI_API_KEY, or choose a Memory model in Advanced.',
  'settings.libraryInstall': 'Telepítés',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'Helyi elérési út',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': 'Telepítés',
  'settings.libraryUninstall': 'Eltávolítás',
  'settings.libraryBuiltIn': 'Beépített',
  'settings.libraryInstalled': 'Telepítve',
  'notify.successTitle': 'Feladat befejezve',
  'notify.failureTitle': 'A feladat meghiúsult',
  'notify.successBody': 'Egy kör befejeződött.',
  'notify.failureBody': 'A feladat hibával ért véget.',
  'updater.available': 'Frissítés érhető el',
  'updater.activeRunsTitle': 'Az Open Design még dolgozik',
  'updater.activeRunsBody': '{count} aktív feladat még fut. Az újraindítás megszakítja őket.',
  'updater.activeRunsUnknownBody': 'Az Open Design nem tudta ellenőrizni, hogy futnak-e feladatok. Az újraindítás megszakíthat aktív munkát.',
  'updater.availableBody': 'Az Open Design {version} elérhető. A telepítő megnyitása előtt letöltődik.',
  'updater.checking': 'Frissítések keresése',
  'updater.download': 'Frissítés letöltése',
  'updater.downloading': 'Frissítés letöltése',
  'updater.downloadingPercent': 'Frissítés letöltése {percent}%',
  'updater.done': 'Kész',
  'updater.failed': 'A frissítés sikertelen',
  'updater.installerOpenBody': 'A telepítő meg van nyitva. Az Open Design kilép, hogy befejezhesse a frissítést.',
  'updater.installerOpened': 'Telepítő megnyitva',
  'updater.later': 'Később',
  "updater.allowSilentUpdates": "Jövőbeli alkalmazáson belüli frissítések automatikus telepítése",
  'updater.openFailedFallback': 'A telepítő nem nyitható meg.',
  'updater.installRestart': 'Telepítés és újraindítás',
  'updater.installingRestart': 'Installing and restarting...',
  'updater.openInstaller': 'Frissítés telepítése',
  'updater.opening': 'Telepítő megnyitása...',
  'updater.dialogAvailableGeneric': 'Új verzió érhető el.\nTöltse le a frissítés telepítéséhez.',
  'updater.dialogAvailableVersion': 'A v{version} elérhető.\nTöltse le a frissítés telepítéséhez.',
  'updater.dialogCheckFailed': 'Nem sikerült ellenőrizni a frissítéseket.\nPróbálja újra rövidesen.',
  'updater.dialogReadyGeneric': 'Az új verzió készen áll.\nJobb élmény, intelligensebb tervezés.',
  'updater.dialogReadyVersion': 'A v{version} készen áll.\nJobb élmény, intelligensebb tervezés.',
  'updater.dialogUnsupported': 'Az alkalmazáson belüli frissítés itt nem érhető el.\nTöltse le a legújabb verziót a kiadások oldaláról.',
  'updater.payloadReadyGeneric': 'A new Open Design update is ready. Open Design will close and restart automatically.',
  'updater.payloadReadyVersion': 'Open Design {version} is ready. Open Design will close and restart automatically.',
  'updater.quitButton': 'Kilépés az Open Designból',
  'updater.quitFailedBody': 'A telepítő meg van nyitva, de az Open Design nem tudott kilépni. Az alkalmazás cseréje előtt lépjen ki az Open Designból.',
  'updater.quitFailedTitle': 'Nem sikerült kilépni',
  'updater.quitting': 'Kilépés...',
  'updater.ready': 'Frissítés kész',
  'updater.readyGeneric': 'Elkészült az új verzió. Az Open Design bezárul, és megnyitja a telepítőt.',
  'updater.readyVersion': 'Az Open Design {version} elkészült. Az Open Design bezárul, és megnyitja a telepítőt.',
  'updater.reinstallLearnMore': 'További információ',
  'updater.reinstallReadyGeneric': 'Ez a frissítés teljes újratelepítést igényel. Az Open Design bezárul, és megnyitja a telepítőt.',
  'updater.reinstallReadyVersion': 'Az Open Design {version} teljes újratelepítést igényel. Az Open Design bezárul, és megnyitja a telepítőt.',
  'updater.restartAnyway': 'Újraindítás mindenképp',
  'updater.upToDate': 'Már a legújabb verziót használja.',
  'updater.viewVersionFeatures': 'Új funkciók felfedezése',
  'updater.manualDownload': 'Kézi letöltés',
  'whatsNew.updatedTitle': 'Megjött az Open Design {version}',
  'whatsNew.cta': 'Kiadási megjegyzések megtekintése',
  'newsletter.label': 'Newsletter (optional)',
  'newsletter.placeholder': 'you@studio.com',
  'settings.memoryModelInlineLabel': 'Memory model',
  'settings.memoryModelInlineSameAsChat': 'Same as chat',
  'settings.memoryModelInlineSameAsChatWithModel': 'Same as chat ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Same as chat ({provider})',
  'settings.memoryModelInlineHintCli': 'Optional. The memory extractor uses an env-var or media-providers API key on this provider; pinning a model here just overrides the auto-pick.',
  'settings.memoryModelInlineHintCliConstrained': 'Optional. Memory will call {provider}; needs an env-var or media-providers API key for that provider, or pick a model below to override.',
  'settings.memoryModelInlineHintByok': 'Optional. Reuses your chat API key on the same provider — picking a different (usually cheaper) model only changes the request body.',
  'settings.memoryModelInlineFlashSaved': 'Saved',
  'settings.memoryModelInlineFlashCleared': 'Cleared',
  'settings.orbit.eyebrow': 'Automatizálás',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': 'Napi csatlakozó-összefoglaló',
  'settings.orbit.lede': 'Gyűjtsd a csatlakozók aktivitását ütemezetten, és tedd közzé az eredményt frissíthető live artifact formában.',
  'settings.orbit.statusOnTitle': 'Az ütemezett napi futások be vannak kapcsolva',
  'settings.orbit.statusOffTitle': 'Az ütemezett napi futások ki vannak kapcsolva',
  'settings.orbit.statusActive': 'Aktív',
  'settings.orbit.statusOff': 'Ki',
  'settings.orbit.runTitle': 'Orbit futás indítása és az élő beszélgetés megnyitása',
  'settings.orbit.running': 'Fut…',
  'settings.orbit.runOpen': 'Futtatás most',
  'settings.orbit.dailySummaryTitle': 'Napi összefoglaló',
  'settings.orbit.dailySummarySub': 'Naponta egyszer fut a beállított helyi időben.',
  'settings.orbit.on': 'Be',
  'settings.orbit.off': 'Ki',
  'settings.orbit.runTimeTitle': 'Futási idő',
  'settings.orbit.runTimeSub': 'Alapértelmezett 08:00. Mentés után érvényesül a daemon ütemezésében.',
  'settings.orbit.runTimeAria': 'Napi Orbit futási idő',
  'settings.orbit.nextRun': 'Következő futás',
  'settings.orbit.nextRunScheduledAfterSave': 'Mentés után ütemezve',
  'settings.orbit.schedule': 'Ütemezés',
  'settings.orbit.pausedManualOnly': 'Szüneteltetve — csak kézi futások',
  'settings.orbit.templateTitle': 'Prompt sablon',
  'settings.orbit.templateMissing': 'A(z) {id} sablon nincs telepítve.',
  'settings.orbit.templateMissingOption': '{id} (hiányzik)',
  'settings.orbit.templateMissingInstall': 'Telepíts Orbit skillt a prompt irányításához.',
  'settings.orbit.templateMissingPickAnother': 'Válassz másik sablont a legördülőből.',
  'settings.orbit.templateResetTitle': 'Visszaállítás erre: {id}',
  'settings.orbit.templateReset': 'Visszaállítás',
  'settings.orbit.templateHelp': 'Irányítsd az Orbit működését skillel — a kiválasztott sablon példa promptja bekerül minden Orbit futásba, hogy az összefoglalók a sablon formáját kövessék.',
  'settings.orbit.templateAria': 'Orbit prompt sablon',
  'settings.orbit.templatesLoading': 'Sablonok betöltése…',
  'settings.orbit.templatesOptgroup': 'Orbit skill sablonok',
  'settings.orbit.lastRun': 'Utolsó futás',
  'settings.orbit.triggerManual': 'Kézi',
  'settings.orbit.triggerScheduled': 'Ütemezett',
  'settings.orbit.meterAria': '{succeeded} sikeres, {skipped} kihagyva, {failed} sikertelen, összesen {checked} ellenőrizve',
  'settings.orbit.countChecked': 'Ellenőrizve',
  'settings.orbit.countSucceeded': 'Sikeres',
  'settings.orbit.countSkipped': 'Kihagyva',
  'settings.orbit.countFailed': 'Sikertelen',
  'settings.orbit.runError': 'Nem sikerült futtatni az Orbit műveletet. Ellenőrizd, hogy a helyi daemon fut-e, és a csatlakozók be vannak-e állítva.',
  'settings.orbit.gateAriaLabel': 'Az Orbit használatához csatlakozók szükségesek',
  'settings.orbit.gateEyebrow': 'Beállítás szükséges',
  'settings.orbit.gateTitle': 'Csatlakoztass egy eszközt az Orbit működéséhez',
  'settings.orbit.gateBody': 'Az Orbit összefoglalja a csatlakozók tevékenységét. Még nem csatlakoztattál semmit — adj hozzá legalább egy integrációt, hogy az Orbitnak legyen miről jelentenie.',
  'settings.orbit.gateBodyNoKey': 'Az Orbit a csatlakozóid tevékenységét összegzi, és a csatlakozók a Composio-n keresztül futnak. Adj hozzá egy Composio API-kulcsot a Csatlakozók alatt, hogy feloldd a katalógust és kiválaszthasd az első integrációd.',
  'settings.orbit.gateAction': 'Csatlakozók megnyitása',
  'settings.orbit.gateActionNoKey': 'Composio beállítása',
  'settings.orbit.gateLoading': 'Csatlakozók ellenőrzése…',
  'settings.orbit.controlsLockedBadge': 'Zárolva',
  'settings.orbit.controlsLockedHint': 'Csatlakoztass egy eszközt az Orbit ütemezésének és sablonjának feloldásához.',
  'settings.orbit.artifactKickerLive': 'élő artifact',
  'settings.orbit.artifactKickerLegacy': 'Régi összefoglaló',
  'settings.orbit.artifactTitle': 'Napi Orbit aktivitási összefoglaló',
  'settings.orbit.artifactMetaLive': 'Csatlakozó-aktivitásból generált frissíthető HTML artifact.',
  'settings.orbit.artifactMetaLegacy': 'A live artifact támogatás engedélyezése előtt készült — futtasd újra az Orbit műveletet egy közzétételéhez.',
  'settings.orbit.copyMarkdownTitle': 'Markdown összefoglaló másolása a vágólapra',
  'settings.orbit.copied': 'Másolva',
  'settings.orbit.copy': 'Másolás',
  'settings.orbit.openArtifact': 'Artefakt megnyitása',
  'settings.orbit.sourceMarkdown': 'Forrás Markdown',
  'settings.memoryModelInlineHintByokNeutral': 'A memória a csevegéstől eltérő modellt használ. Alapértelmezés szerint a csevegési modellt használja.',
  'diagnostics.exportTitle': 'Diagnosztika exportálása',
  'diagnostics.exportButton': 'Diagnosztika exportálása',
  'diagnostics.exportHint': 'A legutóbbi alkalmazásnaplókat és gépinformációkat zip fájlba csomagolja a csapatnak való elküldéshez.',
  'diagnostics.exporting': 'Exportálás…',
  'diagnostics.exportSuccess': 'Diagnosztika mentve: {path}',
  'diagnostics.exportFailed': 'Diagnosztika exportálása sikertelen: {message}',
  'automations.eyebrow': 'Ütemezett Agent-munkamenetek',
  'automations.title': 'Automatizálások',
  'automations.lede': 'Tervezz ismétlődő beszélgetéseket projektmunkához, Orbit összefoglalókhoz és élő tartalmakhoz.',
  'automations.summaryAria': 'Automatizálás-összegzés',
  'automations.metricActive': 'Aktív',
  'automations.metricPaused': 'Szüneteltetve',
  'automations.metricTemplates': 'Sablonok',
  'automations.newAutomation': 'Új automatizálás',
  'automations.yourAutomations': 'Automatizálásaid',
  'automations.loading': 'Betöltés',
  'automations.emptyTitle': 'Még nincs automatizálás',
  'automations.emptyBody': 'Hozz létre egyet sablonból, vagy kezdj üres ütemezéssel.',
  'automations.targetNewEachRun': 'Minden futáshoz új projekt',
  'automations.targetCreateEachRun': 'Minden futáshoz új projekt',
  'automations.lastRun': 'Utolsó futás: {time}',
  'automations.openResult': 'Eredmény megnyitása',
  'automations.run': 'Futtatás',
  'automations.runNowTitle': 'Futtasd most és nyisd meg a beszélgetést',
  'automations.history': 'Előzmények',
  'automations.hideHistory': 'Előzmények elrejtése',
  'automations.edit': 'Szerkesztés',
  'automations.pause': 'Szüneteltetés',
  'automations.resume': 'Folytatás',
  'automations.deleteAria': 'Automatizálás törlése',
  'automations.deleteTitle': 'Az automatizálás törlése',
  'automations.deleteConfirm': 'Törlöd ezt az automatizálást? A korábbi futások és projektjeik megmaradnak.',
  'automations.proposalsTitle': 'Fejlesztési javaslatok',
  'automations.proposalsSub': 'Tekintsd át az automatizálás kimenetét, mielőtt módosítja a memóriát, a készségeket vagy a design rendszereket.',
  'automations.proposalsPending': '{n} függőben',
  'automations.apply': 'Alkalmaz',
  'automations.reject': 'Elutasít',
  'automations.proposalsDismissReason': 'Elvetve az Automatizálásokban',
  'automations.templatesTitle': 'Sablonok',
  'automations.templatesSub': 'Az Orbit és az élő tartalmak sablonok ugyanazon az automatizálási folyamaton belül.',
  'automations.templatesCount': '{filtered} / {total}',
  'automations.templateFiltersAria': 'Sablonszűrők',
  'automations.templatesEmptyTitle': 'Ebben a kategóriában még nincs sablon.',
  'automations.templatesEmptyBody': 'Próbálj másik szűrőt, vagy kezdj üres automatizálással.',
  'automations.useTemplate': 'Sablon használata',
  'automations.runHistoryLoading': 'Futási előzmények betöltése...',
  'automations.runHistoryEmpty': 'Még nincs futás.',
  'automations.runHistoryTitle': 'Futási előzmények',
  'automations.runHistoryLatest': 'Legutóbbi 10',
  'automations.crystallize': 'Kikristályosítás',
  'automations.crystallizing': 'Kikristályosítás folyamatban',
  'automations.crystallizeTitle': 'Készíts készség- és memóriajavaslatokat ebből a futásból',
  'automations.crystallizeFailed': 'Crystallize failed: {error}',
  'automations.crystallizePartialSuccess': 'Crystallize created proposals, but Automations could not refresh the proposal list. Review the visible proposals or try refreshing.',
  'automations.crystallizeRefreshFailed': 'Crystallize finished, but Automations could not refresh proposals. Try refreshing before running it again.',
  'automations.crystallizeNoProposals': 'Crystallize finished, but no proposals were returned. Try refreshing or check the run details.',
  'automations.openConversation': 'Beszélgetés megnyitása',
  'automations.runHistoryAria': 'Automatizálás futási előzményei',
  'automations.proposalsAria': 'Automatizálás fejlesztési javaslatai',
  'automations.templatesAria': 'Automatizálási sablonok',
  'automations.runInProgress': 'Folyamatban',
  'automations.promptPlaceholder': 'Töltsd le a tegnapi GitHub + Linear tevékenységet, és foglald össze, mi változott.',
  'automations.scheduleStatusPaused': 'Szüneteltetve',
  'automations.nextRunManualOnly': 'Csak kézi',
  'automations.nextRunScheduled': 'Ütemezve',
  'automations.nextRunAt': 'Következő: {time}',
  'automations.statusSucceeded': 'Sikeres',
  'automations.statusFailed': 'Sikertelen',
  'automations.statusRunning': 'Fut',
  'automations.statusQueued': 'Sorban áll',
  'automations.statusCanceled': 'Megszakítva',
  'automations.kindOrbit': 'Orbit',
  'automations.kindLiveArtifact': 'Élő tartalom',
  'automations.kindAutomation': 'Automatizálás',
  'automations.proposalTargetMemory': 'Memória',
  'automations.proposalTargetDesignSystem': 'Design rendszer',
  'automations.proposalTargetSkill': 'Készség',
  'automations.proposalTargetTemplate': 'Automatizálási sablon',
  'automations.proposalActionCreate': 'Létrehozás',
  'automations.proposalActionUpdate': 'Frissítés',
  'automations.proposalActionMerge': 'Egyesítés',
  'automations.proposalActionMove': 'Áthelyezés',
  'automations.proposalActionDelete': 'Törlés',
  'automations.proposalActionPromote': 'Előléptetés',
  'automations.filterAll': 'Összes',
  'automations.filterOrbit': 'Orbit',
  'automations.filterLiveArtifacts': 'Élő tartalmak',
  'automations.filterMemory': 'Memória',
  'automations.filterDesignSystems': 'Design rendszerek',
  'automations.filterSkills': 'Készségek',
  'automations.filterConnectors': 'Csatlakozók',
  'automations.filterCompression': 'Tömörítés',
  'automations.filterRelease': 'Kiadás',
  'automations.filterQuality': 'Minőség',
  'automations.tpl.memoryRefresh.title': 'Frissítsd a projektmemóriát a legutóbbi munka alapján.',
  'automations.tpl.memoryRefresh.desc': 'Az ismétlődő döntéseket, preferenciákat és visszajelzéseket újrahasznosítható memóriafrissítésekké alakítja.',
  'automations.tpl.designSystemRefresh.title': 'Frissítsd a design rendszereket a leszállított tartalmak alapján.',
  'automations.tpl.designSystemRefresh.desc': 'Újrahasznosítható tokeneket, komponenseket és szabályokat talál a legutóbbi design munkában.',
  'automations.tpl.liveArtifactRegistry.title': 'Auditáld az élő tartalmakat és frissítsd az elavult verziókat.',
  'automations.tpl.liveArtifactRegistry.desc': 'Naprakészen tartja az állandó irányítópultokat, jelentéseket és előnézeteket azok megkettőzése helyett.',
  'automations.tpl.orbitDashboard.title': 'Építs csatlakozó-tevékenységi irányítópultot.',
  'automations.tpl.orbitDashboard.desc': 'A kiválasztott csatlakozókat Orbit-stílusú élő irányítópulttá összesíti.',
  'automations.tpl.releaseNotes.title': 'Készíts kiadási jegyzeteket a leszállított design munkából.',
  'automations.tpl.releaseNotes.desc': 'Összekapcsolja a beolvasztott PR-eket, tartalmakat és termékoldali változásokat kiadási jegyzetekké.',
  'automations.tpl.qualityRegressionWatch.title': 'Figyeld a design és megvalósítási regressziókat.',
  'automations.tpl.qualityRegressionWatch.desc': 'Összehasonlítja a legutóbbi változásokat a referenciaértékekkel, nyomvonalakkal és elfogadott referenciákkal.',
  'automations.tpl.orbitDaily.title': 'Napi csatlakozó-összefoglaló.',
  'automations.tpl.orbitDaily.desc': 'Ütemezetten frissít egy csatlakozó-tevékenységi összefoglalót.',
  'automations.tpl.liveStatusBoard.title': 'Tarts naprakészen egy élő státusztartalmat.',
  'automations.tpl.liveStatusBoard.desc': 'Egyetlen állandó tartalmat frissít ahelyett, hogy minden futáshoz új jelentést hozna létre.',
  'dsManager.areaAria': 'Design rendszerek terület',
  'dsManager.tabDesignSystem': 'Design rendszer',
  'dsManager.tabTemplate': 'Sablon',
  'dsManager.sourceAria': 'Design rendszer forrása',
  'dsManager.templateSourceAria': 'Sablon forrása',
  'dsManager.yourSystems': 'Rendszereid',
  'dsManager.officialPresets': 'Hivatalos előbeállítások',
  'dsManager.shareToTeam': 'Share to team',
  'dsManager.shareToTeamFailed': 'Couldn\'t share to team',
  'dsManager.syncToTeam': 'Szinkronizálás a csapattal',
  'dsManager.syncToTeamFailed': 'Nem sikerült szinkronizálni a csapattal',
  'dsManager.unshareFromTeam': 'Remove from team',
  'dsManager.unshareFromTeamFailed': 'Couldn\'t remove from team',
  'dsManager.teamSyncedReadOnly': 'Only the sharer or a workspace admin can change this',
  'dsManager.enterprise': 'Vállalati',
  'dsManager.yourTemplates': 'Sablonjaid',
  'dsManager.yourSystemsAria': 'Design rendszereid',
  'dsManager.eyebrowDesignSystems': 'Design rendszerek',
  'dsManager.yourSystemsHeading': 'Rendszereid',
  'dsManager.filterAria': 'Design rendszerek szűrése',
  'dsManager.filterAll': 'Összes',
  'dsManager.filterPublished': 'Közzétett',
  'dsManager.filterDraft': 'Vázlat',
  'dsManager.createTitle': 'Új design rendszer létrehozása',
  'dsManager.createBody': 'Tanítsd meg az Open Designnak a márkádat, terméked, kódod, eszközeid és design referenciáid.',
  'dsManager.createAction': 'Létrehozás',
  'dsManager.emptyMine': 'Még nincs design rendszer. Hozz létre egyet valós termékkontextusból, nézd át a vázlatot, majd tedd közzé a jövőbeli projektekhez.',
  'dsManager.badgeDefault': 'Alapértelmezett',
  'dsManager.rowMetaUpdated': 'Te · frissítve {date}',
  'dsManager.edit': 'Szerkesztés',
  'dsManager.openSystem': 'Megnyitás',
  'dsManager.editWithAgent': 'Szerkesztés Agenttel',
  'dsManager.downloadTitle': 'Designrendszer letöltése (.zip + SKILLS.md)',
  'dsManager.downloadAria': '{title} letöltése .zip fájlként',
  'dsManager.downloadFailed': 'A designrendszer letöltése nem sikerült. Próbáld újra.',
  'dsManager.deleteConfirm': 'Törlöd ezt: „{title}”? Ez eltávolítja a designrendszer vázlatát erről az eszközről.',
  'dsManager.makeDefault': 'Beállítás alapértelmezettként',
  'dsManager.statusPublished': 'Közzétett',
  'dsManager.statusDraft': 'Vázlat',
  'dsManager.openSystemAria': '{title} megnyitása',
  'dsManager.deleteSystemAria': '{title} törlése',
  'dsManager.deletePermissionDenied': 'Nincs jogosultságod ennek a designrendszernek a törléséhez.',
  'dsManager.presetsAria': 'Hivatalos design rendszer előbeállítások',
  'dsManager.eyebrowLibrary': 'Könyvtár',
  'dsManager.eyebrowTemplates': 'Sablonok',
  'dsManager.yourTemplatesAria': 'Sablonjaid',
  'dsManager.emptyTemplates': 'Még nincs sablon. Hozz létre egyet bármely generált projektből a Megosztás funkcióval, amint a sablonközzététel engedélyezve van.',
  'dsManager.templateDescFallback': 'Projektből létrehozva',
  'dsManager.comingSoonBadge': 'Hamarosan',
  'dsManager.enterpriseDsTitle': 'Vállalati design rendszerek',
  'dsManager.enterpriseDsBody': 'A megosztott csapat-design rendszerek és a felügyelt márkakönyvtárak hamarosan elérhetők.',
  'dsManager.enterpriseTplTitle': 'Vállalati sablonok',
  'dsManager.enterpriseTplBody': 'A csapat által jóváhagyott sablonok és a szervezetszintű közzététel hamarosan elérhetők.',
  'settings.instructionsTitle': 'Utasítások és szabályok',
  'settings.instructionsSubtitle': 'Rögzített viselkedés, amelyet az asszisztensnek követnie kell',
  'settings.instructionsNavSub': 'Rögzített asszisztens-viselkedés',
  'settings.customInstructionsDesc': 'Rögzített utasítások, amelyeket az Open Design minden csevegésben követ. Ezek nem mentett memóriák; a tényekhez, preferenciákhoz és projektkontextushoz használd a Memóriát.',
  'mcpClient.forwardedToLabel': 'Továbbítva ide:',
  'mcpClient.notForwardedToLabel': 'Nincs továbbítva ide:',
  'mcpClient.forwardedAcpNote': 'A stdio-ként megjelölt ACP adapterek csak a stdio MCP szervereket kapják meg ebből a listából; a HTTP és SSE bejegyzések indításkor elvetésre kerülnek.',
  'mcpClient.notForwardedNote': 'Ezekhez az Agentekhez állítsd be az MCP szervereket az Agent saját konfigurációs fájljában (pl. ~/.codex/config.toml, ~/.gemini/settings.json); az alábbi szerverek ott csendben kihasználatlanok maradnak.',

  // Brands library + extraction
  'brand.libraryTitle': 'Márkacsomag',
  'brand.librarySubtitle': 'Teach Open Design your brand kits — extract one from a website, then apply it in any chat.',
  'brand.newBrand': 'New Brand Kit',
  'brand.searchPlaceholder': 'Search your brand kits…',
  'brand.empty': 'No brand kits yet. Extract one from a website to get started.',
  'brand.colorsCount': '{count} colors',
  'brand.extracting': 'Extracting…',
  'brand.failed': 'Extraction failed',
  'brand.needsInput': 'Needs input',
  'brand.needsInputHint': 'Extraction paused — open the project to finish verification or answer the question.',
  'brand.appliedToChat': 'Using {name}',
  'brand.previewEmpty': 'Select a brand to preview',
  'brand.viewDetails': 'View details',
  'newBrand.title': 'New Brand',
  'newBrand.subtitle': 'Illessz be egy webhelyet, vagy válassz egy márkát alább, és kinyerjük a színeit, betűtípusait és logóját.',
  'newBrand.urlLabel': 'Brand website',
  'newBrand.urlPlaceholder': 'yourcompany.com',
  'newBrand.extract': 'Extract brand',
  'newBrand.cancel': 'Cancel',
  'newBrand.close': 'Close',
  'newBrand.stage1': 'Fetching the site & measuring its design',
  'newBrand.stage2': 'Building a brand preview',
  'newBrand.stage3': 'Deriving & registering the design system',
  'newBrand.measured': '{colors} colors · {fonts} fonts · {logos} logos',
  'newBrand.done': 'Brand ready',
  'brandDetail.identity': 'Identity',
  'brandDetail.designLanguage': 'Design Language',
  'brandDetail.colors': 'Colors',
  'brandDetail.fonts': 'Fonts',
  'brandDetail.tone': 'Tone',
  'brandDetail.aesthetic': 'Aesthetic',
  'brandDetail.tagline': 'Tagline',
  'brandDetail.voice': 'Voice',
  'brandDetail.useInChat': 'Use in new chat',
  'brandDetail.delete': 'Delete brand',
  'brandDetail.back': 'Márkacsomag',
  'brandDetail.refining': 'Refining this brand…',
  'brandDetail.notFound': 'Brand not found.',
  'brandDetail.logo': 'Logo',
  'brandDetail.typography': 'Typography',
  'brandDetail.palette': 'Palette',
  'brandDetail.voiceTone': 'Voice & tone',
  'brandDetail.imageryLayout': 'Imagery & layout',
  'brandDetail.images': 'Images',
  'brandDetail.designSystem': 'Design system',
  'brandDetail.brandAssets': 'Brand assets',
  'brandDetail.openProject': 'Open project',
  'brandDetail.themeLight': 'Light',
  'brandDetail.themeDark': 'Dark',
  'brandDetail.subjects': 'Subjects',
  'brandDetail.treatment': 'Treatment',
  'brandDetail.useLabel': 'Use',
  'brandDetail.avoidLabel': 'Avoid',
  'brandDetail.layoutPosture': 'Layout posture',
  'brandDetail.deleteConfirm': 'Delete "{name}"? This removes the brand and its design system.',
  'brandDetail.viewMore': 'Show all {count}',
  'brandDetail.viewLess': 'Show less',
  'settings.resetOnboarding': 'Reset onboarding',
  'settings.resetOnboardingDesc': 'Replay the first-run setup, including brand extraction.',
  'settings.resetOnboardingButton': 'Reset',
  'settings.clearUpdaterCacheTitle': 'Frissítési gyorsítótár törlése',
  'settings.clearUpdaterCacheHint': 'Eltávolítja a letöltött frissítéseket és az elavult gyorsítótárakat, majd visszaállítja a frissítési állapotot. Akkor használja, ha a frissítések elakadtak.',
  'settings.clearUpdaterCacheButton': 'Gyorsítótár törlése',
  'settings.clearUpdaterCacheConfirmButton': 'Törlés megerősítése',
  'settings.clearUpdaterCacheSuccess': 'A frissítési gyorsítótár törölve.',
  'settings.clearUpdaterCacheFailed': 'Nem sikerült törölni a frissítési gyorsítótárat.',
  'onboarding.brandTitle': 'Extract your brand kit',
  'onboarding.brandSubtitle': 'Paste a website and we\'ll turn its brand signals into a reusable brand kit for future work.',
  'onboarding.brandSkip': 'Skip for now',
  'onboarding.brandDone': 'Brand kit extracted',
  'onboarding.buildTitle': 'Hozd létre egyszer, építs vele bárhol',
  'onboarding.buildBody': 'Az Open Design a márkádat újrahasználható dizájnrendszerré alakítja, és mindent, amit építesz, márkahűen és egységesen tart.',
  'onboarding.buildBenefitMemoryTitle': 'One brand memory',
  'onboarding.buildBenefitMemoryBody': 'Colors, type, spacing, components, and voice become a DESIGN.md your agents can reuse.',
  'onboarding.buildBenefitAlignedTitle': 'Every output stays aligned',
  'onboarding.buildBenefitAlignedBody': 'Prototype, slide, PDF, dashboard, and marketing work all pull from the same rules.',
  'onboarding.buildBenefitSourcesTitle': 'Start from what you have',
  'onboarding.buildBenefitSourcesBody': 'Use a GitHub repo, website, existing DESIGN.md, screenshots, fonts, or Figma files.',
  'onboarding.buildPreviewLabel': 'Brand system',
  'onboarding.buildStart': 'Dizájnrendszer létrehozása',
  'onboarding.buildHome': 'Ugrás a főoldalra',
  'dsCreate.referenceLabel': 'Copy from existing design system',
  'dsCreate.referenceLoading': 'Loading DESIGN.md...',
  'dsCreate.referenceLoadFailed': 'Could not load that design system.',
  'dsCreate.heroShowGuideAria': 'Show design system guide',
  'dsCreate.heroHideGuideAria': 'Hide design system guide',
  'dsCreate.heroShowGuideTitle': 'Show guide',
  'dsCreate.heroHideGuideTitle': 'Hide guide',
  'dsCreate.heroGuide': 'Guide',
  'dsCreate.missingSourceError': 'Add a website, DESIGN.md, description, file, Figma source, or notes to create a design system.',
  'dsCreate.continueToGeneration': 'Continue to generation',
  'dsCreate.embeddedTitle': 'Generate from your material',
  'dsCreate.embeddedBody': 'Start with a website or brand reference, then add any source files you already have.',
  'dsCreate.sourceSectionTitle': 'Extract from GitHub, websites, or source material',
  'dsCreate.sourceSectionBody': 'Start with a GitHub repo, website, DESIGN.md, or files that show your style. Open Design first creates a usable system quickly, then AI can refine it inside the project.',
  'dsCreate.githubWebsiteLabel': 'GitHub or website',
  'dsCreate.add': 'Add',
  'dsCreate.startFromBrand': 'Start from a brand',
  'dsCreate.brandPickerSubtitle': 'Search hundreds of brands — pick one and we\'ll add its site as a style reference.',
  'dsCreate.brandPickerQuickPicks': 'Popular brands — click to add',
  'dsCreate.addedSourceLinks': 'Added source links',
  'dsCreate.openSourceLabel': 'Open {label}',
  'dsCreate.removeSourceLabel': 'Remove {label}',
  'dsCreate.addFiles': 'Add files',
  'dsCreate.describeBrand': 'Describe brand',
  'dsCreate.optional': 'optional',
  'dsCreate.describeBrandHelp': 'Brand voice, intro and product context. Used in the fast pass and AI refinement.',
  'dsCreate.companyPlaceholder': 'e.g. Mission Impastabowl: fast-casual pasta restaurant with kiosk, mobile app and website',
  'dsCreate.pasteDesignMd': 'Paste DESIGN.md',
  'dsCreate.pasteDesignMdHelp': 'Paste a DESIGN.md to create directly from tokens, rationale and component guidance.',
  'dsCreate.reference': 'Reference',
  'dsCreate.designMdViewMode': 'DESIGN.md view mode',
  'dsCreate.advancedToggle': 'Advanced — repo, local code, Figma',
  'dsCreate.githubRepo': 'GitHub repo',
  'dsCreate.localCodeLabel': 'Link local code',
  'dsCreate.localCodeHelper': 'Use a folder or selected files from this computer.',
  'dsCreate.localCodePrompt': 'Drag a folder here or browse',
  'dsCreate.uploadFigLabel': 'Upload .fig',
  'dsCreate.uploadFigHelper': 'Decoded on your machine into real tokens, components & assets — no Figma account.',
  'dsCreate.uploadFigPrompt': 'Drop .fig here or browse',
  'dsCreate.figmaUrl': 'Figma URL',
  'dsCreate.figmaPlaceholder': 'https://figma.com/design/… or /file/…',
  'dsCreate.addedFigmaUrls': 'Added Figma URLs',
  'dsCreate.savedFigmaHelp': 'Saved as a Figma design source. The agent uses it as the canonical reference; export a .fig above for a full offline decode.',
  'dsCreate.notes': 'Notes',
  'dsCreate.notesPlaceholder': 'e.g. We use a warm, earthy color palette with rounded corners. Our brand voice is playful but professional...',
  'dsCreate.back': 'Back',
  'dsCreate.generate': 'Generate',
  'dsCreate.libraryPickerTitle': 'Select from library',
  'dsCreate.libraryPickerConfirm': 'Add to assets',
  'dsCreate.designMdPreviewKicker': 'DESIGN SYSTEM',
  'dsCreate.designMdPreviewTitle': 'DESIGN.md preview',
  'dsCreate.componentKit': 'component kit',
  'dsCreate.defaultTheme': 'default theme',
  'dsCreate.componentKitTitle': '{name} — component kit',
  'dsCreate.designMdGeneratedDescription': 'Generated from pasted DESIGN.md tokens, rationale and component guidance.',
  'dsCreate.previewButtons': 'Buttons',
  'dsCreate.previewButtonsHelp': 'Five types across three sizes.',
  'dsCreate.buttonPrimary': 'Primary',
  'dsCreate.buttonDashed': 'Dashed',
  'dsCreate.buttonText': 'Text',
  'dsCreate.buttonLink': 'Link',
  'dsCreate.sizeSmall': 'Small',
  'dsCreate.sizeMedium': 'Medium',
  'dsCreate.sizeLarge': 'Large',
  'dsCreate.previewTypeScale': 'Type scale',
  'dsCreate.extractedTokens': 'Extracted DESIGN.md tokens',
  'brandPicker.categorySoftware': 'Software',
  'brandPicker.categoryFinance': 'Finance',
  'brandPicker.categoryFashion': 'Fashion',
  'brandPicker.categoryActivewear': 'Activewear',
  'brandPicker.categoryBeauty': 'Beauty',
  'brandPicker.categoryWellness': 'Wellness',
  'brandPicker.categoryFood': 'Food',
  'brandPicker.categoryBeverage': 'Beverage',
  'brandPicker.categoryMedia': 'Media',
  'brandPicker.categoryEducation': 'Education',
  'brandPicker.categoryElectronics': 'Electronics',
  'brandPicker.categoryAutomotive': 'Automotive',
  'brandPicker.categoryHealthcare': 'Healthcare',
  'brandPicker.categoryTravel': 'Travel',
  'brandPicker.heading': 'Indíts egy márkából, amit szeretsz',
  'brandPicker.subtext': 'Kattints bármelyik márkára, hogy a készletét közvetlenül a weboldaláról kinyerd.',
  'brandPicker.quickPicksLabel': 'Népszerű márkák – kattints a kinyeréshez',
  'brandPicker.searchPlaceholder': 'Márkák keresése…',
  'brandPicker.allCategories': 'Mind',
  'brandPicker.extractAction': 'Kinyerés',
  'brandPicker.showMore': 'Több megjelenítése',
  'brandPicker.opening': 'Kinyerés indítása – {brand} megnyitása…',
  'ds.kitVisualize': 'Vizualizálás',
  'ds.kitEdit': 'Szerkesztés',
  'ds.kitSource': 'Forrás',
  'ds.saveDesignMd': 'DESIGN.md mentése',
  'ds.saving': 'Mentés…',
  'ds.copyDesignMd': 'DESIGN.md másolása',
  'ds.editDesignMd': 'DESIGN.md szerkesztése',
  'ds.openDesignMd': 'DESIGN.md megnyitása',
  'ds.copyDesignMdModule': '{module} szakasz másolása',
  'ds.editDesignMdModule': '{module} szakasz szerkesztése',
  'ds.openDesignMdModule': '{module} szakasz megnyitása',
  'ds.uploadMd': 'MD feltöltése',
  'ds.uploadFont': 'Betűfájl hozzáadása',
  'ds.pasteImage': 'Kép beillesztése',
  'ds.refresh': 'Frissítés',
  'ds.download': 'Letöltés',
  'ds.importFolder': 'Mappa importálása',
  'ds.reset': 'Visszaállítás',
  'ds.editingDesignMdHint': 'A Markdown szerkesztése frissíti a megjelenített kitmodulokat.',
  'ds.editingModuleHint': 'Csak a(z) {module} modul szerkesztése történik.',
  'ds.manualEditModuleHint': 'Edit {module} here. Hover this section to reveal controls.',
  'ds.saveModule': 'Modul mentése',
  'ds.uploadLogo': 'Logó feltöltése',
  'ds.uploadImage': 'Kép feltöltése',
  'ds.uploading': 'Feltöltés…',
  'ds.moduleEmptyLogo': 'Még nincs logó',
  'ds.moduleEmptyFonts': 'Nincsenek rögzített betűkészletek.',
  'ds.actionDone': 'Kész',
  'ds.actionFailed': 'Valami hiba történt. Próbáld újra.',
  'ds.uploadDone': 'Feltöltve',
  'ds.uploadFailed': 'A feltöltés nem sikerült. Próbáld újra.',
  'ds.deleteLogo': 'Logó törlése',
  'ds.deleteImage': '{caption} törlése',
  'ds.deleteProjectConfirm': 'Törlöd ezt: „{title}”? Ez végleg eltávolítja a designrendszert és a projektjét erről az eszközről.',
  'ds.deleteProjectAction': '{title} törlése',
  'ds.editColor': '{name} szerkesztése',
  'ds.colorLabel': 'Szín',
  'ds.hexLabel': 'Hex',
  'ds.hexValueLabel': 'Hex érték',
  'ds.saveColor': 'Szín mentése',
  'ds.invalidHexColor': 'Adj meg érvényes Hex színt, például #FF6A3D.',
  'ds.colorSaveFailed': 'Ezt a színt nem sikerült menteni.',
  'ds.colorResetFailed': 'Ezt a színt nem sikerült visszaállítani.',
  'ds.designMdSectionLabel': '{module} DESIGN.md szakasz',
  'ds.kitErrorTitle': 'Ez a nézet hibába ütközött.',
  'ds.kitErrorRetry': 'Újratöltés',
  'ds.shortcutsLabel': 'Billentyűparancsok',
  'ds.shortcutsHint': 'Parancsok: E szerkesztés · C másolás · U feltöltés · R frissítés · ⌫ logó törlése',
  'ds.moduleEmptyImages': 'Még nincsenek képek',
  'ds.noOriginalColor': 'No original color is available for this swatch.',
  'ds.manifestReadFailed': 'Unable to read _ds_manifest.json.',
  'ds.reviewCollapseSection': 'Collapse {title}',
  'ds.reviewExpandSection': 'Expand {title}',
  'ds.reviewNeedsReview': 'Needs review',
  'ds.reviewLooksGood': 'Looks good',
  'ds.reviewActionsLabel': '{title} review',
  'ds.reviewNeedsWorkEllipsis': 'Needs work...',
  'ds.reviewEditFile': 'Edit {file}',
  'ds.reviewFeedbackLabel': 'Tell the agent what to change',
  'ds.reviewFeedbackPlaceholder': 'e.g. tighten spacing in {title}, regenerate this preview...',
  'ds.reviewChangedAfterFeedback': 'This section changed after your feedback. Review it again before publishing.',
  'ds.reviewChangedDuringRun': 'This section changed during the latest run. Review it before publishing.',
  'ds.reviewLastFeedback': 'Last feedback',
  'ds.previewGenerating': 'Generating preview...',
  'ds.creatingProjectTitle': 'Creating your design system...',
  'ds.creatingProjectSubtitle': 'Keep this tab open. You can come back in a few minutes.',
  'ds.generationProgressLabel': 'Design system generation progress {progress}%',
  'ds.publishRepoRequiredTitle': 'Finish importing your GitHub repo before you can publish.',
  'ds.publishDesignSystem': 'Publish design system',
  'ds.unpublishDesignSystem': 'Unpublish design system',
  'ds.published': 'Published',
  'ds.publish': 'Publish',
  'ds.extractionRunningTitle': 'Extracting design system',
  'ds.extractionCompleteTitle': 'Extraction complete',
  'ds.extractionRunningBody': 'Open Design is updating this system in place.',
  'ds.extractionCompleteBody': 'All extracted modules are shown below; empty sections are intentionally blank.',
  'ds.publishCardPublished': 'Your team\'s new projects can use this design system as context by default.',
  'ds.publishCardDraft': 'Your design system is ready, but your feedback will improve it. Publish it when it is ready to use in future projects.',
  'ds.useSystemTitle': 'Use this system',
  'ds.useSystemBody': 'Start a new design that inherits this system\'s colors, type, and components - kept on-brand automatically.',
  'ds.createNewDesign': 'Create new design',
  'ds.openSourceContext': 'Open source context',
  'ds.manifestNeedsAttention': 'Design manifest needs attention',
  'ds.openManifest': 'Open manifest',
  'ds.workspacePreparing': 'Preparing the design system workspace.',
  'ds.workspaceLoadingLabel': 'Design system workspace is loading',
  'ds.sectionQueued': 'Queued',
  'ds.sectionReviewUpdatedFiles': 'Updated files need review',
  'ds.reviewNeedsWork': 'Needs work',
  'ds.sectionRequiredFileMissing': 'Required file missing: {file}',
  'ds.sectionNoFilesYet': 'No files yet',
  'ds.generationSourceTitle': 'Source context',
  'ds.generationSourceDetail': 'Reading linked source context and repository evidence.',
  'ds.generationGuidanceTitle': 'Brand guidance',
  'ds.generationGuidanceDetail': 'Writing DESIGN.md guidance and voice.',
  'ds.generationTokensTitle': 'Design tokens',
  'ds.generationTokensDetail': 'Extracting colors, type, and spacing tokens.',
  'ds.generationPreviewsTitle': 'Preview cards',
  'ds.generationPreviewsDetail': 'Rendering reviewable preview cards.',
  'ds.generationUiKitTitle': 'UI kit',
  'ds.generationUiKitDetail': 'Creating reusable components and patterns.',
  'ds.generationAssetsTitle': 'Brand assets',
  'ds.generationAssetsDetail': 'Collecting logos, fonts, images, and icons.',
  'ds.phaseQueuedTypography': 'Typography queued',
  'ds.phaseQueuedTokens': 'Tokens queued',
  'ds.phaseQueuedSpacing': 'Spacing queued',
  'ds.phaseQueuedUiKit': 'UI kit queued',
  'ds.phaseQueuedAssets': 'Assets queued',
  'ds.phaseReadingTypography': 'Reading typography',
  'ds.phaseReadingTokens': 'Reading tokens',
  'ds.phaseReadingSpacing': 'Reading spacing',
  'ds.phaseReadingUiKit': 'Reading UI kit',
  'ds.phaseReadingAssets': 'Reading assets',
  'ds.phaseWritingTypography': 'Writing typography',
  'ds.phaseWritingTokens': 'Writing tokens',
  'ds.phaseWritingSpacing': 'Writing spacing',
  'ds.phaseBuildingUiKit': 'Building UI kit',
  'ds.phaseUpdatingAssets': 'Updating assets',
  'ds.phaseNeedsAttention': 'Needs attention',
  'ds.phaseUpdated': 'Updated',
  'ds.sectionActivityFromTodo': '{phase}: {todo}',
  'ds.sectionActivityReadFiles': 'Read {files}',
  'ds.sectionActivityPhaseFiles': '{phase}: {files}',
  'ds.sectionRunningReadingContext': 'Reading context for {title}.',
  'ds.sectionRunningNow': '{phase} now.',
  'ds.reviewLastReviewed': 'Last reviewed {time}',
  'ds.agentFeedbackQueued': 'Agent feedback queued',
  'ds.agentFeedbackSent': 'Agent feedback sent',
  'ds.agentFeedbackSentAt': 'Agent feedback sent {time}',
  'ds.agentFeedbackFailedWithError': 'Agent feedback failed: {error}',
  'ds.agentFeedbackFailed': 'Agent feedback failed',
  'ds.agentFeedbackUnknown': 'Agent feedback status unknown',
  'ds.repoConnectBannerTitle': 'Connect your repo to pull aspects of your design system',
  'ds.repoConnectCardTitle': 'Connect your repo',
  'ds.repoConnectPendingBody': 'Checking your GitHub connection...',
  'ds.repoConnectPendingButton': 'Checking GitHub...',
  'ds.repoConnectedTitle': 'GitHub is connected',
  'ds.repoConnectedBody': 'Re-import this repo to pull its files into your design system.',
  'ds.repoImportButton': 'Import repo',
  'ds.repoConnectBannerBody': 'Connect GitHub so Open Design can read your repository and pull colors, type, and components into this design system.',
  'ds.repoConnectCardBody': 'Pull colors, type, and components from your repository into this design system.',
  'ds.repoConnectButton': 'Connect GitHub',
  // Settings > Workspace region (E-frontend, D4.3): role-gated shell for
  // other-lane workspace destinations (members / billing / team space).
  'settings.workspace': 'Workspace',
  'settings.workspaceHint': 'Members, billing, and team spaces',
  'settings.workspaceLede': 'Team-level settings for this workspace. These areas are managed by the team service — open one to continue.',
  'settings.workspaceBack': 'Back to workspace',
  'settings.workspaceMembers': 'Members & invites',
  'settings.workspaceMembersHint': 'Manage who can access this workspace and send invitations.',
  'settings.workspaceBilling': 'Subscription & seats',
  'settings.workspaceBillingHint': 'Plan, seats, and payment for this workspace.',
  'settings.workspaceAutoRecharge': 'Auto-recharge',
  'settings.workspaceAutoRechargeHint': 'Automatically top up credits when the balance runs low.',
  'settings.workspaceTeamSpace': 'Team space',
  'settings.workspaceTeamSpaceHint': 'Shared projects and visibility for your team.',
  // Full-page Settings (`/settings`): sidebar nav head above the section list.
  'settings.pageBackToHome': 'Back to home',
  'settings.pageNavGroupPersonal': 'Personal',
  'newproj.startFromLabel': 'Kiindulás',
  'newproj.startBlank': 'Üres',
  'newproj.startBlankHint': 'Kezdés a nulláról',
  'workspace.pages': 'Oldalak',
  'workspace.allProjectFiles': 'A projekt összes fájlja',
  'workspace.newBlankPage': 'Új üres oldal',
  'workspace.noPagesYet': 'Még nincsenek oldalak',
  'workspace.pageCreateFailed': 'Az oldal létrehozása nem sikerült.',
  'workspace.pageCreatorTitle': 'Oldal létrehozása',
  'workspace.pageCreatorSearch': 'Sablonok keresése',
  'workspace.pageCreatorCategoryAll': 'Minden helyzet',
  'workspace.pageCreatorEmpty': 'Nincs a keresésnek megfelelő oldaltípus.',
  'workspace.pageCreatorPreview': 'Előnézet',
  'workspace.pageCreatorUse': 'Használat',
  'fileViewer.presentInTabDeckHint': 'Előadói jegyzetek felugró ablakban',
  'fileViewer.presentEscHint': 'Kilépéshez nyomd meg az Esc-et',
  'fileViewer.presenterPause': 'Szünet',
  'fileViewer.presenterResume': 'Folytatás',
  'fileViewer.presenterPrevious': 'Előző',
  'fileViewer.presenterNext': 'Következő',
  'questions.uploadingFiles': 'Fájlok feltöltése…',
  'questions.uploadNeedsProject': 'A fájlfeltöltéshez aktív projekt szükséges.',
  'questions.uploadPartialFailed': '{uploaded} fájl feltöltve, {failed} sikertelen.',
  'questions.uploadFailed': '{failed} fájl feltöltése sikertelen.',
  // #5517 media-providers redesign: pill selector + single detail card.
  'settings.mediaProviderModelProviders': 'Providers',
  'settings.mediaProviderModel': 'Model',
  'settings.mediaProviderModelPlaceholder': 'Use provider default',
  'settings.mediaProviderDocsTitle': 'Documentation',
  'settings.mediaProviderDocsHint': 'View setup instructions for this provider.',
  'settings.mediaProviderSaveHint': 'Changes are not saved until you select Save.',
  'settings.mediaProviderNoKeyRequired': 'No key required',
  'settings.mediaProviderNoKeyHint': 'This provider uses a local login or bundled runtime.',
  'manualEdit.sectionImage': 'IMAGE',
  'manualEdit.sectionContent': 'CONTENT',
  'manualEdit.sectionPage': 'PAGE',
  'manualEdit.pageBackground': 'Background',
  'manualEdit.pageBaseSize': 'Base size',
  'manualEdit.pageStylesHtmlOnly': 'Page styles are available only for full HTML documents.',
  'pluginsView.createKindPlugin': 'Plugin',
  'pluginsView.createKindSkill': 'Skill',
  'pluginsView.importUrlLabel': 'URL',
  'pluginsView.shareActionBadge': 'Action plugin',
  'pluginsView.shareCloseAria': 'Close share confirmation',
  'pluginsView.shareWhatStarts': 'What this starts',
  'pluginsView.shareSourcePlugin': 'Source plugin',
  'pluginsView.shareFactPlugin': 'Plugin',
  'pluginsView.shareFactId': 'ID',
  'pluginsView.shareFactCopiedTo': 'Copied to',
  'pluginsView.shareFactTrust': 'Trust',
  'pluginsView.shareActionPrompt': 'Action prompt',
  'pluginsView.shareStarting': 'Starting…',
  'community.title': 'Community',
  'community.searchPlaceholder': 'Search',
  'community.searchAria': 'Search',
  'community.filtersAria': 'Template filters',
  'community.closePreview': 'Close preview',
  'community.typePrototype': 'Prototype',
  'community.typeLiveArtifact': 'Live Artifact',
  'community.typeSlides': 'Slides',
  'community.typeImage': 'Image',
  'community.typeVideo': 'Video',
  'community.typeHyperFrames': 'HyperFrames',
  'community.typeAudio': 'Audio',
  'community.usePrompt': 'Prompt használata',
  'marketplace.title': 'Plugins marketplace',
  'marketplace.filterTrusted': 'Trusted',
  'marketplace.filterRestricted': 'Restricted',
  'marketplace.emptyBefore': 'No plugins installed yet. Try',
  'marketplace.emptyAfter': ', or register a marketplace below.',
  'marketplace.trustPrefix': 'trust: ',
  'marketplace.catalogsTitle': 'Configured catalogs',
  'marketplace.catalogsEmpty': 'None registered. Add one with',
  'marketplace.pluginCount': '{count} plugin(s)',
  'genui.continue': 'Continue',
  'genui.authorize': 'Authorize',
  'genui.skip': 'Skip',
  'genui.acceptAll': 'Accept all',
  'genui.rejectAll': 'Reject all',
  'genui.submit': 'Submit',
  'genui.submitPartial': 'Submit partial decision',
  'genui.patchNotesPlaceholder': 'Notes for the patch author (optional)',
  'inspect.close': 'Close inspect',
  'inspect.colors': 'Colors',
  'inspect.text': 'Text',
  'inspect.background': 'Background',
  'inspect.typography': 'Typography',
  'inspect.size': 'Size',
  'inspect.weight': 'Weight',
  'inspect.align': 'Align',
  'inspect.padding': 'Padding',
  'inspect.radius': 'Radius',
  'inspect.resetElement': 'Reset element',
  'library.title': 'Library',
  'library.headerHint': 'Clip any page, design system, screenshot, image, or Figma import JSON into your Library — local-first, one click, no login.',
  'library.getClipper': 'Get the Open Design Web Clipper',
  'library.searchPlaceholder': 'Search captions, tags, titles…',
  'library.filterByKind': 'Filter by kind',
  'library.filterBySource': 'Filter by source',
  'library.kindAll': 'All kinds',
  'library.kindImages': 'Images',
  'library.kindElements': 'Elements',
  'library.kindDesignSystems': 'Design systems',
  'library.kindVideo': 'Video',
  'library.kindFonts': 'Fonts',
  'library.kindColors': 'Colors',
  'library.kindText': 'Text',
  'library.kindLinks': 'Links',
  'library.sourceAll': 'All sources',
  'library.sourceClipper': 'Clipper',
  'library.sourceAgent': 'Agent',
  'library.sourceDesignSystem': 'Design system',
  'library.sourceGenerated': 'Generated',
  'library.viewMode': 'View mode',
  'library.viewGrid': 'Grid',
  'library.viewGridTooltip': 'Show assets as a grid',
  'library.viewTimeline': 'Timeline',
  'library.viewTimelineTooltip': 'Group assets by day, newest first',
  'library.refresh': 'Refresh',
  'library.refreshTooltip': 'Reload the list with the current filters',
  'library.sync': 'Sync',
  'library.syncing': 'Syncing…',
  'library.syncTooltip': 'Pull your design systems and agent-generated artifacts into the Library',
  'library.upload': 'Upload',
  'library.uploadTooltip': 'Upload images, fonts, or files into the Library',
  'library.selectedCount': '{count} selected',
  'library.selectAll': 'Select all',
  'library.clear': 'Clear',
  'library.chatToDesign': 'Chat to design',
  'library.chatToDesignTitle': 'Start a chat to turn {count} into a design',
  'library.working': 'Working…',
  'library.useInDesignSystem': 'Use in design system',
  'library.createDesignSystem': 'Create new design system',
  'library.createDesignSystemSub': 'Open the create flow with these {count} attached',
  'library.refineExisting': 'Refine existing',
  'library.noEditableDesignSystems': 'No editable design systems yet.',
  'library.addAssetsAndRefine': 'Add assets & open to refine',
  'library.deleteCount': 'Delete {count}',
  'library.loading': 'Loading…',
  'library.emptyTitle': 'No assets yet.',
  'library.emptyHintBefore': 'Clip from any page with the Open Design Web Clipper, run',
  'library.emptyHintAfter': ', or upload inside a project — everything lands here.',
  'library.dropToUpload': 'Drop to upload to your Library',
  'library.confirmDeleteTitleOne': 'Delete {count} asset?',
  'library.confirmDeleteTitleMany': 'Delete {count} assets?',
  'library.confirmDeleteBodyOne': 'This permanently removes it from your Library. This can’t be undone.',
  'library.confirmDeleteBodyMany': 'This permanently removes them from your Library. This can’t be undone.',
  'library.cancel': 'Cancel',
  'library.today': 'Today',
  'library.yesterday': 'Yesterday',
  'library.previewAsset': 'Preview {title}',
  'library.selectAsset': 'Select asset',
  'library.deselectAsset': 'Deselect asset',
  'library.openDesignSystem': 'Open design system',
  'library.openProject': 'Open project',
  'library.opening': 'Opening…',
  'library.editAsPage': 'Edit as page',
  'library.viewSource': 'Source',
  'library.remove': 'Remove',
  'mcp.aboutTemplate': 'About {name}',
  'mcp.approvedRefresh': 'I’ve approved — Refresh',
  'mcp.approveInBrowserHint': 'Approve in the browser tab that opened. We\'ll catch the callback automatically — or click Refresh below if you completed it already.',
  'mcp.argsPlaceholder': 'space-separated',
  'mcp.authModeNone': 'No managed OAuth',
  'mcp.authModeOAuth': 'Managed OAuth',
  'mcp.browserDidntOpen': 'Browser didn\'t open?',
  'mcp.categoryDataViz': 'Data viz',
  'mcp.categoryDataVizHint': 'Charts and diagrams as proper image artifacts.',
  'mcp.categoryDesignSystems': 'Design systems',
  'mcp.categoryDesignSystemsHint': 'Figma read/write, design-token translation, brand inspiration.',
  'mcp.categoryImageEditing': 'Image editing',
  'mcp.categoryImageEditingHint': 'Local post-processing, OCR and CV-driven edits.',
  'mcp.categoryImageGeneration': 'Image generation',
  'mcp.categoryImageGenerationHint': 'Models that produce raster, vector or video assets.',
  'mcp.categoryPublishing': 'Publishing',
  'mcp.categoryPublishingHint': 'Push generated artifacts to a public URL.',
  'mcp.categoryUiComponents': 'UI components',
  'mcp.categoryUiComponentsHint': 'Designer-grade components, blocks and landing-page material.',
  'mcp.categoryUtilities': 'Utilities',
  'mcp.categoryUtilitiesHint': 'Filesystem, fetch, GitHub and similar generic tools.',
  'mcp.categoryWebCapture': 'Web capture',
  'mcp.categoryWebCaptureHint': 'Render a URL into an image so the agent can see what it built.',
  'mcp.checking': 'Checking…',
  'mcp.clickConnectHint': 'Click Connect to grant Open Design access via the provider\'s OAuth flow.',
  'mcp.closePicker': 'Close picker',
  'mcp.collapse': 'Collapse',
  'mcp.collapseServerAria': 'Collapse this MCP server',
  'mcp.commandPlaceholder': 'e.g. npx, node, /path/to/binary',
  'mcp.commandRequired': 'Command is required for stdio transport.',
  'mcp.completedAuthTitle': 'I\'ve completed authorization — check connection status now',
  'mcp.connect': 'Connect',
  'mcp.connected': 'Connected.',
  'mcp.connecting': 'Connecting…',
  'mcp.customServer': 'Custom server',
  'mcp.customServerDesc': 'Empty form. Pick stdio or SSE / HTTP and fill the fields yourself.',
  'mcp.disabled': 'Disabled',
  'mcp.disconnect': 'Disconnect',
  'mcp.disconnectFailed': 'Disconnect failed. Check daemon logs.',
  'mcp.disconnecting': 'Disconnecting…',
  'mcp.displayNamePlaceholder': 'Display name (optional)',
  'mcp.enabled': 'Enabled',
  'mcp.enableServerAria': 'Enable this MCP server',
  'mcp.expand': 'Expand',
  'mcp.expandServerAria': 'Expand this MCP server',
  'mcp.expandToEdit': 'Expand to edit',
  'mcp.fieldArgs': 'Args',
  'mcp.fieldCommand': 'Command',
  'mcp.fieldEnv': 'Env (KEY=VALUE)',
  'mcp.fieldEnvShort': 'Env',
  'mcp.fieldHeaders': 'Headers (KEY=VALUE)',
  'mcp.fieldId': 'ID',
  'mcp.fieldOAuthMode': 'OAuth mode',
  'mcp.fieldTransport': 'Transport',
  'mcp.fieldUrl': 'URL',
  'mcp.homepage': 'Homepage',
  'mcp.idInvalid': 'ID must start with a letter or digit and only contain letters, digits, dash, or underscore (max 64 chars).',
  'mcp.jsonHelperExampleHead': 'Example MCP JSON',
  'mcp.jsonHelperHttpNote': 'use url + headers instead of command / args',
  'mcp.jsonHelperToggle': 'Need help? Map your MCP server\'s JSON config using the example below.',
  'mcp.moveDown': 'Move down',
  'mcp.moveUp': 'Move up',
  'mcp.noManagedOAuth': 'No managed OAuth.',
  'mcp.noManagedOAuthSaveDirect': 'Save this server and Open Design will use it directly.',
  'mcp.noManagedOAuthUseAsConfigured': 'Open Design will use this server as configured. Add headers below if the server needs a token.',
  'mcp.nonExpiringToken': 'Non-expiring token.',
  'mcp.notConnected': 'Not connected.',
  'mcp.openAuthorizationPage': 'Open authorization page',
  'mcp.pickerFilterPlaceholder': 'Filter by name, transport, capability…',
  'mcp.pickerHint': 'Pre-fills the form. You can still edit any field after.',
  'mcp.pickerNoMatch': 'No templates match “{query}”. Try clearing the filter or use the custom server option below.',
  'mcp.pickTemplate': 'Pick a template',
  'mcp.reauthenticateTitle': 'Reauthenticate (replaces the existing token)',
  'mcp.recheckTokenTitle': 'Re-check token status against the daemon',
  'mcp.reconnect': 'Reconnect',
  'mcp.refresh': 'Refresh',
  'mcp.removeServer': 'Remove this MCP server',
  'mcp.saveFirstThenClick': 'Save first, then click',
  'mcp.starting': 'Starting…',
  'mcp.toGrantOAuthAccess': 'to grant Open Design access via the provider\'s OAuth flow.',
  'mcp.tokenExpires': 'Token expires {time}.',
  'mcp.transportAria': 'Transport: {transport}',
  'mcp.tryLabel': 'Try:',
  'mcp.tryPromptTitle': 'Paste this prompt into the chat composer to try the server end-to-end',
  'mcp.unnamedServer': 'Unnamed MCP server',
  'mcp.urlMalformed': 'URL is malformed.',
  'mcp.urlProtocolInvalid': 'URL must use http:// or https://.',
  'mcp.urlRequired': 'URL is required for SSE / HTTP transport.',
  'mcp.waitingForAuthorization': 'Waiting for authorization…',
  'memory.connectorReadFailed': 'Couldn\'t read {name}.',
  'memory.connectorNoReadableContent': 'No readable content from {name}.',
  'memory.providerLocalCli': 'Local CLI',
  'memory.providerFallbackName': 'Memory model',
  'memory.extractionSourceConnector': 'Connected apps were read, but OpenDesign could not turn that context into memory.',
  'memory.extractionSourceChat': 'OpenDesign could not run memory extraction for this chat.',
  'memory.failureAuthExpiredTitle': '{provider} authentication expired',
  'memory.failureAuthActionCli': 'Sign in to the selected Local CLI or choose a different Memory model.',
  'memory.failureAuthActionKey': 'Update the Memory extraction model key or sign in again.',
  'memory.failureQuotaTitle': '{provider} quota or rate limit hit',
  'memory.failureQuotaAction': 'Try again later or switch the Memory extraction model.',
  'memory.failureRequestTitle': '{provider} request failed',
  'memory.failureRequestActionCli': 'Check the selected Local CLI and try again.',
  'memory.failureRequestActionProvider': 'Check the model provider connection and try again.',
  'memory.failureGenericTitle': 'Memory extraction failed',
  'memory.failureGenericActionCli': 'Try again after checking the selected Local CLI.',
  'memory.failureGenericActionSettings': 'Try again after checking the Memory extraction model settings.',
  'memory.noData': 'No data',
  'memory.attemptReadTitle': 'Read {name}',
  'memory.attemptFailedTitle': 'Could not read {name}',
  'memory.attemptSkippedTitle': 'Skipped {name}',
  'memory.skipChatDisabled': 'Chat conversation learning is off.',
  'memory.kindConnectedApps': 'Connected apps',
  'memory.timeAgo': '{time} ago',
  'memory.scanRunningTitle': 'Scanning connected apps',
  'memory.scanFailedTitle': 'Connected app scan failed',
  'memory.scanSkippedTitle': 'Connected app scan skipped',
  'memory.scanSavedOne': 'Saved {count} memory',
  'memory.scanSavedOther': 'Saved {count} memories',
  'memory.scanNoNewMemories': 'No new memories found',
  'memory.scanTitle': 'Connected app scan',
  'memory.scanMetaChecking': 'Checking selected apps',
  'memory.scanMetaNeedsAttention': 'Needs attention',
  'memory.scanMetaFromConnectedApps': 'From connected apps',
  'memory.scanMetaCheckedApps': 'Checked selected apps',
  'memory.scanBusyLabel': 'Scanning apps',
  'memory.scanSelectPrompt': 'Select apps to scan',
  'memory.scanSelectedApps': 'Scan selected apps',
  'memory.connectorReadFailedRetry': 'Could not read connected apps. Try again from the Connectors tab.',
  'memory.appCountOne': '{count} app',
  'memory.appCountOther': '{count} apps',
  'memory.foundSuggestionsOne': 'Found {count} suggested memory from {apps}. Review before saving.',
  'memory.foundSuggestionsOther': 'Found {count} suggested memories from {apps}. Review before saving.',
  'memory.noSuggestionsFound': 'No memory suggestions found. OpenDesign could not read useful content from the selected app yet.',
  'memory.checkedNoSuggestionsOne': 'Checked {count} selected app, but found no new memory suggestions.',
  'memory.checkedNoSuggestionsOther': 'Checked {count} selected apps, but found no new memory suggestions.',
  'memory.savedFromConnectedAppsOne': 'Saved {count} memory from connected apps.',
  'memory.savedFromConnectedAppsOther': 'Saved {count} memories from connected apps.',
  'memory.savedPartial': 'Saved {saved} of {total} selected memories. Please try the remaining items again.',
  'memory.tabManual': 'Add manually',
  'memory.tabManualCaption': 'Write a fact or preference',
  'memory.tabConnected': 'Import from apps',
  'memory.tabConnectedCaption': 'Scan connected tools',
  'memory.storagePathAria': 'Memory storage path — click to copy',
  'memory.flowOnboarding': 'Onboarding',
  'memory.flowBrandContext': 'Brand context',
  'memory.flowChatSignals': 'Chat signals',
  'memory.flowSavedMemory': 'Saved memory',
  'memory.howCopy': 'Memory is gathered automatically from profile setup, project and brand extraction, connected apps, and useful facts learned during chats. The saved list below is the review surface; everything else stays quiet unless you open Add or Advanced.',
  'memory.areasAria': 'Memory areas',
  'memory.manualPanelHint': 'Add facts, preferences, or project context yourself. Fixed assistant behavior lives in Instructions / Rules.',
  'memory.connectedPanelHint': 'Choose apps to scan for design preferences, project context, and visual references. Nothing is scanned until you select an app.',
  'memory.loading': 'Loading',
  'memory.connectedCount': '{count} connected',
  'memory.manage': 'Manage',
  'memory.chooseSources': 'Choose sources',
  'memory.chooseSourcesHint': 'Select connected apps first. OpenDesign only scans the apps you choose.',
  'memory.selectedCount': '{count} selected',
  'memory.connectorListAria': 'Connected memory apps',
  'memory.readToolsCount': '{count} read tools',
  'memory.checkingConnectionStatus': 'Checking connection status…',
  'memory.finishAuthorization': 'Finish authorization in your browser, then return here',
  'memory.connectBeforeExtraction': 'Connect this app before extraction',
  'memory.useConnectorAria': 'Use {name} for memory extraction',
  'memory.selected': 'Selected',
  'memory.select': 'Select',
  'memory.reconnectConnectorAria': 'Reconnect {name}',
  'memory.connectConnectorAria': 'Connect {name}',
  'memory.connectStateChecking': 'Checking',
  'memory.connectStateWaiting': 'Waiting',
  'memory.connectStateConnecting': 'Connecting',
  'memory.reconnect': 'Reconnect',
  'memory.selectedOfConnectedOne': 'Selected {count} of {total} connected app.',
  'memory.selectedOfConnectedOther': 'Selected {count} of {total} connected apps.',
  'memory.suggestedMemories': 'Suggested memories',
  'memory.suggestedMemoriesHint': 'Review design-related memories before saving them.',
  'memory.saving': 'Saving',
  'memory.saveSelected': 'Save selected',
  'memory.discard': 'Discard',
  'memory.diagnosticsAria': 'Connected app read status',
  'memory.lastScan': 'Last scan',
  'memory.bytesRead': '{bytes} read',
  'memory.recentScans': 'Recent scans',
  'memory.runHistoryAria': 'Connected app memory run status',
  'memory.savedMemoryHint': 'Saved facts, preferences, and project context available to future chats.',
  'memory.savedCount': '{count} saved',
  'memory.extractionCountOne': '{count} extraction',
  'memory.extractionCountOther': '{count} extractions',
  'memory.emptyHintBefore': 'Tell the assistant a fact in chat — e.g.',
  'memory.emptyHintAfter': '— and it will be saved here automatically.',
  'memory.advancedHint': 'Inspect or edit the underlying memory index.',
  'memory.memoryTree': 'Memory tree',
  'memory.memoryTreeHint': 'Technical view of the same saved memories. Most users only need the saved-memory list above.',
  'memory.nodeCountOne': '{count} node',
  'memory.nodeCountOther': '{count} nodes',
  'dsCreate.addingSourceMaterial': 'Adding source material...',
  'dsCreate.browseFolder': 'Browse folder',
  'dsCreate.confirmBody': 'You\'ll land in a project that fills in live — logo, palette, typography, imagery — as it measures your brand. Keep the tab open.',
  'dsCreate.confirmTitle': 'Open Design will extract your design system.',
  'dsCreate.designMdPreviewFallbackName': 'Design system',
  'dsCreate.dropZoneSelections': '{label} selections',
  'dsCreate.extractDesignSystem': 'Extract design system',
  'dsCreate.extractionAlreadyStarting': 'Extraction is already starting. Please wait for the current request to finish.',
  'dsCreate.figmaFileFallbackLabel': 'Figma file',
  'dsCreate.figmaUrlInvalid': 'Enter a Figma file URL (https://figma.com/file/… or /design/…).',
  'dsCreate.githubAccessAutoBody': 'GitHub repo links use the first working access method; other website links are saved as source references.',
  'dsCreate.githubAccessAutoTitle': 'GitHub access: Auto',
  'dsCreate.githubAccessMethodsAria': 'GitHub repository access methods',
  'dsCreate.githubAuthorizeFailed': 'Could not start GitHub authorization.',
  'dsCreate.githubBadgeAutomatic': 'Automatic',
  'dsCreate.githubBadgeChecking': 'Checking',
  'dsCreate.githubBadgeComingSoon': 'Coming soon',
  'dsCreate.githubBadgeConnected': 'Connected',
  'dsCreate.githubBadgeNeedsAttention': 'Needs attention',
  'dsCreate.githubBadgeNotConfigured': 'Not configured',
  'dsCreate.githubBadgeOptional': 'Optional',
  'dsCreate.githubBadgePending': 'Pending',
  'dsCreate.githubComposioCheckingDesc': 'Checking connector status in the background; URL intake is not blocked.',
  'dsCreate.githubComposioConnectedAsDesc': 'Composio GitHub connector connected as {account}; it is available as fallback when this device cannot read the repository.',
  'dsCreate.githubComposioConnectedDesc': 'Composio GitHub connector is available as fallback when this device cannot read the repository.',
  'dsCreate.githubComposioDefaultDesc': 'Composio GitHub connector access for agent tools; repo URLs still work with local git or GitHub CLI.',
  'dsCreate.githubComposioErrorDesc': 'Reconnect the Composio GitHub connector, or continue with local git/GitHub CLI.',
  'dsCreate.githubComposioNotConfiguredDesc': 'Add a Composio API key only if this project needs connector-backed GitHub tools.',
  'dsCreate.githubComposioPendingDesc': 'Finish the Composio authorization window; local GitHub intake remains available.',
  'dsCreate.githubConfigureComposio': 'Configure Composio',
  'dsCreate.githubConnecting': 'Connecting...',
  'dsCreate.githubConnectorCheckFailed': 'Could not check the GitHub connector.',
  'dsCreate.githubConnectorCheckTimeout': 'Could not finish checking GitHub connector. You can still add repository URLs or connect GitHub manually.',
  'dsCreate.githubConnectViaComposio': 'Connect via Composio',
  'dsCreate.githubDisconnect': 'Disconnect',
  'dsCreate.githubDisconnectFailed': 'Could not disconnect GitHub.',
  'dsCreate.githubDisconnecting': 'Disconnecting...',
  'dsCreate.githubHideAccessMethods': 'Hide access methods',
  'dsCreate.githubMethodConnectorPlatform': 'Connector platform',
  'dsCreate.githubMethodOdAccount': 'Open Design account',
  'dsCreate.githubMethodOdAccountDesc': 'Native GitHub sign-in managed by Open Design; this build does not use an OD-managed GitHub token yet.',
  'dsCreate.githubMethodThisDevice': 'This device',
  'dsCreate.githubMethodThisDeviceDesc': 'Uses public git clone, local git credentials, or GitHub CLI auth available on this machine.',
  'dsCreate.githubOpenAuthorization': 'Open authorization',
  'dsCreate.githubShowAccessMethods': 'Show access methods',
  'dsCreate.libraryPartiallyAdded': 'Added {added} of {total} item(s) from the library.',
  'dsCreate.localCodeFilesSelected': '{count} local code files selected',
  'dsCreate.prepareProjectFailed': 'Could not prepare the design system project.',
  'dsCreate.removeFile': 'Remove {name}',
  'dsCreate.startingExtraction': 'Starting extraction...',
  'dsFlow.activityDetailFailed': 'The chat message has the run details. You can adjust the request and try again.',
  'dsFlow.activityDetailReady': 'Review the updated Design System and Design Files tabs.',
  'dsFlow.activityDetailRunning': 'Watching project files and preparing the review draft.',
  'dsFlow.activityFailedTitle': 'Workspace update needs attention',
  'dsFlow.activityProgressAria': 'Workspace update progress {progress}%',
  'dsFlow.activityReadyTitle': 'Workspace update ready',
  'dsFlow.activityRunningTitle': 'Open Design is updating this system',
  'dsFlow.addBrandFonts': 'Add brand font files',
  'dsFlow.agentMsgCapturedDirection': 'Captured direction: {summary}',
  'dsFlow.agentMsgCreating': 'I am creating the design system workspace, preview cards, and supporting files from the context you provided.',
  'dsFlow.agentMsgReady': 'Your design system draft is ready. Review the Design System tab, inspect generated files, publish it, or ask me for changes here.',
  'dsFlow.agentMsgRevision': 'I am applying your feedback to the design system. You can keep reviewing the current draft while the revision runs.',
  'dsFlow.agentMsgTokenRebuild': 'I am preparing a token contract rebuild for review. The active contract will stay unchanged until the revision is accepted.',
  'dsFlow.agentPushLayer': 'Agent push layer',
  'dsFlow.assetsLabel': 'Assets',
  'dsFlow.auditNeedsRepair': '{summary} Review the audit details before running a repair.',
  'dsFlow.brandFontsMissingBody': 'Typography previews are using substitute web fonts until brand font files are added.',
  'dsFlow.brandFontsMissingTitle': 'Brand font files missing',
  'dsFlow.chatCreateRequest': 'Create design system',
  'dsFlow.chatSeedUpdateSystem': 'Update this design system: ',
  'dsFlow.composerPlaceholder': 'Follow-up action: use AI extraction to refine this system. Longer run; updates land here.',
  'dsFlow.conversationCreateFailed': 'Could not create a design system conversation.',
  'dsFlow.evidenceFallbackTokens': 'Fallback tokens',
  'dsFlow.evidenceFonts': 'Fonts',
  'dsFlow.evidenceIndexes': 'Evidence indexes',
  'dsFlow.evidenceScannedFiles': 'Scanned files',
  'dsFlow.evidenceSnippets': 'Snippets',
  'dsFlow.evidenceSourceTokens': 'Source tokens',
  'dsFlow.fileDraftPreview': 'File draft preview',
  'dsFlow.filesTouched': 'Files touched',
  'dsFlow.forceRebuild': 'Force',
  'dsFlow.generalRevision': 'General revision',
  'dsFlow.generationCompleted': 'Generation completed',
  'dsFlow.generationProgressAria': 'Generation progress {progress}%',
  'dsFlow.generationStopped': 'Generation stopped',
  'dsFlow.generationStoppedWithError': 'Generation stopped: {error}',
  'dsFlow.jobCompleted': '{noun} completed',
  'dsFlow.jobDetailGeneration': 'Preparing the remaining files.',
  'dsFlow.jobDetailReady': 'Review workspace is ready.',
  'dsFlow.jobDetailRevision': 'Applying your feedback.',
  'dsFlow.jobDetailTokenRebuild': 'Preparing a reviewable token contract draft.',
  'dsFlow.jobNeedsAttention': '{noun} needs attention',
  'dsFlow.jobNounGeneration': 'Generation',
  'dsFlow.jobNounRevision': 'Revision',
  'dsFlow.jobNounTokenRebuild': 'Token rebuild',
  'dsFlow.jobRebuildingTokens': 'Open Design is rebuilding tokens',
  'dsFlow.jobRevising': 'Open Design is revising',
  'dsFlow.jobStillWorking': 'Open Design is still working',
  'dsFlow.loadingDesignSystem': 'Loading design system...',
  'dsFlow.metaEvidenceNotes': 'Evidence notes',
  'dsFlow.metaScannedInventory': 'Scanned file inventory',
  'dsFlow.metaSnippetIndex': 'Snippet index',
  'dsFlow.metaTokenExtraction': 'Token extraction evidence',
  'dsFlow.metaTokenReport': 'Token contract quality report',
  'dsFlow.movedBackToDraft': 'Moved back to draft',
  'dsFlow.needsWorkSeed': 'Needs work on {title}: ',
  'dsFlow.no': 'No',
  'dsFlow.openingDesignSystemWorkspace': 'Opening the design system workspace...',
  'dsFlow.openingWorkspace': 'Opening the workspace...',
  'dsFlow.packageFallbackMeta': '{source} · DESIGN.md-only fallback',
  'dsFlow.packageLegacy': 'Legacy design system',
  'dsFlow.packageManifestMeta': '{source} · {mode} mode · manifest indexed',
  'dsFlow.packagePillFallback': 'Fallback',
  'dsFlow.packagePillReady': 'Hybrid ready',
  'dsFlow.packageStructured': 'Structured import package',
  'dsFlow.pendingRevision': 'Pending revision',
  'dsFlow.pickLocalAgentFirst': 'Pick a local agent first, then ask Open Design to update this design system.',
  'dsFlow.previewPages': 'Preview pages',
  'dsFlow.proposedChanges': 'Proposed changes',
  'dsFlow.publishCardReady': 'Open Design is ready for review. Give feedback on the work so far, then publish when it is useful for future projects.',
  'dsFlow.publishCardRevision': 'Open Design is applying your feedback. You can keep reviewing while the updated draft is prepared.',
  'dsFlow.publishCardTokenRebuild': 'Open Design is preparing a token contract rebuild for review. The active contract stays unchanged until you accept it.',
  'dsFlow.publishCardWorking': 'Open Design is still working, but you can start giving feedback on the work so far.',
  'dsFlow.pullLayer': 'Pull layer',
  'dsFlow.rebuildTokenContract': 'Rebuild token contract',
  'dsFlow.reviewDraftTitle': 'Review draft design system',
  'dsFlow.revisionAccept': 'Accept',
  'dsFlow.revisionAccepted': 'Revision accepted',
  'dsFlow.revisionAcceptFailed': 'Could not accept revision',
  'dsFlow.revisionHistory': 'Revision history',
  'dsFlow.revisionMsgAccepted': 'Accepted. The design system draft now includes this update.',
  'dsFlow.revisionMsgPending': 'I prepared a proposed update. Review the diff card on the right, then accept it or ask for another change.',
  'dsFlow.revisionMsgRejected': 'Rejected. I left the current design system unchanged.',
  'dsFlow.revisionProgressUnavailable': 'Could not read revision progress',
  'dsFlow.revisionReady': 'Revision ready for review',
  'dsFlow.revisionReject': 'Reject',
  'dsFlow.revisionRejected': 'Revision rejected',
  'dsFlow.revisionRejectFailed': 'Could not reject revision',
  'dsFlow.revisionStopped': 'Revision stopped',
  'dsFlow.revisionStoppedWithError': 'Revision stopped: {error}',
  'dsFlow.saveChangesFailed': 'Could not save changes',
  'dsFlow.savedDesignMd': 'Saved DESIGN.md',
  'dsFlow.sectionDraftBody': 'Draft body',
  'dsFlow.sectionFallbackTitle': 'Section',
  'dsFlow.sectionMarkedLooksGood': '{title} marked as looks good',
  'dsFlow.sectionNoContent': 'No content yet.',
  'dsFlow.sectionNoDetails': 'No details yet.',
  'dsFlow.setDefaultAction': 'Default for new chats',
  'dsFlow.setDefaultTitle': 'Preselect this design system for new chats and new projects.',
  'dsFlow.sourceEvidence': 'Source evidence',
  'dsFlow.sourceTypeBundled': 'Bundled',
  'dsFlow.sourceTypeDefault': 'Design system',
  'dsFlow.sourceTypeGithub': 'GitHub import',
  'dsFlow.sourceTypeInstalled': 'Installed',
  'dsFlow.sourceTypeLocal': 'Local import',
  'dsFlow.sourceTypeUser': 'User workspace',
  'dsFlow.statusUpdateFailed': 'Could not update status',
  'dsFlow.stepReadCurrentSystem': 'Read current system',
  'dsFlow.stepRefreshReview': 'Refresh review',
  'dsFlow.stepUpdateDesignFiles': 'Update design files',
  'dsFlow.subtitleBrand': 'Logo, voice and usage rules',
  'dsFlow.subtitleColor': 'Palette and semantic roles',
  'dsFlow.subtitleComponents': 'Reusable interface patterns',
  'dsFlow.subtitleDefault': 'Design guidance',
  'dsFlow.subtitleSpacing': 'Spacing scale and radius tokens',
  'dsFlow.subtitleTypography': 'Text hierarchy and styles',
  'dsFlow.tabDesignFiles': 'Design Files',
  'dsFlow.tabDesignSystem': 'Design System',
  'dsFlow.tokenContractLabel': 'Token contract',
  'dsFlow.tokenContractRebuildRecommended': 'rebuild recommended',
  'dsFlow.tokenContractReportAvailable': 'quality report available',
  'dsFlow.tokenContractScore': 'score {score}',
  'dsFlow.tokenRebuildStarted': 'Token contract rebuild started',
  'dsFlow.tokenRebuildStartFailed': 'Could not start token contract rebuild',
  'dsFlow.workspaceOpenFailed': 'Could not open the design system workspace.',
  'dsFlow.workspaceUpdatedReview': 'Workspace updated. Review the files or ask for another change.',
  'dsFlow.workspaceUpdatedSynced': 'Workspace updated and DESIGN.md synced for review.',
  'dsFlow.workspaceUpdatedWithAudit': 'Workspace updated. {summary}',
  'dsFlow.yes': 'Yes',
  'pluginDetail.backToList': 'Back to list',
  'pluginDetail.quickCommands': 'Quick commands',
  'pluginDetail.noQuickCommands': 'No quick commands available.',
  'pluginDetail.dataConnections': 'Data connections',
  'pluginDetail.noDataConnections': 'This suite does not require any external data connections.',
  'pluginDetail.knowledgeSkills': 'Knowledge skills',
  'pluginDetail.noKnowledgeSkills': 'This suite has no standalone knowledge skills yet.',
  'pluginDetail.officialBadge': 'Open Design official',
  'pluginDetail.loadFailed': 'Failed to load plugin: {error}',
  'pluginDetail.applyFailed': 'Apply failed. Make sure the daemon is reachable.',
  'pluginDetail.examples': 'Examples',
  'skillDetail.providedBy': 'provided by {author}',
  'skillDetail.markdownNotice': 'The following content is taken verbatim from this skill’s SKILL.md',
  'skillDetail.loadFailed': 'Couldn’t load this skill’s SKILL.md.',
  'skillDetail.previewAria': '{title} SKILL.md preview',
  'common.dismiss': 'Dismiss',
  'campaign.deepseekV4Flash.headline': 'Most ne spórolj. Korlátlan DeepSeek V4 Flash.',
  'campaign.deepseekV4Flash.description': 'Landingek, oldalak, deckek és képek — annyit, amennyi kell.',
  'campaign.deepseekV4Flash.benefit': 'Korlátlan DeepSeek V4 Flash',
  'campaign.deepseekV4Flash.timing': 'aug. 6–13.: ingyenes a kampányablakban',
  'campaign.deepseekV4Flash.ruleSummary': 'Aug. 6–13. között a fizetős felhasználók ingyen használhatják a DeepSeek V4 Flash-t az Open Designban. Nagyarányú visszaélés szüneteltetheti a kampányhozzáférést.',
  'campaign.deepseekV4Flash.windowLabel': 'aug. 6–13.',
  'campaign.deepseekV4Flash.weekFreeSuffix': 'egy hét ingyen',
  'campaign.deepseekV4Flash.boundary': 'A csomag korlátlan modellkvótája és ingyenes generálásai csak az Open Designon belül érvényesek — nem MCP, CLI, API vagy más felületeken. A végleges értelmezés az Open Designé.',
  'campaign.deepseekV4Flash.countdownLabel': 'Kampány visszaszámlálás',
  'campaign.deepseekV4Flash.countdownEnded': 'A kampány véget ért',
  'campaign.deepseekV4Flash.countdownRemaining': '{days}n {hms}',
  'campaign.deepseekV4Flash.closeAria': 'Bezárás',
  'campaign.deepseekV4Flash.unlocked': 'Feloldva',
  'campaign.deepseekV4Flash.locked': 'Zárolva',
  'campaign.deepseekV4Flash.later': 'Később',
  'campaign.deepseekV4Flash.paid.eyebrow': '7 nap ingyen',
  'campaign.deepseekV4Flash.paid.status': 'Feloldva · aug. 6–13.',
  'campaign.deepseekV4Flash.paid.cta': 'Használom most',
  'campaign.deepseekV4Flash.paid.modelBadge': 'Korlátlan',
  'campaign.deepseekV4Flash.unpaid.eyebrow': 'Ingyenes a fizetős csomagokra',
  'campaign.deepseekV4Flash.unpaid.status': 'Frissíts a feloldáshoz · aug. 13-ig',
  'campaign.deepseekV4Flash.unpaid.cta': 'Csomagfrissítés és használat',
  'campaign.deepseekV4Flash.unpaid.modelBadge': 'Frissítés kell',
  'campaign.deepseekV4Flash.unpaid.tooltip': 'Iratkozz fel a kampányablakban az ingyenes használathoz; aug. 13-án véget ér.',
  'campaign.deepseekV4Flash.restricted.modelBadge': 'Szüneteltetve',
  'campaign.deepseekV4Flash.restricted.tooltip': 'Szokatlanul nagy forgalmat észleltünk, ezért a kampányhozzáférés szünetel. Segítségért keresd a támogatást.',
  'campaign.deepseekV4Flash.workbenchBadge': 'DeepSeek V4 korlátlan ingyen',
  'campaign.deepseekV4Flash.workbenchBadgeAria': 'DeepSeek V4 korlátlan ingyen — Pricing megnyitása',
};
